(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("_"), require("axios"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("pro-gallery-renderer", ["React", "_", "axios", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["pro-gallery-renderer"] = factory(require("React"), require("_"), require("axios"), require("ReactDOM"));
	else
		root["pro-gallery-renderer"] = factory(root["React"], root["_"], root["axios"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_114__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 139);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(89);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _renderUtils = __webpack_require__(70);

var _renderUtils2 = _interopRequireDefault(_renderUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Utils = function (_RenderUtils) {
  (0, _inherits3.default)(Utils, _RenderUtils);

  function Utils() {
    (0, _classCallCheck3.default)(this, Utils);
    return (0, _possibleConstructorReturn3.default)(this, (Utils.__proto__ || (0, _getPrototypeOf2.default)(Utils)).apply(this, arguments));
  }

  (0, _createClass3.default)(Utils, [{
    key: 'isWixIframe',
    value: function isWixIframe() {
      return window && window.Wix && window.top !== window.self;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(element, to, duration, isHorizontal, callback) {

      if (this.isMobile()) {
        duration = 0; //do not animate scroll on mobile (looks jumpy and buggy)
      }

      var easeInOutQuad = function easeInOutQuad(currentTime, start, change, duration) {
        //t = current time
        //b = start value
        //c = change in value
        //d = duration
        if (duration === 0) {
          return change + start;
        }

        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime--;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      };

      var start = isHorizontal ? element.scrollLeft : element.scrollTop;
      var change = to - start;
      var currentTime = 0;
      var increment = 20;

      var animateScroll = function animateScroll() {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);

        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        } else {
          element.setAttribute('data-scrolling', '');
          if (typeof callback === 'function') {
            callback();
          }
        }

        if (isHorizontal) {
          element.scrollLeft = val;
        } else {
          element.scrollTop = val;
        }
      };

      element.setAttribute('data-scrolling', 'true');
      animateScroll();
    }
  }]);
  return Utils;
}(_renderUtils2.default);

exports.default = new Utils();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(149), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(170);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(174);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(144), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(59)('wks');
var uid = __webpack_require__(41);
var Symbol = __webpack_require__(11).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _Wix = __webpack_require__(214);

var _Wix2 = _interopRequireDefault(_Wix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixSdkWrapper = function () {
  function WixSdkWrapper() {
    (0, _classCallCheck3.default)(this, WixSdkWrapper);

    this.init();
  }

  (0, _createClass3.default)(WixSdkWrapper, [{
    key: 'wixSdkIsAvailable',
    value: function wixSdkIsAvailable() {
      try {
        return typeof window !== 'undefined' && typeof window.Wix !== 'undefined' && typeof window.Wix.Utils.getCompId === 'function'; //getCompId function is only available is the TPA version of the sdk
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'init',
    value: function init() {
      try {
        if (this.wixSdkIsAvailable()) {
          //Wix Sdk is on the window
          (0, _assign2.default)(this, _Wix2.default, window.Wix);
          this.isMock = false;
        } else {
          (0, _assign2.default)(this, _Wix2.default);
          this.isMock = true;
        }
      } catch (e) {
        (0, _assign2.default)(this, _Wix2.default);
        this.isMock = true;
      }
    }
  }]);
  return WixSdkWrapper;
}();

exports.default = new WixSdkWrapper();

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(8);
var ctx = __webpack_require__(24);
var hide = __webpack_require__(20);
var has = __webpack_require__(21);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(84);
var toPrimitive = __webpack_require__(54);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(153);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(161);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(31);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemActions = undefined;

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _baseUtils = __webpack_require__(28);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _biLogger = __webpack_require__(29);

var _translationUtils = __webpack_require__(120);

var _translationUtils2 = _interopRequireDefault(_translationUtils);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _html2canvas = __webpack_require__(267);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemActions = function () {
  function ItemActions() {
    (0, _classCallCheck3.default)(this, ItemActions);


    this.isMultisharing = function () {};
    this.wasInit = false;
    this.loveCounts = {};
    this.fetchSiteInfo();
  }

  (0, _createClass3.default)(ItemActions, [{
    key: 'initWidgetData',
    value: function initWidgetData(config) {

      this.config = config;

      if (config.compId) {
        this.compId = config.compId;
      }
      if (config.pageId) {
        this.pageId = config.pageId;
      }
      if (config.styleId) {
        this.styleId = config.styleId;
      }
      if (config.galleryId) {
        this.galleryId = config.galleryId;
      }
      if (config.fullscreenUrl) {
        this.siteUrl = this.fullscreenUrl = this.normalizeFullscreenUrl(config.fullscreenUrl);
        try {
          this.siteUrl = this.fullscreenUrl.match(/.*\..*\//g)[0];
        } catch (e) {
          //
        }
      }

      if (config.reachLevel) {
        this.setReachLevel(config.reachLevel);
      }

      if (this.galleryId && this.galleryId !== '') {
        this.loveCountFetched = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.loveCountFetched.initCustomEvent('love_count_fetched', false, false, null);
        this.getStats();
      }

      this.wasInit = config;

      return Date.now();
    }

    /**
     * Sometimes we may get a full screen url with some additional parameters (like we get right after the user logs in. We need to remove them)
     */

  }, {
    key: 'normalizeFullscreenUrl',
    value: function normalizeFullscreenUrl(fullscreenUrl) {
      var querylessUrl = fullscreenUrl;
      if (fullscreenUrl) {
        querylessUrl = fullscreenUrl.split('?')[0];
      }
      return querylessUrl;
    }
  }, {
    key: 'fetchSiteInfo',
    value: function fetchSiteInfo() {
      var _this = this;

      var href = void 0;
      try {
        href = window.location.href;
      } catch (e) {
        href = '';
      }

      if (_baseUtils.baseUtils.isInWix()) {
        this.siteInfo = {};
        _WixSdkWrapper2.default.getSiteInfo(function (res) {
          _this.siteInfo = res;
        });
      } else {
        this.siteInfo = {
          url: href,
          baseUrl: href,
          siteTitle: 'Wix Pro Gallery',
          siteDescription: 'The best gallery any Wix user has ever seen!',
          siteKeywords: 'gallery,photos,photographer,professional'
        };
      }
    }
  }, {
    key: 'getSiteUrl',
    value: function getSiteUrl() {
      return this.siteInfo.url;
    }
  }, {
    key: 'getStats',
    value: function getStats() {
      var _this2 = this;

      if (_baseUtils.baseUtils.isDev() || _baseUtils.baseUtils.isTest()) {
        return;
      }
      if (!this.galleryId || this.galleryId === '' || this.galleryId.length < 10) {
        console.log('galleryId id', this.galleryId, (0, _typeof3.default)(this.galleryId));
        console.error('get stats error - no galleryId');
        return;
      }
      _axios2.default.get('//progallery.wix.com/_api/pro-gallery-webapp/v1/gallery/' + this.galleryId + '/stats/properties').then(function (res) {
        try {
          res = res.data;
          _this2.statsProps = JSON.parse(res.properties);
          _this2.statsToken = res.statsToken;
        } catch (e) {
          console.error('Failed getting stats props', e);
        }
      });

      var instanceId = void 0;
      try {
        instanceId = window.instanceId;
      } catch (e) {
        instanceId = '';
      }

      if (!instanceId) {
        console.warn('cannot report love counter - no instance id');
      } else {

        _axios2.default.get('//progallery.wix.com/_api/pro-gallery-webapp/v1/gallery/' + this.galleryId + '/' + instanceId + '/stats').then(function (res) {
          try {
            res = res.data;
            _this2.loveCounts = res.photoId2Love;
            window.dispatchEvent(_this2.loveCountFetched);
          } catch (e) {
            console.error('Failed getting love counts', e);
          }
        });
      }
    }
  }, {
    key: 'getLoveCount',
    value: function getLoveCount(photoId) {
      return Math.max(0, this.loveCounts[photoId]) || 0;
    }
  }, {
    key: 'html2img',
    value: function html2img(itemDto, callback) {
      try {
        var div = document.createElement('div');
        div.innerHTML = itemDto.html;
        div.style.boxSizing = 'border-box';
        div.style.background = itemDto.style.bgColor;
        div.style.position = 'absolute';
        div.style.top = 0;
        div.style.left = 0;
        div.style.zIndex = -1;
        div.className = 'text-item';
        document.body.appendChild(div);

        (0, _html2canvas2.default)(div, {
          onrendered: function onrendered(canvas) {
            div.remove();
            var url = canvas.toDataURL();
            if (typeof callback === 'function') {
              callback(url);
            }
          }
        });
      } catch (e) {
        if (typeof callback === 'function') {
          callback('');
        }
      }
    }
  }, {
    key: 'share',
    value: function share(type, itemDto, origin, numOfItems) {
      if (_baseUtils.baseUtils.isDemo()) {
        return;
      }
      _biLogger.logger.trackBi(_biLogger.logger.biEvents.share, {
        origin: origin,
        platform: type
      });
      if (numOfItems) {
        //itemDto.numOfItems is not extensible because it is being passed in props. only for multishare
        itemDto.numOfItems = numOfItems;
      }
      this.shareImp(type, itemDto);
    }
  }, {
    key: 'downloadTextItem',
    value: function downloadTextItem(itemDto, origin) {
      _biLogger.logger.trackBi(_biLogger.logger.biEvents.download, {
        origin: origin
      });
      this.html2img(itemDto, function (url) {
        try {
          url = url.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
          window.open(url);
        } catch (e) {
          //
        }
      });
    }
  }, {
    key: 'getReachLevel',
    value: function getReachLevel(increment) {
      var inc = Number(increment || 0);
      var rl = void 0;
      if (_lodash2.default.isUndefined(this.reachLevel)) {
        var ls = _baseUtils.baseUtils.getLocalStorage();
        rl = Number(ls[this.siteUrl + '|reach-level'] || 0) + inc;
      } else {
        rl = this.reachLevel + inc;
      }
      return rl;
    }
  }, {
    key: 'setReachLevel',
    value: function setReachLevel(rl, hashtag) {
      if (!(rl > 0)) {
        rl = 0;
      }
      try {
        var origRl = this.getReachLevel(0); //if this user already registered a reach-level for this site (already saw it) don't register again
        if (rl > 0 && origRl === 0 && _lodash2.default.isUndefined(this.reachLevel)) {
          _biLogger.logger.track('log_reach_level', {
            hashtag: hashtag,
            reach_level: rl
          });
          var ls = _baseUtils.baseUtils.getLocalStorage();
          ls[this.siteUrl + '|reach-level'] = rl;
          this.reachLevel = rl;
        }
      } catch (e) {
        console.warn('set reach level error', e);
      }
    }
  }, {
    key: 'getShareUrl',
    value: function getShareUrl(item) {
      return this.fullscreenUrl + '/' + this.compId + '/' + this.getItemId(item) + '/' + item.idx + '/' + encodeURIComponent('?i=' + item.idx + '&p=' + this.pageId + '&s=' + this.styleId + '&rl=' + this.getReachLevel(1) + (item.hashtag ? '&ht=' + item.hashtag : ''));
    }
  }, {
    key: 'getItemId',
    value: function getItemId(item) {
      return item.id || item.photoId || item.itemId;
    }
  }, {
    key: 'shareImp',
    value: function shareImp(type, itemDto, callback) {

      function openWindow(url, source) {
        try {
          if (_baseUtils.baseUtils.isiOS() && source === 'Email') {
            window.location.href = url;
          } else {
            var windowRef = window.open(url, source + ' Share', 'height=640,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no');
            setTimeout(
            // When the mailto url opens. In some configurations the new window redirects to the configured mail client (e.g. gmail).
            // In other instances a desktop client is opened (e.g. Outlook) and the new window is blank. This tests for that situation and closes the window if it happens.
            function () {
              try {
                if (source === 'Email' && windowRef.location.hasOwnProperty('pathname') && windowRef.location.pathname === 'blank') {
                  windowRef.close();
                }
              } catch (e) {
                console.warn('Could not close mailto window');
              }
            }, 5000);
          }
        } catch (e) {
          //
        }
      }

      var item = {
        id: this.getItemId(itemDto),
        idx: itemDto.idx || 0,
        url: itemDto.sample_url && itemDto.sample_url.img,
        title: itemDto.title || itemDto.description || this.siteInfo.siteTitle,
        hashtag: itemDto.hashtag
      };

      var shareUrl = encodeURIComponent(this.getShareUrl(item));
      var shareTitle = encodeURIComponent(item.title || '');
      var shareImageUrl = encodeURIComponent(item.url);

      var shareKeywords = encodeURIComponent(this.siteInfo.siteKeywords);

      var shareMessage = encodeURIComponent('' + this.getShareUrl(item));

      if (!_lodash2.default.isFunction(callback)) {
        callback = openWindow;
      }

      switch (type) {
        case 'facebook':
          callback('http://www.facebook.com/sharer/sharer.php?u=' + shareUrl + '&t=' + shareTitle, 'Facebook');
          break;
        case 'twitter':
          {
            var twitterMaxLength = 110;
            var shareUrlExtraData = '&amp;text=' + (shareTitle === 'undefined' ? '' : shareTitle);
            if (shareUrlExtraData.length > twitterMaxLength) {
              shareUrlExtraData = shareUrlExtraData.slice(0, twitterMaxLength - 3) + '...';
            } else {
              var shareKeywordsUrlComponent = '&amp;hashtags=' + shareKeywords;
              if ((shareUrlExtraData + shareKeywordsUrlComponent).length <= twitterMaxLength) {
                shareUrlExtraData += shareKeywordsUrlComponent;
              }
            }
            callback('https://twitter.com/intent/tweet?url=' + shareUrl + shareUrlExtraData, 'Twitter');
            break;
          }
        case 'pinterest':
          callback('https://pinterest.com/pin/create/button/?url=' + shareUrl + '&media=' + shareImageUrl.replace('webp', 'jpg') + '&description=' + shareTitle, 'Pinterest');
          break;
        case 'google':
          callback('https://plus.google.com/share?url=' + shareUrl, 'Google Plus');
          break;
        case 'tumblr':
          callback('http://www.tumblr.com/share/link?url=' + shareUrl, 'Tumblr');
          break;
        case 'email':
          callback('mailto:?Subject=' + shareTitle + '&body=' + shareMessage, 'Email');
          break;
        default:
          break;
      }
    }
  }, {
    key: 'reportLoveToStats',
    value: function reportLoveToStats(photoId, value) {
      try {

        if (!this.statsProps || !this.statsProps.instance_id) {
          this.getStats();
          return;
        }

        var statsProps = _lodash2.default.merge(this.statsProps, {
          photo_id: photoId
        });

        var statsToken = this.statsToken || window.statsToken;

        var uniqueUUID = _baseUtils.baseUtils.generateUUID();

        (0, _axios2.default)({
          url: window.location.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + statsToken,
          method: 'post',
          data: {
            messageId: uniqueUUID,
            metrics: [{
              type: 'photo',
              reportMetrics: [{
                name: 'love',
                value: String(value)
              }],
              properties: statsProps
            }]
          }
        }).then(function (data) {
          console.log('Success report love', data);
        });
      } catch (e) {
        console.error('Error reporting love to stats', e);
      }
    }
  }, {
    key: 'getLoveStorageKey',
    value: function getLoveStorageKey(photoId) {
      return 'pro-gallery-item-love-' + photoId;
    }
  }, {
    key: 'isLoved',
    value: function isLoved(photoId) {
      try {
        if (typeof _baseUtils.baseUtils.getLocalStorage() === 'undefined') {
          return false;
        }
        return !!_baseUtils.baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] || false;
      } catch (e) {
        console.warn('isLoved failed', e);
      }
    }
  }, {
    key: 'toggleLove',
    value: function toggleLove(photoId, origin, forceVal) {
      try {
        if (!_baseUtils.baseUtils.getLocalStorage()) {
          return false;
        }
        var inc = void 0;
        if (this.isLoved(photoId) && forceVal !== true || forceVal === false) {
          // unlove
          _baseUtils.baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] = '';
          inc = -1;
        } else {
          //love
          _biLogger.logger.trackBi(_biLogger.logger.biEvents.love, {
            origin: origin
          });
          _baseUtils.baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] = true;
          inc = 1;
        }
        this.reportLoveToStats(photoId, inc);
      } catch (e) {
        console.warn('toggleLove failed', e);
      }
    }
  }, {
    key: 'isFirstLoveClick',
    value: function isFirstLoveClick(photoId) {
      try {
        return _baseUtils.baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] === undefined;
      } catch (e) {
        console.warn('isFirstLoveClick failed', e);
      }
    }
  }, {
    key: 'postLoveActivity',
    value: function postLoveActivity(item) {

      var postSocialTrackActivity = function postSocialTrackActivity(data) {
        try {
          var activity = {
            type: _WixSdkWrapper2.default.Activities.Type.SOCIAL_TRACK,
            info: {
              type: data.activityType,
              channel: data.activityNetwork,
              itemInfo: {
                itemUrl: data.url,
                itemId: data.id,
                itemType: data.type.toUpperCase()
              }
            },
            details: {
              additionalInfoUrl: data.url,
              summary: ''
            },
            contactUpdate: null
          };

          var onSuccess = function onSuccess(d) {
            console.log('Activity ID: ' + d.activityId + ', Contact ID: ' + d.contactId);
          };
          var onFailure = function onFailure(d) {
            console.log('Failure message:', d);
          };

          _WixSdkWrapper2.default.Activities.postActivity(activity, onSuccess, onFailure);
        } catch (e) {
          console.log('error posting activity.', e);
        }
      };
      var itemId = this.getItemId(item);
      if (this.isFirstLoveClick(itemId)) {
        postSocialTrackActivity({
          activityType: 'LOVE',
          activityNetwork: 'SITE',
          id: itemId,
          url: this.getShareUrl(item),
          type: item.type
        });
      }
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip(e, key, pos) {

      if (document.getElementsByClassName('pro-tooltip').length >= 1) {
        return;
      }

      var target = e.currentTarget;

      if (!target) {
        return;
      }

      var offset = target.getBoundingClientRect();
      var top = offset.top;
      var left = offset.left;

      var css = void 0;
      var innerWidth = void 0;
      try {
        innerWidth = window.innerWidth;
      } catch (e) {
        innerWidth = 980;
      }

      if (typeof pos === 'undefined') {
        pos = left > innerWidth / 2 ? 'right' : 'left';
      }

      switch (pos) {
        case 'top':
          css = {
            top: top - 30,
            left: left + 28,
            opacity: 1
          };
          break;
        case 'right':
          css = {
            top: top - 4,
            left: left - 20,
            opacity: 1
          };

          break;
        default:
        case 'left':
          css = {
            top: top - 4,
            left: left + 40,
            opacity: 1
          };
          break;
      }
      css['pointer-events'] = 'none';

      var div = document.createElement('div');
      div.classList.add('pro-tooltip');
      div.classList.add(pos);
      div.style = css;
      div.innerHTML = _translationUtils2.default.getByKey(key);
      document.body.appendChild(div);
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      document.body.removeChild(document.getElementsByClassName('pro-tooltip')[0]);
    }
  }, {
    key: 'toggleTooltip',
    value: function toggleTooltip(e, key, pos) {
      var hasTooltip = document.getElementsByClassName('pro-tooltip').length === 1;
      if (hasTooltip) {
        this.hideTooltip();
      } else {
        this.showTooltip(e, key, pos);
      }
    }
  }, {
    key: 'viewClassName',
    value: function viewClassName(layout, device) {
      if (layout === 'fullscreen') {
        return device === 'desktop' ? 'fullscreen-icon' : '';
      } else {
        return '';
      }
    }
  }]);
  return ItemActions;
}();

exports.default = ItemActions;
var itemActions = exports.itemActions = new ItemActions();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataItem = __webpack_require__(80);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents bi events from the "fed monitoring" source:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BiBaseDataItem = function (_DataItem) {
  _inherits(BiBaseDataItem, _DataItem);

  function BiBaseDataItem(evid, sessionId) {
    _classCallCheck(this, BiBaseDataItem);

    return _possibleConstructorReturn(this, (BiBaseDataItem.__proto__ || Object.getPrototypeOf(BiBaseDataItem)).call(this, {
      src: 72,
      evid: evid,
      session_id: sessionId, // eslint-disable-line
      _: new Date().getTime() // cache buster
    }));
  }

  return BiBaseDataItem;
}(_dataItem2.default);

exports.default = BiBaseDataItem;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(40);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(86);
var defined = __webpack_require__(55);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseUtils = undefined;

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = __webpack_require__(106);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _queryString = __webpack_require__(73);

var qs = _interopRequireWildcard(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseUtils = function () {
  /* @ngInject */
  function BaseUtils() {
    (0, _classCallCheck3.default)(this, BaseUtils);

    this._cache = {};
    this._hash2int = {};
    this._params = {};
  }

  (0, _createClass3.default)(BaseUtils, [{
    key: 'isUndefined',
    value: function isUndefined(something) {
      return typeof something === 'undefined';
    }
  }, {
    key: 'getOrPutFromCache',
    value: function getOrPutFromCache(fld, func) {
      if (this._cache[fld] !== undefined) {
        return this._cache[fld];
      }
      this._cache[fld] = func();
      return this._cache[fld];
    }
  }, {
    key: 'isDemo',
    value: function isDemo() {
      return this.parseGetParam('demo') === '1';
    }
  }, {
    key: 'isInWix',
    value: function isInWix() {
      return this.isTest() || this.getOrPutFromCache('isInWix', function () {
        try {
          return top !== self && document.location.host === 'progallery.wix.com' && document.location.search.indexOf('instance=') >= 0;
        } catch (e) {
          return false;
        }
      });
    }
  }, {
    key: 'isSemiNative',
    value: function isSemiNative() {
      try {
        return window.semiNative;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'hashToInt',
    value: function hashToInt(str, min, max) {
      var int = 0;

      if (this.isUndefined(str) || str.length === 0) {
        return int;
      }

      if (!this._hash2int[str]) {
        for (var i = 0; i < str.length; i++) {
          int += str.charCodeAt(i);
        }
        this._hash2int[str] = int;
      }

      if (this.isUndefined(min) || this.isUndefined(max)) {
        return this._hash2int[str];
      } else {
        return this._hash2int[str] % (max - min + 1) + min;
      }
    }
  }, {
    key: 'parseGetParam',
    value: function parseGetParam(val, url) {

      try {
        if (!this.isUndefined(this._params[val])) {
          return this._params[val];
        }

        var result = '',
            tmp = [];

        var _location = location;

        if (url) {
          _location = {
            search: '?' + (url.split('?')[1] || ''),
            pathname: (url.split('?')[0] || '').split('/')[1] || ''
          };
        }

        _location.search
        //.replace ( "?", "" )
        // this is better, there might be a question mark inside
        .substr(1).split('&').forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });

        if (!result) {

          //if the param was not found in the search, try decoding the path
          var query = decodeURIComponent(_location.pathname).split('?')[1];
          if (!query) {
            return '';
          }

          query.split('&').forEach(function (item) {
            tmp = item.split('=');
            if (tmp[0] === val) {
              result = decodeURIComponent(tmp[1]);
            }
          });
        }

        this._params[val] = result;

        return result;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'parsePathParam',
    value: function parsePathParam(val) {
      var path = location.pathname;
      var pathArr = path.split('/');
      for (var i = 0; i < pathArr.length; i++) {
        var param = pathArr[i];
        if (param.indexOf(val) >= 0) {
          return param;
        }
      }
      return '';
    }
  }, {
    key: 'parseHashParam',
    value: function parseHashParam(val) {
      var result = '';
      var tmp = [];
      var hashPart = location.href.split('#')[1] || '';

      if (!hashPart) {
        return '';
      }

      hashPart
      //.replace ( "?", "" )
      // this is better, there might be a question mark inside
      .substr(1).split('&').forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === val) {
          result = decodeURIComponent(tmp[1]);
        }
      });
      return result;
    }
  }, {
    key: 'stripSlashes',
    value: function stripSlashes(str) {
      var newStr = '';
      if (typeof str === 'string') {
        newStr = str.replace(/\\\//g, '/').replace(/\\'/g, '\'').replace(/\\"/g, '"').replace(/\\0/g, '\0').replace(/\\\\/g, '\\');
      }
      return newStr;
    }
  }, {
    key: 'parseStringObject',
    value: function parseStringObject(sObj) {
      if (typeof sObj !== 'string') {
        return sObj;
      }

      var stripedObj = this.stripSlashes(sObj);
      if (typeof sObj === 'string' && /^[\],:{}\s]*$/.test(stripedObj.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        //this is a json
        try {
          return JSON.parse(stripedObj);
        } catch (e) {
          // console.error('Parse object error: Catched ', e);
        }
      }
      return stripedObj;
    }
  }, {
    key: 'isWixMobile',
    value: function isWixMobile() {
      var _this = this;

      var _isWixMobile = function _isWixMobile() {
        var deviceType = _this.parseGetParam('deviceType');
        if (deviceType) {
          return String(deviceType).indexOf('mobile') >= 0;
        } else {
          return undefined;
        }
      };

      if (!this.isSite()) {
        return _isWixMobile();
      } else {
        return this.getOrPutFromCache('isWixMobile', _isWixMobile);
      }
    }
  }, {
    key: 'isUserAgentMobile',
    value: function isUserAgentMobile() {

      try {
        var _isUserAgentMobile = function _isUserAgentMobile() {
          var check = false;
          (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|pixel|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
              check = true;
            }
          })(navigator.userAgent || navigator.vendor || window.opera);
          return check;
        };

        if (!this.isSite()) {
          return _isUserAgentMobile();
        } else {
          return this.getOrPutFromCache('isUserAgentMobile', _isUserAgentMobile);
        }
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isMobile',
    value: function isMobile() {
      var _this2 = this;

      var _isMobile = function _isMobile() {
        var isWixMobile = _this2.isWixMobile();
        var isUserAgentMobile = _this2.isUserAgentMobile();

        return _this2.isUndefined(isWixMobile) ? isUserAgentMobile : isWixMobile;
      };

      if (this.isTest()) {
        return false;
      } else if (!this.isSite()) {
        return _isMobile();
      } else {
        return this.getOrPutFromCache('isMobile', _isMobile);
      }
    }
  }, {
    key: 'isTest',
    value: function isTest() {
      try {
        return window.isTest;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isDev',
    value: function isDev() {

      var isDev = this.isLocal();

      if (!this.isUndefined(this._cache.isDev)) {
        return this._cache.isDev;
      }

      isDev = isDev || this.shouldDebug('ph_local');
      isDev = isDev || this.parseGetParam('debug') === 'true';
      isDev = isDev || (this.safeLocalStorage() || {}).forceDevMode === 'true';
      this._cache.isDev = isDev;
      return isDev;
    }
  }, {
    key: 'isVerbose',
    value: function isVerbose() {
      return !this.isTest() && (this.safeLocalStorage() || {}).forceDevMode === 'true';
    }
  }, {
    key: 'isLocal',
    value: function isLocal() {
      var ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}:[0-9]{1,5}/; //matches 111.222.333.444:9999

      if (!this.isUndefined(this._cache.isLocal)) {
        return this._cache.isLocal;
      }
      var host = window.location.hostname;
      var isLocal = host === 'local.wix.com' || host === '0.0.0.0' || host.indexOf('localhost') >= 0 || ipRegex.exec(host) !== null;
      this._cache.isLocal = isLocal;
      return isLocal;
    }
  }, {
    key: 'isStoreGallery',
    value: function isStoreGallery() {
      var _this3 = this;

      return this.getOrPutFromCache('isStoreGallery', function () {
        if (_this3.isSemiNative()) {
          return false;
        }

        try {
          return window.location.search.toLowerCase().indexOf('isstore') > -1;
        } catch (e) {
          if (_this3.isDev()) {
            console.error('cant find window', e);
          }
          return false;
        }
      });
    }
  }, {
    key: 'isDemoMode',
    value: function isDemoMode() {
      return _WixSdkWrapper2.default && _WixSdkWrapper2.default.Utils && _WixSdkWrapper2.default.Utils.getInstanceValue && _WixSdkWrapper2.default.Utils.getInstanceValue('demoMode');
    }
  }, {
    key: 'updateViewMode',
    value: function updateViewMode() {
      //NOTICE: this method must be called after each EDIT_MODE_CHANGED event to clear the cache
      try {
        if (window && window.Wix && window.Wix.Utils && window.Wix.Utils.getViewMode) {
          this._cache.viewMode = window.Wix.Utils.getViewMode();
          return this._cache.viewMode;
        }
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getViewModeFromCache',
    value: function getViewModeFromCache() {
      return this.getOrPutFromCache('viewMode', function () {
        try {
          return window && window.Wix && window.Wix.Utils && window.Wix.Utils.getViewMode();
        } catch (e) {
          return false;
        }
      });
    }
  }, {
    key: 'isEditor',
    value: function isEditor() {
      if (!this.isInWix()) {
        return false;
      }
      return this.getViewModeFromCache() === 'editor';
    }
  }, {
    key: 'isPreview',
    value: function isPreview() {
      if (!this.isInWix()) {
        return false;
      }
      return this.getViewModeFromCache() === 'preview';
    }
  }, {
    key: 'isSite',
    value: function isSite() {
      return !this.isEditor() && !this.isPreview();
    }
  }, {
    key: 'getUUID',
    value: function getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: 'generateUUID',
    value: function generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.floor(Math.random() * 16) || 0;
        return c === 'x' ? r.toString(16) : c;
      });
    }
  }, {
    key: 'isInSettings',
    value: function isInSettings() {
      return this.parseGetParam('expandsettingsmode') === '1';
    }
  }, {
    key: 'isExternalUrl',
    value: function isExternalUrl(url) {
      return (/(^https?)|(^data)|(^blob)/.test(url)
      );
    }
  }, {
    key: 'isMobileViewer',
    value: function isMobileViewer() {
      if (this.isSite() && !this.isUndefined(this._cache.isMobileViewer)) {
        return this._cache.isMobileViewer;
      }

      var isWixMobile = this.isWixMobile();
      var isUserAgentMobile = this.isUserAgentMobile();

      this._cache.isMobileViewer = isWixMobile && !isUserAgentMobile;
      return this._cache.isMobileViewer;
    }
  }, {
    key: 'isiOS',
    value: function isiOS() {
      return this.getOrPutFromCache('isiOS', function () {
        try {
          return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
          );
        } catch (e) {
          return false;
        }
      });
    }
  }, {
    key: 'isiPhone',
    value: function isiPhone() {
      return this.getOrPutFromCache('isiPhone', function () {
        try {
          return (/iPhone/.test(navigator.userAgent) && !window.MSStream
          );
        } catch (e) {
          return false;
        }
      });
    }
  }, {
    key: 'isTouch',
    value: function isTouch() {
      var _this4 = this;

      return this.getOrPutFromCache('isTouch', function () {
        try {
          return _this4.isMobile() || 'ontouchstart' in document.documentElement;
        } catch (e) {
          return false;
        }
      });
    }
  }, {
    key: 'browserIs',
    value: function browserIs(browserName) {

      var browsers = {
        chrome: false,
        chromeIos: false,
        explorer: false,
        firefox: false,
        safari: false,
        opera: false
      };

      try {
        if (this.isUndefined(this._cache.browsers)) {

          browsers.chrome = navigator.userAgent.indexOf('Chrome') > -1;
          browsers.chromeIos = navigator.userAgent.indexOf('CriOS') > -1;
          browsers.explorer = navigator.userAgent.indexOf('MSIE') > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./); // support for edge
          browsers.firefox = navigator.userAgent.indexOf('Firefox') > -1;
          browsers.safari = navigator.userAgent.indexOf('Safari') > -1;
          browsers.opera = navigator.userAgent.toLowerCase().indexOf('op') > -1;

          if (browsers.chrome && browsers.safari) {
            browsers.safari = false;
          }

          if (browsers.chrome && browsers.opera) {
            browsers.chrome = false;
          }

          this._cache.browsers = browsers;
        }

        return this._cache.browsers[browserName];
      } catch (e) {
        this._cache.browsers = browsers;
        return false;
      }
    }
  }, {
    key: 'isPlayground',
    value: function isPlayground() {
      if (this.isInWix()) {
        return false;
      }

      try {
        var isPlayground = false;
        try {
          isPlayground = top.location.href.indexOf('playground.html') > 0;
        } catch (e) {
          isPlayground = false;
        }

        return isPlayground;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isInAlbumsBuilder',
    value: function isInAlbumsBuilder() {
      if (!this.isInWix()) {
        return false;
      }
      try {
        return window && window.debugApp && window.debugApp.indexOf('ph_source_albums') > -1;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isWixDomain',
    value: function isWixDomain() {
      try {
        return window.location.href.indexOf('wix.com') >= 0;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isLandscape',
    value: function isLandscape() {
      if (this.isSemiNative()) {
        return false;
      }
      if (!this.isUndefined(this._cache.isLandscape)) {
        return this._cache.isLandscape;
      }
      if (!this.isMobile()) {
        this._cache.isLandscape = false;
      }
      try {
        if (!this.isUndefined(window.orientation)) {
          this._cache.isLandscape = window.orientation === 90 || window.orientation === -90;
        } else {
          var mql = window.matchMedia('(orientation: landscape)');
          if (mql && mql.matches === true) {
            this._cache.isLandscape = true;
          } else {
            this._cache.isLandscape = false;
          }
        }
      } catch (e) {
        this._cache.isLandscape = false;
      }
      return this._cache.isLandscape;
    }
  }, {
    key: 'isOnBoarding',
    value: function isOnBoarding() {
      try {
        var params = qs.parse(window.location.search);
        return params.viewMode && params.viewMode.toLowerCase() === 'onboarding';
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isAccessibilityEnabled',
    value: function isAccessibilityEnabled() {
      var _this5 = this;

      if (typeof this._cache.isAccessibilityEnabled !== 'undefined') {
        return this._cache.isAccessibilityEnabled;
      }

      if (!this.isSite()) {
        return false;
      }

      var isDevAccessibility = this.shouldDebug('accessibility');

      if (_WixSdkWrapper2.default && typeof _WixSdkWrapper2.default.isVisualFocusEnabled === 'function') {
        try {
          _WixSdkWrapper2.default.isVisualFocusEnabled(function (isIt) {
            _this5._cache.isAccessibilityEnabled = isIt || isDevAccessibility;
          });
        } catch (e) {
          //
        }
      }

      // return false;
      return isDevAccessibility;
    }
  }, {
    key: 'isDebugBuild',
    value: function isDebugBuild() {
      try {
        return "production" === 'development';
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getDeviceType',
    value: function getDeviceType() {
      return this.isWixMobile() ? 'mobile' : 'desktop';
    }
  }, {
    key: 'safeLocalStorage',
    value: function safeLocalStorage() {
      try {
        return localStorage;
      } catch (e) {
        return window;
      }
    }
  }, {
    key: 'shouldDebug',
    value: function shouldDebug(str) {
      try {
        return !!this.safeLocalStorage()[str] || (window.debugApp || '').indexOf(str) >= 0 || (this.parseGetParam('debugApp') || '').indexOf(str) >= 0;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'shouldLog',
    value: function shouldLog(str) {
      return this.shouldDebug('ph_log_' + str);
    }
  }, {
    key: 'getDateCreatedTicksFromStr',
    value: function getDateCreatedTicksFromStr(dateCreatedStr) {
      var isDateCreatedValid = isNaN(Date.parse(dateCreatedStr)) === false;
      if (isDateCreatedValid) {
        return Date.parse(dateCreatedStr);
      }
      return -8640000000000000;
    }
  }, {
    key: 'deviceHasMemoryIssues',
    value: function deviceHasMemoryIssues() {
      return this.isiOS();
    }
  }, {
    key: 'getUrlPrefix',
    value: function getUrlPrefix(forceProduction) {
      try {
        return window.location.protocol + '//' + (!forceProduction && this.isLocal() ? 'local.wix.com:3001' : 'progallery.wix.com') + '/';
      } catch (e) {
        return 'http://progallery.wix.com/';
      }
    }
  }, {
    key: 'getFullscreenSectionId',
    value: function getFullscreenSectionId() {
      var isStore = this.isStoreGallery();
      return isStore ? 'fullscreen_store_page' : 'fullscreen_page';
    }
  }, {
    key: 'getApiUrlPrefix',
    value: function getApiUrlPrefix() {
      return this.getUrlPrefix(true) + 'api/v1/';
    }
  }, {
    key: 'generateUrl',
    value: function generateUrl(endpointFile, params) {
      params = params || {};
      var isStore = this.isStoreGallery();
      var url = this.getUrlPrefix() + endpointFile;

      if (isStore) {
        params.isStore = true;
      }

      var paramsStr = qs.stringify(params);

      return paramsStr ? url + '?' + paramsStr : url;
    }
  }, {
    key: 'getManageMediaUrl',
    value: function getManageMediaUrl() {
      return this.generateUrl('photos.html');
    }
  }, {
    key: 'getExpandSettingsUrl',
    value: function getExpandSettingsUrl(params) {
      return this.generateUrl('settings-expand.html', params);
    }
  }, {
    key: 'getSettingsWatermarkDisableUrl',
    value: function getSettingsWatermarkDisableUrl() {
      return this.generateUrl('settings-watermark-disable.html');
    }
  }, {
    key: 'getSettingsAddonsUrl',
    value: function getSettingsAddonsUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.generateUrl('settings-addons.html', params);
    }
  }, {
    key: 'getProviderModalUrl',
    value: function getProviderModalUrl() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.generateUrl('provider-modal.html', params);
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex(elementName) {
      var elementsArr = ['currentGalleryItem', 'loadMoreButton', 'slideshowNext', 'slideshowPrev', 'currentThumbnail', 'slideshowLove', 'slideshowShare', 'cartIcon', 'cartClose', 'cartFrame', 'fullscreenClose', 'fullscreenNext', 'fullscreenPrev', 'fullscreenInfo',
      // 'fullscreenTitle',
      // 'fullscreenDesc',
      'fullscreenLink', 'fullscreenProvider', 'fullscreenCartButton', 'fullscreenCheckout', 'fullscreenExpand', 'fullscreenVideoPlay', 'fullscreenVideoBar', 'fullscreenVideoMute', 'fullscreenVideoVolume', 'fullscreenCartIcon', 'fullscreenDownload', 'fullscreenLove', 'fullscreenShare'];

      var elementIdx = elementsArr.indexOf(elementName) + 1;
      return elementIdx || -1; //no tabIndex (tab will not focus on this item)
    }
  }, {
    key: 'safeSessionStorage',
    value: function safeSessionStorage() {
      try {
        return sessionStorage;
      } catch (e) {
        return window || {};
      }
    }
  }, {
    key: 'getLocalStorage',
    value: function getLocalStorage() {
      if (this.isDev()) {
        return this.safeSessionStorage();
      } else {
        var _localStorage = this.safeLocalStorage();
        return _localStorage || this.safeSessionStorage();
      }
    }
  }, {
    key: 'setStateAndLog',
    value: function setStateAndLog(that, caller, state, callback) {
      var _this6 = this;

      if (this.isVerbose()) {
        console.log('State Change Called (' + caller + ')', state);
        var oldState = _lodash2.default.clone(that.state);
        that.setState(state, function () {
          var newState = _lodash2.default.clone(that.state);
          var change = _this6.printableObjectsDiff(oldState, newState, 'state');
          if (_lodash2.default.keys(change).length > 0) {
            console.log('State Change Completed (' + caller + ')', change);
          }
          if (_lodash2.default.isFunction(callback)) {
            callback.bind(that)();
          }
        });
      } else {
        that.setState(state, function () {
          if (_lodash2.default.isFunction(callback)) {
            callback.bind(that)();
          }
        });
      }
    }
  }, {
    key: 'printableObjectsDiff',
    value: function printableObjectsDiff(obj1, obj2) {
      var _this7 = this;

      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


      var _toString = function _toString(v) {
        if (v === '') {
          v = '\'\'';
        } else if (_this7.isUndefined(v)) {
          v = 'undefined';
        }
        return _lodash2.default.toString(v);
      };

      var getInnerDiff = function getInnerDiff(obj1, obj2, prefix) {
        var innerDiff = _lodash2.default.reduce(obj1, function (res, v, k) {
          if (!_lodash2.default.isEqual(v, obj2[k])) {
            if (_lodash2.default.isArray(obj2[k])) {
              if (v.length !== obj2[k].length) {
                res[k + '.length'] = '[' + v.length + '] => [' + obj2[k].length + ']';
              }
              res = _lodash2.default.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
            } else if (_lodash2.default.isObject(obj2[k])) {
              res = _lodash2.default.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
            } else {
              res[(prefix ? prefix + '.' : '') + k] = _toString(v) + ' => ' + _toString(obj2[k]);
            }
          }
          return res;
        }, {});
        return innerDiff;
      };

      return getInnerDiff(obj1, obj2, prefix);
    }
  }, {
    key: 'getUrlParam',
    value: function getUrlParam(name) {
      try {
        (window.location.search.replace('?', '').split('&').filter(function (queryParam) {
          return queryParam.indexOf('=') !== -1;
        }).map(function (queryParam) {
          var _queryParam$split = queryParam.split('='),
              _queryParam$split2 = (0, _slicedToArray3.default)(_queryParam$split, 2),
              key = _queryParam$split2[0],
              value = _queryParam$split2[1];

          return { key: key, value: value };
        }).filter(function (pair) {
          return pair.key === name;
        }).shift() || { value: '' }).value;
      } catch (e) {
        return '';
      }
    }
  }, {
    key: 'isMacOs',
    value: function isMacOs() {
      try {
        window.source === 'mac-os' || this.getUrlParam('macos') === 'true';
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'setExternalId',
    value: function setExternalId() {
      try {
        var uuid = this.getUUID();
        this._setExternalId(uuid);
        setTimeout(this._setExternalId.bind(this), 4000, uuid); //try setting external id again. There is a bug that it is not set sometimes.
      } catch (e) {
        console.error('Utils setExternalId - fail');
        return false;
      }
    }
  }, {
    key: '_setExternalId',
    value: function _setExternalId(id) {
      var _this8 = this;

      _WixSdkWrapper2.default.Settings.setExternalId(id, function (success) {
        _this8.isDev() && console.log('Utils setExternalId - success', id, success);
      }, function (error) {
        console.error('Utils setExternalId - fail', id, error);
      });
    }
  }, {
    key: 'isWebpSupported',
    value: function isWebpSupported() {
      if (this.isTest()) {
        return false;
      }
      try {
        var canvas = (typeof document === 'undefined' ? 'undefined' : (0, _typeof3.default)(document)) === 'object' ? document.createElement('canvas') : {};
        canvas.width = canvas.height = 1;
        return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
      } catch (e) {
        return false;
      }
    }
  }]);
  return BaseUtils;
}();

exports.default = BaseUtils;
var baseUtils = exports.baseUtils = new BaseUtils(); // for inner use

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = undefined;

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _wixBiLogger = __webpack_require__(259);

var W = _interopRequireWildcard(_wixBiLogger);

var _baseUtils = __webpack_require__(28);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _iframeAppBiContext = __webpack_require__(263);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

var omitEmails = function omitEmails(obj, str) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      obj[key] = obj[key].replace(emailRegex, str);
    }
  }
};

var BiLogger = function () {

  /* @ngInject */
  function BiLogger(wixBiArgs) {
    (0, _classCallCheck3.default)(this, BiLogger);

    this.needsGalleryType = function (evid) {
      return [401, 403, 406, 500, 501, 502, 700, 703, 704].indexOf(evid) > -1;
    };
    this.initVisitorId();
    // predefine events
    this.biLogger = W && W.BI ? new W.BI.Logger(wixBiArgs) : false;

    try {
      this.protocol = window.location.protocol;
      this.performance = window.performance;
    } catch (e) {
      this.protocol = 'http:';
      this.performance = false;
    }

    this.biEvents = {
      store_banner_clicked: {
        evid: 182
      },
      add_pro_gallery: {
        evid: 400
      },
      change_settings: {
        evid: 401
      },
      mange_media_upper_panel_open: {
        evid: 402
      },
      pro_gallery_settings_load: {
        evid: 403
      },
      manage_media_set: {
        evid: 404
      },
      manage_media_text_editor_customize: {
        evid: 405
      },
      upload_media: {
        evid: 406
      },
      upload_media_error: {
        evid: 407
      },
      remove_media_from_gallery: {
        evid: 408
      },
      layouts_select: {
        evid: 409
      },
      gallery_performance: {
        evid: 410
      },
      settings_tab_navigation: {
        evid: 411
      },
      // choose_provider: {
      //   evid: 420
      // },
      // activate_store_click: {
      //   evid: 421
      // },
      // media_sell_wizard_started: {
      //   evid: 422
      // },
      // set_pricing: {
      //   evid: 423
      // },
      // set_pricing_add_product_click: {
      //   evid: 424
      // },
      // set_pricing_ass_product_success: {
      //   evid: 425
      // },
      // manage_store_connect_paypal_success: {
      //   evid: 426
      // },
      // manage_store_connect_paypal_error: {
      //   evid: 427
      // },
      // manage_store_stats_click: {
      //   evid: 428
      // },
      // manage_store_my_profile_set: {
      //   evid: 429
      // },
      share: {
        evid: 500
      },
      love: {
        evid: 501
      },
      download: {
        evid: 502
      },
      info: {
        evid: 503
      },
      expand: {
        evid: 504
      },
      payment_excepted: {
        evid: 506
      },
      payment_error: {
        evid: 507
      },
      pro_gallery_load_error: {
        evid: 509
      },
      pro_gallery_loaded: {
        evid: 510
      },
      pro_gallery_error: {
        evid: 512
      },
      pro_gallery_load_users: {
        evid: 177
      },
      pro_gallery_load_uou: {
        evid: 304
      },
      select_photo: {
        evid: 600
      },
      share_group: {
        evid: 601
      },
      log_reach_level: {
        evid: 602
      },
      manageMediaClick: {
        evid: 700
      },
      storeSetUpTab: {
        evid: 702
      },
      expandSettings: {
        evid: 703
      },
      expandSettingsDone: {
        evid: 704
      },
      watermarkSettings: {
        evid: 705
      },
      watermarkEnable: {
        evid: 706
      },
      cartSettings: {
        evid: 708
      },
      cartSettingsDesignTab: {
        evid: 709
      },
      openStoreDashboard: {
        evid: 727
      },
      saveBusinessInfo: {
        evid: 728
      },
      artStore_startNow: {
        evid: 729
      },
      artStore_chooseSellingMethod: {
        evid: 730
      },
      buyNowClick: {
        evid: 800
      }
    };
  }

  (0, _createClass3.default)(BiLogger, [{
    key: 'getGalleryType',
    value: function getGalleryType() {
      return _baseUtils.baseUtils.isStoreGallery() ? 'store' : 'progallery';
    }
  }, {
    key: 'track',
    value: function track(eventName, params, callback) {
      var biEvent = this.biEvents[eventName];
      if (!biEvent) {
        console.error('TRACK EVENT ERROR - No such bi event ' + eventName);
        return false;
      } else {
        return this.trackBi(biEvent, params, callback);
      }
    }
  }, {
    key: 'trackBi',
    value: function trackBi(biEvent) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments[2];

      if (!biEvent) {
        console.error('TRACK EVENT ERROR - No such bi event');
        return false;
      }

      if (!this.biParams) {
        var biContext = {};
        if (!_baseUtils.baseUtils.isTest()) {
          try {
            biContext = (0, _iframeAppBiContext.getBiContext)(_WixSdkWrapper2.default);
          } catch (e) {
            console.error('getBiContext:', e);
          }
        }
        this.biParams = (0, _assign2.default)({}, biContext, {
          gallery_id: this.getParam('galleryId'),
          src: 65 //predefined wix-albums source
        });
      }

      var evid = biEvent.evid;
      if (evid === 404) {
        omitEmails(params, '-omitted email-');
      }

      if (this.isUserOfUserEvent(evid) && _baseUtils.baseUtils.getViewModeFromCache() !== 'site') {
        return;
      }

      if (this.needsGalleryType(evid)) {
        params.galleryType = this.getGalleryType();
      }

      try {
        var defParams = biEvent.defaultParams || {};
        var logData = (0, _assign2.default)({}, defParams, params, this.biParams);
        this.biLog(evid, logData, callback);
      } catch (e) {
        console.warn('BI LOGGER ERROR!', e);
      }
    }
  }, {
    key: 'stats',
    value: function stats(stats_token, instance_id, album_id, action) {
      var value = 1;
      if (action === 'unlove') {
        value = -1;
        action = 'love';
      }

      var uniqueUUID = _baseUtils.baseUtils.generateUUID();

      (0, _axios2.default)({
        url: this.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + stats_token,
        method: 'post',
        data: {
          messageId: uniqueUUID,
          metrics: [{
            type: 'album',
            reportMetrics: [{
              name: action,
              value: value
            }],
            properties: {
              instance_id: instance_id,
              album_id: album_id
            }
          }]
        }
      }).then(function (data) {
        console.log('yeeee', data);
      });
    }
  }, {
    key: 'biLog',
    value: function biLog(evid, params, callback) {

      if (_baseUtils.baseUtils.isDev() || _baseUtils.baseUtils.isTest()) {
        return;
      }

      if (!this.biLogger) {
        console.warn('no biLogger, cannot log event');
        return;
      }
      if (typeof evid === 'undefined') {
        console.warn('evid is missing, cannot log event', evid, params);
        return;
      }
      if (typeof params === 'undefined') {
        console.warn('params are missing, cannot log event', evid, params);
        return;
      }

      var logData = (0, _assign2.default)({ evid: evid }, params);

      var adapter = this.getAdapter(evid);
      if (adapter !== null) {
        (0, _assign2.default)(logData, { adapter: adapter });
      }
      this.biLogger.log(logData, callback);
    }
  }, {
    key: 'isBot',
    value: function isBot() {
      return (/bot|googlebot|crawler|spider|robot|crawling|bing/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'trackLoadBi',
    value: function trackLoadBi(endpoint) {
      var _this = this;

      var eventType = _baseUtils.baseUtils.getViewModeFromCache() === 'site' ? this.biEvents.pro_gallery_load_uou : this.biEvents.pro_gallery_load_users;
      try {
        if (!this.isBot()) {
          if (eventType === this.biEvents.pro_gallery_load_users || this.visitorId) {
            var loading_time = this.performance ? this.performance.timing.domContentLoadedEventEnd - this.performance.timing.navigationStart : null;
            this.trackBi(eventType, { endpoint: endpoint, loading_time: loading_time });
          } else {
            this.onInitVisitorId = function () {
              return _this.trackLoadBi(endpoint);
            };
          }
        }
      } catch (e) {
        console.error('track load event error', e);
      }
    }
  }, {
    key: 'initBiLoadedEventListener',
    value: function initBiLoadedEventListener(endpoint) {
      var _this2 = this;

      try {
        window.addEventListener('load', function () {
          _this2.trackLoadBi(endpoint);
        });
      } catch (e) {
        //
      }
    }
  }, {
    key: 'initVisitorId',
    value: function initVisitorId() {
      var _this3 = this;

      if (_baseUtils.baseUtils.getViewModeFromCache() !== 'site') {
        return;
      }
      if (typeof _promise2.default === 'undefined') {
        console.error('promise is undefined in initVisitorId. Cant init visitor id');
        return;
      }
      var timeOut = 9000;
      var beginTime = Date.now();
      // const sessionTokenToVisitorId = s => [[0, 8], [8, 12], [12, 16], [16, 20], [20, 32]].map(i => s.slice(...i)).join('-');	
      // new Promise(resolve => Wix.Activities.getUserSessionToken(resolve))	
      //   .then(sessionTokenToVisitorId)	
      //   .then(val => {	
      new _promise2.default(function (resolve) {
        return resolve(_WixSdkWrapper2.default.Utils.getInstanceValue('aid') || _WixSdkWrapper2.default.Utils.getInstanceValue('uid'));
      }).then(function (val) {
        _this3.visitorId = val;
        _this3.onInitVisitorId && _this3.onInitVisitorId();
        var interval = Date.now() - beginTime;
        if (interval > timeOut) {
          console.error('took over ' + timeOut + 'ms to get the visitor id', interval + 'ms');
        }
      }).catch(function (err) {
        return console.error('cant get visitorID/sessionToken', err);
      });
      setTimeout(function () {
        if (!_this3.visitorId) {
          console.error('waiting ' + timeOut + 'ms for visitorID/sessionToken');
        }
      }, timeOut);
    }
  }, {
    key: 'isInRange',
    value: function isInRange(val, min, max) {
      return val >= min && val < max;
    }
  }, {
    key: 'isUserEvent',
    value: function isUserEvent(evid) {
      return !this.isUserOfUserEvent(evid);
    }
  }, {
    key: 'isUserOfUserEvent',
    value: function isUserOfUserEvent(evid) {
      return this.isInRange(evid, 500, 605) || evid === 304 || evid === 800;
    }
  }, {
    key: 'getAdapter',
    value: function getAdapter(evid) {
      var adapter = void 0;
      if (this.isUserEvent(evid)) {
        adapter = 'photo-users';
      } else if (this.isUserOfUserEvent(evid)) {
        adapter = 'photo-ugc';
      } else {
        console.error('evid', evid, 'is not user, or uou event (???)');
      }
      return adapter;
    }
  }, {
    key: 'getParam',
    value: function getParam(val) {
      var vmDefaultStringRegex = /^\$\{.*\}$/; //e.g. "${instance}" or "${some_variable}"
      var windowVal = String(window[val]);

      if (windowVal && vmDefaultStringRegex.exec(windowVal) === null) {
        return windowVal;
      } else {
        var result = '',
            tmp = [];
        location.search
        //.replace ( "?", "" )
        // this is better, there might be a question mark inside
        .substr(1).split('&').forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });
        return result;
      }
    }
  }]);
  return BiLogger;
}();

var wixBiArgs = {
  defaultEventArgs: {},
  defaultErrorArgs: {},
  adapter: 'photo-users'
};

var logger = exports.logger = new BiLogger(wixBiArgs);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_30__;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(85);
var enumBugKeys = __webpack_require__(60);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(55);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(155)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(90)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 38 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _layouter = __webpack_require__(132);

var _layouter2 = _interopRequireDefault(_layouter);

var _item = __webpack_require__(133);

var _group = __webpack_require__(134);

var _createLayout = __webpack_require__(291);

var _createLayout2 = _interopRequireDefault(_createLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Layouter: _layouter2.default,
  Group: _group.Group,
  Item: _item.Item,
  createLayout: _createLayout2.default
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(21);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158);
var global = __webpack_require__(11);
var hide = __webpack_require__(20);
var Iterators = __webpack_require__(27);
var TO_STRING_TAG = __webpack_require__(12)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(212), __esModule: true };

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initWixData = initWixData;
exports.navigationIn = navigationIn;
exports.videoPlayModeChanged = videoPlayModeChanged;
exports.videoEnded = videoEnded;
exports.videoAdded = videoAdded;
exports.videoRemoved = videoRemoved;
exports.galleryWindowLayoutChanged = galleryWindowLayoutChanged;
exports.editorModeChanged = editorModeChanged;
exports.toggleHoverPreview = toggleHoverPreview;

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _galleryTypes = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initWixData() {
  if (_index2.default.isInWix() && !_index2.default.isDemo()) {
    return function (dispatch) {
      _WixSdkWrapper2.default.getBoundingRectAndOffsets(function (res) {
        dispatch({
          type: _galleryTypes.SET_WIX_DATA,
          boundingRectAndOffsets: res
        });
      });
    };
  } else {
    return {
      type: _galleryTypes.SET_WIX_DATA
    };
  }
}

// export function setItems(items) {
//     return {
//         items: items,
//         type: SET_ITEMS
//     }
// }
//
//
// export function setRenderedItemsCount(count) {
//     return {
//         count: count,
//         type: SET_RENDERED_ITEMS_COUNT
//     }
// }

function navigationIn() {
  return {
    type: _galleryTypes.NAVIGATION_IN
  };
}

function videoPlayModeChanged(videoPlayMode) {
  return {
    videoPlayMode: videoPlayMode,
    type: _galleryTypes.VIDEO_PLAY_MODE
  };
}

function videoEnded(idx) {
  return {
    type: _galleryTypes.VIDEO_ENDED
  };
}

function videoAdded(videoData) {
  return {
    payload: videoData,
    type: _galleryTypes.VIDEO_ADDED
  };
}

function videoRemoved(index) {
  return {
    type: _galleryTypes.VIDEO_REMOVED,
    payload: index
  };
}

function galleryWindowLayoutChanged(_ref) {
  var documentHeight = _ref.documentHeight;

  return {
    documentHeight: documentHeight,
    type: _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED
  };
}

function editorModeChanged() {
  return {
    type: _galleryTypes.EDITOR_MODE_CHANGED
  };
}

function toggleHoverPreview(toggle) {
  return {
    type: _galleryTypes.TOGGLE_HOVER_PREVIEW,
    toggle: toggle
  };
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _BasePlayer2 = __webpack_require__(78);

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|ogg|spx)($|\?)/i;

var FilePlayer = function (_BasePlayer) {
  _inherits(FilePlayer, _BasePlayer);

  function FilePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onPause = _props.onPause,
          onEnded = _props.onEnded,
          onError = _props.onError;

      this.player.addEventListener('canplay', this.onReady);
      this.player.addEventListener('play', this.onPlay);
      this.player.addEventListener('pause', function () {
        if (_this2.mounted) {
          onPause();
        }
      });
      this.player.addEventListener('ended', onEnded);
      this.player.addEventListener('error', onError);
      this.player.setAttribute('webkit-playsinline', '');
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props,
          onPause = _props2.onPause,
          onEnded = _props2.onEnded,
          onError = _props2.onError;

      this.player.removeEventListener('canplay', this.onReady);
      this.player.removeEventListener('play', this.onPlay);
      this.player.removeEventListener('pause', onPause);
      this.player.removeEventListener('ended', onEnded);
      this.player.removeEventListener('error', onError);
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'load',
    value: function load(url) {
      this.player.src = url;
    }
  }, {
    key: 'play',
    value: function play() {
      this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.player.removeAttribute('src');
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
      this.player.currentTime = this.getDuration() * fraction;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady) return null;
      return this.player.currentTime / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || this.player.buffered.length === 0) return null;
      return this.player.buffered.end(0) / this.getDuration();
    }
  }, {
    key: 'stopBuffering',
    value: function stopBuffering() {
      var _this3 = this;

      this.player.pause();
      var time = this.player.currentTime;

      var setTime = function setTime() {
        _this3.player.currentTime = time;
        _this3.player.removeEventListener('loadedmetadata', setTime);
      };
      this.player.addEventListener('loadedmetadata', setTime);
      this.player.load();
      try {
        setTime(); // if it can't set player.currentTime, it will run in the event listener.
      } catch (e) {}
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          url = _props3.url,
          loop = _props3.loop,
          controls = _props3.controls,
          fileConfig = _props3.fileConfig;

      var Media = AUDIO_EXTENSIONS.test(url) ? 'audio' : 'video';
      var style = {
        width: '100%',
        height: '100%',
        display: url ? 'block' : 'none'
      };
      return _react2['default'].createElement(Media, _extends({
        ref: this.ref,
        style: style,
        preload: 'auto',
        controls: controls,
        loop: loop
      }, fileConfig.attributes));
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return true;
    }
  }]);

  return FilePlayer;
}(_BasePlayer3['default']);

FilePlayer.displayName = 'FilePlayer';
exports['default'] = FilePlayer;
module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var placements = {
  SHOW_ON_HOVER: 'SHOW_ON_HOVER',
  SHOW_ALWAYS: 'SHOW_ALWAYS',
  DONT_SHOW: 'DONT_SHOW'
};

var dimensions = {
  SIDE_BAR_WIDTH: 430,
  STORE_SIDE_BAR_WIDTH: 560,
  MOBILE_PADDING: 120,
  NO_PADDING: 0
};

exports.default = {
  placements: placements,
  dimensions: dimensions
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _location = __webpack_require__(126);

var _location2 = _interopRequireDefault(_location);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * window.performance wrappers
 */
exports.default = {
  getNavigation: function getNavigation() {
    return window && window.performance ? window.performance.navigation : {};
  },


  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];
    try {
      return window && window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return window && window.performance ? window.performance.timing : {};
  },


  /**
   * Duration relative to navigation start (window.performance.timing.navigationStart)
   */
  now: function now() {
    return window && window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    if (_location2.default.isFedopsDev()) {
      window && window.performance && window.performance.mark && window.performance.mark(name);
    }
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    if (_location2.default.isFedopsDev()) {
      window && window.performance && window.performance.measure && window.performance.measure(name, startMark, endMark);
    }
  }
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _proGalleryLayouter = __webpack_require__(39);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _watermarkApi = __webpack_require__(294);

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

var _imageClientSDK = __webpack_require__(297);

var imageSdk = _interopRequireWildcard(_imageClientSDK);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryItem = function () {
  function GalleryItem(config) {
    var _this = this;

    (0, _classCallCheck3.default)(this, GalleryItem);


    this.uniqueId = _index2.default.generateUUID();
    this.isGalleryItem = true;
    this.createdBy = config.createdBy;

    if (config.dto && config.dto.dto) {
      config.dto = config.dto.dto; //defence patch due to mis-use of item-core
      if (_index2.default.isDev()) {
        console.warn('Item core is created with already existing item core');
      }
    }
    this.dto = _lodash2.default.merge({}, config.dto);
    _lodash2.default.merge(this, config.dto);

    if (config.scheme) {
      this.processScheme(config.scheme);
    } else {
      var dto = {};
      (0, _assign2.default)(dto, this.dto, this.metadata);
      this.processScheme(new _proGalleryLayouter.Item({ dto: dto }).scheme);
    }
    if (config.wixImage && _lodash2.default.isNumber(config.orderIndex)) {
      this.createFromWixImage(config.wixImage, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (config.wixVideo && _lodash2.default.isNumber(config.orderIndex)) {
      this.createFromWixVideo(config.wixVideo, config.orderIndex, config.addWithTitles, config.isSecure);
    }
    if (config.wixExternal && _lodash2.default.isNumber(config.orderIndex)) {
      this.createFromExternal(config.wixExternal, config.orderIndex, config.addWithTitles, config.isSecure);
    }

    if (this.dto) {
      var itemMetadata = this.dto.metaData || this.dto.metadata;
      if (itemMetadata) {
        //metadata is encoded encoded, parsed if needed
        this.dto.metaData = _index2.default.parseStringObject(itemMetadata);
      }
    }
    if (_index2.default.isStoreGallery() && !this.isVideo) {
      this.watermark = config.watermark;
      if (!this.watermark) {
        _watermarkApi2.default.getWatermarkData() //this request should be sync (the watermark should have been cached by the gallery or the fullscreen)
        .then(function (data) {
          _this.watermark = data;
          _this.watermarkStrSdk = _this.watermark && _this.watermark.imageUrl ? _this.watermark.imageUrl + '-' + _this.watermark.opacity + '-' + _this.watermark.position + '-' + _this.watermark.size : '';
          _this.watermarkStr = _this.watermark && _this.watermark.imageUrl ? ',wm_' + _this.watermarkStrSdk : '';
        });
      } else {
        // protect against watermark being a string - it happens some times.
        if (typeof this.watermark === 'string') {
          try {
            this.watermark = JSON.parse(this.watermark);
          } catch (error) {
            console.error('item-core - given watermark (' + this.watermark + ') is not an object', error);
          }
        }
        this.watermarkStr = '';
        if (this.watermark.imageUrl) {
          this.watermarkStrSdk = this.watermark.imageUrl + '-' + this.watermark.opacity + '-' + this.watermark.position + '-' + this.watermark.size;
          this.watermarkStr = ',wm_' + this.watermarkStrSdk;
        }
      }
    }

    this.sharpParams = _lodash2.default.merge({}, config.sharpParams);
    if (!this.sharpParams.quality) {
      this.sharpParams.quality = 90;
    }
    if (!this.sharpParams.usm) {
      this.sharpParams.usm = {};
    }
    this.updateSharpParams();

    this.createUrls();
  }

  (0, _createClass3.default)(GalleryItem, [{
    key: 'processScheme',
    value: function processScheme(scheme) {
      this.id = scheme.id;
      this.idx = scheme.idx;
      this.type = scheme.type;
      this.style = scheme.style;
      this.width = scheme.width;
      this.maxWidth = scheme.maxWidth;
      this.height = scheme.height;
      this.maxHeight = scheme.maxHeight;
      this.margins = scheme.margins;
      this.ratio = scheme.ratio;
      this.cubeRatio = scheme.cropRatio;
      this.cubeImages = scheme.isCropped;
      this.cubeType = scheme.cropType || 'fill';
      this.offset = scheme.offset;
      this.group = scheme.group;
      this.transform = scheme.transform;
      this.orientation = scheme.orientation;
      this.visibility = scheme.visibility;
    }
  }, {
    key: 'renderProps',
    value: function renderProps(config) {

      return _lodash2.default.merge({
        className: 'image',
        key: this.key,
        idx: this.idx,
        photoId: this.photoId,
        id: this.id,
        hash: this.id,
        html: this.html,
        type: this.type,
        url: this.url,
        alt: this.alt,
        linkUrl: this.linkUrl,
        linkOpenType: this.linkOpenType,
        originalsUrl: this.getOriginalsUrl(),
        title: this.title,
        fileName: this.fileName,
        description: this.description,
        full_url: this.full_url,
        download_url: this.download_url,
        sample_url: this.sample_url,
        square_url: this.square_url,
        pixel_url: this.pixel_url,
        resized_url: this.resized_url,
        thumbnail_url: this.thumbnail_url,
        cubeImages: this.cubeImages,
        cubeType: this.cubeType,
        cubeRatio: this.cubeRatio,
        transform: this.transform,
        offset: this.offset,
        style: _lodash2.default.merge({
          bgColor: this.bgColor,
          maxWidth: this.maxWidth,
          maxHeight: this.maxHeight,
          ratio: this.ratio,
          orientation: this.orientation
        }, this.style),
        isDemo: this.isDemo,
        videoUrl: this.videoUrl,
        isExternalVideo: this.isExternalVideo,
        scroll: config.scroll,
        visible: config.visible,
        styleParams: config.styleParams,
        actions: config.actions,
        currentIdx: config.currentIdx
      }, config);
    }
  }, {
    key: 'getDataForShop',
    value: function getDataForShop() {
      var focalPoint = this.focalPoint;
      var metadata = this.metadata;
      return {
        isDemo: metadata.isDemo,
        orderIndex: this.orderIndex,
        itemId: this.dto.itemId,
        originalUrl: this.getOriginalsUrl(),
        itemUrl: this.url,
        itemHeight: metadata.height,
        title: metadata.title,
        itemWidth: metadata.width,
        itemType: metadata.type || 'image',
        imageUrl: this.resizedUrl('fit', 200, 200, null, null).img,
        imagePurchasedUrl: this.dto.mediaUrl,
        fpX: focalPoint[0],
        fpY: focalPoint[1]
      };
    }
  }, {
    key: 'createFromWixImage',
    value: function createFromWixImage(wixData, orderIndex, addWithTitles, isSecure) {
      var url = wixData.uri || wixData.relativeUri || wixData.url;
      var itemId = url.slice(0, url.length - 4);
      var metadata = {
        createdOn: new Date().getTime(),
        height: wixData.height,
        width: wixData.width,
        lastModified: new Date().getTime(),
        focalPoint: wixData.focalPoint,
        name: wixData.fileName,
        fileName: wixData.title,
        title: '',
        type: wixData.type,
        link: this.initialLinkObject,
        sourceName: wixData.sourceName,
        tags: wixData.tags,
        wm: wixData.wm
        // title: wixData.title || '',
        // description: wixData.description || '',
      };

      if (addWithTitles) {
        metadata.title = wixData.title;
      }

      this.dto = { itemId: itemId, mediaUrl: url, orderIndex: orderIndex, metadata: metadata, isSecure: isSecure };
    }
  }, {
    key: 'createFromWixVideo',
    value: function createFromWixVideo(wixData, orderIndex, addWithTitles, isSecure) {

      var qualities = _lodash2.default.map(wixData.fileOutput.video, function (q) {
        return {
          height: q.height,
          width: q.width,
          quality: q.quality,
          formats: [q.format]
        };
      });

      var posters = _lodash2.default.map(wixData.fileOutput.image, _lodash2.default.partialRight(_lodash2.default.pick, ['url', 'width', 'height']));
      posters = _lodash2.default.map(posters, function (p) {
        p.url = p.url.replace('media/', '');
        return p;
      });
      var resolution = this.getHighestMp4Resolution(qualities);
      var metaData = {
        createdOn: new Date().getTime(),
        name: wixData.title,
        lastModified: new Date().getTime(),
        width: resolution.width,
        height: resolution.height,
        type: 'video',
        posters: posters,
        customPoster: '',
        isExternal: false,
        duration: wixData.fileInput.duration,
        qualities: qualities,
        link: this.initialLinkObject
        // title: wixData.title,
        // description: wixData.description,
      };

      if (addWithTitles) {
        metaData.title = wixData.title;
      }

      var mediaUrl = wixData.fileBaseUrl.replace('video/', '');
      this.dto = { itemId: wixData.id, mediaUrl: mediaUrl, orderIndex: orderIndex, metaData: metaData, isSecure: isSecure };
    }
  }, {
    key: 'getHighestMp4Resolution',
    value: function getHighestMp4Resolution(qualities) {
      var mp4s = qualities.filter(function (video) {
        return video.formats[0] === 'mp4';
      });
      var _mp4s$sort$ = mp4s.sort(function (a, b) {
        return b.width - a.width;
      })[0],
          width = _mp4s$sort$.width,
          height = _mp4s$sort$.height;

      return { width: width, height: height };
    }
  }, {
    key: 'createFromExternal',
    value: function createFromExternal(wixData, orderIndex, addWithTitles, isSecure) {
      var metaData = {
        createdOn: new Date().getTime(),
        name: wixData.id,
        videoId: wixData.id,
        lastModified: new Date().getTime(),
        height: 1080,
        width: 1920,
        source: wixData.source || '',
        videoUrl: wixData.videoUrl || '',
        isExternal: true,
        type: 'video',
        posters: wixData.posters,
        customPoster: '',
        duration: 0,
        qualities: []
      };

      this.dto = { itemId: wixData.id, mediaUrl: metaData.posters[0].url, orderIndex: orderIndex, metaData: metaData, isSecure: isSecure };
    }
  }, {
    key: 'useImageClientApi',
    value: function useImageClientApi() {
      var isSdkExperimentOn = !(window && window.petri && window.petri['specs.pro-gallery.ImageClientApi'] === 'false'); //use the new api unless the experiment is specifically turned off
      var isImageSizeAvailable = !this.isDimensionless;
      var isSSR = !(window && window.document); //the image client lib can only be used in the client (dahh)
      var hasWatermark = !!this.watermark;

      return isImageSizeAvailable && isSdkExperimentOn && !isSSR && !hasWatermark;
    }
  }, {
    key: 'resizeUrlImp',
    value: function resizeUrlImp(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];

      if (this.useImageClientApi()) {
        return this.resizeUrlImp_sdk(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, faces, allowWatermark, focalPoint);
      } else {
        return this.resizeUrlImp_manual(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, faces, allowWatermark, focalPoint);
      }
    }
  }, {
    key: 'resizeUrlImp_manual',
    value: function resizeUrlImp_manual(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];


      var requiredRatio = requiredWidth / requiredHeight;
      var showWatermark = allowWatermark && this.watermarkStr;

      if (!_index2.default.isMobile()) {
        requiredWidth = Math.ceil(requiredWidth / 250) * 250;
        requiredHeight = Math.ceil(requiredWidth / requiredRatio);
      }

      // assign sharp default parameters
      sharpParams = sharpParams || {};

      // calc default quality
      if (!sharpParams.quality) {
        sharpParams.quality = 90;
      }

      //don't allow quality above 90 till we have proper UI indication
      sharpParams.quality = Math.min(90, sharpParams.quality);

      if (sharpParams.usm && sharpParams.usm.usm_r) {
        sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
        sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0)); //should be max 500 - but it's returning a 404
        sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
      }

      if (_index2.default.isExternalUrl(originalUrl)) {
        return originalUrl;
      } else if (!focalPoint) {
        //todo remove when supporting focal point
        var retUrl = 'https://static.wixstatic.com/media/' + originalUrl + '/v1/' + resizeMethod + '/';
        retUrl += 'w_' + requiredWidth;
        retUrl += ',h_' + requiredHeight;
        retUrl += ',al_' + (faces ? 'fs' : 'c');
        retUrl += ',q_' + sharpParams.quality;

        retUrl += sharpParams.usm && sharpParams.usm.usm_r ? ',usm_' + sharpParams.usm.usm_r.toFixed(2) + '_' + sharpParams.usm.usm_a.toFixed(2) + '_' + sharpParams.usm.usm_t.toFixed(2) : '';
        // Important to use this as the last param
        if (showWatermark) {
          retUrl += this.watermarkStr;
        }
        retUrl += '/' + originalUrl;
        return retUrl;
      } else {

        var scale = void 0;
        var x = void 0;
        var y = void 0;
        var orgW = void 0;
        var orgH = void 0;

        //find the scale
        if (this.ratio > requiredRatio) {
          //wide image (relative to required ratio
          scale = requiredHeight / this.maxHeight;
          orgW = Math.floor(requiredHeight * this.ratio);
          y = 0;
          x = Math.round(orgW * focalPoint[0] - requiredWidth / 2);
          x = Math.min(orgW - requiredWidth, x);
          x = Math.max(0, x);
        } else {
          //narrow image

          scale = requiredWidth / this.maxWidth;
          orgH = Math.floor(requiredWidth / this.ratio);
          x = 0;
          y = Math.round(orgH * focalPoint[1] - requiredHeight / 2);
          y = Math.min(orgH - requiredHeight, y);
          y = Math.max(0, y);
        }

        //make sure scale is not lower than needed
        //scale must be higher to prevent cases that there will be white margins (or 404)
        scale = Math.ceil(scale * 100) / 100;

        var _retUrl = 'https://static.wixstatic.com/media/' + originalUrl + '/v1/crop/';
        _retUrl += 'w_' + requiredWidth;
        _retUrl += ',h_' + requiredHeight;
        _retUrl += ',x_' + x;
        _retUrl += ',y_' + y;
        _retUrl += ',scl_' + scale.toFixed(2);
        _retUrl += ',q_' + sharpParams.quality;
        _retUrl += sharpParams.usm && sharpParams.usm.usm_r ? ',usm_' + sharpParams.usm.usm_r.toFixed(2) + '_' + sharpParams.usm.usm_a.toFixed(2) + '_' + sharpParams.usm.usm_t.toFixed(2) : '';
        // Important to use this as the last param
        if (showWatermark) {
          _retUrl += this.watermarkStr;
        }
        _retUrl += '/' + originalUrl;
        return _retUrl;
      }
    }
  }, {
    key: 'resizeUrlImp_sdk',
    value: function resizeUrlImp_sdk(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams) {
      var faces = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var allowWatermark = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var focalPoint = arguments[7];


      var requiredRatio = requiredWidth / requiredHeight;
      var showWatermark = allowWatermark && this.watermarkStr;

      if (!_index2.default.isMobile()) {
        requiredWidth = Math.ceil(requiredWidth / 250) * 250;
        requiredHeight = Math.ceil(requiredWidth / requiredRatio);
      }

      // assign default parameters
      originalUrl = originalUrl || '';
      sharpParams = sharpParams || {};

      // calc default quality
      if (sharpParams.quality > 0) {
        //don't allow quality above 90 till we have proper UI indication
        sharpParams.quality = Math.min(90, sharpParams.quality);
      }

      var focalPointObj = { x: 50, y: 50 };
      if (focalPoint && focalPoint.length === 2) {
        focalPointObj.x = Math.round(focalPoint[0] * 100);
        focalPointObj.y = Math.round(focalPoint[1] * 100);
      }

      if (sharpParams.usm && sharpParams.usm.usm_r) {
        sharpParams.usm.usm_a = Math.min(5, Math.max(0, sharpParams.usm.usm_a || 0));
        sharpParams.usm.usm_r = Math.min(128, Math.max(0, sharpParams.usm.usm_r || 0)); //should be max 500 - but it's returning a 404
        sharpParams.usm.usm_t = Math.min(1, Math.max(0, sharpParams.usm.usm_t || 0));
      }

      if (_index2.default.isExternalUrl(originalUrl)) {
        return originalUrl;
      } else {

        var resizer = _lodash2.default.noop;
        if (resizeMethod === 'fit') {
          // function getScaleToFitImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
          resizer = imageSdk.getScaleToFitImageURL;
        } else {
          // function getScaleToFillImageURL(relativeUrl, sourceWidth, sourceHeight, targetWidth, targetHeight, options) {
          resizer = imageSdk.getScaleToFillImageURL;
        }

        /**
         * the transform options
         * @typedef  {object}   ImageTransformOptions
         * @property {boolean}  [progressive]               image transform progressive
         * @property {number}   [quality]                   image transform quality
         * @property {string}   [watermark]                 image watermark id
         * @property {object}   [unsharpMask]               unsharpMask filter
         * @property {number}   [unsharpMask.radius]        unsharpMask radius
         * @property {number}   [unsharpMask.amount]        unsharpMask amount
         * @property {number}   [unsharpMask.threshold]     unsharpMask threshold
         */

        var options = {};
        if (sharpParams.quality > 0) {
          options.quality = sharpParams.quality;
        }
        if (focalPointObj) {
          options.focalPoint = focalPointObj;
        }
        if (sharpParams && sharpParams.usm) {
          options.unsharpMask = {
            radius: sharpParams.usm.usm_r,
            amount: sharpParams.usm.usm_a,
            threshold: sharpParams.usm.usm_t
          };
        }
        if (this.watermarkStrSdk) {
          options.watermark = this.watermarkStrSdk;
        }

        var prefix = '';
        if (originalUrl.indexOf('/') < 0) {
          prefix = 'media/';
        }

        var retUrl = resizer(prefix + originalUrl, this.maxWidth, this.maxHeight, requiredWidth, requiredHeight, options);

        /*
            console.log('USING THE CLIENT IMAGE SDK! Resized the image: ', retUrl, 'Previuos url was: ', this.resizeUrlImp_manual(originalUrl, resizeMethod, requiredWidth, requiredHeight, sharpParams, faces, allowWatermark, focalPoint), 'parameters were: ', {
              originalUrl,
              resizeMethod,
              orgWidth: this.maxWidth,
              orgHeight: this.maxHeight,
              requiredWidth,
              requiredHeight,
              options
            });
        	*/
        return retUrl;
      }
    }
  }, {
    key: 'createUrls',
    value: function createUrls() {
      var devicePixelRatio = this.useImageClientApi() ? 1 : _index2.default.getDevicePixelRatio(); // when using ImageClientAPI the devicePixelRatio is added automatically
      var maxWidth = this.maxWidth || this.dto.width || this.metadata.width;
      var maxHeight = this.maxHeight || this.dto.height || this.metadata.height;
      // const maxWidth = this.cubeImages ? Math.min(this.maxWidth, this.maxHeight) : this.maxWidth;
      // const maxHeight = this.cubeImages ? Math.min(this.maxWidth, this.maxHeight) : this.maxHeight;
      this.resizeWidth = Math.min(maxWidth, Math.ceil(this.width * devicePixelRatio));
      this.resizeHeight = Math.min(maxHeight, Math.ceil(this.height * devicePixelRatio));
      this.resized_url = this.resizedUrl(this.cubeType, this.resizeWidth, this.resizeHeight, this.sharpParams, false);

      this.pixel_url = this.resizedUrl('fill', 1, 1, { quality: 30 }, false);

      var maxDimension = 500;
      this.thumbnailWidth = Math.min(maxWidth, this.width, maxDimension);
      this.thumbnailHeight = Math.min(maxHeight, this.height, maxDimension);
      this.thumbnail_url = this.resizedUrl('fit', this.thumbnailWidth, this.thumbnailHeight, { quality: 30 }, false);
      this.square_url = this.resizedUrl('fill', 100, 100, { quality: 80 }, false);
      this.full_url = this.resizedUrl(this.cubeType, this.maxWidth, this.maxHeight, this.sharpParams, false);

      this.sample_url = this.resizedUrl('fit', 500, 500, this.sharpParams, false, true);

      this.download_url = _index2.default.isStoreGallery() ? this.sample_url : { img: this.getOriginalsUrl(), mp4: this.full_url.mp4 };
      if (this.download_url.img) {
        this.download_url.img += '?dn=' + this.fileName; //https://jira.wixpress.com/browse/PHOT-129#
      }
    }
  }, {
    key: 'resizedUrl',
    value: function resizedUrl(resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, noCrop) {

      if (this.isText) {
        return {};
      }

      requiredWidth = Math.round(requiredWidth);
      requiredHeight = Math.round(requiredHeight);
      var thumbSize = 180;

      var urls = {};

      if (this.metadata.posters || this.metadata.customPoster) {
        var maxHeight = 720;
        var qualities = this.metadata.qualities;
        var poster = this.metadata.customPoster || (this.metadata.posters ? this.metadata.posters[this.metadata.posters.length - 1] : null);
        if (poster) {
          if (qualities && qualities.length) {
            var suffix = '/';

            var mp4Qualities = qualities.filter(function (video) {
              return video.formats[0] === 'mp4';
            });
            //search for the first quality bigger that the required one
            for (var quality, q = 0; quality = mp4Qualities[q]; q++) {
              if (quality.height >= requiredHeight || quality.height >= maxHeight || !mp4Qualities[q + 1]) {
                suffix += quality.quality; //e.g. 720p
                for (var format, i = 0; format = quality.formats[i]; i++) {
                  urls[format] = window.location.protocol + '//video.wixstatic.com/video/' + this.url + suffix + '/' + format + '/file.' + format;
                }
                break;
              }
            }
            var ratio = poster.width / poster.height;
            var isWider = ratio > 1;
            if (isWider) {
              requiredWidth = Math.ceil(requiredHeight * ratio);
            } else {
              requiredHeight = Math.ceil(requiredWidth / ratio);
            }
          }

          urls.img = this.resizeUrlImp(poster.url, resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, false);
          urls.thumb = this.resizeUrlImp(poster.url, 'fit', thumbSize, thumbSize, sharpParams, false, false);
        }
      } else {
        var fp = noCrop !== true && this.isCropped && this.focalPoint;
        urls.img = this.resizeUrlImp(this.url, resizeMethod, requiredWidth, requiredHeight, sharpParams, showFaces, true, fp);
        urls.thumb = this.resizeUrlImp(this.url, 'fit', thumbSize, thumbSize, sharpParams, showFaces, true, fp);
      }

      // if (window.isWebpSupported && !utils.isStoreGallery()) {
      //   urls.thumb = urls.thumb.replace(/\.jpg$/i, '.webp');
      //   urls.img = urls.img.replace(/\.jpg$/i, '.webp');
      // }

      return urls;
    }
  }, {
    key: 'getOriginalsUrl',
    value: function getOriginalsUrl() {
      return 'https://static.wixstatic.com/media/' + this.url;
    }
  }, {
    key: 'updateSharpParams',
    value: function updateSharpParams() {
      //override sharpParams with item sharpParams
      if (this.dto.metaData && this.dto.metaData.sharpParams && this.dto.metaData.sharpParams.L) {
        var sharpParams = this.dto.metaData.sharpParams.L;
        if (sharpParams.quality && sharpParams.overrideQuality === true) {
          this.sharpParams.quality = sharpParams.quality;
        }

        if (sharpParams.usm && sharpParams.overrideUsm === true) {
          this.sharpParams.usm = sharpParams.usm;
        }
      }
    }
  }, {
    key: 'updateId',
    value: function updateId(id) {
      this.dto.itemId = this.id = id;
    }
  }, {
    key: 'updateOrderIndex',
    value: function updateOrderIndex(value) {
      var ret = this.orderIndex !== value;
      this.orderIndex = value;
      return ret;
    }
  }, {
    key: 'itemId',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'metadata',
    get: function get() {
      var md = this.dto.metaData || this.dto.metadata;
      if (_lodash2.default.isUndefined(md)) {
        // console.error('Item with no metadata' + JSON.stringify(this.dto));
        md = {};
      }
      return md;
    }
  }, {
    key: 'metaData',
    get: function get() {
      return this.metadata;
    }
  }, {
    key: 'bgColor',
    get: function get() {
      var bg = void 0;
      if (this.isText) {
        bg = this.metadata && this.metadata.textStyle && this.metadata.textStyle.backgroundColor;
      } else {
        bg = 'none';
      }
      return bg;
    }
  }, {
    key: 'isCropped',
    get: function get() {
      return this.cubeImages && this.cubeType === 'fill';
    }
  }, {
    key: 'focalPoint',
    get: function get() {
      return this.metadata.focalPoint || [0.5, 0.5];
    },
    set: function set(value) {
      this.metadata.focalPoint = value;
    }

    //----------------------------------------------------------------//

  }, {
    key: 'demoTitle',
    get: function get() {
      return 'I am a title, only a sample title but still a title. ';
    }
  }, {
    key: 'demoDescription',
    get: function get() {
      return 'I am a description, the best description ever! Here is some lorem ipsum for you: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
    }
  }, {
    key: 'demoExif',
    get: function get() {
      return {
        GPSVersionID: '2.2.0.0',
        GPSAltitudeRef: '1.8',
        GPSAltitude: '0',
        Make: 'LG Electronics',
        Model: 'LG-H815L',
        Orientation: 'right-top',
        XResolution: '72',
        YResolution: '72',
        ResolutionUnit: '2',
        Software: 'Picasa',
        DateTime: '2016:04:17 07:19:25',
        YCbCrPositioning: '1',
        ExposureTime: '0.041666666666666664',
        FNumber: '1.8',
        ExifIFDPointer: '214',
        ExposureProgram: 'Undefined',
        GPSInfoIFDPointer: '1262',
        PhotographicSensitivity: '200',
        ExifVersion: '0220',
        DateTimeOriginal: '2016:04:17 07:19:25',
        DateTimeDigitized: '2016:04:17 07:19:25',
        ComponentsConfiguration: 'YCbCr',
        ShutterSpeedValue: '4.585',
        ApertureValue: '1.69',
        BrightnessValue: '-0.88',
        ExposureBias: '0',
        MeteringMode: 'CenterWeightedAverage',
        Flash: 'Flash did not fire, compulsory flash mode',
        FocalLength: '4.42',
        UserComment: '32,32,32,70,77,49,32,32,32,70,67,48,48,48,48,48,48,48,48,48,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0',
        SubSecTime: '802528',
        SubSecTimeOriginal: '802528',
        SubSecTimeDigitized: '802528',
        FlashpixVersion: '0100',
        ColorSpace: '1',
        PixelXDimension: '5312',
        PixelYDimension: '2988',
        InteroperabilityIFDPointer: '1320',
        SensingMethod: 'Undefined',
        SceneType: 'Directly photographed',
        ExposureMode: '0',
        WhiteBalance: 'Auto white balance',
        DigitalZoomRatio: '1',
        SceneCaptureType: 'Standard',
        ImageUniqueID: '36f6e92221e27c830000000000000000'
      };
    }
  }, {
    key: 'photoId',
    get: function get() {
      return this.id;
    }
  }, {
    key: 'key',
    get: function get() {
      if (!this._key) {
        this._key = (this.dto.key || this.id || this.dto.url || 'no_key_found').replace(/\W/g, '');
      }
      return this._key;
    }
  }, {
    key: 'orderIndex',
    get: function get() {
      return this.dto.orderIndex || this.dto.o || 0;
    },
    set: function set(value) {
      this.dto.orderIndex = value;
    }
  }, {
    key: 'name',
    get: function get() {
      return this.metadata.fileName || '';
    }
  }, {
    key: 'url',
    get: function get() {
      //todo :change from mediaUrl
      return this.dto.file_url || this.dto.mediaUrl || this.dto.url || this.dto.src;
    }
  }, {
    key: 'mediaUrl',
    get: function get() {
      return this.url;
    }
  }, {
    key: 'html',
    get: function get() {
      return this.dto.html || this.dto.text || this.metadata.html || this.metadata.text;
    }
  }, {
    key: 'lastModified',
    get: function get() {
      return this.metadata.lastModified;
    }
  }, {
    key: 'seed',
    get: function get() {
      return _index2.default.hashToInt(this.url);
    }
  }, {
    key: 'isImage',
    get: function get() {
      return this.type === 'image';
    }
  }, {
    key: 'isImportant',
    get: function get() {
      return !!this.dto.i;
    }
  }, {
    key: 'isVideo',
    get: function get() {
      return this.type === 'video';
    }
  }, {
    key: 'videoUrl',
    get: function get() {
      return this.metadata.videoUrl;
    }
  }, {
    key: 'isExternalVideo',
    get: function get() {
      return this.metadata.isExternal;
    }
  }, {
    key: 'isExternal',
    get: function get() {
      return this.metadata.isExternal === true;
    }
  }, {
    key: 'type',
    set: function set(type) {
      this._type = type;
    },
    get: function get() {
      switch (this._type || this.dto.type || this.metadata.type || this.dto.media_type) {
        case 'dummy':
          return 'dummy';
        case 'v':
        case 'video':
          return 'video';
        case 'h':
        case 'html':
        case 'text':
          return 'text';
        case 'i':
        case 'image':
        default:
          return 'image';
      }
    }
  }, {
    key: 'alt',
    get: function get() {
      return this.metadata.alt || this.title || this.description;
    }
  }, {
    key: 'title',
    get: function get() {
      var title = this.metadata.title;
      if (typeof title === 'string') {
        return title;
      } else {
        var filename = this.metadata.fileName;
        if (filename) return filename;
      }
      return '';
      // if (!this.metadata.isDemo) {
      //   return this.metadata.title || '';
      // }
      // return this.getTranslatedValue(this.metadata.title);
    },
    set: function set(value) {
      this.metadata.title = value;
    }
  }, {
    key: 'fileName',
    get: function get() {
      return this.metadata.fileName || '';
    },
    set: function set(value) {
      this.metadata.fileName = value;
    }
  }, {
    key: 'description',
    get: function get() {
      return this.metadata.description || '';
      // if (!this.metadata.isDemo) {
      //   return this.metadata.description || '';
      // }
      // return this.getTranslatedValue(this.metadata.description);
    },
    set: function set(value) {
      this.metadata.description = value;
    }
  }, {
    key: 'exif',
    get: function get() {
      return this.metadata.exif || '';
    }
  }, {
    key: 'hasLink',
    get: function get() {
      switch (this.linkType) {
        case 'wix':
          return !!this.linkData.type;
        default:
          return !!this.linkUrl;
      }
    }
  }, {
    key: 'link',
    get: function get() {
      return this.metadata.link || {};
    }
  }, {
    key: 'linkData',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.data || {};
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.data = value;
    }
  }, {
    key: 'linkType',
    get: function get() {
      if (this.metadata.link && !_lodash2.default.isUndefined(this.metadata.link.type)) {
        return this.metadata.link.type;
      } else if (this.linkUrl) {
        return 'web';
      } else {
        return 'none';
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }

      // reset metadata.link when 'none' is selected - that's the way wix galleries work
      this.metadata.link = {
        type: value,
        url: undefined,
        text: undefined,
        title: undefined,
        target: '_blank'
      };
    }
  }, {
    key: 'defaultLinkText',
    get: function get() {
      var linkData = this.linkData;

      switch (this.linkType) {
        case 'wix':
          if (linkData) {
            switch (linkData.type) {
              case 'PageLink':
                return 'Go to Page ' + linkData.pageName;
              case 'AnchorLink':
                return 'Scroll to ' + linkData.anchorName;
              case 'ExternalLink':
                return '' + linkData.url;
              case 'EmailLink':
                return 'Email ' + linkData.recipient;
              case 'PhoneLink':
                return 'Call ' + linkData.phoneNumber;
              case 'DocumentLink':
                return 'Open ' + linkData.name;
              default:
                return 'Go to Link';
            }
          } else {
            return 'Go to Link';
          }
        case 'web':
          return this.linkUrl;
        case 'page':
          return this.linkTitle;
        default:
          return '';
      }
      /*
          const wixLinkDataSamples = {
            page: {
              pageId: "#c1dmp",
              type: "PageLink"
            },
            anchor: {
              anchorDataId: "",
              anchorName: "Anchor 1",
              pageId: "#masterPage",
              type: "AnchorLink"
            },
            web: {
              target: "_self",
              type: "ExternalLink",
              url: "http://google.com"
            },
            email: {
              recipient: "guyso@wix.com",
              subject: "subject",
              type: "EmailLink"
            },
            phone: {
              phoneNumber: "0547787444",
              type: "PhoneLink"
            },
            document: {
              docId: "0d72ac_7395fddc29a84899a472b5fcf0dee3ed.doc",
              name: "חוזה-שכירות-משנה-בלתי-מוגנת.doc",
              type: "DocumentLink"
            },
            scroll: {
              anchorDataId: "SCROLL_TO_TOP",
              anchorName: "Top of Page",
              pageId: "#masterPage",
              type: "AnchorLink"
            },
            lightbox: {
              pageId: "#zwjzg",
              type: "PageLink"
            }
           }
      */
    }
  }, {
    key: 'defaultLinkValue',
    get: function get() {
      var linkData = this.linkData;

      switch (this.linkType) {
        case 'wix':
          if (linkData) {
            switch (linkData.type) {
              case 'PageLink':
                if (linkData.pageName) {
                  return 'PAGE - ' + linkData.pageName;
                } else {
                  return 'PAGE';
                }
              case 'AnchorLink':
                return 'ANCHOR - ' + linkData.anchorName;
              case 'ExternalLink':
                return 'LINK - ' + linkData.url;
              case 'EmailLink':
                return 'EMAIL - ' + linkData.recipient;
              case 'PhoneLink':
                return 'PHONE - ' + linkData.phoneNumber;
              case 'DocumentLink':
                return 'DOCUMENT - ' + linkData.name;
              default:
                return 'Add a Link';
            }
          } else {
            return 'Add a Link';
          }
        case 'web':
          return this.linkUrl;
        case 'page':
          return this.linkTitle;
        default:
          return '';
      }
    }
  }, {
    key: 'linkText',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.text || this.defaultLinkText;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.text = value;
    }
  }, {
    key: 'linkTitle',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.title;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.title = value;
    }
  }, {
    key: 'linkUrl',
    get: function get() {
      if (this.metadata.link) {
        return this.metadata.link.url;
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.url = value;
    }
  }, {
    key: 'unprotectedLinkOpenType',
    get: function get() {
      return _lodash2.default.get(this, 'metadata.link.target');
    }
  }, {
    key: 'linkOpenType',
    get: function get() {
      if (_index2.default.isEditor() || _index2.default.isPreview()) {
        //in preview never open link in current window (causes many errors)
        return '_blank';
      } else if (this.metadata.link && !_lodash2.default.isUndefined(this.metadata.link.target)) {
        return this.unprotectedLinkOpenType;
      } else if (this.metadata.link && !_lodash2.default.isUndefined(this.metadata.link.targetBlank)) {
        return this.metadata.link.targetBlank ? '_blank' : '_top';
      } else {
        return '_blank';
      }
    },
    set: function set(value) {
      if (!this.metadata.link) {
        this.metadata.link = {};
      }
      this.metadata.link.target = value;
    }
  }, {
    key: 'initialLinkObject',
    get: function get() {
      return {
        type: 'none',
        url: undefined,
        text: undefined,
        title: undefined,
        target: '_blank'
      };
    }
  }, {
    key: 'isDemo',
    get: function get() {
      return this.metadata.isDemo || this.dto.isDemo || this.metadata.sourceName === 'public' || _lodash2.default.includes(this.metadata.tags, '_paid');
    },
    set: function set(val) {
      this.metadata.isDemo = val;
    }
  }, {
    key: 'isText',
    get: function get() {
      return this.type === 'text';
    }
  }, {
    key: 'isVisible',
    get: function get() {
      return this.visibility && this.visibility.visible;
    }
  }, {
    key: 'isRendered',
    get: function get() {
      return this.visibility && this.visibility.rendered;
    }
  }, {
    key: 'isDimensionless',
    get: function get() {
      return !(this.maxWidth > 1 || this.maxHeight > 1);
    }
  }]);
  return GalleryItem;
}();

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

////// <reference path="../../reference.ts" />


exports.default = GalleryItem;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(76);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _baseUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minDate = -8640000000000000;

var VersionManager = function () {
  function VersionManager() {
    var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dateCreated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : minDate;
    var manualUpdates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck3.default)(this, VersionManager);

    this.features = features;
    this.update(dateCreated, manualUpdates);
  }

  (0, _createClass3.default)(VersionManager, [{
    key: 'update',
    value: function update(dateCreated) {
      var manualUpdates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.dateCreated = dateCreated || this.dateCreated;
      this.manualUpdates = manualUpdates;
    }
  }, {
    key: 'getFeature',
    value: function getFeature(featureName) {
      var featureVersions = this.features[featureName];
      if (!featureVersions) {
        return;
      }

      var manualUpdate = this.manualUpdates[featureName];
      var manualUpdateDateStr = manualUpdate && manualUpdate.date;
      var manualUpdateDate = manualUpdateDateStr ? _baseUtils.baseUtils.getDateCreatedTicksFromStr(manualUpdateDateStr) : null;

      for (var i = featureVersions.length - 1; i >= 0; i--) {
        var versionDate = manualUpdateDate || this.dateCreated;
        if (versionDate >= featureVersions[i].dateFrom) {
          return featureVersions[i];
        }
      }
    }
  }, {
    key: 'getVersion',
    value: function getVersion(featureName) {
      var feature = this.getFeature(featureName);
      return feature ? feature.version : VersionManager.Versions.min;
    }
  }, {
    key: 'getFeaturesWithNewerVersions',
    value: function getFeaturesWithNewerVersions() {
      var _this = this;

      var manualUpdates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var featuresWithNewerVersions = {};
      var isStore = _baseUtils.baseUtils.isStoreGallery();
      (0, _keys2.default)(this.features).forEach(function (featureName) {
        var featureLatest = _.last(_this.features[featureName]);
        var featureManualUpdate = manualUpdates[featureName];
        var featureManualUpdateDateStr = featureManualUpdate && featureManualUpdate.date;
        var featureManualUpdateDate = featureManualUpdateDateStr ? _baseUtils.baseUtils.getDateCreatedTicksFromStr(featureManualUpdateDateStr) : null;
        var isAFutureFeature = featureLatest.dateFrom > Date.parse(new Date());
        var shouldAffectProGallry = typeof featureLatest.affectsProGallery === 'undefined' || featureLatest.affectsProGallery && !isStore;
        var shouldAffectArtStore = typeof featureLatest.affectsArtStore === 'undefined' || featureLatest.affectsArtStore && isStore;
        var shouldAffect = isStore ? shouldAffectArtStore : shouldAffectProGallry;
        var featureHasNewerVersion = featureLatest.dateFrom > (featureManualUpdateDate || _this.dateCreated);
        var featureNeedsToUpgrade = !isAFutureFeature && featureHasNewerVersion && shouldAffect;
        if (featureNeedsToUpgrade && !featureLatest.ignoreUserManuaUpdate) {
          featuresWithNewerVersions[featureName] = featureLatest;
        }
      });
      return featuresWithNewerVersions;
    }
  }]);
  return VersionManager;
}();

VersionManager.Versions = {
  min: 'min'
};

module.exports = VersionManager;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(11).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(57);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(59)('keys');
var uid = __webpack_require__(41);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var global = __webpack_require__(11);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(34) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 60 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 61 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(15);
var dPs = __webpack_require__(157);
var enumBugKeys = __webpack_require__(60);
var IE_PROTO = __webpack_require__(58)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(53)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(92).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(8);
var LIBRARY = __webpack_require__(34);
var wksExt = __webpack_require__(63);
var defineProperty = __webpack_require__(16).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(178)();
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(193);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_WIX_DATA = exports.SET_WIX_DATA = 'SET_WIX_DATA';
var SET_ITEMS = exports.SET_ITEMS = 'SET_ITEMS';
var SET_RENDERED_ITEMS_COUNT = exports.SET_RENDERED_ITEMS_COUNT = 'SET_RENDERED_ITEMS_COUNT';

var VIDEO_PLAY_MODE = exports.VIDEO_PLAY_MODE = 'VIDEO_PLAY_MODE';
var GALLERY_WINDOW_LAYOUT_CHANGED = exports.GALLERY_WINDOW_LAYOUT_CHANGED = 'GALLERY_WINDOW_LAYOUT_CHANGED';
var VIDEO_ENDED = exports.VIDEO_ENDED = 'VIDEO_ENDED';
var VIDEO_ADDED = exports.VIDEO_ADDED = 'VIDEO_ADDED';
var VIDEO_REMOVED = exports.VIDEO_REMOVED = 'VIDEO_REMOVED';
var NAVIGATION_IN = exports.NAVIGATION_IN = 'NAVIGATION_IN';
var EDITOR_MODE_CHANGED = exports.EDITOR_MODE_CHANGED = 'EDITOR_MODE_CHANGED';
var TOGGLE_HOVER_PREVIEW = exports.TOGGLE_HOVER_PREVIEW = 'TOGGLE_HOVER_PREVIEW';
var SET_VIDEO_PLAY_INDEX = exports.SET_VIDEO_PLAY_INDEX = 'SET_VIDEO_PLAY_INDEX';

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  gallery: {
    wixInit: false,
    renderedItemsCount: 50,
    videoIndexPlay: -1,
    documentHeight: _utils2.default.getScreenHeight()
  },
  fullscreen: {},
  multishare: {}
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderUtils = undefined;

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseUtils = __webpack_require__(28);

var _baseUtils2 = _interopRequireDefault(_baseUtils);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderUtils = function (_BaseUtils) {
  (0, _inherits3.default)(RenderUtils, _BaseUtils);

  /* @ngInject */
  function RenderUtils() {
    (0, _classCallCheck3.default)(this, RenderUtils);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RenderUtils.__proto__ || (0, _getPrototypeOf2.default)(RenderUtils)).call(this));

    _this._cache = {};
    _this._hash2int = {};
    _this._params = {};
    _this._refs = {};
    _this._params = {};

    return _this;
  }

  (0, _createClass3.default)(RenderUtils, [{
    key: 'getScreenWidth',
    value: function getScreenWidth() {
      if (this.isPreview() && this.isMobile()) {
        // In editor preview-mode, the screen is still a desktop, but the viewport in which the preview mode renders us is only 320, so 'window.screen.width' returns a wrong value.
        return 320;
      }
      if (this.isTest() || this.isSemiNative()) {
        return 1920;
      }
      try {
        if (this.isLandscape()) {
          return Math.max(window.screen.width, window.screen.height);
        } else {
          return window.screen.width;
        }
      } catch (e) {
        return 1920;
      }
    }
  }, {
    key: 'getScreenHeight',
    value: function getScreenHeight() {
      if (this.isTest() || this.isSemiNative()) {
        return 1200;
      }
      try {
        if (this.isLandscape()) {
          return Math.min(window.screen.width, window.screen.height);
        } else {
          return window.screen.height;
        }
      } catch (e) {
        return 1200;
      }
    }
  }, {
    key: 'fixViewport',
    value: function fixViewport() {
      if (this.isSemiNative() || !this.isInWix()) {
        return;
      }
      try {
        this._cache.isLandscape = undefined;
        if (this.isSite() && this.isMobile() && !this.isMobileViewer()) {
          //using isUserAgentMobile creates a bug in mobile view when configured to show desktop on mobile (so isWixMobile is false)
          var viewportAspectRatio = this.getViewportScaleRatio();
          document.body.style.transform = 'scale(' + viewportAspectRatio + ')';
          document.body.style.transformOrigin = '0 0';
          document.body.style.width = 100 / viewportAspectRatio + '%';
          document.body.style.height = 100 / viewportAspectRatio + '%';
        }
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isSmallScreen',
    value: function isSmallScreen() {
      try {
        return (window.innerWidth || window.outerWidth) < 640 || this.isMobile();
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isVerticalScreen',
    value: function isVerticalScreen() {
      try {
        return window.innerWidth < window.innerHeight;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'isLandscape',
    value: function isLandscape() {
      if (this.isSemiNative()) {
        return false;
      }
      if (!this.isUndefined(this._cache.isLandscape)) {
        return this._cache.isLandscape;
      }
      if (!this.isMobile()) {
        this._cache.isLandscape = false;
      }
      try {
        if (!this.isUndefined(window.orientation)) {
          this._cache.isLandscape = window.orientation === 90 || window.orientation === -90;
        } else if (window.matchMedia) {
          var mql = window.matchMedia('(orientation: landscape)');
          if (mql && mql.matches === true) {
            this._cache.isLandscape = true;
          } else {
            this._cache.isLandscape = false;
          }
        } else {
          this._cache.isLandscape = false;
        }
      } catch (e) {
        this._cache.isLandscape = false;
      }
      return this._cache.isLandscape;
    }
  }, {
    key: 'getDevicePixelRatio',
    value: function getDevicePixelRatio() {
      try {
        return window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI; // Support for IE10
      } catch (e) {
        return 1;
      }
    }
  }, {
    key: 'getWindowWidth',
    value: function getWindowWidth() {
      try {
        return window.innerWidth || 980;
      } catch (e) {
        return 980;
      }
    }
  }, {
    key: 'getWindowHeight',
    value: function getWindowHeight() {
      try {
        return window.innerHeight || 1080;
      } catch (e) {
        return 1080;
      }
    }
  }, {
    key: 'getWindow',
    value: function getWindow(windowName, verifyParam, compId, instanceId) {

      if (this.isTest()) {
        return window;
      }

      if (!this.isUndefined(this._refs[windowName])) {
        var cacheWindow = this._refs[windowName];
        if (cacheWindow && cacheWindow.location && cacheWindow.location.href) {
          return this._refs[windowName];
        } else {
          this._refs[windowName] = null;
        }
      }

      for (var d = 0; d < window.parent.frames.length; d++) {
        var frame = window.parent.frames[d];
        try {
          var found = false;
          try {
            if (frame[verifyParam]) {
              found = true;
            }
          } catch (e) {
            // console.warn('couldn\'t access frame', windowName, {d, e});
          }
          if (found) {
            //check if this is the window
            this._refs[windowName] = frame;
            break;
          } else {
            //check if one of this window's children is the one (e.g. when accessing the worker from the settings, the worker is inside the editor's iframe)
            var frames = [];
            if (compId) {
              if (frame.document.getElementById(compId)) {
                frames = frame.document.getElementById(compId).getElementsByTagName('iframe');
              }
            } else {
              frames = frame.document.getElementsByTagName('iframe');
            }

            for (var f = 0; f < frames.length; f++) {
              try {
                var subFrame = frames[f].contentWindow;
                if (subFrame[verifyParam]) {
                  // console.log('comparing ', instanceId, subFrame.instanceId);
                  if (!instanceId || subFrame.instanceId === instanceId) {
                    //check if this is the window
                    this._refs[windowName] = subFrame;
                    break;
                  }
                }
              } catch (e) {
                // console.warn('catch frame ', windowName, {d, f, e});
              }
            }
            if (this._refs[windowName]) {
              break;
            }
          }
        } catch (e) {
          // console.warn('catch frame ', windowName, {d, e});
        }
      }

      if (this.isUndefined(this._refs[windowName])) {
        return this.safeSessionStorage();
      }

      return this._refs[windowName];
    }
  }, {
    key: 'getWorkerWindow',
    value: function getWorkerWindow() {
      if (this.isSemiNative()) {
        return [];
      }
      if (this.isStoreGallery()) {
        return this.getWindow('worker', 'isStoreWorker');
      } else {
        return this.getWindow('worker', 'isWorker');
      }
    }
  }, {
    key: 'getMultishareWindow',
    value: function getMultishareWindow() {
      return this.getWindow('multishare', 'isMultishare');
    }
  }, {
    key: 'getGalleryWindow',
    value: function getGalleryWindow(compId, instanceId) {
      return this.getWindow('gallery', 'isGallery', compId, instanceId);
    }
  }, {
    key: 'getGalleryByCompId',
    value: function getGalleryByCompId(compId) {
      if (this.isUndefined(this._cache.galleries)) {
        this._cache.galleries = {};
      }

      //todo - caching of galleries removed because in some cases it made the window stay at a old version
      //e.g. - adding an image to the gallery (after fullscreen was already opened) and reopening it

      //if (!this.isUndefined(this._cache.galleries[compId])) {
      //  return this._cache.galleries[compId];
      //}

      for (var d = 0; d < window.parent.frames.length; d++) {
        try {
          var frame = window.parent.frames[d];
          if (frame.isGallery === true || frame.document.location.href.indexOf(this.getUrlPrefix() + 'gallery') >= 0) {
            if (frame.document.location.href.indexOf('compId=' + compId) >= 0) {
              // console.warn('got gallery by compId', compId, frame, frame['proGalleryWidget']);
              this._cache.galleries[compId] = frame;
            }
          }
        } catch (e) {
          //console.log('catch frame'+ d);
        }
      }
      return this._cache.galleries[compId];
    }
  }, {
    key: 'getViewportScaleRatio',
    value: function getViewportScaleRatio() {
      //320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
      if (this.shouldDebug('ph_scale_ratio')) {
        return 1;
      } else if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
        return 320 / this.getScreenWidth();
      } else {
        return 1;
      }
    }
  }, {
    key: 'getMobileEnabledClick',
    value: function getMobileEnabledClick(action) {
      //todo: bring back this line before pushing to master
      return this.isMobile() ? { onTouchEnd: action } : { onClick: action };
      // return {onClick: action};
    }
  }, {
    key: 'getTopUrlParam',
    value: function getTopUrlParam(name) {
      if (this.isUndefined(this._cache.params)) {
        this._cache.params = {};
      }
      if (this.isUndefined(this._cache.params[name])) {
        try {
          this._cache.params[name] = top.location.search.replace('?', '').split('&').map(function (ele) {
            var arr = ele.split('=');
            return arr[0] === name ? arr[1] || '' : '';
          }).join('');
        } catch (e) {
          this._cache.params[name] = false;
          // console.log('caught cross origin error');
          //comment to avoid 'block is empty' from linter
        }
      }
      return this._cache.params[name];
    }
  }, {
    key: 'getGalleryDataFromWorker',
    value: function getGalleryDataFromWorker() {
      var compId = _WixSdkWrapper2.default.Utils.getOrigCompId() || this.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
      var galleryData = this.getWorkerWindow()['pro-gallery-data-' + compId] || {};
      return galleryData;
    }
  }, {
    key: 'getGallerySettingsFromWindow',
    value: function getGallerySettingsFromWindow() {
      var galleryWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

      try {
        var gallerySettingsStr = galleryWindow && galleryWindow.prerenderedGallery && galleryWindow.prerenderedGallery.gallerySettings;
        if (!gallerySettingsStr) {
          gallerySettingsStr = galleryWindow && galleryWindow.prerenderedItem && galleryWindow.prerenderedItem.gallerySettings;
        }
        if (gallerySettingsStr) {
          return JSON.parse(this.stripSlashes(gallerySettingsStr));
        }
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'getTitleOrFilename',
    value: function getTitleOrFilename(title, filename) {
      var shouldShowTitle = (typeof title === 'undefined' ? 'undefined' : (0, _typeof3.default)(title)) === (0, _typeof3.default)('');
      return shouldShowTitle ? title : filename;
    }
  }, {
    key: 'getFullscreenUrlState',
    value: function getFullscreenUrlState(compId, itemId, itemIdx, pageId, styleId) {
      return compId + '/' + itemId + '/' + itemIdx + '/?i=' + itemIdx + '&p=' + pageId + '&s=' + styleId;
    }
  }]);
  return RenderUtils;
}(_baseUtils2.default);

exports.default = RenderUtils;
var renderUtils = exports.renderUtils = new RenderUtils(); // for inner use

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(33);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(71);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(27);
module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(215);
var objectAssign = __webpack_require__(216);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(226), __esModule: true };

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(40);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(239), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _propTypes = __webpack_require__(65);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var string = _propTypes2['default'].string,
    bool = _propTypes2['default'].bool,
    number = _propTypes2['default'].number,
    oneOfType = _propTypes2['default'].oneOfType,
    shape = _propTypes2['default'].shape,
    object = _propTypes2['default'].object,
    func = _propTypes2['default'].func;
var propTypes = exports.propTypes = {
  url: string,
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  hidden: bool,
  className: string,
  style: object,
  progressFrequency: number,
  soundcloudConfig: shape({
    clientId: string,
    showArtwork: bool
  }),
  youtubeConfig: shape({
    playerVars: object,
    preload: bool
  }),
  vimeoConfig: shape({
    iframeParams: object,
    preload: bool
  }),
  fileConfig: shape({
    attributes: object
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onEnded: func,
  onError: func,
  onDuration: func
};

var defaultProps = exports.defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: 0.8,
  playbackRate: 1,
  width: 640,
  height: 360,
  hidden: false,
  progressFrequency: 100,
  soundcloudConfig: {
    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
    showArtwork: true
  },
  youtubeConfig: {
    playerVars: {},
    preload: false
  },
  vimeoConfig: {
    iframeParams: {},
    preload: false
  },
  fileConfig: {
    attributes: {}
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {}
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _props2 = __webpack_require__(77);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var BasePlayer = function (_Component) {
  _inherits(BasePlayer, _Component);

  function BasePlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BasePlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BasePlayer.__proto__ || Object.getPrototypeOf(BasePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
      var _this$props = _this.props,
          volume = _this$props.volume,
          onStart = _this$props.onStart,
          onPlay = _this$props.onPlay,
          onDuration = _this$props.onDuration,
          playbackRate = _this$props.playbackRate;

      if (_this.startOnPlay) {
        _this.setPlaybackRate(playbackRate);
        _this.setVolume(volume);
        onStart();
        _this.startOnPlay = false;
      }
      onPlay();
      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);
        _this.seekOnPlay = null;
      }
      if (_this.durationOnPlay) {
        onDuration(_this.getDuration());
        _this.durationOnPlay = false;
      }
    }, _this.onReady = function () {
      var _this$props2 = _this.props,
          onReady = _this$props2.onReady,
          playing = _this$props2.playing,
          onDuration = _this$props2.onDuration;

      _this.isReady = true;
      onReady();
      if (playing || _this.preloading) {
        _this.preloading = false;
        if (_this.loadOnReady) {
          _this.load(_this.loadOnReady);
          _this.loadOnReady = null;
        } else {
          _this.play();
        }
      }
      var duration = _this.getDuration();
      if (duration) {
        onDuration(duration);
      } else {
        _this.durationOnPlay = true;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BasePlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var url = this.props.url;

      this.mounted = true;
      if (url) {
        this.load(url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          url = _props.url,
          playing = _props.playing,
          volume = _props.volume,
          playbackRate = _props.playbackRate;
      // Invoke player methods based on incoming props

      if (url !== nextProps.url && nextProps.url) {
        this.seekOnPlay = null;
        this.startOnPlay = true;
        this.load(nextProps.url);
      } else if (url && !nextProps.url) {
        this.stop();
        clearTimeout(this.updateTimeout);
      } else if (!playing && nextProps.playing) {
        this.play();
      } else if (playing && !nextProps.playing) {
        this.pause();
      } else if (volume !== nextProps.volume) {
        this.setVolume(nextProps.volume);
      } else if (playbackRate !== nextProps.playbackRate) {
        this.setPlaybackRate(nextProps.playbackRate);
      }
    }
    // shouldComponentUpdate (nextProps) {
    //   return this.props.url !== nextProps.url
    // }

  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      var _this2 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && fraction !== 0) {
        this.seekOnPlay = fraction;
        setTimeout(function () {
          _this2.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
      }
    }
  }]);

  return BasePlayer;
}(_react.Component);

BasePlayer.propTypes = _props2.propTypes;
BasePlayer.defaultProps = _props2.defaultProps;
exports['default'] = BasePlayer;
module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timingMark = timingMark;
exports.timingMeasure = timingMeasure;
exports.itemLoadStart = itemLoadStart;
exports.itemLoaded = itemLoaded;
exports.appLoaded = appLoaded;
exports.appPartiallyLoaded = appPartiallyLoaded;

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _biLogger = __webpack_require__(29);

var _baseUtils = __webpack_require__(28);

var _fedopsLogger = __webpack_require__(270);

var fedopsLogger = _interopRequireWildcard(_fedopsLogger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function timingMark(name) {
  try {
    window.performance && performance.mark && performance.mark(name);
  } catch (e) {
    console.error('Error in timingMark', e);
  }
}

function timingMeasure(measureName, startMarkName, endMarkName) {
  try {
    if (window.performance && performance.measure) {
      if (endMarkName) {
        //performance.measure is not allowed to get undefined in ie
        performance.measure(measureName, startMarkName, endMarkName);
      } else if (startMarkName) {
        performance.measure(measureName, startMarkName);
      } else {
        performance.measure(measureName);
      }
    }
  } catch (e) {
    console.error('Error in timingMeasure', e);
  }
}

function itemLoadStart() {
  try {
    if (!window.itemLoadStart) {
      window.itemLoadStart = true;
      timingMark('itemLoadStart');
    }
  } catch (e) {
    //
  }
}

function itemLoaded() {
  try {
    if (!window.proGalleryItemLoaded) {
      timingMeasure('firstItemLoaded', 'itemLoadStart');
      window.proGalleryItemLoaded = true;
      // appLoaded('pro-gallery-statics')
      if (window.performance && performance.getEntriesByName) {
        var _performance$getEntri = performance.getEntriesByName('firstItemLoaded')[0],
            startTime = _performance$getEntri.startTime,
            duration = _performance$getEntri.duration;

        _biLogger.logger.trackBi(_biLogger.logger.biEvents.pro_gallery_load_uou, {
          endpoint: 'itemLoadStart',
          loading_time: Math.round(startTime)
        });
        _biLogger.logger.trackBi(_biLogger.logger.biEvents.pro_gallery_load_uou, {
          endpoint: 'firstItemLoadDuration',
          loading_time: Math.round(duration + startTime)
        });
      }
    }
  } catch (e) {
    console.error('apploaded measure', e);
  }
}

function appLoaded(appName) {
  if (_baseUtils.baseUtils.isTest()) {
    return;
  }
  try {
    window.createFedopsLogger = fedopsLogger.create || function () {};
    if (!window.proGalleryLoaded) {
      window.proGalleryLoaded = true;
      window.fedopsLogger = window.createFedopsLogger(appName, {
        networkAnalysis: window.debugApp === 'fedops'
      });
      if (window.fedopsLogger) {
        window.fedopsLogger.appLoaded();
      }
      _WixSdkWrapper2.default.Performance.applicationLoaded();
    }
  } catch (e) {
    console.error('fedopsLogger: apploaded failed ', appName, e);
  }
}

function appPartiallyLoaded(appName) {
  if (_baseUtils.baseUtils.isTest()) {
    return;
  }
  try {
    if (!window.proGalleryPartiallyLoaded) {
      window.proGalleryPartiallyLoaded = true;
      _WixSdkWrapper2.default.Performance.applicationLoadingStep(1, 'Pro Gallery is Loading');
    }
  } catch (e) {
    console.error('Wix performance: appPartiallyLoaded failed ', appName, e);
  }
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  _createClass(DataItem, [{
    key: 'isActive',
    value: function isActive() {
      return true;
    }
  }, {
    key: 'export',
    value: function _export() {
      return this.data;
    }
  }]);

  return DataItem;
}();

exports.default = DataItem;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Utils = function () {
  function Utils() {
    (0, _classCallCheck3.default)(this, Utils);

    this._hash2int = {};
  }

  (0, _createClass3.default)(Utils, [{
    key: 'stripSlashes',
    value: function stripSlashes(str) {
      var newStr = '';
      if (typeof str === 'string') {
        newStr = str.replace(/\\\//g, '/').replace(/\\'/g, '\'').replace(/\\"/g, '"').replace(/\\0/g, '\0').replace(/\\\\/g, '\\');
      }
      return newStr;
    }
  }, {
    key: 'parseStringObject',
    value: function parseStringObject(sObj) {
      if (typeof sObj !== 'string') {
        return sObj;
      }

      var stripedObj = this.stripSlashes(sObj);
      //eslint-disable-next-line
      if (typeof sObj === 'string' && /^[\],:{}\s]*$/.test(stripedObj.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        //this is a json
        try {
          return JSON.parse(stripedObj);
        } catch (e) {
          // console.error('Parse object error: Catched ', e);
        }
      }
      return stripedObj;
    }
  }, {
    key: 'hashToInt',
    value: function hashToInt(str, min, max) {
      var int = 0;

      if (typeof str === 'undefined' || str.length === 0) {
        return int;
      }

      if (!this._hash2int[str]) {
        for (var i = 0; i < str.length; i++) {
          int += str.charCodeAt(i);
        }
        this._hash2int[str] = int;
      }

      if (typeof min === 'undefined' || typeof max === 'undefined') {
        return this._hash2int[str];
      } else {
        return this._hash2int[str] % (max - min + 1) + min;
      }
    }
  }, {
    key: 'insertIfDefined',
    value: function insertIfDefined(obj, field, value) {
      if (typeof value !== 'undefined') {
        obj[field] = value;
      }
    }
  }, {
    key: 'convertStyleParams',
    value: function convertStyleParams(styleParams) {

      //default styleParams
      var convertedStyleParams = (0, _assign2.default)({
        cubeImages: false,
        cubeType: 'fill',
        cubeRatio: 1,
        rotatingCropRatios: '',
        smartCrop: false,
        imageMargin: 10,
        galleryMargin: 0,
        floatingImages: 0,
        chooseBestGroup: true,
        groupSize: 3,
        groupTypes: '1,2h,2v,3h,3v,3t,3b,3l,3r',
        rotatingGroupTypes: '',
        isVertical: true,
        minItemSize: 120,
        oneRow: false,
        gallerySize: 500,
        collageDensity: 50
      }, styleParams);

      this.insertIfDefined(convertedStyleParams, 'cubeImages', convertedStyleParams.cropItems);
      this.insertIfDefined(convertedStyleParams, 'cubeType', convertedStyleParams.cropType);
      this.insertIfDefined(convertedStyleParams, 'cubeRatio', convertedStyleParams.cropRatio);
      this.insertIfDefined(convertedStyleParams, 'rotatingCropRatios', Array.isArray(convertedStyleParams.rotatingCropRatios) ? convertedStyleParams.rotatingCropRatios.join(',') : undefined);
      this.insertIfDefined(convertedStyleParams, 'smartCrop', convertedStyleParams.smartCrop);
      this.insertIfDefined(convertedStyleParams, 'imageMargin', convertedStyleParams.itemSpacing);
      this.insertIfDefined(convertedStyleParams, 'galleryMargin', convertedStyleParams.layoutSpacing);
      this.insertIfDefined(convertedStyleParams, 'floatingImages', convertedStyleParams.randomSpacings);
      this.insertIfDefined(convertedStyleParams, 'chooseBestGroup', convertedStyleParams.smartGrouping);
      this.insertIfDefined(convertedStyleParams, 'groupSize', convertedStyleParams.itemsPerGroup);
      this.insertIfDefined(convertedStyleParams, 'groupTypes', Array.isArray(convertedStyleParams.allowedGroupTypes) ? convertedStyleParams.allowedGroupTypes.join(',') : undefined);
      this.insertIfDefined(convertedStyleParams, 'rotatingGroupTypes', Array.isArray(convertedStyleParams.rotatingGroupTypes) ? convertedStyleParams.rotatingGroupTypes.join(',') : undefined);
      this.insertIfDefined(convertedStyleParams, 'isVertical', convertedStyleParams.isColumnsLayout);
      this.insertIfDefined(convertedStyleParams, 'minItemSize', convertedStyleParams.minItemSize);
      this.insertIfDefined(convertedStyleParams, 'oneRow', convertedStyleParams.isVerticalScroll);
      this.insertIfDefined(convertedStyleParams, 'gallerySize', convertedStyleParams.rowSize || convertedStyleParams.columnSize);
      this.insertIfDefined(convertedStyleParams, 'collageDensity', convertedStyleParams.collageDensity);

      return convertedStyleParams;
    }
  }, {
    key: 'convertContainer',
    value: function convertContainer(container, styleParams) {
      var convertedContainer = (0, _extends3.default)({
        bounds: {}
      }, container);
      var width = container.width || container.galleryWidth;
      var height = container.height || container.galleryHeight;

      if (container.width >= 0) {
        convertedContainer.galleryWidth = width + ((styleParams.imageMargin || 0) - (styleParams.galleryMargin || 0)) * 2;
        delete convertedContainer.width;
      }
      if (container.height >= 0) {
        convertedContainer.galleryHeight = height + ((styleParams.imageMargin || 0) - (styleParams.galleryMargin || 0));
        delete convertedContainer.height;
      }

      return convertedContainer;
    }
  }]);
  return Utils;
}();

var utils = exports.utils = new Utils();

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _proGalleryLayouter = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryGroup = function () {
  function GalleryGroup(config) {
    (0, _classCallCheck3.default)(this, GalleryGroup);


    this.uniqueId = _index2.default.generateUUID();
    this.isGalleryGroup = true;

    if (config.dto && config.dto.dto) {
      config.dto = config.dto.dto; //defence patch due to mis-use of item-core
      if (_index2.default.isDev()) {
        console.warn('Item core is created with already existing item core');
      }
    }
    this.dto = _lodash2.default.merge({}, config.dto);
    _lodash2.default.merge(this, config.dto);

    if (config.scheme) {
      this.processScheme(config.scheme);
    } else {
      this.processScheme(new _proGalleryLayouter.Group({ dto: config.dto }).scheme);
    }

    if (config.items) {
      this.items = config.items;
    } else {
      console.warn('Pro Gallery created Gallery Group without items', config);
    }
  }

  (0, _createClass3.default)(GalleryGroup, [{
    key: 'processScheme',
    value: function processScheme(scheme) {
      this.id = scheme.id;
      this.idx = scheme.idx;
      this.width = scheme.width;
      this.height = scheme.height;
      this.totalHeight = scheme.totalHeight;
      this.ratio = scheme.ratio;
      this.top = scheme.top;
      this.left = scheme.left;
      this.right = scheme.right;
      this.bottom = scheme.bottom;
      this.visible = scheme.visible;
      this.rendered = scheme.rendered;
      this.required = scheme.required;
    }
  }, {
    key: 'renderProps',
    value: function renderProps(galleryConfig) {

      return {
        className: 'group',
        id: this.id,
        idx: this.idx,
        key: this.key,
        type: this.type,
        top: this.top,
        left: this.left,
        right: this.right,
        bottom: this.bottom,
        width: this.width,
        height: this.height,
        bottomInfoHeight: this.bottomInfoHeight,
        totalHeight: this.totalHeight,
        items: this.items,
        visible: this.visible,
        rendered: this.rendered,
        required: this.required,
        galleryConfig: galleryConfig
      };
    }
  }, {
    key: 'key',
    get: function get() {
      return 'group_' + this.id;
    }
  }]);
  return GalleryGroup;
}();

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

////// <reference path="../../reference.ts" />


exports.default = GalleryGroup;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _versionManager = __webpack_require__(52);

var _versionManager2 = _interopRequireDefault(_versionManager);

var _proGalleryVersionManager = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpacingVersionManager = function () {
  function SpacingVersionManager(proGallertVersionManager) {
    (0, _classCallCheck3.default)(this, SpacingVersionManager);

    this.pgVersionManager = proGallertVersionManager || _proGalleryVersionManager.pgVersionManager;
  }

  (0, _createClass3.default)(SpacingVersionManager, [{
    key: 'isNewSpacing',
    value: function isNewSpacing() {
      return this.pgVersionManager.getVersion('spacing') !== _versionManager2.default.Versions.min;
    }
  }]);
  return SpacingVersionManager;
}();

var spacingVersionManager = new SpacingVersionManager();
module.exports = { spacingVersionManager: spacingVersionManager, SpacingVersionManager: SpacingVersionManager };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(53)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(21);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(147)(false);
var IE_PROTO = __webpack_require__(58)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(33);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(21);
var toObject = __webpack_require__(35);
var IE_PROTO = __webpack_require__(58)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(14);
var core = __webpack_require__(8);
var fails = __webpack_require__(25);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(151), __esModule: true };

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(34);
var $export = __webpack_require__(14);
var redefine = __webpack_require__(91);
var hide = __webpack_require__(20);
var Iterators = __webpack_require__(27);
var $iterCreate = __webpack_require__(156);
var setToStringTag = __webpack_require__(43);
var getPrototypeOf = __webpack_require__(87);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(11).document;
module.exports = document && document.documentElement;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(85);
var hiddenKeys = __webpack_require__(60).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(42);
var createDesc = __webpack_require__(31);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(54);
var has = __webpack_require__(21);
var IE8_DOM_DEFINE = __webpack_require__(84);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {



/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(96);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(194);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(187);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(103);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(66);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  videoModeChanged: 'VIDEO_MODE_CHANGED'
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemViewAction = itemViewAction;
exports.playVideo = playVideo;
exports.pauseVideo = pauseVideo;
var ITEM_VIEW_ACTION = exports.ITEM_VIEW_ACTION = 'ITEM_VIEW_ACTION';
var PLAY_VIDEO = exports.PLAY_VIDEO = 'PLAY_VIDEO';
var PAUSE_VIDEO = exports.PAUSE_VIDEO = 'PAUSE_VIDEO';

function itemViewAction() {
  return {
    type: ITEM_VIEW_ACTION
  };
}

function playVideo(idx) {
  return {
    idx: idx,
    type: PLAY_VIDEO
  };
}

function pauseVideo() {
  return {
    type: PAUSE_VIDEO
  };
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(209);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(46);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(15);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(27);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(15);
var aFunction = __webpack_require__(40);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(24);
var invoke = __webpack_require__(230);
var html = __webpack_require__(92);
var cel = __webpack_require__(53);
var global = __webpack_require__(11);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(33)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(75);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_114__;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(237);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _groupView = __webpack_require__(116);

var _groupView2 = _interopRequireDefault(_groupView);

var _galleryDebugMessage = __webpack_require__(129);

var _galleryDebugMessage2 = _interopRequireDefault(_galleryDebugMessage);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _galleryEmpty = __webpack_require__(130);

var _galleryEmpty2 = _interopRequireDefault(_galleryEmpty);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _performanceUtils = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_index2.default.fixViewport('Gallery');

var GalleryView = function (_React$Component) {
  (0, _inherits3.default)(GalleryView, _React$Component);

  function GalleryView(props) {
    (0, _classCallCheck3.default)(this, GalleryView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GalleryView.__proto__ || (0, _getPrototypeOf2.default)(GalleryView)).call(this, props));

    _this.handleArrowKeys = _this.handleArrowKeys.bind(_this);
    _this.showMoreItems = _this.showMoreItems.bind(_this);
    _this.createGalleryConfig = _this.createGalleryConfig.bind(_this);
    _this.createEmptyState = _this.createEmptyState.bind(_this);
    _this.screenLogs = _this.screenLogs.bind(_this);
    _this.createGallery = _this.createGallery.bind(_this);

    _this.id = Date.now() + '|' + Math.floor(Math.random() * 10000);

    _this.state = {
      currentIdx: 0
    };
    if (!_index2.default.isLocal()) {
      (0, _performanceUtils.appPartiallyLoaded)('pro-gallery-statics');
    }
    return _this;
  }

  (0, _createClass3.default)(GalleryView, [{
    key: 'handleArrowKeys',
    value: function handleArrowKeys(e) {
      var activeItemIdx = document.activeElement.getAttribute('data-idx');

      if (activeItemIdx) {

        var findNeighborItem = this.props.galleryStructure.findNeighborItem;
        var idx = Number(activeItemIdx);

        var newIdx = -1;

        switch (e.keyCode || e.charCode) {
          case 38:
            //up
            newIdx = findNeighborItem(idx, 'up');
            break;
          case 37:
            //left
            newIdx = findNeighborItem(idx, 'left');
            break;
          case 40:
            //down
            newIdx = findNeighborItem(idx, 'down');
            break;
          case 39:
            //right
            newIdx = findNeighborItem(idx, 'right');
            break;
        }

        if (newIdx >= 0) {
          e.preventDefault();
          e.stopPropagation();
          _index2.default.setStateAndLog(this, 'Set Gallery Current Item', {
            currentIdx: newIdx
          });
          return false;
        }
      }

      return true;
    }
  }, {
    key: 'showMoreItems',
    value: function showMoreItems() {
      var _this2 = this;

      if (_index2.default.isAccessibilityEnabled()) {
        // tal - I left this check since we do not want to focus the last item in non-accessibility mode
        //find the last visible item and focus on it
        try {
          var lastItemIdx = this.props.galleryStructure.lastVisibleItemIdx();
          _index2.default.setStateAndLog(this, 'Focus on Last Gallery Item', {
            currentIdx: lastItemIdx + 1
          }, function () {
            _this2.props.actions.toggleInfiniteScroll();
          });
        } catch (e) {
          console.warn('Cannot find item to focus', e);
        }
      } else {
        this.props.actions.toggleInfiniteScroll();
      }
    }
  }, {
    key: 'createGallery',
    value: function createGallery(showMore) {
      var _this3 = this;

      var galleryConfig = this.createGalleryConfig();
      var showMoreContainerHeight = 138; //according to the scss
      var galleryHeight = showMore ? this.props.container.galleryHeight - showMoreContainerHeight * _index2.default.getViewportScaleRatio() + 'px' : '100%';
      var debugMsg = _react2.default.createElement(_galleryDebugMessage2.default, this.props.debug);
      var columns = this.props.galleryStructure.columns;

      var layout = _lodash2.default.map(columns, function (column, c) {

        var paddingTop = 0;
        if (_this3.props.gotScrollEvent) {
          var firstRenderedGroup = _lodash2.default.find(column.groups, function (group) {
            return group.rendered;
          });
          if (!firstRenderedGroup) {
            if (_this3.props.scroll.top > 0 && column.groups.length > 0) {
              //gallery is above the fold
              firstRenderedGroup = { top: column.groups[column.groups.length - 1].bottom };
            } else {
              //gallery is below the fold
              firstRenderedGroup = { top: 0 };
            }
          }
          paddingTop = firstRenderedGroup.top || 0;
        }

        return !!column.galleryGroups.length && _react2.default.createElement(
          'div',
          { 'data-hook': 'gallery-column', className: 'gallery-column', key: 'column' + c,
            style: { width: column.width, paddingTop: paddingTop } },
          column.galleryGroups.map(function (group) {
            return group.rendered ? _react2.default.createElement(_groupView2.default, _lodash2.default.merge(group.renderProps(galleryConfig), { store: _this3.props.store })) : false;
          })
        );
      });
      return _react2.default.createElement(
        'div',
        { id: 'pro-gallery-container', className: 'pro-gallery inline-styles ' + (this.props.styleParams.oneRow ? ' one-row slider hide-scrollbars ' : '') + (_index2.default.isAccessibilityEnabled() ? ' accessible ' : ''),
          style: {
            height: galleryHeight,
            width: this.props.container.galleryWidth,
            overflowX: 'hidden'
          },
          onKeyDown: this.handleArrowKeys
        },
        debugMsg,
        layout
      );
    }
  }, {
    key: 'createGalleryConfig',
    value: function createGalleryConfig() {
      return {
        scroll: this.props.scroll,
        container: this.props.container,
        styleParams: this.props.styleParams,
        multishare: this.props.multishare,
        watermark: this.props.watermark,
        settings: this.props.settings,
        currentIdx: this.state.currentIdx,
        actions: {
          getMoreItemsIfNeeded: this.props.actions.getMoreItemsIfNeeded,
          toggleFullscreen: this.props.actions.toggleFullscreen,
          addItemToMultishare: this.props.actions.addItemToMultishare,
          removeItemFromMultishare: this.props.actions.removeItemFromMultishare
        }
      };
    }
  }, {
    key: 'createEmptyState',
    value: function createEmptyState() {
      return !(this.props.renderedItemsCount > 0) && _index2.default.isEditor() ? _react2.default.createElement(_galleryEmpty2.default, { actions: {
          setWixHeight: this.props.actions.setWixHeight
        } }) : '';
    }
  }, {
    key: 'screenLogs',
    value: function screenLogs() {
      return _index2.default.shouldDebug('screenLogs') ? _react2.default.createElement(
        'div',
        { className: 'screen-logs' },
        'URL width: ',
        _index2.default.parseGetParam('width'),
        ', Container: ',
        (0, _stringify2.default)(this.props.container.galleryWidth),
        ', document.body.clientWidth ',
        document.body.clientWidth,
        ', window.innerWidth ',
        window.innerWidth,
        ', window.screen.width: ',
        window.screen.width
      ) : '';
    }
  }, {
    key: 'createShowMoreButton',
    value: function createShowMoreButton() {
      var showMoreButton = false;
      var shouldShowButton = !this.props.scroll.isInfinite && this.props.galleryStructure.height > _index2.default.getWindowHeight();

      if (shouldShowButton) {

        var buttonText = this.props.styleParams.loadMoreButtonText || 'Load More';

        showMoreButton = _react2.default.createElement(
          'div',
          { className: 'show-more-container' },
          _react2.default.createElement(
            'button',
            {
              tabIndex: _index2.default.getTabIndex('loadMoreButton'),
              className: 'show-more',
              onClick: this.showMoreItems,
              'data-hook': 'show-more',
              'aria-label': buttonText
            },
            buttonText
          )
        );
      }

      return showMoreButton;
    }
  }, {
    key: 'getStyles',
    value: function getStyles() {
      return {
        margin: -1 * (this.props.styleParams.imageMargin - this.props.styleParams.galleryMargin)
      };
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      if (_index2.default.isVerbose()) {
        console.count('galleryView render');
        console.time('Rendering Gallery took ');
        console.log('[DEBUG_RENDER] GalleryView styleParams', this.props.styleParams);
        console.log('[DEBUG_RENDER] GalleryView props changed', _index2.default.printableObjectsDiff(this.lastProps || {}, this.props));
        this.lastProps = _lodash2.default.cloneDeep(this.props);
        console.log('[DEBUG_RENDER] GalleryView state changed', _index2.default.printableObjectsDiff(this.lastState || {}, this.state));
        this.lastState = _lodash2.default.cloneDeep(this.state);
        this.renderCount = (this.renderCount || 0) + 1;
      }

      var showMore = this.createShowMoreButton();
      var gallery = this.createGallery(showMore);
      var emptyState = this.createEmptyState();

      if (_index2.default.isVerbose()) {
        console.timeEnd('Rendering Gallery took ');
      }
      var screenLogs = this.screenLogs();

      return _react2.default.createElement(
        'div',
        { className: 'pro-gallery-parent-container',
          key: 'pro-gallery-' + this.id,
          style: this.getStyles()
        },
        screenLogs,
        emptyState,
        gallery,
        showMore
      );
    }
  }]);
  return GalleryView;
}(_react2.default.Component);

exports.default = GalleryView;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(76);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _itemContainer = __webpack_require__(241);

var _itemContainer2 = _interopRequireDefault(_itemContainer);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupView = function (_React$Component) {
  (0, _inherits3.default)(GroupView, _React$Component);

  function GroupView(props) {
    (0, _classCallCheck3.default)(this, GroupView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupView.__proto__ || (0, _getPrototypeOf2.default)(GroupView)).call(this, props));

    _this.displayName = 'GroupView';
    _this.dom = [];

    _this.state = {
      visibleVertically: false,
      renderedVertically: false,
      visibleHorizontally: false,
      renderedHorizontally: false
    };

    _this.useRefactoredProGallery = !!(window && window.petri && window.petri['specs.pro-gallery.newGalleryContainer'] === 'true');

    return _this;
  }

  (0, _createClass3.default)(GroupView, [{
    key: 'isRenderedVertically',
    value: function isRenderedVertically(_ref) {
      var target = _ref.target;

      var renderedPadding = _utils2.default.parseGetParam('renderedPadding') || target.clientHeight * 2;
      var isBelowViewportTop = target.offsetTop + this.props.bottom > target.scrollTop - renderedPadding;
      var isAboveViewportBottom = target.offsetTop + this.props.top < target.scrollTop + target.clientHeight + renderedPadding;
      var rendered = isBelowViewportTop && isAboveViewportBottom;
      return rendered;
    }
  }, {
    key: 'isVisibleVertically',
    value: function isVisibleVertically(_ref2) {
      var target = _ref2.target;

      var visiblePadding = _utils2.default.parseGetParam('displayPadding') || target.clientHeight * 0.5;
      var isBelowViewportTop = target.offsetTop + this.props.bottom > target.scrollTop - visiblePadding;
      var isAboveViewportBottom = target.offsetTop + this.props.top < target.scrollTop + target.clientHeight + visiblePadding;
      var visible = isBelowViewportTop && isAboveViewportBottom;
      if (this.props.idx === 0) {
        console.log('PROGALLERY [visibility] - Gallery #' + target.offsetTop + ' Group #' + this.props.idx + ' is vertically ' + (visible ? 'VISIBLE' : 'HIDDEN'), target);
      }
      return visible;
    }
  }, {
    key: 'isVisibleHorizontally',
    value: function isVisibleHorizontally(_ref3) {
      var target = _ref3.target;

      if (!this.props.galleryConfig.styleParams.oneRow) {
        return true;
      }
      var visiblePadding = _utils2.default.parseGetParam('displayPadding') || target.clientWidth * 0.5;
      var isRightToViewportLeft = this.props.right > target.scrollLeft - visiblePadding;
      var isLeftToViewportRight = this.props.left < target.scrollLeft + target.clientWidth + visiblePadding;
      var visible = isRightToViewportLeft && isLeftToViewportRight;
      // console.log(`PROGALLERY [visibility] - Gallery #${target.offsetTop} Group #${this.props.idx} is horizontally ${visible ? 'VISIBLE' : 'HIDDEN'}`);
      return visible;
    }
  }, {
    key: 'isRenderedHorizontally',
    value: function isRenderedHorizontally(_ref4) {
      var target = _ref4.target;

      if (!this.props.galleryConfig.styleParams.oneRow) {
        return true;
      }
      var renderedPadding = _utils2.default.parseGetParam('renderedPadding') || target.clientWidth * 2;
      var isRightToViewportLeft = this.props.right > target.scrollLeft - renderedPadding;
      var isLeftToViewportRight = this.props.left < target.scrollLeft + target.clientWidth + renderedPadding;
      var rendered = isRightToViewportLeft && isLeftToViewportRight;
      return rendered;
    }
  }, {
    key: 'setVisibilityState',
    value: function setVisibilityState(state) {
      var _this2 = this;

      var newState = {};
      (0, _keys2.default)(state).forEach(function (key) {
        if (state[key] !== _this2.state[key]) {
          newState[key] = state[key];
        }
      });
      this.setState(newState);
    }
  }, {
    key: 'setVerticalVisibility',
    value: function setVerticalVisibility(params) {
      this.setVisibilityState({
        visibleVertically: this.isVisibleVertically(params),
        renderedVertically: this.isRenderedVertically(params)
      });
    }
  }, {
    key: 'setHorizontalVisibility',
    value: function setHorizontalVisibility(params) {
      this.setVisibilityState({
        visibleHorizontally: this.isVisibleHorizontally(params),
        renderedHorizontally: this.isRenderedHorizontally(params)
      });
    }
  }, {
    key: 'setInitialVisibility',
    value: function setInitialVisibility() {
      var _props$galleryConfig$ = this.props.galleryConfig.container,
          scrollBase = _props$galleryConfig$.scrollBase,
          height = _props$galleryConfig$.height,
          width = _props$galleryConfig$.width,
          galleryHeight = _props$galleryConfig$.galleryHeight,
          galleryWidth = _props$galleryConfig$.galleryWidth;

      this.setVerticalVisibility({
        target: {
          scrollTop: 0,
          offsetTop: scrollBase,
          clientHeight: height || galleryHeight
        }
      });
      this.setHorizontalVisibility({
        target: {
          scrollLeft: 0,
          clientWidth: width || galleryWidth
        }
      });
    }
  }, {
    key: 'initScrollListener',
    value: function initScrollListener() {
      this.onVerticalScroll = _lodash2.default.throttle(this.setVerticalVisibility.bind(this), 500);
      var getScrollingElement = this.props.galleryConfig.container.getScrollingElement;

      getScrollingElement.vertical().addEventListener('scroll', this.onVerticalScroll);
      var oneRow = this.props.galleryConfig.styleParams.oneRow;

      if (oneRow) {
        this.onHorizontalScroll = _lodash2.default.throttle(this.setHorizontalVisibility.bind(this), 500);
        getScrollingElement.horizontal().addEventListener('scroll', this.onHorizontalScroll);
      }
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      var getScrollingElement = this.props.galleryConfig.container.getScrollingElement;

      getScrollingElement.vertical().removeEventListener('scroll', this.onVerticalScroll);
      getScrollingElement.horizontal().removeEventListener('scroll', this.onHorizontalScroll);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.useRefactoredProGallery) {
        this.initScrollListener();
        this.setInitialVisibility();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.useRefactoredProGallery) {
        this.removeScrollListener();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.useRefactoredProGallery) {
        if (this.props.galleryConfig.actions.getMoreItemsIfNeeded && this.state.visible) {
          //this group just got rendered - if it's the last, check if more items can be fetched from the db
          this.props.galleryConfig.actions.getMoreItemsIfNeeded(this.props.idx);
        }
      }
    }
  }, {
    key: 'createDom',
    value: function createDom(rendered, visible) {
      if (this.useRefactoredProGallery && !rendered) {
        return null;
      } else {
        var dom = [];
        for (var item, i = 0; item = this.props.items[i]; i++) {
          dom.push(_react2.default.createElement(_itemContainer2.default, _lodash2.default.merge(item.renderProps(_lodash2.default.merge(this.props.galleryConfig, { visible: visible, bottomInfoHeight: this.props.bottomInfoHeight })), { store: this.props.store })));
        }
        return dom;
      }
    }
  }, {
    key: 'render',
    value: function render() {

      var visible = this.useRefactoredProGallery ? this.state.visibleVertically && this.state.visibleHorizontally : this.props.visible;
      var rendered = this.useRefactoredProGallery ? this.state.renderedVertically && this.state.renderedHorizontally : this.props.rendered;

      return _react2.default.createElement(
        'div',
        {
          className: ' gallery-group gallery-group-' + (rendered ? visible ? 'visible' : 'hidden' : 'none'),
          style: { width: this.props.width, height: this.props.totalHeight },
          'data-hook': 'group-view',
          key: 'group_' + this.props.idx,
          'data-group-idx': this.props.idx,
          'data-group-type': this.props.type,
          'data-group-ratios': this.props.ratios,
          'data-visible': rendered ? visible ? 'visible' : 'rendered' : 'hidden'
        },
        !!this.useRefactoredProGallery && this.props.idx,
        this.createDom(rendered, visible)
      );
    }
  }]);
  return GroupView;
}(_react2.default.Component);

exports.default = GroupView;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _customButtonIcon = __webpack_require__(258);

var _customButtonIcon2 = _interopRequireDefault(_customButtonIcon);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _biLogger = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomButton = function (_React$Component) {
  (0, _inherits3.default)(CustomButton, _React$Component);

  function CustomButton() {
    (0, _classCallCheck3.default)(this, CustomButton);
    return (0, _possibleConstructorReturn3.default)(this, (CustomButton.__proto__ || (0, _getPrototypeOf2.default)(CustomButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomButton, [{
    key: 'render',
    value: function render() {
      var styleParams = this.props.styleParams;

      var defaultText = _index2.default.isStoreGallery() ? 'Buy Now' : 'Click here';
      var buttonText = styleParams.customButtonText || defaultText;
      return _react2.default.createElement(
        'div',
        { className: 'custom-button-wrapper', style: { justifyContent: styleParams.galleryHorizontalAlign } },
        this.props.small ? _react2.default.createElement(_customButtonIcon2.default, null) : _react2.default.createElement(
          'button',
          { 'data-hook': 'custom-button-button', onClick: function onClick() {
              return _biLogger.logger.trackBi(_biLogger.logger.biEvents.buyNowClick);
            },
            tabIndex: -1
          },
          buttonText,
          _react2.default.createElement('div', { className: 'overlay' })
        )
      );
    }
  }]);
  return CustomButton;
}(_react2.default.Component);

exports.default = CustomButton;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTitle = function (_React$Component) {
  (0, _inherits3.default)(ItemTitle, _React$Component);

  function ItemTitle() {
    (0, _classCallCheck3.default)(this, ItemTitle);
    return (0, _possibleConstructorReturn3.default)(this, (ItemTitle.__proto__ || (0, _getPrototypeOf2.default)(ItemTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemTitle, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          title = _props.title,
          style = _props.style;

      return _react2.default.createElement(
        "div",
        { className: "gallery-item-title", "data-hook": "item-title", style: style },
        title
      );
    }
  }]);
  return ItemTitle;
}(_react2.default.Component);

exports.default = ItemTitle;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _itemActions = __webpack_require__(22);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _loveButton = __webpack_require__(268);

var _loveButton2 = _interopRequireDefault(_loveButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoveButton = function (_React$Component) {
  (0, _inherits3.default)(LoveButton, _React$Component);

  function LoveButton(props) {
    (0, _classCallCheck3.default)(this, LoveButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoveButton.__proto__ || (0, _getPrototypeOf2.default)(LoveButton)).call(this, props));

    _this.toggleLove = _this.toggleLove.bind(_this);
    _this.updateLoveCount = _this.updateLoveCount.bind(_this);

    _this.state = {
      isLoved: _itemActions.itemActions.isLoved(props.itemId),
      loveCount: _itemActions.itemActions.getLoveCount(props.itemId),
      animate: false
    };
    return _this;
  }

  (0, _createClass3.default)(LoveButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currIsLoved = _itemActions.itemActions.isLoved(nextProps.itemId);
      var currLoveCount = _itemActions.itemActions.getLoveCount(nextProps.itemId);
      if (nextProps.itemId !== this.props.itemId || this.state.isLoved !== currIsLoved || this.state.loveCount !== currLoveCount) {
        this.setState({
          isLoved: currIsLoved,
          loveCount: currLoveCount
        });
      }
    }
  }, {
    key: 'toggleLove',
    value: function toggleLove(e) {
      e.stopPropagation();
      e.preventDefault();
      var item = _lodash2.default.pick(this.props, ['layout', 'type', 'itemId', 'id', 'item', 'idx', 'hashtag']);
      (0, _assign2.default)(item, { type: 'image' });
      _itemActions.itemActions.postLoveActivity(item);
      _itemActions.itemActions.toggleLove(item.itemId, item.layout);
      this.setState({
        animate: !this.state.isLoved,
        isLoved: !this.state.isLoved
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('love_count_fetched', this.updateLoveCount);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('love_count_fetched', this.updateLoveCount);
    }
  }, {
    key: 'containerClassName',
    value: function containerClassName() {
      switch (this.props.layout) {
        case 'fullscreen':
          return 'fullscreen-social-love-container show-tooltip';
        default:
          return 'block-fullscreen gallery-item-social-love gallery-item-social-button show-tooltip';
      }
    }
  }, {
    key: 'buttonClasssName',
    value: function buttonClasssName() {
      var className = [];
      switch (this.props.layout) {
        case 'fullscreen':
          className.push('fullscreen-social-love');
          break;
        default:
          className.push('gallery-item-social-love');
          if (!_utils2.default.isStoreGallery()) {
            className.push('block-fullscreen');
          }
      }
      className.push(this.viewClassName());
      if (this.state.isLoved) {
        className.push('progallery-svg-font-icons-love_full pro-gallery-loved');
        className.push(_loveButton2.default.loved);
      } else {
        className.push('progallery-svg-font-icons-love_empty');
      }
      if (this.state.animate) {
        className.push('love-animation');
      }
      return className.join(' ');
    }
  }, {
    key: 'viewClassName',
    value: function viewClassName() {
      switch (this.props.layout) {
        case 'fullscreen':
          return this.props.device === 'desktop' ? 'fullscreen-icon' : '';
        default:
          return '';
      }
    }
  }, {
    key: 'counterClassName',
    value: function counterClassName() {
      switch (this.props.layout) {
        case 'fullscreen':
          return 'fullscreen-social-love-count shown ' + this.viewClassName();
        default:
          return 'block-fullscreen gallery-item-social-love-count ' + this.viewClassName();
      }
    }
  }, {
    key: 'createLoveCounter',
    value: function createLoveCounter() {
      var count = this.state.loveCount + (this.state.isLoved ? 1 : 0);
      return !!this.props.showCounter && count > 0 ? _react2.default.createElement(
        'i',
        {
          'data-hook': 'love-counter',
          className: this.counterClassName() },
        count
      ) : null;
    }
  }, {
    key: 'createMouseOver',
    value: function createMouseOver() {
      var _this2 = this;

      return function (e) {
        if (_this2.props.isSettings) {
          _itemActions.itemActions.showTooltip(e, 'This option is not available in editor');
        }
      };
    }
  }, {
    key: 'createMouseOut',
    value: function createMouseOut() {
      var _this3 = this;

      return function () {
        if (_this3.props.isSettings) {
          _itemActions.itemActions.hideTooltip();
        }
      };
    }
  }, {
    key: 'updateLoveCount',
    value: function updateLoveCount() {
      this.setState({
        loveCount: _itemActions.itemActions.getLoveCount(this.props.itemId)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var loveCounter = this.createLoveCounter();
      var clickAction = _utils2.default.getMobileEnabledClick(this.toggleLove);

      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({ 'data-hook': 'love-button',
          className: this.containerClassName(),
          onMouseOver: this.createMouseOver(),
          onMouseOut: this.createMouseOut()
        }, clickAction),
        _react2.default.createElement('button', {
          'data-hook': 'love-icon',
          className: this.buttonClasssName(),
          role: 'checkbox'
        }),
        loveCounter
      );
    }
  }]);
  return LoveButton;
}(_react2.default.Component);

exports.default = LoveButton;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TranslationUtil = {
  getByKey: function getByKey(strKey) {
    try {
      var strValue = null;
      if (window.translations) {
        strValue = window.translations[strKey];
      }

      if ( /*utils.isDev() && */!strValue) {
        strValue = strKey;
      }

      if (window) {
        if (window.isClientDev) {
          strValue = strKey;
        }
        if (window.unescape) {
          strValue = window.unescape(strValue); // for chars that come from babel like &#39;
        }
      }

      return strValue;
    } catch (e) {
      return strKey;
    }
  }
};

exports.default = TranslationUtil;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts object to query string
 *
 * @param   {Object} data   a map to convert
 * @returns {String}        query string
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function mapToQuery(data) {
  var res = [];

  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      // eslint-disable-line
      res.push(key + '=' + encodeURIComponent(data[key]));
    }
  }

  return res.join('&');
}

/**
 * Generates a valid GUID
 *
 * @returns {String}  GUID
 */
function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line
    return v.toString(16);
  });
}

exports.default = {
  mapToQuery: mapToQuery,
  generateGuid: generateGuid
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataSource = __webpack_require__(276);

var _dataSource2 = _interopRequireDefault(_dataSource);

var _biLoadPhaseItem = __webpack_require__(277);

var _biLoadPhaseItem2 = _interopRequireDefault(_biLoadPhaseItem);

var _durationItem = __webpack_require__(123);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biErrorItem = __webpack_require__(127);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(50);

var _performance2 = _interopRequireDefault(_performance);

var _resourceItem = __webpack_require__(278);

var _resourceItem2 = _interopRequireDefault(_resourceItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base Logger
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, BaseLogger);

    this.appName = appName;
    this.appVersion = appVersion;
    this.reporter = reporter;
    this.params = { sessionId: sessionId };
    this.errorHandlerToggle = errorHandlerToggle;
    this.disableAutoLoadFinish = disableAutoLoadFinish;
    this.dataSource = new _dataSource2.default({ appName: appName });
    if (errorHandlerToggle) {
      window.fedopsLoggerErrorHandler.subscribeListener(appName, this.reportError.bind(this));
    }
  }

  _createClass(BaseLogger, [{
    key: 'reportNetworkAnalysis',
    value: function reportNetworkAnalysis() {
      var _this = this;

      var resources = _performance2.default.getResources();
      setTimeout(function () {
        try {
          var resourceDataItem = new _resourceItem2.default(_this.sessionId);
          var analysis = resourceDataItem.performNetworkAnalysis(resources);
          if (!analysis) {
            return;
          }
          var dataSource = _this.dataSource.clone().addItem(resourceDataItem).addItem(analysis);
          _this._report(dataSource);
        } catch (e) {
          console.error('[fedops] Failed to report resource metrics', e);
        }
      }, 1000);
    }
  }, {
    key: 'reportError',
    value: function reportError(error, errorType, errorInfo) {
      var interactionName = void 0;

      if (!this._appLoadedCalled) {
        interactionName = '[APP LOAD]';
      } else {
        interactionName = Object.keys(this._outgoingInteractions)[0];
      }

      var dataSource = this.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: errorType }).addItem({ errorInfo: errorInfo }).addItem(new _biErrorItem2.default(this.sessionId));

      // const stackTrace = error.stack;

      if (interactionName) {
        this._report(dataSource);
      }
    }
  }, {
    key: '_report',
    value: function _report(dataSource) {
      return this.reporter.report(dataSource.mergeItems());
    }
  }, {
    key: 'getAppName',
    value: function getAppName() {
      return this.appName;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      return this.appVersion;
    }
  }, {
    key: 'getReporter',
    value: function getReporter() {
      return this.reporter;
    }
  }, {
    key: 'getParam',
    value: function getParam(paramName) {
      return this.params[paramName];
    }
  }, {
    key: '_isDisableAutoLoadFinish',
    value: function _isDisableAutoLoadFinish() {
      return this.disableAutoLoadFinish;
    }
  }, {
    key: 'appLoadingPhase',


    /**
     * Custom phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
     * Call this method to report custom phases during initial application load.
     *
     * @param {String} phaseName  phase name
     */
    value: function appLoadingPhase(phaseName) {
      var dataSource = this.dataSource.clone().addItem({ name: phaseName }).addItem(new _biLoadPhaseItem2.default(this.sessionId)).addItem(new _durationItem2.default());

      return this._report(dataSource);
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = __webpack_require__(124);

var _time2 = _interopRequireDefault(_time);

var _dataItem = __webpack_require__(80);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DurationDataItem = function (_DataItem) {
  _inherits(DurationDataItem, _DataItem);

  function DurationDataItem(appName) {
    _classCallCheck(this, DurationDataItem);

    var _this = _possibleConstructorReturn(this, (DurationDataItem.__proto__ || Object.getPrototypeOf(DurationDataItem)).call(this, {
      duration: Math.floor(_time2.default.appLoadTime(appName))
    }));

    _this.appName = appName;
    return _this;
  }

  _createClass(DurationDataItem, [{
    key: 'setFirstRequestDuration',
    value: function setFirstRequestDuration() {
      this.data.frd = Math.floor(_time2.default.firstRequestDuration(this.appName));
      return this;
    }
  }]);

  return DurationDataItem;
}(_dataItem2.default);

exports.default = DurationDataItem;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appData = __webpack_require__(125);

var _appData2 = _interopRequireDefault(_appData);

var _performance = __webpack_require__(50);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function startLoadTime(appName) {
  return _appData2.default.getStartLoadTime(appName) || 0;
}

function endLoadTime() {
  return _performance2.default.now();
}

/**
 * calculates the app load time
 */
exports.default = {
  appLoadTime: function appLoadTime(appName) {
    return endLoadTime() - startLoadTime(appName);
  },
  loadStarted: function loadStarted(appName) {
    _appData2.default.setStartLoadTime(appName, _performance2.default.now());
  },
  firstRequestDuration: function firstRequestDuration(appName) {
    return startLoadTime(appName);
  }
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * window.fedops.apps wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAppData(appName) {
  return window.fedops.apps[appName];
}

exports.default = {
  init: function init(appName) {
    window.fedops.apps[appName] = window.fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var location = function location() {
  return typeof window !== 'undefined' && window.location;
};

exports.default = {
  getHost: function getHost() {
    return location() && window.location.host;
  },
  isFedopsDev: function isFedopsDev() {
    var q = (location() || {}).search || '';
    return q.indexOf('fedops=dev') > -1;
  }
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVID = undefined;

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVID = exports.EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiErrorItem = function (_BiBaseDataItem) {
  _inherits(BiErrorItem, _BiBaseDataItem);

  function BiErrorItem(sessionId) {
    _classCallCheck(this, BiErrorItem);

    return _possibleConstructorReturn(this, (BiErrorItem.__proto__ || Object.getPrototypeOf(BiErrorItem)).call(this, EVID, sessionId));
  }

  return BiErrorItem;
}(_biBaseItem2.default);

exports.default = BiErrorItem;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonItemContainer = exports.CommonItemContainerNotConnected = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _galleryActions = __webpack_require__(47);

var _itemViewActions = __webpack_require__(105);

var _reactRedux = __webpack_require__(45);

var _itemActions = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonItemContainerNotConnected = exports.CommonItemContainerNotConnected = function CommonItemContainerNotConnected(ComposedComponent) {
  var InnerComponent = function (_React$Component) {
    (0, _inherits3.default)(InnerComponent, _React$Component);

    function InnerComponent(props, context) {
      (0, _classCallCheck3.default)(this, InnerComponent);

      var _this = (0, _possibleConstructorReturn3.default)(this, (InnerComponent.__proto__ || (0, _getPrototypeOf2.default)(InnerComponent)).call(this, props, context));

      _this.updateLoveCount = _this.updateLoveCount.bind(_this);

      _this.state = {
        isLoved: _itemActions.itemActions.isLoved(props.photoId),
        loveCount: 0
      };
      return _this;
    }

    (0, _createClass3.default)(InnerComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('love_count_fetched', this.updateLoveCount);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('love_count_fetched', this.updateLoveCount);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var photoId = nextProps.photoId;

        this.setState({
          isLoved: _itemActions.itemActions.isLoved(photoId),
          loveCount: _itemActions.itemActions.getLoveCount(photoId)
        });
      }
    }, {
      key: 'updateLoveCount',
      value: function updateLoveCount() {
        this.setState({
          loveCount: _itemActions.itemActions.getLoveCount(this.props.photoId)
        });
      }
    }, {
      key: 'toggleLove',
      value: function toggleLove() {
        _itemActions.itemActions.postLoveActivity(this.props);
        _itemActions.itemActions.toggleLove(this.props.photoId, 'gallery');
        this.setState({
          isLoved: !this.state.isLoved
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var photoId = this.props.photoId;
        var _state = this.state,
            isLoved = _state.isLoved,
            loveCount = _state.loveCount;

        return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, {
          love: {
            isLoved: isLoved,
            count: loveCount + (isLoved ? 1 : 0),
            toggleLove: this.toggleLove.bind(this)
          }
        }));
      }
    }]);
    return InnerComponent;
  }(_react2.default.Component);

  return InnerComponent;
};

var CommonItemContainer = exports.CommonItemContainer = function CommonItemContainer(ComposedComponent) {
  var commonItemContainerNotConnected = CommonItemContainerNotConnected(ComposedComponent);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var galleryState = state.gallery || {};
    return {
      playing: galleryState.videoIndexPlay === ownProps.idx,
      documentHeight: galleryState.documentHeight,
      previewHover: galleryState.previewHover
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, { videoEnded: _galleryActions.videoEnded, videoAdded: _galleryActions.videoAdded, videoRemoved: _galleryActions.videoRemoved, playVideo: _itemViewActions.playVideo, pauseVideo: _itemViewActions.pauseVideo })(commonItemContainerNotConnected);
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryDebugMessage = function (_React$Component) {
  (0, _inherits3.default)(GalleryDebugMessage, _React$Component);

  function GalleryDebugMessage() {
    (0, _classCallCheck3.default)(this, GalleryDebugMessage);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryDebugMessage.__proto__ || (0, _getPrototypeOf2.default)(GalleryDebugMessage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryDebugMessage, [{
    key: 'render',
    value: function render() {
      if (_index2.default.getTopUrlParam('pgdebug') !== 'true') {
        return false;
      }

      var version = _react2.default.createElement(
        'div',
        { className: 'version-header ' },
        'Pro Gallery Version #',
        window.staticsVersion
      );

      var parentSize = '';
      try {
        parentSize = ' psw' + window.top.screen.width + ' piw' + window.top.innerWidth + ' pbw' + window.top.document.body.clientWidth;
      } catch (e) {
        //not on the domain
      }

      var debugMsg = _react2.default.createElement(
        'div',
        { className: 'version-header ' },
        _index2.default.isLandscape() ? 'land' : 'port',
        ' sw',
        window.screen.width,
        'sh',
        window.screen.height,
        ' iw',
        window.innerWidth,
        ' bw',
        document.body.clientWidth,
        ' sr',
        _index2.default.getViewportScaleRatio(),
        'rc',
        this.props.resizeCount,
        ' oc',
        this.props.orientationCount,
        ' nh',
        this.props.newHeight,
        ' lh',
        this.props.lastHeight,
        parentSize,
        'www',
        this.props.maxGalleryWidth
      );

      return _react2.default.createElement(
        'div',
        null,
        version,
        debugMsg
      );
    }
  }]);
  return GalleryDebugMessage;
}(_react2.default.Component);

exports.default = GalleryDebugMessage;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _translationUtils = __webpack_require__(120);

var _translationUtils2 = _interopRequireDefault(_translationUtils);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryEmpty = function (_React$Component) {
  (0, _inherits3.default)(GalleryEmpty, _React$Component);

  function GalleryEmpty() {
    (0, _classCallCheck3.default)(this, GalleryEmpty);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryEmpty.__proto__ || (0, _getPrototypeOf2.default)(GalleryEmpty)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryEmpty, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.setWixHeight(390, window.innerHeight);
    }
  }, {
    key: 'render',
    value: function render() {
      if (_utils2.default.isVerbose()) {
        console.log('Not rendering - gallery is empty');
      }
      var emptyContent = _utils2.default.isStoreGallery() ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-title' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header'),
          _react2.default.createElement('br', null),
          _translationUtils2.default.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Header2')
        ),
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-info' },
          _translationUtils2.default.getByKey('Gallery_ArtStore_Organize_Images_EmptyState_Text'),
          _react2.default.createElement('br', null)
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-title' },
          _translationUtils2.default.getByKey('Gallery_Empty_Title'),
          _react2.default.createElement('br', null),
          _translationUtils2.default.getByKey('Gallery_Empty_Title2')
        ),
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-info' },
          _translationUtils2.default.getByKey('Gallery_Empty_Description'),
          _react2.default.createElement('br', null),
          _translationUtils2.default.getByKey('Gallery_Empty_Description2')
        )
      );
      return _react2.default.createElement(
        'div',
        { className: 'pro-gallery-empty' },
        _react2.default.createElement(
          'div',
          { className: 'pro-gallery-empty-wrapper' },
          _react2.default.createElement('div', { className: 'pro-gallery-empty-image' }),
          emptyContent
        )
      );
    }
  }]);
  return GalleryEmpty;
}(_react2.default.Component);

exports.default = GalleryEmpty;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(106);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _groupView = __webpack_require__(116);

var _groupView2 = _interopRequireDefault(_groupView);

var _galleryEmpty = __webpack_require__(130);

var _galleryEmpty2 = _interopRequireDefault(_galleryEmpty);

var _proGalleryLayouter = __webpack_require__(39);

var _galleryDebugMessage = __webpack_require__(129);

var _galleryDebugMessage2 = _interopRequireDefault(_galleryDebugMessage);

var _performanceUtils = __webpack_require__(79);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_utils2.default.fixViewport('Gallery');

var SlideshowView = function (_React$Component) {
  (0, _inherits3.default)(SlideshowView, _React$Component);

  function SlideshowView(props) {
    (0, _classCallCheck3.default)(this, SlideshowView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SlideshowView.__proto__ || (0, _getPrototypeOf2.default)(SlideshowView)).call(this, props));

    _this.scrollToThumbnail = _this.scrollToThumbnail.bind(_this);
    _this.stopAutoSlideshow = _this.stopAutoSlideshow.bind(_this);
    _this.startAutoSlideshowIfNeeded = _this.startAutoSlideshowIfNeeded.bind(_this);
    _this.handleKeypress = _this.handleKeypress.bind(_this);
    _this.createEmptyState = _this.createEmptyState.bind(_this);
    _this._setCurrentItemByScroll = _lodash2.default.throttle(_this.setCurrentItemByScroll, 600, { leading: false, trailing: true }).bind(_this);
    _this._nextItem = _lodash2.default.throttle(_this.nextItem, 400, { leading: true, trailing: false }).bind(_this);
    _this.state = {
      flatItems: [],
      currentIdx: 0,
      isInView: true
    };
    if (!_utils2.default.isLocal()) {
      (0, _performanceUtils.appPartiallyLoaded)('pro-gallery-statics');
    }
    return _this;
  }

  (0, _createClass3.default)(SlideshowView, [{
    key: 'isFirstItem',
    value: function isFirstItem() {
      return this.state.currentIdx === 0 || this.props.scroll.top === 0;
    }
  }, {
    key: 'isLastItem',
    value: function isLastItem() {
      var _props$galleryStructu = this.props.galleryStructure.groups.slice(-1),
          _props$galleryStructu2 = (0, _slicedToArray3.default)(_props$galleryStructu, 1),
          lastGroup = _props$galleryStructu2[0];

      var isLastItem = this.state.currentIdx >= this.props.totalItemsCount - 1 || !lastGroup || this.props.container.galleryWidth + this.props.scroll.top >= lastGroup.right;
      return isLastItem;
    }
  }, {
    key: 'nextItem',
    value: function nextItem(direction, isAutoTrigger) {
      var scrollDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;

      var currentIdx = this.setCurrentItemByScroll() || this.state.currentIdx;
      var showArrows = this.props.styleParams.showArrows;
      var scrollToItem = this.props.actions.scrollToItem;

      var nextItem = currentIdx + direction;
      if (isAutoTrigger) {
        // ---- Called by the Auto Slideshow ---- //
        if (this.isLastItem()) {
          nextItem = 0;
          scrollDuration = 0;
        }
      } else {
        // ---- Called by the user (arrows, keys etc.) ---- //
        this.startAutoSlideshowIfNeeded(this.props.styleParams);
        var isScrollingPastEdge = direction === 1 && this.isLastItem() || direction === -1 && this.isFirstItem();
        if (isScrollingPastEdge) {
          return;
        }
      }
      // ---- navigate ---- //
      try {
        scrollToItem(nextItem, false, true, scrollDuration);
      } catch (e) {
        console.error('Cannot proceed to the next Item', e);
        this.stopAutoSlideshow();
        return;
      }
      this.isAutoScrolling = true;
      _utils2.default.setStateAndLog(this, 'Next Item', {
        currentIdx: nextItem
      });
    }
  }, {
    key: 'stopAutoSlideshow',
    value: function stopAutoSlideshow() {
      clearInterval(this.autoSlideshowInterval);
    }
  }, {
    key: 'startAutoSlideshowIfNeeded',
    value: function startAutoSlideshowIfNeeded(styleParams) {
      var _this2 = this;

      var isAutoSlideshow = styleParams.isAutoSlideshow,
          autoSlideshowInterval = styleParams.autoSlideshowInterval,
          galleryLayout = styleParams.galleryLayout;

      this.stopAutoSlideshow();
      if (!(galleryLayout === 5 || galleryLayout === 4 || galleryLayout === 3)) return;
      if (!(isAutoSlideshow && autoSlideshowInterval > 0 && this.state.isInView)) return;
      this.autoSlideshowInterval = setInterval(function () {
        _this2._nextItem(1, true, 800);
      }, autoSlideshowInterval * 1000);
    }
  }, {
    key: 'scrollToThumbnail',
    value: function scrollToThumbnail(itemIdx) {
      var scrollDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
      //not to confuse with this.props.actions.scrollToItem. this is used to replace it only for thumbnail items
      this.isAutoScrolling = true;
      this.startAutoSlideshowIfNeeded(this.props.styleParams);

      itemIdx += this.firstItemIdx;

      _utils2.default.setStateAndLog(this, 'Scroll to Item', {
        currentIdx: itemIdx
      });

      this.props.actions.scrollToItem(itemIdx, false, true, scrollDuration);
    }
  }, {
    key: 'handleKeypress',
    value: function handleKeypress(e) {
      if (!_utils2.default.isInWix()) {
        return;
      }
      switch (e.charCode || e.keyCode) {
        case 38: //up
        case 37: //left
        case 33:
          //page up
          e.preventDefault();
          this._nextItem(-1);
          return false;
        case 39: //right
        case 40: //down
        case 32: //space
        case 34:
          //page down
          e.preventDefault();
          this._nextItem(1);
          return false;
      }
      return true; //continue handling the original keyboard event
    }
  }, {
    key: 'createThumbnails',
    value: function createThumbnails(thumbnailPosition) {
      var _this3 = this;

      var currentIdx = this.state.currentIdx; // zero based (3)
      _utils2.default.isVerbose() && console.log('creating thumbnails for idx', currentIdx);

      var width = this.props.thumbnailSize;
      var height = this.props.thumbnailSize;

      var oneRow = void 0;
      var numOfThumbnails = void 0;

      switch (thumbnailPosition) {
        case 'top':
        case 'bottom':
          width = this.props.container.galleryWidth + this.props.styleParams.thumbnailSpacings; //window.innerWidth / utils.getViewportScaleRatio();
          height = this.props.thumbnailSize + 2 * this.props.styleParams.thumbnailSpacings;
          oneRow = true;
          numOfThumbnails = Math.ceil(width / this.props.thumbnailSize);
          break;
        case 'left':
        case 'right':
          height = this.props.container.galleryHeight + 2 * this.props.styleParams.thumbnailSpacings; // window.innerHeight * utils.getViewportScaleRatio();
          width = this.props.thumbnailSize + 2 * this.props.styleParams.thumbnailSpacings;
          oneRow = false;
          numOfThumbnails = Math.ceil(height / this.props.thumbnailSize);
          break;
      }

      this.firstItemIdx = currentIdx - Math.floor(numOfThumbnails / 2); // (1)
      this.lastItemIdx = this.firstItemIdx + numOfThumbnails - 1; // (5)

      if (this.firstItemIdx < 0) {
        this.lastItemIdx -= this.firstItemIdx;
        this.firstItemIdx = 0;
      }

      if (this.lastItemIdx > this.props.items.length - 1) {
        this.firstItemIdx -= this.lastItemIdx - (this.props.items.length - 1);
        if (this.firstItemIdx < 0) {
          this.firstItemIdx = 0;
        }
        this.lastItemIdx = this.props.items.length - 1;
      }

      numOfThumbnails = this.lastItemIdx - this.firstItemIdx + 1;
      if (numOfThumbnails % 2 === 0) {
        // keep an odd number of thumbnails
        numOfThumbnails += 1;
        this.lastItemIdx += 1;
      }
      var thumbnailsContainerSize = numOfThumbnails * (this.props.thumbnailSize + this.props.styleParams.thumbnailSpacings);
      var thumbnailsStyle = { width: width, height: height };

      if (currentIdx > numOfThumbnails / 2 - 1 && currentIdx < this.props.items.length - numOfThumbnails / 2) {
        //set selected to center only if neeeded
        switch (thumbnailPosition) {
          case 'top':
          case 'bottom':
            thumbnailsStyle.width = thumbnailsContainerSize + 'px';
            thumbnailsStyle.left = 0;
            break;
          case 'left':
          case 'right':
            thumbnailsStyle.height = thumbnailsContainerSize + 'px';
            thumbnailsStyle.marginTop = (height - thumbnailsContainerSize) / 2 + 'px';
            break;
        }
      } else if (currentIdx < numOfThumbnails / 2 - 1) {
        //one of the first thumbnails
        switch (thumbnailPosition) {
          case 'top':
          case 'bottom':
            thumbnailsStyle.width = thumbnailsContainerSize + 'px';
            thumbnailsStyle.left = 0;
            break;
          case 'left':
          case 'right':
            thumbnailsStyle.height = thumbnailsContainerSize + 'px';
            thumbnailsStyle.marginTop = 0;
            break;
        }
      } else if (this.lastItemIdx > numOfThumbnails && currentIdx >= this.lastItemIdx - 3) {
        //scroll to the left/top if the chosen thumbnail is one of the last three
        var entireThumbnailsSize = thumbnailsContainerSize - this.props.styleParams.thumbnailSpacings;
        switch (thumbnailPosition) {
          case 'top':
          case 'bottom':
            thumbnailsStyle.left = width - entireThumbnailsSize + 'px';
            thumbnailsStyle.overflow = 'visible';
            break;
          case 'left':
          case 'right':
            thumbnailsStyle.top = height - entireThumbnailsSize + 'px';
            thumbnailsStyle.overflow = 'visible';
            break;
        }
      }

      var container = _lodash2.default.merge({}, this.props.container, {
        galleryWidth: width,
        galleryHeight: height
      });

      var thumbnailsLayout = this.props.convertToGalleryItems(new _proGalleryLayouter.Layouter({
        items: this.props.items.slice(this.firstItemIdx, this.lastItemIdx + 1).map(function (item) {
          return _this3.props.convertDtoToLayoutItem(item);
        }),
        container: container,
        watermark: this.props.watermark,
        styleParams: {
          gotStyleParams: false,
          isVertical: false,
          gallerySize: this.props.thumbnailSize,
          minItemSize: this.props.thumbnailSize,
          imageMargin: this.props.styleParams.thumbnailSpacings,
          galleryMargin: 0,
          groupSize: 1,
          chooseBestGroup: false,
          groupTypes: '1',
          cubeImages: true,
          smartCrop: false,
          collageAmount: 0,
          collageDensity: 0,
          cubeRatio: 1,
          fixedColumns: 0,
          oneRow: oneRow
        },
        gotScrollEvent: true,
        showAllItems: true
      }), { watermark: this.props.watermark });

      var thumbnailsConfig = {
        scroll: _lodash2.default.merge({}, this.props.scroll || {}),
        thumbnailHighlightId: _lodash2.default.get(this, 'props.items.' + currentIdx + '.itemId'),
        watermark: this.props.watermark,
        container: container,
        styleParams: _lodash2.default.merge({}, this.props.styleParams, {
          allowSocial: false,
          allowDownload: false,
          allowTitle: false,
          allowMultishare: false,
          loveButton: false,
          loveCounter: false,
          videoLoop: false,
          videoSpeed: 1,
          videoPlay: 'onClick',
          sharpParams: {
            quality: 90,
            usm: {}
          },
          imageMargin: this.props.styleParams.thumbnailSpacings,
          galleryMargin: 0,
          enableInfiniteScroll: 0,
          showArrows: false,
          itemClick: 'expand'
        }),
        actions: {
          scrollToItem: this.scrollToThumbnail,
          toggleFullscreen: this.props.actions.toggleFullscreen
        },
        hidePlay: true
      };

      var thumbnailsMargin = void 0;
      var m = this.props.styleParams.thumbnailSpacings;
      switch (this.props.styleParams.galleryThumbnailsAlignment) {
        case 'bottom':
          thumbnailsMargin = m + 'px -' + m + 'px 0 -' + m + 'px';
          break;
        case 'left':
          thumbnailsMargin = '-' + m + 'px ' + m + 'px -' + m + 'px 0';
          break;
        case 'top':
          thumbnailsMargin = '0 -' + m + 'px ' + m + 'px -' + m + 'px';
          break;
        case 'right':
          thumbnailsMargin = '-' + m + 'px 0 -' + m + 'px ' + m + 'px';
          break;
      }

      var thumbnails = _react2.default.createElement(
        'div',
        { className: 'pro-gallery inline-styles thumbnails-gallery ' + (oneRow ? ' one-row hide-scrollbars ' : '') + (_utils2.default.isAccessibilityEnabled() ? ' accessible ' : ''),
          style: {
            width: width,
            height: height,
            margin: thumbnailsMargin
          },
          'data-hook': 'gallery-thumbnails' },
        thumbnailsLayout.columns.map(function (column, c) {
          return _react2.default.createElement(
            'div',
            { 'data-hook': 'gallery-thumbnails-column', className: 'gallery-column', key: 'thumbnails-column' + c,
              style: thumbnailsStyle },
            column.galleryGroups.map(function (group) {
              return _react2.default.createElement(_groupView2.default, _lodash2.default.merge(group.renderProps(thumbnailsConfig), { store: _this3.props.store }));
            })
          );
        })
      );

      return thumbnails;
    }
  }, {
    key: 'setFlattenItems',
    value: function setFlattenItems(galleryStructure) {
      var flatItems = _lodash2.default.flattenDeep(galleryStructure.columns.map(function (column) {
        return column.galleryGroups.map(function (group) {
          return group.items;
        });
      }));

      this.setState({
        flatItems: flatItems
      });
    }
  }, {
    key: 'setCurrentItemByScroll',
    value: function setCurrentItemByScroll() {

      _utils2.default.isVerbose() && console.log('Setting current Idx by scroll', this.isAutoScrolling);

      if (this.isAutoScrolling) {
        //avoid this function if the scroll was originated by us (arrows or thumbnails)
        this.isAutoScrolling = false;
        return;
      }

      var isScrolling = (this.container && this.container.getAttribute('data-scrolling')) === 'true';

      if (isScrolling) {
        this.stopAutoSlideshow();

        //while the scroll is animating, prevent the reaction to this event
        return;
      }
      this.startAutoSlideshowIfNeeded(this.props.styleParams);
      var scrollLeft = this.container && this.container.scrollLeft || 0;

      var items = this.state.flatItems;

      var currentIdx = void 0;

      for (var item, i = 0; item = items[i]; i++) {
        if (item.offset.left > scrollLeft + (this.props.container.galleryWidth - item.width) / 2) {
          currentIdx = i - 1;
          break;
        }
      }

      if (!_lodash2.default.isUndefined(currentIdx)) {
        _utils2.default.setStateAndLog(this, 'Set Current Item', {
          currentIdx: currentIdx
        });
      }
      return currentIdx;
    }
  }, {
    key: 'createDebugMsg',
    value: function createDebugMsg() {
      return _react2.default.createElement(_galleryDebugMessage2.default, this.props.debug);
    }
  }, {
    key: 'createNavArrows',
    value: function createNavArrows() {
      var _this4 = this;

      var shouldNotRenderNavArrows = this.props.galleryStructure.columns.some(function (column) {
        var allRenderedGroups = _lodash2.default.filter(column.groups, function (group) {
          return group.rendered;
        }) || [];
        var allGroupsWidth = allRenderedGroups.reduce(function (sum, group) {
          return sum + Math.max(0, group.width);
        }, 0);
        var isAllItemsFitsGalleryWidth = _this4.props.styleParams.oneRow && _this4.props.container.galleryWidth >= allGroupsWidth;
        return isAllItemsFitsGalleryWidth;
      });

      //remove navBars if no scroll is needed and is column layout
      if (shouldNotRenderNavArrows) {
        return null;
      }

      return [this.isFirstItem() ? '' : _react2.default.createElement(
        'button',
        {
          className: 'nav-arrows-container prev ',
          onClick: function onClick() {
            return _this4._nextItem(-1);
          },
          'aria-label': 'Previous Item',
          tabIndex: _utils2.default.getTabIndex('slideshowPrev'),
          key: 'nav-arrow-back',
          'data-hook': 'nav-arrow-back'
        },
        _react2.default.createElement('img', { src: __webpack_require__(292) })
      ), this.isLastItem() ? '' : _react2.default.createElement(
        'button',
        {
          className: 'nav-arrows-container next',
          onClick: function onClick() {
            return _this4._nextItem(1);
          },
          'aria-label': 'Next Item',
          tabIndex: _utils2.default.getTabIndex('slideshowNext'),
          key: 'nav-arrow-next',
          'data-hook': 'nav-arrow-next'
        },
        _react2.default.createElement('img', { src: __webpack_require__(293) })
      )];
    }
  }, {
    key: 'createLayout',
    value: function createLayout() {
      var _this5 = this;

      var galleryConfig = {
        renderedItemsCount: this.props.renderedItemsCount,
        scroll: this.props.scroll,
        styleParams: this.props.styleParams,
        container: this.props.container,
        multishare: this.props.multishare,
        watermark: this.props.watermark,
        settings: this.props.settings,
        currentIdx: this.state.currentIdx,
        actions: {
          getMoreItemsIfNeeded: this.props.actions.getMoreItemsIfNeeded,
          toggleFullscreen: this.props.actions.toggleFullscreen,
          addItemToMultishare: this.props.actions.addItemToMultishare,
          removeItemFromMultishare: this.props.actions.removeItemFromMultishare
        }
      };

      return this.props.galleryStructure.columns.map(function (column, c) {

        var marginLeft = 0;
        var firstGroup = _lodash2.default.find(column.groups, function (group) {
          return group.rendered;
        }) || {};
        if (_this5.props.gotScrollEvent) {
          marginLeft = firstGroup.left || 0;
        }

        return !!column.galleryGroups.length && _react2.default.createElement(
          'div',
          { 'data-hook': 'gallery-column', id: 'gallery-horizontal-scroll', className: 'gallery-horizontal-scroll gallery-column hide-scrollbars', key: 'column' + c,
            style: { width: column.width } },
          _react2.default.createElement('div', { className: 'gallery-left-padding', style: { width: marginLeft } }),
          column.galleryGroups.map(function (group) {
            return group.rendered ? _react2.default.createElement(_groupView2.default, _lodash2.default.merge(group.renderProps(galleryConfig), { store: _this5.props.store })) : false;
          })
        );
      });
    }
  }, {
    key: 'createGallery',
    value: function createGallery() {
      var galleryStyle = {
        height: this.props.container.galleryHeight,
        width: this.props.container.galleryWidth
      };

      return _react2.default.createElement(
        'div',
        { id: 'pro-gallery-container', className: 'pro-gallery inline-styles one-row hide-scrollbars ' + (this.props.styleParams.enableScroll ? ' slider ' : '') + (_utils2.default.isAccessibilityEnabled() ? ' accessible ' : ''),
          style: galleryStyle
        },
        this.createEmptyState(),
        this.createDebugMsg(),
        this.createLayout(),
        this.createNavArrows()
      );
    }
  }, {
    key: 'getThumbnails',
    value: function getThumbnails() {
      var hasThumbnails = this.props.styleParams.hasThumbnails;
      var thumbnailsPosition = this.props.styleParams.galleryThumbnailsAlignment;

      var thumbnailsGallery = hasThumbnails ? this.createThumbnails(thumbnailsPosition) : false;

      var thumbnails = [];
      switch (thumbnailsPosition) {
        case 'top':
        case 'left':
          thumbnails[0] = thumbnailsGallery;
          thumbnails[1] = false;
          break;
        case 'right':
        case 'bottom':
          thumbnails[0] = false;
          thumbnails[1] = thumbnailsGallery;
          break;
      }
      return thumbnails;
    }
  }, {
    key: 'getClassNames',
    value: function getClassNames() {
      var classNames = '';
      if (this.props.styleParams.isSlideshow) {
        classNames = ' gallery-slideshow';
      } else if (this.props.styleParams.isSlider) {
        classNames = ' gallery-slider';
      } else if (this.props.styleParams.hasThumbnails) {
        classNames = ' gallery-thumbnails';
      } else if (this.props.styleParams.isColumns) {
        classNames = ' gallery-columns';
      }

      if (this.props.container.galleryWidth >= _utils2.default.getWindowWidth() - 10) {
        classNames += ' streched';
      }

      return classNames;
    }
  }, {
    key: 'getStyles',
    value: function getStyles() {
      return {
        margin: -1 * (this.props.styleParams.imageMargin - this.props.styleParams.galleryMargin)
      };
    }

    //-----------------------------------------| REACT |--------------------------------------------//

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.items) {
        this.setFlattenItems(props.galleryStructure);
      }

      if (!_utils2.default.isSite()) {
        if ( //check that the change is related to the slideshow settings
        this.props.styleParams.isAutoSlideshow !== props.styleParams.isAutoSlideshow || this.props.styleParams.autoSlideshowInterval !== props.styleParams.autoSlideshowInterval) {
          this.startAutoSlideshowIfNeeded(props.styleParams);
        }
      }
    }
  }, {
    key: 'createEmptyState',
    value: function createEmptyState() {
      return !(this.props.renderedItemsCount > 0) && _utils2.default.isEditor() ? _react2.default.createElement(_galleryEmpty2.default, { actions: {
          setWixHeight: this.props.actions.setWixHeight
        } }) : '';
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this6 = this;

      if (this.props.galleryStructure) {
        this.setFlattenItems(this.props.galleryStructure);
      }

      window.addEventListener('keydown', this.handleKeypress);
      window.addEventListener('gallery_navigation_out', function () {
        _utils2.default.setStateAndLog(_this6, 'Next Item', {
          isInView: false
        });
        _this6.stopAutoSlideshow();
      });
      window.addEventListener('gallery_navigation_in', function () {
        _utils2.default.setStateAndLog(_this6, 'Next Item', {
          isInView: true
        });
        _this6.startAutoSlideshowIfNeeded(_this6.props.styleParams);
      });

      this.container = document.getElementById('gallery-horizontal-scroll');
      if (this.container) {
        this.container.addEventListener('scroll', this._setCurrentItemByScroll);
      }
      this.setCurrentItemByScroll();
      this.startAutoSlideshowIfNeeded(this.props.styleParams);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.container) {
        this.container.removeEventListener('scroll', this._setCurrentItemByScroll);
      }
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      if (_utils2.default.isDev()) {
        console.count('galleryView render');
        console.count('Rendering Gallery count');
        console.time('Rendering Gallery took ');
      }

      var gallery = this.createGallery();
      var thumbnails = this.getThumbnails();

      if (_utils2.default.isDev()) {
        console.timeEnd('Rendering Gallery took ');
      }

      return _react2.default.createElement(
        'div',
        { className: this.getClassNames(), style: this.getStyles() },
        thumbnails[0],
        gallery,
        thumbnails[1]
      );
    }
  }]);
  return SlideshowView;
}(_react2.default.Component);

exports.default = SlideshowView;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(46);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = __webpack_require__(81);

var _item = __webpack_require__(133);

var _group = __webpack_require__(134);

var _strip = __webpack_require__(289);

var _column = __webpack_require__(290);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layouter = function () {
  function Layouter(layoutParams) {
    (0, _classCallCheck3.default)(this, Layouter);


    this.ready = false;
    this.pointer = 0;
    this.layoutItems = [];

    this.findNeighborItem = this.findNeighborItem.bind(this);

    this.updateParams(layoutParams);
    this.createLayout();
  }

  (0, _createClass3.default)(Layouter, [{
    key: 'updateParams',
    value: function updateParams(layoutParams) {
      this.srcItems = layoutParams.items;
      this.styleParams = _utils.utils.convertStyleParams(layoutParams.styleParams);
      this.container = _utils.utils.convertContainer(layoutParams.container, this.styleParams);
      this.showAllItems = layoutParams.showAllItems;
    }
  }, {
    key: 'verifyGalleryState',
    value: function verifyGalleryState() {
      if (!this.container.galleryWidth) {
        this.ready = false;
        this.reason = 'galleryWidth is undefined or 0';
        return false;
      }

      if (!this.styleParams.gallerySize) {
        this.ready = false;
        this.reason = 'gallerySize is undefined or 0';
        return false;
      }

      return true;
    }
  }, {
    key: 'calcNumberOfColumns',
    value: function calcNumberOfColumns(galleryWidth, gallerySize) {
      var numOfCols = 1;
      if (this.styleParams.isVertical) {
        if (this.styleParams.fixedColumns > 0) {
          numOfCols = this.styleParams.fixedColumns;
        } else {
          numOfCols = Math.ceil(galleryWidth / gallerySize) || 1;
        }
      } else {
        numOfCols = 1;
      }
      return numOfCols;
    }
  }, {
    key: 'findShortestColumn',
    value: function findShortestColumn(columns, groupIdx) {
      var minCol = columns[0];
      if (this.styleParams.placeGroupsLtr) {
        minCol = columns[groupIdx % columns.length];
      } else {
        var minColH = -1;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var column = _step.value;

            var colH = column.height;
            if (colH < minColH || minColH < 0) {
              minColH = colH;
              minCol = column;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return minCol;
    }
  }, {
    key: 'createLayout',
    value: function createLayout(layoutParams) {
      var _this = this;

      if (typeof layoutParams !== 'undefined') {
        this.updateParams(layoutParams);
      }

      if (!this.verifyGalleryState()) {
        return false;
      }

      this.pointer = 0;
      this.firstGroup = false;
      this.layoutItems = [];
      this.groups = [];
      this.strips = [];

      var gallerySize = Math.floor(this.styleParams.gallerySize) + Math.ceil(2 * (this.styleParams.imageMargin - this.styleParams.galleryMargin));
      var galleryWidth = Math.floor(this.container.galleryWidth);
      var maxGroupSize = this.maxGroupSize;

      var groupIdx = 0;
      var item = {};

      var groupItems = [];
      var group = void 0;
      var bounds = this.container.bounds || {};

      var strip = new _strip.Strip({
        idx: 1,
        container: this.container,
        styleParams: this.styleParams
      });

      var galleryHeight = 0;

      var numOfCols = this.calcNumberOfColumns(galleryWidth, gallerySize);
      gallerySize = this.styleParams.isVertical ? Math.floor(galleryWidth / numOfCols) : gallerySize;

      var columns = Array(numOfCols).fill(0).map(function (column, idx) {
        return new _column.Column(idx, gallerySize, _this.styleParams.cubeRatio);
      });
      columns[numOfCols - 1].width += galleryWidth - gallerySize * numOfCols; //the last group compensates for half pixels in other groups
      columns[numOfCols - 1].cubeRatio = this.styleParams.cubeRatio * (columns[numOfCols - 1].width / gallerySize); //fix the last group's cube ratio

      var maxLoops = this.srcItems.length * 10;

      while (this.srcItems[this.pointer]) {

        maxLoops--;
        if (maxLoops <= 0) {
          console.error('Cannot create layout, maxLoops reached!!!');
          return false;
        }

        item = new _item.Item({
          idx: this.pointer,
          inGroupIdx: groupItems.length + 1,
          scrollTop: galleryHeight,
          dto: this.srcItems[this.pointer],
          container: this.container,
          styleParams: this.styleParams
        });

        this.layoutItems[this.pointer] = item;

        //push the image to a group - until its full
        groupItems.push(item);
        if (groupItems.length < maxGroupSize && this.srcItems[this.pointer + 1]) {
          this.pointer++;
          continue;
        }

        group = new _group.Group({
          idx: groupIdx,
          stripIdx: strip.idx,
          inStripIdx: strip.groups.length + 1,
          top: galleryHeight,
          items: groupItems,
          isLastItems: this.isLastImages,
          gallerySize: gallerySize,
          showAllItems: this.showAllItems,
          container: this.container,
          styleParams: this.styleParams
        });
        this.groups[groupIdx] = group;

        //take back the pointer in case the group was created with less items
        this.pointer += group.realItems.length - groupItems.length;

        groupIdx++;
        groupItems = [];

        //resize and fit the group in the strip / column
        if (!this.styleParams.isVertical) {

          //---------------------| STRIPS GALLERY |----------------------//

          if (strip.isFull(group, this.isLastImage)) {
            //close the current strip
            strip.resizeToHeight(galleryWidth / strip.ratio);
            strip.setWidth(galleryWidth);
            galleryHeight += strip.height;
            columns[0].addGroups(strip.groups);
            this.strips.push(strip);

            //open a new strip
            strip = new _strip.Strip({
              idx: strip.idx + 1,
              container: this.container,
              styleParams: this.styleParams
            });

            //reset the group (this group will be rebuilt)
            this.pointer -= group.realItems.length - 1;
            groupIdx--;
            continue;
          }

          //add the group to the (current/new) strip
          group.setTop(galleryHeight);
          group.stripIdx = strip.idx;
          strip.ratio += group.ratio;
          // strip.height = Math.min(gallerySize, (galleryWidth / strip.ratio));
          strip.height = galleryWidth / strip.ratio;
          strip.setWidth(galleryWidth);
          strip.addGroup(group);

          if (this.isLastImage && strip.hasGroups) {
            if (this.styleParams.oneRow) {
              strip.height = this.container.galleryHeight + (this.styleParams.imageMargin - this.styleParams.galleryMargin);
            } else if (gallerySize * 1.5 < strip.height) {
              //stretching the strip to the full width will make it too high - so make it as high as the gallerySize and not stretch
              strip.height = gallerySize;
              strip.markAsIncomplete();
            }

            strip.resizeToHeight(strip.height);
            galleryHeight += strip.height;
            columns[0].addGroups(strip.groups);
            this.strips.push(strip);
          }
        } else {

          //---------------------| COLUMNS GALLERY |----------------------//

          //find the shortest column
          var minCol = this.findShortestColumn(columns, this.groups.length - 1);

          //resize the group and images
          group.fixItemsRatio(minCol.cubeRatio); //fix last column's items ratio (caused by stretching it to fill the screen)
          group.resizeToWidth(minCol.width);
          group.round();

          //update the group's position
          group.setTop(minCol.height);
          group.setLeft(minCol.idx * gallerySize);

          //add the image to the column
          minCol.addGroup(group);

          //add the image height to the column
          minCol.height += group.totalHeight;

          if (galleryHeight < minCol.height) {
            galleryHeight = minCol.height;
          }
        }

        //set the group visibility

        if (!this.gotScrollEvent && this.pointer < 10) {
          //until the first scroll event, make sure the first 10 groups are displayed
          group.calcVisibilities(true);
        } else {
          group.calcVisibilities(bounds);
        }

        if (!this.firstGroup) {
          this.firstGroup = group;
        }

        //advance the this.pointer
        this.pointer++;
      }

      //results
      this.lastGroup = group;
      this.columns = columns;
      this.colWidth = Math.floor(galleryWidth / numOfCols);
      this.height = galleryHeight - (this.styleParams.imageMargin - this.styleParams.galleryMargin) * 2;

      this.calcVisibilities(bounds);

      this.ready = true;

      return this.scheme;
    }
  }, {
    key: 'calcVisibilities',
    value: function calcVisibilities(bounds) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var column = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(column.groups), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var group = _step3.value;

              group.calcVisibilities(bounds);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this.scheme;
    }
  }, {
    key: 'lastVisibleItemIdxInHeight',
    value: function lastVisibleItemIdxInHeight(height) {
      for (var i = this.items.length - 1; i >= 0; i--) {
        var item = this.items[i];
        var isVisible = item.offset.top < height;
        if (isVisible) {
          return i;
        }
      }
      return this.items.length - 1;
    }
  }, {
    key: 'lastVisibleItemIdx',
    value: function lastVisibleItemIdx() {
      //the item must be visible and about the show more button
      return this.lastVisibleItemIdxInHeight(this.container.galleryHeight - 100);
    }
  }, {
    key: 'findNeighborItem',
    value: function findNeighborItem(itemIdx, dir) {
      var _this2 = this;

      var currentItem = this.layoutItems[itemIdx];

      var neighborItem = void 0;

      var findClosestItem = function findClosestItem(currentItemX, currentItemY, condition) {

        var minDistance = null;
        var minDistanceItem = {};

        var itemY = void 0;
        var itemX = void 0;
        var distance = void 0;

        // each(slice(this.layoutItems, itemIdx - 50, itemIdx + 50), (item) => {
        _this2.layoutItems.forEach(function (item) {
          itemY = item.offset.top + item.height / 2;
          itemX = item.offset.left + item.width / 2;
          distance = Math.sqrt(Math.pow(itemY - currentItemY, 2) + Math.pow(itemX - currentItemX, 2));
          if ((minDistance === null || distance > 0 && distance < minDistance) && condition(currentItemX, currentItemY, itemX, itemY)) {
            minDistance = distance;
            minDistanceItem = item;
          }
        });
        return minDistanceItem;
      };

      switch (dir) {
        case 'up':
          neighborItem = findClosestItem(currentItem.offset.left + currentItem.width / 2, currentItem.offset.top, function (curX, curY, itmX, itmY) {
            return itmY < curY;
          });
          break;

        case 'left':
          neighborItem = findClosestItem(currentItem.offset.left, currentItem.offset.top + currentItem.height / 2, function (curX, curY, itmX) {
            return itmX < curX;
          });
          break;

        case 'down':
          neighborItem = findClosestItem(currentItem.offset.left + currentItem.width / 2, currentItem.offset.bottom, function (curX, curY, itmX, itmY) {
            return itmY > curY;
          });
          break;

        default:
        case 'right':
          neighborItem = findClosestItem(currentItem.offset.right, currentItem.offset.top + currentItem.height / 2, function (curX, curY, itmX) {
            return itmX > curX;
          });
          break;

      }

      if (neighborItem.idx >= 0) {
        return neighborItem.idx;
      } else {
        console.warn('Could not find offset for itemIdx', itemIdx, dir);
        return itemIdx; //stay on the same item
      }
    }
  }, {
    key: 'isLastImage',
    get: function get() {
      return !this.srcItems[this.pointer + 1];
    }
  }, {
    key: 'isLastImages',
    get: function get() {
      if (this.styleParams.layoutsVersion > 1) {
        //layouts version 2+
        return !this.srcItems[this.pointer + 1];
      } else {
        //Backwards compatibility
        return !this.srcItems[this.pointer + 3];
      }
    }
  }, {
    key: 'imagesLeft',
    get: function get() {
      return this.srcItems.length - this.pointer - 1;
    }
  }, {
    key: 'maxGroupSize',
    get: function get() {
      var _maxGroupSize = 1;
      try {
        var groupTypes = typeof this.styleParams.groupTypes === 'string' && this.styleParams.groupTypes.length > 0 ? this.styleParams.groupTypes.split(',') : this.styleParams.groupTypes;
        _maxGroupSize = groupTypes.reduce(function (curSize, groupType) {
          return Math.max(curSize, parseInt(groupType));
        }, 1);
        _maxGroupSize = Math.min(_maxGroupSize, this.styleParams.groupSize);
      } catch (e) {
        console.error('couldn\'t calculate max group size - returing 3 (?)', e);
        _maxGroupSize = 3;
      }
      return _maxGroupSize;
    }
  }, {
    key: 'items',
    get: function get() {
      return this.layoutItems;
    }
  }, {
    key: 'scheme',
    get: function get() {
      return {
        items: this.items.map(function (item) {
          return item.scheme;
        }),
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        strips: this.strips.map(function (strip) {
          return strip.scheme;
        }),
        columns: this.columns.map(function (column) {
          return column.scheme;
        }),
        height: this.height
      };
    }
  }]);
  return Layouter;
}();

exports.default = Layouter;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = undefined;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = exports.Item = function () {

  /* @ngInject */
  function Item(config) {
    (0, _classCallCheck3.default)(this, Item);

    this.style = {};
    this.visibility = {};

    config = config || {};

    if (!config.dto) {
      console.error('Item has no DTO', config);
      config.dto = {};
    }

    this.dto = config.dto;
    this.idx = config.idx;
    this.inGroupIdx = config.inGroupIdx;
    this.container = config.container;
    this.cubeType = 'fill';

    if (config.styleParams) {
      var _config = config,
          styleParams = _config.styleParams;

      this.cubeType = styleParams.cubeType;
      this.cubeImages = styleParams.cubeImages;
      this._cubeRatio = styleParams.cubeRatio;
      this.rotatingCropRatios = styleParams.rotatingCropRatios;
      this.smartCrop = styleParams.smartCrop;
      this.cropOnlyFill = styleParams.cropOnlyFill;
      this.imageMargin = styleParams.imageMargin;
      this.galleryMargin = styleParams.galleryMargin;
      this.floatingImages = styleParams.floatingImages;
      this.smartCrop = styleParams.smartCrop;
    }

    this._groupOffset = {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    };
    this._group = {};
    this.calcPinOffset = function () {
      return 0;
    };

    this.resize(1);
  }

  (0, _createClass3.default)(Item, [{
    key: 'fixMetadataVerticalVideoRatio',
    value: function fixMetadataVerticalVideoRatio(metadata) {
      if (metadata.qualities && metadata.qualities[0]) {
        //fix incorrect width height for vertical videos
        var qualities = metadata.qualities;
        var _qualities = qualities[qualities.length - 1],
            height = _qualities.height,
            width = _qualities.width;

        metadata.height = height;
        metadata.width = width;
      }
    }
  }, {
    key: 'resize',
    value: function resize(scaleOrDimensions) {

      var scale = 1;
      if (scaleOrDimensions === false) {
        return;
      } else if (scaleOrDimensions > 0) {
        scale = scaleOrDimensions;
      } else if ((typeof scaleOrDimensions === 'undefined' ? 'undefined' : (0, _typeof3.default)(scaleOrDimensions)) === 'object') {
        if (scaleOrDimensions.width) {
          var w = Math.max(1, scaleOrDimensions.width);
          scale = w / this.width;
        } else if (scaleOrDimensions.height) {
          var h = Math.max(1, scaleOrDimensions.height);
          scale = h / this.height;
        }
      }

      this.width *= scale;
      this.height *= scale;

      this.resized = true;

      return this;
    }
  }, {
    key: 'pinToCorner',
    value: function pinToCorner(cornerName) {
      var _this = this;

      var pinAfter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


      var isTop = cornerName.indexOf('top') >= 0;
      var isLeft = cornerName.indexOf('left') >= 0;

      this.style.top = isTop ? 0 : 'auto';
      this.style.bottom = isTop ? 'auto' : 0;
      this.style.left = isLeft ? 0 : 'auto';
      this.style.right = isLeft ? 'auto' : 0;

      this.pin = cornerName;
      this.isPinnedTop = isTop;
      this.isPinnedLeft = isLeft;
      this.pinAfter = pinAfter;
      this.pinAfterType = isTop ? 'top' : isLeft ? 'left' : '';
      this.calcPinOffset = function (groupSize, dir) {
        if (!_this.pinAfter) {
          return 0;
        } else if (_this.pin === dir) {
          //this is used only for 3h/3v group types - to calc the offset of the middle item
          var m = _this.imageMargin;
          // return ((groupSize - 6 * m) * this.pinOffset + 2 * m);
          if (dir === 'top') {
            return _this.pinAfter.height + 2 * m;
          } else if (dir === 'left') {
            return _this.pinAfter.width + 2 * m;
          } else {
            return 0;
          }
          // return ((groupSize - 6 * m) * this.pinOffset + 4 * m);
        } else {
          return 0;
        }
      };
    }
  }, {
    key: 'setPosition',
    value: function setPosition(position) {
      this.style.position = position;
    }
  }, {
    key: 'getPosition',
    value: function getPosition(pos) {
      return parseInt(pos, 10) >= 0 ? pos : 'auto';
    }
  }, {
    key: 'top',
    get: function get() {
      return this.getPosition(this.style.top);
    }
  }, {
    key: 'left',
    get: function get() {
      return this.getPosition(this.style.left);
    }
  }, {
    key: 'right',
    get: function get() {
      return this.getPosition(this.style.right);
    }
  }, {
    key: 'bottom',
    get: function get() {
      return this.getPosition(this.style.bottom);
    }
  }, {
    key: 'group',
    set: function set(group) {
      (0, _assign2.default)(this._group, group);
    },
    get: function get() {
      return this._group;
    }
  }, {
    key: 'groupOffset',
    set: function set(offset) {
      (0, _assign2.default)(this._groupOffset, offset);
    }
  }, {
    key: 'offset',
    get: function get() {
      var offset = {
        top: this._groupOffset.top + (this.isPinnedTop ? this.calcPinOffset(this._group.height, 'top') : this._group.height - this.outerHeight) || 0,
        left: this._groupOffset.left + (this.isPinnedLeft ? this.calcPinOffset(this._group.width, 'left') : this._group.width - this.outerWidth) || 0
      };
      offset.right = offset.left + this.width;
      offset.bottom = offset.top + this.height;
      return offset;
    }
  }, {
    key: 'transform',
    get: function get() {
      if (this.floatingImages > 0) {

        var m = this.imageMargin;
        var g = this.galleryMargin;

        var spaceLeft = this.offset.left > 0 ? m : g;
        var spaceRight = this.container.galleryWidth - this.offset.right > 2 * m ? m : g;
        var spaceUp = this.offset.top > 0 ? m : g;
        var spaceDown = this.container.galleryHeight - this.offset.bottom > 2 * m ? m : g;

        var horizontalShift = _utils.utils.hashToInt(this.hash + this.offset.right + 'x', -1 * spaceLeft, spaceRight) * this.floatingImages;
        var verticalShift = _utils.utils.hashToInt(this.hash + this.offset.top + 'y', -1 * spaceUp, spaceDown) * this.floatingImages;

        return {
          transform: 'translate3d(' + horizontalShift + 'px, ' + verticalShift + 'px, 0)'
        };
      } else {
        return {};
      }
    }
  }, {
    key: 'id',
    get: function get() {
      return this.dto.id || this.dto.photoId || this.dto.itemId;
    },
    set: function set(id) {
      this.dto.itemId = this.dto.photoId = this.dto.id = id;
    }
  }, {
    key: 'hash',
    get: function get() {
      return this.dto.hash || this.dto.mediaUrl || this.dto.id;
    }
  }, {
    key: 'maxWidth',
    get: function get() {
      return this.dto.width || this.dto.w;
    },
    set: function set(w) {
      this.dto.width = w;
    }
  }, {
    key: 'outerWidth',
    get: function get() {
      return this.width + 2 * this.margins;
    }
  }, {
    key: 'orgWidth',
    get: function get() {
      return this.style.width || this.dto.width || this.dto.w || 1; //make sure the width / height is not undefined (crashes the gallery)
    }
  }, {
    key: 'width',
    get: function get() {
      var width = void 0;
      if (this.cubeImages && this.ratio >= this.cubeRatio) {
        width = this.style.cubedWidth || this.orgHeight * this.cubeRatio;
      } else {
        width = this.orgWidth;
      }
      return Math.max(width, 1);
    },
    set: function set(w) {
      this.style.cubedWidth = this.style.width = Math.max(1, w);
    }
  }, {
    key: 'outerHeight',
    get: function get() {
      return this.height + 2 * this.margins;
    }
  }, {
    key: 'orgHeight',
    get: function get() {
      return this.style.height || this.dto.height || this.dto.h || 1; //make sure the width / height is not undefined (creashes the gallery)
    }
  }, {
    key: 'height',
    get: function get() {
      var height = void 0;
      if (this.cubeImages && this.ratio < this.cubeRatio) {
        height = this.style.cubedHeight || this.orgWidth / this.cubeRatio;
      } else {
        height = this.orgHeight;
      }
      return Math.max(height, 1);
    },
    set: function set(h) {
      this.style.cubedHeight = this.style.height = Math.max(1, h);
    }
  }, {
    key: 'maxHeight',
    get: function get() {
      return this.dto.height || this.dto.h;
    },
    set: function set(h) {
      h = this.dto.height;
    }
  }, {
    key: 'margins',
    get: function get() {
      return this.imageMargin || 0;
    },
    set: function set(m) {
      this.imageMargin = m;
    }
  }, {
    key: 'cubeRatio',
    get: function get() {
      var ratio = void 0;
      if (this.rotatingCropRatios && this.rotatingCropRatios.length > 0) {
        var cropRatiosArr = String(this.rotatingCropRatios).split(',');
        ratio = cropRatiosArr[this.idx % cropRatiosArr.length];
      }
      if (!ratio && typeof this._cubeRatio === 'function') {
        ratio = this._cubeRatio();
      }
      if (!ratio && this.cropOnlyFill && this.cubeType === 'fit') {
        ratio = this.ratio;
      }
      if (!ratio) {
        ratio = this._cubeRatio || this.ratio;
      }
      ratio = Number(ratio);

      if (this.smartCrop === true) {
        if (this.isPortrait) {
          return Math.min(ratio, 1 / ratio);
        } else {
          return Math.max(ratio, 1 / ratio);
        }
      } else {
        return ratio;
      }
    },
    set: function set(ratio) {
      this._cubeRatio = ratio;
      this.style.cubedHeight = this.style.cubedWidth = 0;
    }
  }, {
    key: 'orientation',
    get: function get() {
      return this.ratio < 0.999 ? 'portrait' : 'landscape'; //make sure that almost square images get the same treatment
    }
  }, {
    key: 'isPortrait',
    get: function get() {
      return this.orientation === 'portrait';
    }
  }, {
    key: 'isLandscape',
    get: function get() {
      return this.orientation === 'landscape';
    }
  }, {
    key: 'ratio',
    get: function get() {
      if (!this.orgRatio) {
        this.orgRatio = this.orgWidth / this.orgHeight;
      }
      return this.orgRatio;
    },
    set: function set(r) {
      this.orgRatio = r;
    }
  }, {
    key: 'scheme',
    get: function get() {
      return {
        id: this.id,
        idx: this.idx,
        inGroupIdx: this.inGroupIdx,
        dto: this.dto,
        type: this.type,
        style: this.style,
        width: this.width,
        maxWidth: this.maxWidth,
        outerWidth: this.outerWidth,
        height: this.height,
        maxHeight: this.maxHeight,
        outerHeight: this.outerHeight,
        margins: this.margins,
        ratio: this.ratio,
        cropRatio: this.cubeRatio,
        isCropped: this.cubeImages,
        cropType: this.cubeType,
        group: this.group,
        offset: this.offset,
        groupOffset: this._groupOffset,
        transform: this.transform,
        orientation: this.orientation,
        isPortrait: this.isPortrait,
        isLandscape: this.isLandscape,
        visibility: this.visibility
      };
    }
  }]);
  return Item;
}();

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = undefined;

var _getIterator2 = __webpack_require__(46);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = __webpack_require__(81);

var _lodash = __webpack_require__(287);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GROUP_TYPES_BY_RATIOS_V = {
  lll: '1,2h',
  llp: '1,3r',
  lpl: '1,2h',
  pll: '1,2h,3l',
  lpp: '1,2h,3r,3h',
  plp: '1,2h,3l,3r,3h',
  ppl: '1,2h,3l,3h',
  ppp: '1,2h,3l,3r,3h'
};

var GROUP_TYPES_BY_RATIOS_H = {
  lll: '1,2v,3t,3b,3v',
  llp: '1,2v,3t,3v',
  lpl: '1,2v,3t,3b,3v',
  pll: '1,2v,3b,3v',
  lpp: '1,2v,3t',
  plp: '1,2v',
  ppl: '1,3b',
  ppp: '1,2h'
};

var GROUP_SIZES_BY_MAX_SIZE = {
  1: [[1]],
  2: [[1], [1, 2], [2]],
  3: [[1], [1, 2], [1, 2, 3], [2, 3], [3]]
};

var Group = exports.Group = function () {
  function Group(config) {
    (0, _classCallCheck3.default)(this, Group);

    this.idx = config.idx;
    this.stripIdx = config.stripIdx;
    this.inStripIdx = config.inStripIdx;
    this.items = config.items;
    this.top = config.top;
    this.showAllItems = config.showAllItems;
    this.isLastItems = config.isLastItems;
    this.dummyItems = [];

    if (config.styleParams) {
      var styleParams = config.styleParams;

      this.oneRow = styleParams.oneRow;
      this.cubeType = styleParams.cubeType;
      this.cubeImages = styleParams.cubeImages;
      this.isVertical = styleParams.isVertical;
      this.minItemSize = styleParams.minItemSize;
      this.gallerySize = styleParams.gallerySize;
      this.collageAmount = styleParams.collageAmount;
      this.collageDensity = styleParams.collageDensity;
      this.groupTypes = styleParams.groupTypes;
      this.rotatingGroupTypes = styleParams.rotatingGroupTypes;
      this.chooseBestGroup = styleParams.chooseBestGroup;
      this.layoutsVersion = styleParams.layoutsVersion;
      this.bottomInfoHeight = styleParams.bottomInfoHeight;
      this.imageMargin = styleParams.imageMargin;
    }

    this.visible = true;
    this.rendered = true;
    this.required = true;

    //prepare the group
    var forcedGroupSize = this.items.length;

    //todo - check if minItem size is really working
    while (!this.isWithinMinItemSize && forcedGroupSize > 0) {
      this.placeItems(forcedGroupSize);
      this.resize();
      forcedGroupSize--;
    }
  }

  (0, _createClass3.default)(Group, [{
    key: 'resize',
    value: function resize() {
      if (this.isVertical) {
        this.resizeToWidth(this.gallerySize);
      } else {
        this.resizeToHeight(this.gallerySize);
      }
      this.setLeft(this.left);
      this.setTop(this.top);
    }
  }, {
    key: 'safeGetItem',
    value: function safeGetItem(idx) {
      if (this.items[idx]) {
        return this.items[idx];
      } else if (this.dummyItems[idx]) {
        return this.dummyItems[idx];
      } else {
        var item = (0, _lodash2.default)(this.items[this.items.length - 1]);
        item.id += 'dummy';
        item.idx = this.idx * (idx + 1) + 1;
        item.type = 'dummy';
        this.dummyItems[idx] = item;
        return item;
      }
    }
  }, {
    key: 'fixItemsRatio',
    value: function fixItemsRatio(ratio) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {

        for (var _iterator = (0, _getIterator3.default)(this.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.cubeRatio = ratio;
          item.resize(1);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'round',
    value: function round() {

      //round all sizes to full pixels

      if (this.isLastGroup && !this.oneRow) {
        this.width = this.stripWidth - this.left;
      } else {
        this.width = Math.round(this.width);
      }
      this.height = Math.round(this.height);

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.width = Math.round(item.width);
          item.height = Math.round(item.height);
          item.group = {
            width: this.width,
            height: this.height
          };
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var m = this.imageMargin * 2;

      switch (this.type) {
        default:
        case '1':
          this.safeGetItem(0).width = this.width - m;
          this.safeGetItem(0).height = this.height - m;
          break;
        case '2v':
          this.safeGetItem(0).width = this.safeGetItem(1).width = this.width - m;
          this.safeGetItem(0).height = this.height - this.safeGetItem(1).height - 2 * m;
          break;
        case '2h':
          this.safeGetItem(0).height = this.safeGetItem(1).height = this.height - m;
          this.safeGetItem(0).width = this.width - this.safeGetItem(1).width - 2 * m;
          break;
        case '3t':
          this.safeGetItem(0).width = this.width - m;
          this.safeGetItem(0).height = this.height - this.safeGetItem(1).height - 2 * m;
          this.safeGetItem(1).width = this.width - this.safeGetItem(2).width - 2 * m;
          this.safeGetItem(2).height = this.safeGetItem(1).height;
          break;
        case '3b':
          this.safeGetItem(0).width = this.width - this.safeGetItem(1).width - 2 * m;
          this.safeGetItem(1).height = this.safeGetItem(0).height;
          this.safeGetItem(2).height = this.height - this.safeGetItem(1).height - 2 * m;
          this.safeGetItem(2).width = this.width - m;
          break;
        case '3l':
          this.safeGetItem(1).height = this.height - this.safeGetItem(2).height - 2 * m;
          this.safeGetItem(2).width = this.safeGetItem(1).width;
          this.safeGetItem(0).width = this.width - this.safeGetItem(1).width - 2 * m;
          this.safeGetItem(0).height = this.height - m;
          break;
        case '3r':
          this.safeGetItem(0).height = this.height - this.safeGetItem(1).height - 2 * m;
          this.safeGetItem(1).width = this.safeGetItem(0).width;
          this.safeGetItem(2).width = this.width - this.safeGetItem(1).width - 2 * m;
          this.safeGetItem(2).height = this.height - m;
          break;
        case '3v':
          this.safeGetItem(0).width = this.width - m;
          this.safeGetItem(1).width = this.width - m;
          this.safeGetItem(2).width = this.width - m;
          this.safeGetItem(2).height = this.height - this.safeGetItem(0).height - this.safeGetItem(1).height - 3 * m;
          break;
        case '3h':
          this.safeGetItem(0).height = this.height - m;
          this.safeGetItem(1).height = this.height - m;
          this.safeGetItem(2).height = this.height - m;
          this.safeGetItem(2).width = this.width - this.safeGetItem(0).width - this.safeGetItem(1).width - 3 * m;
          break;
      }
    }
  }, {
    key: 'getGroupType',
    value: function getGroupType(forcedGroupSize) {

      //---------| Override with specifically defined rotating group types (ignores everything else)
      if (this.rotatingGroupTypes) {
        var groupTypesArr = String(this.rotatingGroupTypes).split(',');
        return groupTypesArr[this.idx % groupTypesArr.length];

        // } else if (this.isLastItems) {
        //   return this.groupTypes.split(',')[0] || '1';
      } else {
        //isVertical - is the gallery vertical (pinterest style) or horizontal (flickr style)

        //---------| Find the best groupType for each ratios case
        //optional types:
        //  1   => single photo
        //  2v  => 2 photos one above the other
        //  2h  => 2 photos one alongside the other
        //  3b  => 3 photos - one large at the bottom and two small on top, one alongside the other
        //  3t  => 3 photos - one large on top and two small at the bottom, one alongside the other
        //  3l  => 3 photos - one large on the left and two small on the right, one above the other
        //  3r  => 3 photos - one large on the right and two small on the left, one above the other

        //define optional ratios for each type:
        //  1   => all
        //  2v  => lll,llp,ppp     (horizontal only)
        //  2h  => ppp,ppl,lll     (vertical only)
        //  3b  => lll,lpl,pll,ppl (horizontal only)
        //  3t  => lll,lpl,llp,lpp (horizontal only)
        //  3l  => ppp,plp,ppl,pll (vertical only)
        //  3r  => ppp,plp,lpp,llp (vertical only)

        var isV = this.isVertical;
        var optionalTypes = void 0; //optional groupTypes (separated by ,). 1 is always optional

        if (this.chooseBestGroup) {

          //map the group to l=landscape and p=portrait
          //create a string to state the images group's type
          var ratios = this.items.map(function (item) {
            return item.orientation.slice(0, 1);
          }).join('');
          optionalTypes = (isV ? GROUP_TYPES_BY_RATIOS_V : GROUP_TYPES_BY_RATIOS_H)[ratios];
        } else if (this.items.length === 3 || forcedGroupSize === 3) {
          optionalTypes = isV ? '1,2h,3l,3r,3h' : '1,2v,3t,3b,3v';
        }

        if (this.items.length === 2 || forcedGroupSize === 2) {
          optionalTypes = isV ? '1,2h' : '1,2v';
        }
        if (this.items.length === 1 || forcedGroupSize === 1) {
          optionalTypes = '1';
        }

        var groupTypes = optionalTypes.length > 0 ? optionalTypes.split(',') : [];

        //---------| Override with specifically defined group types
        if (this.groupTypes) {

          // let groupTypesArr = union(['1'], this.groupTypes.split(','));
          var _groupTypesArr = this.groupTypes.split(',');

          if (_groupTypesArr.length > 1) {
            groupTypes = groupTypes.filter(function (gt) {
              return _groupTypesArr.indexOf(gt) >= 0;
            });

            if (groupTypes.length === 0) {
              //there is no match between required group types and the optional ones - use
              groupTypes = ['1'];
            }
          } else {
            groupTypes = _groupTypesArr;
          }
        }

        //---------| Calc collage density
        if (this.layoutsVersion > 1 && this.collageDensity >= 0) {
          //th new calculation of the collage amount

          var collageDensity = this.collageDensity;

          //use the collage amount to determine the optional groupsize
          var maxGroupType = parseInt(groupTypes[groupTypes.length - 1]);
          var optionalGroupSizes = GROUP_SIZES_BY_MAX_SIZE[maxGroupType];
          var targetGroupSizes = optionalGroupSizes[Math.floor(collageDensity * (optionalGroupSizes.length - 1))];
          // seed += ((collageDensity * 1.5) - 0.75) * numOfOptions;

          groupTypes = groupTypes.filter(function (groupType) {
            return targetGroupSizes.indexOf(parseInt(groupType)) >= 0;
          });

          if (groupTypes.length === 0) {
            groupTypes = ['1'];
          }
        }

        var seed = this.calculateRandomSeed(groupTypes.length);

        //---------| Final group type to render according to:
        // - the number of options
        // - the collageAmount (if 0 - always renders 1 image, if 1 always renders the max amount)
        // - random seed (determined by the hash)
        return groupTypes[seed] || '1';
      }
    }
  }, {
    key: 'calculateRandomSeed',
    value: function calculateRandomSeed(numOfOptions) {
      var seed = void 0;
      if (this.isVertical) {
        //vertical galleries random is not relevant (previous group is in another column)
        seed = _utils.utils.hashToInt(this.items[0].hash) % numOfOptions;
      } else {
        seed = (this.inStripIdx + this.stripIdx) % numOfOptions;
      }

      if (this.layoutsVersion === 1 && this.collageAmount >= 0) {
        //backwards compatibility
        seed += (this.collageAmount - 0.5) * numOfOptions;
      }

      return Math.round(Math.min(Math.max(0, seed), numOfOptions - 1));
    }
  }, {
    key: 'placeItems',
    value: function placeItems(forcedGroupSize) {

      this.type = this.getGroupType(forcedGroupSize);

      //---------| Render the images by the groupType
      var items = [];
      var item = void 0;
      var w = 0;
      var h = 0;

      switch (this.type) {
        default:
        case '1':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          items.push(item);
          w = item.width;
          h = item.height;

          break;

        case '2v':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(1);
          item.pinToCorner('bottom-left');
          item.resize(w / item.width);
          h += item.height;
          items.push(item);

          break;

        case '2h':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          item.innerOffset = [0, 0];
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(1);
          item.pinToCorner('top-right');
          item.innerOffset = [0, 0];
          item.resize(h / item.height);
          w += item.width;
          items.push(item);

          break;

        case '3b':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(1);
          item.pinToCorner('top-right');
          item.resize(h / item.height);
          w += item.width;
          items.push(item);

          item = this.safeGetItem(2);
          item.pinToCorner('bottom-left');
          item.resize(w / item.width);
          h += item.height;
          items.push(item);

          break;

        case '3t':

          item = this.safeGetItem(1);
          item.pinToCorner('bottom-left');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(2);
          item.pinToCorner('bottom-right');
          item.resize(h / item.height);
          w += item.width;
          items.push(item);

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          item.resize(w / item.width);
          h += item.height;
          items = [item].concat(items);

          break;

        case '3r':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(1);
          item.pinToCorner('bottom-left');
          item.resize(w / item.width);
          h += item.height;
          items.push(item);

          item = this.safeGetItem(2);
          item.pinToCorner('top-right');
          item.resize(h / item.height);
          w += item.width;
          items.push(item);

          break;

        case '3l':

          item = this.safeGetItem(1);
          item.pinToCorner('top-right');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(2);
          item.pinToCorner('bottom-right');
          item.resize(w / item.width);
          h += item.height;
          items.push(item);

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          item.resize(h / item.height);
          w += item.width;
          items = [item].concat(items);

          break;

        case '3v':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          item.setPosition('relative');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(2);
          item.pinToCorner('bottom-left');
          item.setPosition('relative');
          item.resize(w / item.width);
          h += item.height;
          items.push(item);

          //the middle item must be last to position it in the middle (h must be full height)
          item = this.safeGetItem(1);
          item.setPosition('relative');
          item.resize(w / item.width);
          h += item.height;
          item.pinToCorner('top', items[0]);
          items = [items[0], item, items[1]];

          break;

        case '3h':

          item = this.safeGetItem(0);
          item.pinToCorner('top-left');
          item.setPosition('relative');
          items.push(item);
          w = item.width;
          h = item.height;

          item = this.safeGetItem(2);
          item.pinToCorner('top-right');
          item.setPosition('relative');
          item.resize(h / item.height);
          w += item.width;
          items.push(item);

          //the middle item must be last to position it in the middle (w must be full width)
          item = this.safeGetItem(1);
          item.setPosition('relative');
          item.resize(h / item.height);
          w += item.width;
          item.pinToCorner('left', items[0]);
          items = [items[0], item, items[1]];

          break;
      }

      this.width = w;
      this.height = h;
      this.items = items;
      this.placed = true;
    }
  }, {
    key: 'resizeToHeight',
    value: function resizeToHeight(height) {
      this.height = height;
      this.width = this.getWidthByHeight(height);

      this.resizeItems();
    }
  }, {
    key: 'resizeToWidth',
    value: function resizeToWidth(width) {
      this.width = width;
      this.height = this.getHeightByWidth(width);

      this.resizeItems();
    }
  }, {
    key: 'resizeItems',
    value: function resizeItems() {
      var _this = this;

      var items = ['3b', '3r'].indexOf(this.type) >= 0 ? this.items.slice().reverse() : this.items;
      items.forEach(function (item, i) {
        item.resize(_this.getItemDimensions(items, i));
        item.group = {
          top: _this.top,
          left: _this.left,
          width: _this.width,
          height: _this.height
        };
        item.groupOffset = {
          bottom: _this.top + _this.height,
          right: _this.left + _this.width
        };
      });
    }
  }, {
    key: 'getItemDimensions',
    value: function getItemDimensions(items, idx) {
      var m = this.imageMargin * 2;
      switch (this.type) {
        default:
        case '1':
        case '2v':
        case '3v':
          {
            var w = this.width - m;
            return {
              width: w
            };
          }
        case '2h':
        case '3h':
          {
            var h = this.height - m;
            return {
              height: h
            };
          }
        case '3t':
        case '3b':
          if (idx === 0) {
            var _w = this.width - m;
            return {
              width: _w
            };
          } else {
            var _h = this.height - items[0].height - 2 * m;
            return {
              height: _h
            };
          }
        case '3r':
        case '3l':
          if (idx === 0) {
            var _h2 = this.height - m;
            return {
              height: _h2
            };
          } else {
            var _w2 = this.width - items[0].width - 2 * m;
            return {
              width: _w2
            };
          }
      }
    }
  }, {
    key: 'getHeightByWidth',
    value: function getHeightByWidth(W) {
      var Rg = 1;
      var Rm = 1;
      var M = this.imageMargin * 2;
      var R = this.items.map(function (item) {
        return item.width / item.height;
      });
      switch (this.type) {
        // ---------------------------------
        // GENERAL FORMULA:
        // ---------------------------------
        // Rg = Group ratio [layout specific calculation]
        // M = margin space between items ( = margin around item * 2)
        // Rm = Margin ratio [layout specific calculation]
        // ---------------------------------
        // | H = W * R + M * Rm |
        // ---------------------------------
        //    const H = W * Rg + M * (Vi - Hi * Rg);

        default:
        case '1':
          Rg = 1 / R[0];
          Rm = 1 - Rg;
          break;
        case '2h':
          Rg = 1 / (R[0] + R[1]);
          Rm = 1 - 2 * Rg;
          break;
        case '2v':
          Rg = 1 / R[0] + 1 / R[1];
          Rm = 2 - Rg;
          break;
        case '3h':
          Rg = 1 / (R[0] + R[1] + R[2]);
          Rm = 1 - 3 * Rg;
          break;
        case '3v':
          Rg = 1 / R[0] + 1 / R[1] + 1 / R[2];
          Rm = 3 - Rg;
          break;
        case '3t':
          Rg = 1 / (R[2] + R[1]) + 1 / R[0];
          Rm = 2 - 2 / (R[2] + R[1]) + 1 / R[0];
          break;
        case '3b':
          Rg = 1 / (R[0] + R[1]) + 1 / R[2];
          Rm = 2 - 2 / (R[0] + R[1]) + 1 / R[2];
          break;
        case '3l':
          Rg = (R[1] + R[2]) / (R[0] * R[1] + R[1] * R[2] + R[0] * R[2]);
          Rm = 2 - Rg * (2 + R[0]);
          break;
        case '3r':
          Rg = (R[0] + R[1]) / (R[0] * R[1] + R[1] * R[2] + R[0] * R[2]);
          Rm = 2 - Rg * (2 + R[2]);
          break;
      }
      var H = W * Rg + M * Rm;

      return H;
    }
  }, {
    key: 'getWidthByHeight',
    value: function getWidthByHeight(H) {
      var Rg = 1;
      var Rm = 1;
      var M = this.imageMargin * 2;
      var R = this.items.map(function (item) {
        return item.width / item.height;
      });
      switch (this.type) {
        // ---------------------------------
        // GENERAL FORMULA:
        // ---------------------------------
        // Rh = Group ratio [layout specific calculation]
        // M = margin space between items ( = margin around item * 2)
        // Rm = Margin ratio [layout specific calculation]
        // ---------------------------------
        // | W = H * Rg + M * Rm |
        // ---------------------------------
        default:
        case '1':
          Rg = R[0];
          Rm = 1 - Rg;
          break;
        case '2h':
          Rg = R[0] + R[1];
          Rm = 2 - Rg;
          break;
        case '2v':
          Rg = 1 / (1 / R[0] + 1 / R[1]);
          Rm = 1 - 2 * Rg;
          break;
        case '3h':
          Rg = R[0] + R[1] + R[2];
          Rm = 3 - Rg;
          break;
        case '3v':
          Rg = 1 / (1 / R[0] + 1 / R[1] + 1 / R[2]);
          Rm = 1 - 3 * Rg;
          break;
        case '3t':
          Rg = 1 / (1 / (R[2] + R[1]) + 1 / R[0]);
          Rm = (2 / (R[2] + R[1]) + 1 / R[0] - 2) * Rg;
          break;
        case '3b':
          Rg = 1 / (1 / (R[0] + R[1]) + 1 / R[2]);
          Rm = (2 / (R[0] + R[1]) + 1 / R[2] - 2) * Rg;
          break;
        case '3l':
          Rg = (R[0] * R[1] + R[1] * R[2] + R[0] * R[2]) / (R[1] + R[2]);
          Rm = 2 + R[0] - 2 * Rg;
          break;
        case '3r':
          Rg = (R[0] * R[1] + R[1] * R[2] + R[0] * R[2]) / (R[0] + R[1]);
          Rm = 2 + R[2] - 2 * Rg;
          break;
      }
      var W = H * Rg + M * Rm;

      return W;
    }
  }, {
    key: 'setTop',
    value: function setTop(top) {
      this.top = top || 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          item.groupOffset = {
            top: top,
            bottom: top + this.height
          };
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'setLeft',
    value: function setLeft(left) {
      this.left = left || 0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(this.items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          item.groupOffset = {
            left: left,
            right: left + this.width
          };
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }, {
    key: 'calcVisibilities',
    value: function calcVisibilities(bounds) {
      if (bounds === true || this.showAllItems === true) {
        this.onscreen = this.visible = this.rendered = this.required = true;
      } else if (this.oneRow) {
        this.onscreen = this.right >= bounds.onscreenTop && this.left <= bounds.onscreenBottom;
        this.visible = this.right >= bounds.visibleTop && this.left <= bounds.visibleBottom;
        this.rendered = this.right >= bounds.renderedTop && this.left <= bounds.renderedBottom;
        this.required = this.right >= bounds.requiredTop && this.left <= bounds.requiredBottom;
      } else {
        this.onscreen = this.bottom >= bounds.onscreenTop && this.top <= bounds.onscreenBottom;
        this.visible = this.bottom >= bounds.visibleTop && this.top <= bounds.visibleBottom;
        this.rendered = this.bottom >= bounds.renderedTop && this.top <= bounds.renderedBottom;
        this.required = this.bottom >= bounds.requiredTop && this.top <= bounds.requiredBottom;
      }
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].visibility = {
          onscreen: this.onscreen,
          visible: this.visible,
          rendered: this.rendered,
          required: this.required
        };
      }
    }
  }, {
    key: 'id',
    get: function get() {
      return 'g' + this.idx + '_' + (this.items[0] || {}).id;
    }
  }, {
    key: 'ratio',
    get: function get() {
      var w = this.width;
      var h = this.height;
      return w / h;
    }
  }, {
    key: 'totalHeight',
    get: function get() {
      return this.height + (this.bottomInfoHeight || 0);
    }
  }, {
    key: 'bottom',
    get: function get() {
      return this.top + this.height;
    }
  }, {
    key: 'right',
    get: function get() {
      return this.left + this.width;
    }
  }, {
    key: 'items',
    set: function set(items) {
      this._items = items;
    },
    get: function get() {
      return this._items;
    }
  }, {
    key: 'realItems',
    get: function get() {
      return this._items.filter(function (item) {
        return item.type !== 'dummy';
      });
    }
  }, {
    key: 'isWithinMinItemSize',
    get: function get() {
      var _this2 = this;

      if (this.items.length === 0 || !this.placed) {
        return false;
      }
      if (this.items.length === 1) {
        return true;
      } else {
        return this.items.reduce(function (i, item) {
          var isInSize = Math.min(item.width, item.height) >= _this2.minItemSize;
          return i && isInSize;
        }, true);
      }
    }
  }, {
    key: 'scheme',
    get: function get() {
      return {
        id: this.id,
        idx: this.idx,
        stripIdx: this.stripIdx,
        inStripIdx: this.inStripIdx,
        isLastGroup: this.isLastGroup,
        items: this.items.map(function (item) {
          return item.scheme;
        }),
        type: this.type,
        width: this.width,
        height: this.height,
        totalHeight: this.totalHeight,
        ratio: this.ratio,
        top: this.top,
        left: this.left,
        right: this.right,
        bottom: this.bottom,
        visible: this.visible,
        rendered: this.rendered,
        required: this.required
      };
    }
  }]);
  return Group;
}();

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _versionManager = __webpack_require__(52);

var _versionManager2 = _interopRequireDefault(_versionManager);

var _renderUtils = __webpack_require__(70);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _featuresList = __webpack_require__(298);

var _featuresList2 = _interopRequireDefault(_featuresList);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _queryString = __webpack_require__(73);

var qs = _interopRequireWildcard(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getManualUpdatesData = function getManualUpdatesData() {
  var workerWindow = _renderUtils.renderUtils.getWorkerWindow();
  var manualUpdates = void 0;
  if (workerWindow) {
    var workerWindowData = _renderUtils.renderUtils.getGalleryDataFromWorker();
    manualUpdates = _lodash2.default.get(workerWindowData, 'window.gallerySettings.upgrades');
  }
  if (!manualUpdates) {
    manualUpdates = _lodash2.default.get(_renderUtils.renderUtils.getGallerySettingsFromWindow(), 'upgrades');
  }
  return manualUpdates;
};

var ProGalleryVersionManager = function () {
  function ProGalleryVersionManager(dateCreated, features) {
    (0, _classCallCheck3.default)(this, ProGalleryVersionManager);

    this.dateCreated = dateCreated;
    this.versionManager = new _versionManager2.default(features, dateCreated);
  }

  (0, _createClass3.default)(ProGalleryVersionManager, [{
    key: 'update',
    value: function update(dateCreated) {
      this.dateCreated = dateCreated || this.dateCreated;
      var manualUpdates = getManualUpdatesData();
      this.versionManager.update(this.dateCreated, manualUpdates);
    }
  }, {
    key: 'getFeaturesWithNewerVersions',
    value: function getFeaturesWithNewerVersions() {
      var manualUpdates = getManualUpdatesData();
      var featuresWithNewerVersions = this.versionManager.getFeaturesWithNewerVersions(manualUpdates);
      return _lodash2.default.isEmpty(featuresWithNewerVersions) ? null : featuresWithNewerVersions;
    }
  }, {
    key: 'getVersion',
    value: function getVersion(featureName) {
      return this.versionManager.getVersion(featureName);
    }
  }, {
    key: 'getFeature',
    value: function getFeature(featureName) {
      return this.versionManager.getFeature(featureName);
    }
  }]);
  return ProGalleryVersionManager;
}();

//If this is a template gallery, always use the lates version


var dateCreated = void 0;
var urlParams = void 0;
try {
  dateCreated = window.dateCreated;
  urlParams = qs.parse(window.location.search);

  if (_WixSdkWrapper2.default.Utils.getDemoMode()) {
    dateCreated = new Date().toString();
  }
} catch (e) {
  dateCreated = {};
  urlParams = '';
}

//For QA - when adding 'features_upgrade' to the debugApp, the gallery will load with the oldest features.
var debugApp = _lodash2.default.get(urlParams, 'debugApp');
if (debugApp && debugApp.indexOf('features_upgrade') > -1) {
  dateCreated = null;
}

var dateCreatedTicks = _renderUtils.renderUtils.getDateCreatedTicksFromStr(dateCreated);
var pgVersionManager = new ProGalleryVersionManager(dateCreatedTicks, _featuresList2.default);

module.exports = { ProGalleryVersionManager: ProGalleryVersionManager, pgVersionManager: pgVersionManager, VersionManagerCore: _versionManager2.default, featuresList: _featuresList2.default };

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _versionManager = __webpack_require__(52);

var _versionManager2 = _interopRequireDefault(_versionManager);

var _proGalleryVersionManager = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LayoutsVersionManager = function () {
  function LayoutsVersionManager(proGallertVersionManager) {
    (0, _classCallCheck3.default)(this, LayoutsVersionManager);

    this.pgVersionManager = proGallertVersionManager || _proGalleryVersionManager.pgVersionManager;
  }

  (0, _createClass3.default)(LayoutsVersionManager, [{
    key: 'allowFixedColumnsInMasonry',
    value: function allowFixedColumnsInMasonry() {
      return this.pgVersionManager.getVersion('layouts') !== _versionManager2.default.Versions.min;
    }
  }]);
  return LayoutsVersionManager;
}();

var layoutsVersionManager = new LayoutsVersionManager();
module.exports = { layoutsVersionManager: layoutsVersionManager, LayoutsVersionManager: LayoutsVersionManager };

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * prepend-http-extra <https://github.com/tunnckoCore/prepend-http-extra>
 *
 * Copyright (c) 2016 Charlike Mike Reagent <@tunnckoCore> (http://www.tunnckocore.tk)
 * Released under the MIT license.
 */



var prepend = __webpack_require__(299)

module.exports = function prependHttpExtra (url) {
  url = prepend(url)
  if (/^\/\//.test(url)) {
    return 'http:' + url
  }
  return url
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thumbnailSize = exports.getGalleryRatio = exports.getGalleryWidth = exports.getGalleryHeight = exports.getGalleryDimensions = undefined;

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var thumbnailSize = _utils2.default.isMobile() ? 90 : 120;
var slideshowInfoSize = 220;

function protectGalleryWidth(width) {

  var maxGalleryWidth = void 0;
  if (_utils2.default.isSite()) {
    maxGalleryWidth = Number(_utils2.default.parseGetParam('width'));
  }

  if (_utils2.default.browserIs('chromeIos')) {
    // This can be the width calc for all galleries, but in chromeIos it must be used otherwise there is a gap on the left of the gallery.
    // Currently there is a bug with Mitzi that the width parmeter is not updating fast enough once it is fixed, use this code always.
    maxGalleryWidth = maxGalleryWidth || document.body.clientWidth;
  } else {
    maxGalleryWidth = document.body.clientWidth;
  }

  if (_utils2.default.isMobile()) {
    maxGalleryWidth = Math.floor(maxGalleryWidth / _utils2.default.getViewportScaleRatio());
  }
  return Math.min(Math.floor(width), maxGalleryWidth);
}

function protectGalleryHeight(height, offsetTop) {

  var galleryHeight = Math.floor(height - offsetTop);
  if (_utils2.default.isMobile() && !_utils2.default.isiOS()) {
    galleryHeight = Math.floor(galleryHeight / _utils2.default.getViewportScaleRatio());
  }
  return galleryHeight;
}

function getDimensionFix(styles) {
  return Number(styles.imageMargin) - Number(styles.galleryMargin);
}

function getGalleryDimensions(styles, container) {

  var res = {
    galleryWidth: getGalleryWidth(styles, container),
    galleryHeight: getGalleryHeight(styles, container)
  };

  var fixedThumbnailSize = thumbnailSize + styles.galleryMargin + 3 * styles.thumbnailSpacings;

  if (styles.hasThumbnails) {
    switch (styles.galleryThumbnailsAlignment) {
      case 'top':
      case 'bottom':
        res.galleryHeight -= fixedThumbnailSize;
        break;
      case 'left':
      case 'right':
        res.galleryWidth -= fixedThumbnailSize;
        break;
      default:
        break;
    }
  } else if (styles.isSlideshow) {
    // res.galleryHeight = 550; //if the height of the image is constant
    res.galleryHeight -= slideshowInfoSize; //if the height of the text is constant
  }

  return res;
}

function getGalleryWidth(styles, container) {
  // const DomWidth = window.innerWidth && document.documentElement.clientWidth ?
  //   Math.min(window.innerWidth, document.documentElement.clientWidth) :
  //   window.innerWidth ||
  //   document.documentElement.clientWidth ||
  //   document.getElementsByTagName('body')[0].clientWidth;
  var domWidth = function domWidth() {
    return protectGalleryWidth(_utils2.default.isMobile() ? document.body.clientWidth : window.innerWidth);
  }; //on mobile we use the document width - which takes in account the pixel ratio fix (width more that 100% and scale down)
  return Math.floor((container.width > 0 ? container.width : domWidth()) + getDimensionFix(styles) * 2); //add margins to width and then remove them in css negative margins
}

function getGalleryHeight(styles, container) {
  var offsetTop = styles.oneRow ? container.offsetTop : 0;
  var domHeight = function domHeight() {
    return protectGalleryHeight(window.innerHeight, offsetTop);
  };
  return Math.floor((container.height > 0 ? container.height : domHeight()) + getDimensionFix(styles));
}

function getGalleryRatio(styles, container) {
  return getGalleryWidth(styles, container) / getGalleryHeight(styles, container);
}

// function getGalleryScroll(params, isHorizontal) {
//   let currentScrollPosition;
//   if (isHorizontal) {
//     currentScrollPosition = document.getElementById('gallery-horizontal-scroll').scrollLeft;
//   } else if (params && _.isNumber(params.customScrollTop)) {
//     currentScrollPosition = params.customScrollTop;
//   } else if (utils.isInWix() || utils.isWixIframe()) {
//     if (params && _.isNumber(params.scrollTop) && _.isNumber(params.y)) {
//       let scrollBase = params.y || 0;
//       if (this.boundingRect) {
//         scrollBase += this.boundingRect.y;
//       }
//       const scrollTop = params.scrollTop;
//       this.pageScale = params.scale || 1;
//       if (this.scrollBase !== scrollBase && _.isNumber(scrollBase) && !_.isNaN(scrollBase)) {
//         if (utils.isDev()) {
//           console.log('gallery ' + this.compId + ' scroll base has changed from ' + this.scrollBase + ' to ' + scrollBase);
//         }
//         this.scrollBase = scrollBase * this.pageScale;
//       }
//       currentScrollPosition = ((scrollTop - this.scrollBase) / utils.getViewportScaleRatio()) * this.pageScale;
//     }
//   } else {
//     currentScrollPosition = window.scrollTop;
//   }
//   return currentScrollPosition;
// }

// function combineScrollParams(innerScroll, outerScroll) {

// }

exports.getGalleryDimensions = getGalleryDimensions;
exports.getGalleryHeight = getGalleryHeight;
exports.getGalleryWidth = getGalleryWidth;
exports.getGalleryRatio = getGalleryRatio;
exports.thumbnailSize = thumbnailSize;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CommonItemContainer = exports.GalleryItem = exports.LoveButton = exports.ProGallery = undefined;

__webpack_require__(140);

__webpack_require__(141);

__webpack_require__(142);

var _proGallery = __webpack_require__(143);

var _proGallery2 = _interopRequireDefault(_proGallery);

var _loveButton = __webpack_require__(119);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _galleryItem = __webpack_require__(51);

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _commonItemContainer = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProGallery = _proGallery2.default;
exports.LoveButton = _loveButton2.default;
exports.GalleryItem = _galleryItem2.default;
exports.CommonItemContainer = _commonItemContainer.CommonItemContainer;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pro-circle-preloader":"_3HLI9","proCirclePreloader":"_3HLI9","semi-rotate":"_2fSBY","semiRotate":"_2fSBY","inner-rotate":"_35BZn","innerRotate":"_35BZn","love-animation":"_2FaRo","loveAnimation":"_2FaRo","loved":"Nv9dE","text-item":"_1cK7o","textItem":"_1cK7o","te-pro-gallery-text-item":"_3wK_8","teProGalleryTextItem":"_3wK_8","clear":"y2Ywp","inactive":"WWMPB","pro-tooltip":"_3h6w_","proTooltip":"_3h6w_","left":"_3YpLx","right":"_2zpOR","top":"_33kgL","hide-scrollbars":"_39dv8","hideScrollbars":"_39dv8","rotation":"_1od_p"};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"changing_background":"rVV94","changingBackground":"rVV94"};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(45);

var _redux = __webpack_require__(37);

var _reduxThunk = __webpack_require__(204);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _index = __webpack_require__(205);

var _index2 = _interopRequireDefault(_index);

var _galleryActions = __webpack_require__(47);

var _galleryContainer = __webpack_require__(220);

var _galleryContainer2 = _interopRequireDefault(_galleryContainer);

var _galleryContainerNew = __webpack_require__(300);

var _galleryContainerNew2 = _interopRequireDefault(_galleryContainerNew);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _videoActionTypes = __webpack_require__(104);

var _videoActionTypes2 = _interopRequireDefault(_videoActionTypes);

var _videoMiddleware = __webpack_require__(303);

var _videoMiddleware2 = _interopRequireDefault(_videoMiddleware);

var _videoQueue = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProGallery = function (_React$Component) {
  (0, _inherits3.default)(ProGallery, _React$Component);

  function ProGallery(props) {
    (0, _classCallCheck3.default)(this, ProGallery);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProGallery.__proto__ || (0, _getPrototypeOf2.default)(ProGallery)).call(this));

    _this.canRender = typeof window !== 'undefined' && typeof document !== 'undefined'; //do not render if it is SSR
    if (_this.canRender) {
      _this.init(props);
    }
    return _this;
  }

  (0, _createClass3.default)(ProGallery, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.store && this.store.dispatch && this.props.forceHover === true) {
        this.store.dispatch((0, _galleryActions.toggleHoverPreview)(this.props.forceHover));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.store && this.store.dispatch && nextProps.forceHover !== this.props.forceHover) {
        this.store.dispatch((0, _galleryActions.toggleHoverPreview)(nextProps.forceHover));
      }
    }
  }, {
    key: 'init',
    value: function init(props) {
      this.domId = Math.floor(Math.random() * 1000000);
      var middlewares = [_reduxThunk2.default, (0, _videoMiddleware2.default)({ videoQueue: new _videoQueue.VideoQueue(), utils: _utils2.default })];
      this.store = (0, _redux.createStore)(_index2.default, /* { gallery: { videoPlayMode: videoPlayModes.hover } } */{}, _redux.applyMiddleware.apply(undefined, middlewares));
      this.initStoreEvents(this.store);
    }
  }, {
    key: 'initStoreEvents',
    value: function initStoreEvents(store) {
      if (_WixSdkWrapper2.default && _WixSdkWrapper2.default.addEventListener) {
        _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.STYLE_PARAMS_CHANGE, function (styleParams) {
          store.dispatch({
            type: _videoActionTypes2.default.videoModeChanged,
            payload: styleParams.numbers.videoPlay
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var ProGalleryComponent = this.props.useRefactoredProGallery === true ? _galleryContainerNew2.default : _galleryContainer2.default;
      return this.canRender && _react2.default.createElement(
        'div',
        { id: 'pro-gallery-' + this.domId, className: 'pro-gallery' },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: this.store },
          _react2.default.createElement(ProGalleryComponent, (0, _extends3.default)({}, this.props, {
            domId: this.domId,
            items: this.props.items || __webpack_require__(306).defaultImages,
            store: this.store,
            watermarkData: this.props.watermarkData,
            settings: this.props.settings || {},
            offsetTop: this.props.offsetTop
          }))
        )
      );
    }
  }]);
  return ProGallery;
}(_react2.default.Component);

exports.default = ProGallery;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(14);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(146) });


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(32);
var gOPS = __webpack_require__(61);
var pIE = __webpack_require__(42);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(86);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(56);
var toAbsoluteIndex = __webpack_require__(148);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(150);
module.exports = __webpack_require__(8).Object.getPrototypeOf;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(35);
var $getPrototypeOf = __webpack_require__(87);

__webpack_require__(88)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(152);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(154), __esModule: true };

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(44);
module.exports = __webpack_require__(63).f('iterator');


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var defined = __webpack_require__(55);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(62);
var descriptor = __webpack_require__(31);
var setToStringTag = __webpack_require__(43);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(20)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(15);
var getKeys = __webpack_require__(32);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(159);
var step = __webpack_require__(160);
var Iterators = __webpack_require__(27);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(90)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(162), __esModule: true };

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
__webpack_require__(95);
__webpack_require__(168);
__webpack_require__(169);
module.exports = __webpack_require__(8).Symbol;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(11);
var has = __webpack_require__(21);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(14);
var redefine = __webpack_require__(91);
var META = __webpack_require__(164).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(59);
var setToStringTag = __webpack_require__(43);
var uid = __webpack_require__(41);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(63);
var wksDefine = __webpack_require__(64);
var enumKeys = __webpack_require__(165);
var isArray = __webpack_require__(166);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(17);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(54);
var createDesc = __webpack_require__(31);
var _create = __webpack_require__(62);
var gOPNExt = __webpack_require__(167);
var $GOPD = __webpack_require__(94);
var $DP = __webpack_require__(16);
var $keys = __webpack_require__(32);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(93).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(42).f = $propertyIsEnumerable;
  __webpack_require__(61).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(34)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(20)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(41)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(21);
var setDesc = __webpack_require__(16).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(32);
var gOPS = __webpack_require__(61);
var pIE = __webpack_require__(42);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(33);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(93).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('asyncIterator');


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64)('observable');


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(171), __esModule: true };

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(172);
module.exports = __webpack_require__(8).Object.setPrototypeOf;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(14);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(173).set });


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(15);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(24)(Function.call, __webpack_require__(94).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(175), __esModule: true };

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(176);
var $Object = __webpack_require__(8).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(62) });


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(66);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(179);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(202);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(102);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(190);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(188);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38)))

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(99);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(192);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(196);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38), __webpack_require__(195)(module)))

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(100);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(101);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(102);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(203);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(66);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(37);

var _loveButtonReducer = __webpack_require__(206);

var _loveButtonReducer2 = _interopRequireDefault(_loveButtonReducer);

var _galleryReducer = __webpack_require__(208);

var _galleryReducer2 = _interopRequireDefault(_galleryReducer);

var _fullscreenReducer = __webpack_require__(217);

var _fullscreenReducer2 = _interopRequireDefault(_fullscreenReducer);

var _multishareReducer = __webpack_require__(219);

var _multishareReducer2 = _interopRequireDefault(_multishareReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  loveButton: _loveButtonReducer2.default,
  gallery: _galleryReducer2.default,
  fullscreen: _fullscreenReducer2.default,
  multishare: _multishareReducer2.default
});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loveButtonReducer;

var _actionTypes = __webpack_require__(207);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isLoved: false,
  count: 0
};

function loveButtonReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.TOGGLE_LOVE:
      {
        var newCount = action.isLoved ? state.count + 1 : state.count - 1;
        return _lodash2.default.merge({}, state, { isLoved: action.isLoved, count: newCount });
      }
    default:
      return state;
  }
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_LOVE = exports.TOGGLE_LOVE = 'TOGGLE_LOVE';
var PROOF_ITEM_HOVER = exports.PROOF_ITEM_HOVER = 'PROOF_ITEM_HOVER';
var PROOF_ITEM_SELECT = exports.PROOF_ITEM_SELECT = 'PROOF_ITEM_SELECT';
var PROOF_MODE_CHANGE = exports.PROOF_MODE_CHANGE = 'PROOF_MODE_CHANGE';

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = galleryReducer;

var _galleryTypes = __webpack_require__(68);

var _videoActionTypes = __webpack_require__(104);

var _videoActionTypes2 = _interopRequireDefault(_videoActionTypes);

var _itemViewActions = __webpack_require__(105);

var _initialState = __webpack_require__(69);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function galleryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.gallery;
  var action = arguments[1];

  switch (action.type) {
    case _galleryTypes.SET_WIX_DATA:
      if (action.boundingRectAndOffsets) {
        var res = action.boundingRectAndOffsets;
        var scrollBase = res.offsets.y;
        var scrollTop = -1 * res.rect.top / _utils2.default.getViewportScaleRatio();
        var maxGalleryWidth = void 0;
        if (res && res.rect && !_lodash2.default.isUndefined(res.rect.width)) {
          maxGalleryWidth = res.rect.width;
        }

        return _lodash2.default.merge({}, state, {
          wixInit: true,
          scrollBase: scrollBase,
          scrollTop: scrollTop,
          maxGalleryWidth: maxGalleryWidth
        });
      } else {
        return _lodash2.default.merge({}, state, {
          wixInit: true,
          scrollBase: 0
        });
      }

    case _videoActionTypes2.default.videoModeChanged:
      {
        var newVideoPlayMode = action.payload;
        var _state = state,
            videoPlayMode = _state.videoPlayMode;

        if (videoPlayMode !== newVideoPlayMode) {
          state = (0, _extends3.default)({}, state, { videoPlayMode: newVideoPlayMode });
        }

        break;
      }
    case _galleryTypes.SET_ITEMS:
      return _lodash2.default.merge({}, state, { items: action.items });
    case _galleryTypes.SET_RENDERED_ITEMS_COUNT:
      return _lodash2.default.merge({}, state, { renderedItemsCount: action.count });
    case _galleryTypes.GALLERY_WINDOW_LAYOUT_CHANGED:
      {
        var documentHeight = { documentHeight: action.documentHeight };
        return _lodash2.default.merge({}, state, documentHeight);
      }
    case _galleryTypes.SET_VIDEO_PLAY_INDEX:
      state = (0, _extends3.default)({}, state, { videoIndexPlay: action.payload });
      break;
    case _itemViewActions.PLAY_VIDEO:
      return _lodash2.default.merge({}, state, { videoIndexPlay: action.idx });
    case _itemViewActions.PAUSE_VIDEO:
      return _lodash2.default.merge({}, state, { videoIndexPlay: -1 });
    case _galleryTypes.TOGGLE_HOVER_PREVIEW:
      return _lodash2.default.merge({}, state, { previewHover: action.toggle });
    default:
      return state;
  }

  return state;
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(210), __esModule: true };

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44);
__webpack_require__(36);
module.exports = __webpack_require__(211);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(71);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(27);
module.exports = __webpack_require__(8).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44);
__webpack_require__(36);
module.exports = __webpack_require__(213);


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var get = __webpack_require__(72);
module.exports = __webpack_require__(8).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var modelCache = {};

var _document = typeof document !== 'undefined' ? document : {
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {}
};

var WixMock = {
  closeWindow: function closeWindow() {},
  addEventListener: function addEventListener(event, callback) {
    _document.addEventListener(event, callback);
  },
  removeEventListener: function removeEventListener(event, callback) {
    _document.removeEventListener(event, callback);
  },

  stylesMock: { fonts: { testKey: { cssFontFamily: '1111' } }, numbers: {}, colors: {}, booleans: {} },
  colorMock: { colors: { testColorKey: 'color-1' } },
  getBoundingRectAndOffsets: function getBoundingRectAndOffsets(callback) {
    callback({
      offsets: {
        x: 0,
        y: 0
      }
    });
  },
  getCurrentPageId: function getCurrentPageId(callback) {
    callback('mock-page-id');
  },

  Utils: {
    navigateToSection: function navigateToSection() {},
    getOrigCompId: function getOrigCompId() {},
    getCompId: function getCompId() {
      return 'mock-comp-id';
    },
    getViewMode: function getViewMode() {},
    getDemoMode: function getDemoMode() {},
    getInstance: function getInstance() {
      return 'instance';
    },
    getInstanceValue: function getInstanceValue() {
      return '';
    },
    getInstanceId: function getInstanceId() {
      return 'instance-id';
    },
    getBusinessId: function getBusinessId() {
      return 'business-id';
    },
    isOverEditor: function isOverEditor() {
      return false;
    },
    getSectionUrl: function getSectionUrl(sectionIdentifier, callback) {
      setTimeout(function () {
        callback('https://mock_section_url');
      }, 0);
    },

    Media: {
      getResizedImageUrl: function getResizedImageUrl(relativeUrl, width, height) {
        return '/images/test-' + relativeUrl + '-' + width + '-' + height + '.jpg';
      }
    }
  },
  setHeight: function setHeight() {},

  UI: {
    create: function create() {
      return {};
    },
    initialize: function initialize() {},
    onChange: function onChange(key, func) {
      _document.addEventListener(key, function () {
        func(modelCache[key]);
      });
    },
    get: function get(key) {
      return modelCache[key];
    },
    set: function set(key, val) {
      modelCache[key] = val;
    },

    modelCache: modelCache
  },
  Styles: {
    getColorByreference: function getColorByreference() {
      return { value: '#123456' };
    },
    getSiteColors: function getSiteColors() {
      var arr = [];
      for (var i = 0; i < 31; i++) {
        arr[i] = i;
      }
      return arr;
    },
    getStyleParams: function getStyleParams(callbackFunc) {
      if (callbackFunc) {
        return callbackFunc(WixMock.stylesMock);
      } else {
        return WixMock.stylesMock;
      }
    },
    getStyleParamsByStyleId: function getStyleParamsByStyleId(styleId, callbackFunc) {
      if (callbackFunc) {
        return callbackFunc(WixMock.stylesMock);
      } else {
        return WixMock.stylesMock;
      }
    },
    restoreParam: function restoreParam() {
      WixMock.stylesMock = { fonts: { testKey: { cssFontFamily: '1111' } }, numbers: {}, colors: {}, booleans: {} };
    },
    setFontParam: function setFontParam(key, value, callback) {
      WixMock.stylesMock.fonts[key] = { cssFontFamily: value.value.cssFontFamily };
      if (callback) {
        callback();
      }
    },
    setColorParam: function setColorParam(key, value, callback) {
      WixMock.colorMock.colors[key] = value;
      if (callback) {
        callback();
      }
    },
    getSiteTextPresets: function getSiteTextPresets() {
      return {
        Title: {
          editorKey: 'font_0',
          fontFamily: 'fontFamilyTitle',
          lineHeight: '1.4em',
          size: '40px',
          style: 'normal',
          value: 'value',
          weight: 'normal'
        }
      };
    },
    getEditorFonts: function getEditorFonts() {
      return [{
        language: 'hebrew',
        fonts: [{
          cssFontFamily: 'fontFamilyTitle0',
          fontFamily: 'fontFamilyTitle0',
          genericFamily: 'cursive0',
          permissions: 'all0',
          provider: 'google0',
          spriteIndex: 132
        }]
      }, {
        language: 'latin',
        fonts: [{
          cssFontFamily: 'fontFamilyTitle',
          fontFamily: 'fontFamilyTitle',
          genericFamily: 'cursive',
          permissions: 'all',
          provider: 'google',
          spriteIndex: 154
        }]
      }, {
        language: 'arabic',
        fonts: [{
          cssFontFamily: 'fontFamilyTitleArabic',
          fontFamily: 'fontFamilyTitleArabic',
          genericFamily: 'cursiveArabic',
          permissions: 'allArabic',
          provider: 'googleArabic',
          spriteIndex: 160
        }]
      }];
    },
    getStyleId: function getStyleId(callback) {
      callback('mock-style-id');
    }
  },
  Settings: {
    openModal: function openModal(url, width, height, name, callback) {
      callback();
    },
    triggerSettingsUpdatedEvent: function triggerSettingsUpdatedEvent() {},
    getSiteInfo: function getSiteInfo(callback) {
      return callback({ baseUrl: 'www.test.boost.co.il' });
    },
    getDashboardAppUrl: function getDashboardAppUrl(func) {
      func.call();
    },
    refreshApp: function refreshApp() {
      return '';
    },
    setExternalId: function setExternalId() {},
    addComponent: function addComponent() {},

    MediaType: {
      IMAGE: 'photos',
      BACKGROUND: 'backgrounds',
      AUDIO: 'audio',
      DOCUMENT: 'documents',
      SWF: 'swf',
      SECURE_MUSIC: 'secure_music',
      VIDEO: 'video',
      SHAPE: 'shape',
      MUSIC: 'music',
      CLIPART: 'clipart',
      BG_VIDEO: 'bg_video',
      ICON_DOCUMENT: 'icon_document',
      ICON_SOCIAL: 'bg_social',
      ICON_FAVICON: 'bg_favicon',
      MUSIC_PRO: 'secure_music',
      IMAGE_PRO: 'secure_picture',
      FLASH: 'swf',
      BG_IMAGE: 'backgrounds'
    }
  },
  Events: {
    PUBLIC_DATA_CHANGED: 'PUBLIC_DATA_CHANGED',
    SETTINGS_UPDATED: 'SETTINGS_UPDATED',
    EDIT_MODE_CHANGE: 'EDIT_MODE_CHANGE',
    STYLE_PARAMS_CHANGE: 'STYLE_PARAMS_CHANGE',
    THEME_CHANGE: 'THEME_CHANGE',
    PAGE_NAVIGATION_IN: 'PAGE_NAVIGATION_IN',
    PAGE_NAVIGATION_OUT: 'PAGE_NAVIGATION_OUT'
  },
  Theme: {
    BARE: 'bare'
  },
  scrollTo: function scrollTo() {},
  scrollBy: function scrollBy() {},
  getSiteInfo: function getSiteInfo() {},

  Data: {
    Public: {
      get: function get(key, jsonObj, callback) {
        callback({ pg: 1 });
      }
    }
  },
  Features: {
    isSupported: function isSupported() {
      //isSupported: function (feature, callback){
      //callback(true);
    },

    Types: {
      ADD_COMPONENT: 'ADD_COMPONENT'
    }
  },
  PubSub: {
    subscribe: function subscribe() {},
    publish: function publish() {}
  },
  getSitePages: function getSitePages(callback) {
    if (typeof callback === 'function') {
      callback([]);
    }
  },
  replaceSectionState: function replaceSectionState() {},

  Performance: {
    applicationLoaded: function applicationLoaded() {}
  }
};

exports.default = WixMock;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fullscreenReducer;

var _fullscreenActions = __webpack_require__(218);

var _initialState = __webpack_require__(69);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fullscreenReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.fullscreen;
  var action = arguments[1];


  switch (action.type) {
    case _fullscreenActions.SET_SLIDE:
      return _lodash2.default.merge({}, state, {
        slideIdx: action.slideIdx
      });

    default:
      return state;
  }
}

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSlide = setSlide;
var SET_SLIDE = exports.SET_SLIDE = 'SET_SLIDE';

function setSlide(slideIdx) {

  return {
    type: SET_SLIDE,
    slideIdx: slideIdx
  };
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = multishareReducer;

var _initialState = __webpack_require__(69);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {} from '../actions/multishareActions.js';
function multishareReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default.multishare;
  var action = arguments[1];


  switch (action.type) {
    default:
      return state;
  }
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryContainer = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(221);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(114);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(45);

var _redux = __webpack_require__(37);

var _galleryActions = __webpack_require__(47);

var actions = _interopRequireWildcard(_galleryActions);

var _galleryView = __webpack_require__(115);

var _galleryView2 = _interopRequireDefault(_galleryView);

var _slideshowView = __webpack_require__(131);

var _slideshowView2 = _interopRequireDefault(_slideshowView);

var _proGalleryLayouter = __webpack_require__(39);

var _galleryItem = __webpack_require__(51);

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _galleryGroup = __webpack_require__(82);

var _galleryGroup2 = _interopRequireDefault(_galleryGroup);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _spacing = __webpack_require__(83);

var _layouts = __webpack_require__(136);

var _itemActions = __webpack_require__(22);

var _biLogger = __webpack_require__(29);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _consts = __webpack_require__(49);

var _consts2 = _interopRequireDefault(_consts);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _prependHttpExtra = __webpack_require__(137);

var _prependHttpExtra2 = _interopRequireDefault(_prependHttpExtra);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

try {
  window.itemActions = _itemActions.itemActions; //itemActions must be saved on the window because the specific instance of each gallery's itemActions is accessed from other frames
} catch (e) {
  //
}

var FullscreenContainer = void 0;
// if (!utils.isInWix()) {
//   import(/* webpackChunkName: "fullscreenContainer" */ '../fullscreen/fullscreenContainer.js').then(fullscreen => {
//     FullscreenContainer = fullscreen.default;
//   });
// }

var GalleryContainer = exports.GalleryContainer = function (_React$Component) {
  (0, _inherits3.default)(GalleryContainer, _React$Component);

  function GalleryContainer(props, context) {
    (0, _classCallCheck3.default)(this, GalleryContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GalleryContainer.__proto__ || (0, _getPrototypeOf2.default)(GalleryContainer)).call(this, props, context));

    _this.closeFullscreenCallback = _this.closeFullscreenCallback.bind(_this);
    _this.toggleInfiniteScroll = _this.toggleInfiniteScroll.bind(_this);
    _this.toggleFullscreen = _this.toggleFullscreen.bind(_this);
    _this.getGalleryScroll = _this.getGalleryScroll.bind(_this);
    _this.setWixHeight = _this.setWixHeight.bind(_this);
    _this.scrollToItem = _this.scrollToItem.bind(_this);
    _this.addItemToMultishare = _this.addItemToMultishare.bind(_this);
    _this.removeItemFromMultishare = _this.removeItemFromMultishare.bind(_this);
    _this.updateMultishareItems = _this.updateMultishareItems.bind(_this);
    _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_this);
    _this.dispatchNavigationOutIfNeeded = _this.dispatchNavigationOutIfNeeded.bind(_this);
    _this.dispatchNavigationInIfNeeded = _this.dispatchNavigationInIfNeeded.bind(_this);

    _this.reRenderForHorizontalScroll = _this.reRenderForHorizontalScroll.bind(_this);
    _this.reRenderForScroll = _this.reRenderForScroll.bind(_this);
    _this.reRenderForStyles = _this.reRenderForStyles.bind(_this);
    _this.reRenderForSettings = _this.reRenderForSettings.bind(_this);
    _this.reRenderForResize = _this.reRenderForResize.bind(_this);
    _this.reRenderForOrientation = _this.reRenderForOrientation.bind(_this);
    _this.reRenderForEditMode = _this.reRenderForEditMode.bind(_this);
    _this.reRenderForDevice = _this.reRenderForDevice.bind(_this);
    _this.onResizeEvent = _this.onResizeEvent.bind(_this);

    var debouncer = _lodash2.default.throttle;
    var debounceInterval = 2000;
    if (!_utils2.default.browserIs('explorer') && !_utils2.default.isTest()) {
      try {
        switch (_utils2.default.safeLocalStorage().scrollThrottleMode) {
          case 'throttle250':
            debounceInterval = 250;
            break;
          case 'throttle500':
            debounceInterval = 500;
            break;
          case 'throttle1000':
            debounceInterval = 1000;
            break;
          default:
          case 'throttle2000':
            debounceInterval = 2000;
            break;
          case 'debounce100':
            debounceInterval = 100;
            debouncer = _lodash2.default.debounce;
            break;
          case 'debounce300':
            debounceInterval = 300;
            debouncer = _lodash2.default.debounce;
            break;
          case 'debounce500':
            debounceInterval = 500;
            debouncer = _lodash2.default.debounce;
            break;
        }

        _this.reRenderForScroll = debouncer(_this.reRenderForScroll, debounceInterval);
        _this.reRenderForHorizontalScroll = debouncer(_this.reRenderForHorizontalScroll, debounceInterval);
        if (_utils2.default.isVerbose()) {
          console.log('debouncing scroll', debouncer, debounceInterval);
        }
      } catch (e) {
        console.error('Could not debounce scroll', e);
      }
    }

    _this.renderTriggers = {
      SCROLL: 'Scroll',
      STYLES: 'Styles',
      ITEMS: 'Items',
      RESIZE: 'Resize',
      ORIENTATION: 'Orientation',
      MODE: 'Mode',
      NONE: 'None',
      LAYOUT: 'Layout',
      ALL: 'All'
    };

    _this.lastHeight = 0;
    _this.newHeight = 0;
    _this.resizeCount = 0;
    _this.orientationCount = 0;
    _this.scrollBase = 0;
    _this.lastOffsetTop = 0;

    _this.thumbnailSize = _utils2.default.isMobile() ? 90 : 120;
    _this.slideshowInfoSize = 220;

    _this.preloadedItems = [];

    var initPromise = _this.init();

    _this.defaultStateStyles = {
      gotStyleParams: false,
      galleryLayout: _utils2.default.isStoreGallery() ? 2 : 0,
      selectedLayout: 0,
      isVertical: false,
      gallerySize: 320,
      minItemSize: 120,
      groupSize: 3,
      chooseBestGroup: true,
      groupTypes: '1,2h,2v,3t,3b,3l,3r',
      cubeImages: false,
      cubeType: 'fill',
      smartCrop: false,
      fullscreen: true,
      allowSocial: true,
      allowDownload: false,
      allowTitle: true,
      allowDescription: false,
      allowMultishare: false,
      loveButton: true,
      loveCounter: true,
      videoLoop: true,
      videoSpeed: 1,
      videoPlay: 'hover',
      gallerySliderImageRatio: 0,
      galleryImageRatio: 2,
      numberOfImagesPerRow: 3,
      sharpParams: {
        quality: 90,
        usm: {} // do not apply usm - {usm_r: 0.66, usm_a: 1.00, usm_t: 0.01},
      },
      collageAmount: 0.8,
      collageDensity: 0.8,
      borderRadius: 0,
      boxShadow: 0,
      imageMargin: 5,
      galleryMargin: 0,
      floatingImages: 0,
      viewMode: 'preview',
      galleryHorizontalAlign: 'center',
      galleryTextAlign: 'center',
      galleryVerticalAlign: 'center',
      enableInfiniteScroll: 1,
      itemClick: 'expand',
      cubeRatio: 1, //determine the ratio of the images when using grid (use 1 for squares grid)
      fixedColumns: 0, //determine the number of columns regardless of the screen size (use 0 to ignore)
      oneRow: false, //render the gallery as a single row with horizontal scroll
      showArrows: false,
      isSlideshow: false,
      hasThumbnails: false,
      galleryThumbnailsAlignment: 'bottom',
      thumbnailSpacings: 0,
      gridStyle: 0,
      useCustomButton: _utils2.default.isStoreGallery(),
      titlePlacement: _consts2.default.placements.SHOW_ON_HOVER,
      mobilePanorama: false,
      isAutoSlideshow: false,
      autoSlideshowInterval: 4
    };

    var galleryWidth = _this.getGalleryWidth();
    _this.galleryStructure = {};
    _this.items = _this.props.items;

    var itemsIds = _this.itemsIds(_this.items);
    _this.newProps = {};
    _this.state = {
      items: itemsIds,
      renderedItemsCount: _this.props.renderedItemsCount || itemsIds.length,
      totalItemsCount: _this.props.totalItemsCount || itemsIds.length,
      scroll: {
        isInfinite: _this.isInfiniteScroll(),
        base: _this.scrollBase || 0,
        top: _this.currentScrollPosition || 0
      },
      container: {
        maxGalleryWidth: _this.props.maxGalleryWidth,
        galleryWidth: galleryWidth,
        galleryHeight: _this.getGalleryHeight(),
        viewMode: 'site',
        bounds: {
          visibleTop: 0,
          visibleBottom: 1000,
          renderedTop: 0,
          renderedBottom: 3000
        }
      },
      styleParams: _lodash2.default.clone(_this.defaultStateStyles),
      hashtag: {
        filter: _utils2.default.getWorkerWindow()['pro-gallery-hashtag-filter'] || '',
        items: []
      },
      multishare: {
        items: [],
        isMultisharing: _this.props.defaultSelectMode === true
      }
    };

    window.isWebpSupported = _utils2.default.isWebpSupported();

    if (_lodash2.default.isFunction(props.onInit)) {
      props.onInit();
    }

    setTimeout(function () {
      var sp = _this.state.styleParams;
      if (sp.gotStyleParams === undefined) {
        console.error('Gallery Container: styleParams are empty');
      }
    }, 5000);

    /*setTimeout(
      () => {
        const sp = this.state.styleParams;
        sp.gotStyleParams || this.reRenderForStyles(); //ugly hack, some galleries don't have the styleparams and don't render
      }, 0
    );*/
    return _this;
  }

  //-------------------------------------------| INIT |--------------------------------------------//

  (0, _createClass3.default)(GalleryContainer, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var initPromises = [];
      var addPromiseIfExists = function addPromiseIfExists(value) {
        value && initPromises.push(value);
      };
      this.currentScrollPosition = 0;
      this.compId = _utils2.default.isSemiNative() ? 'compId' : _WixSdkWrapper2.default.Utils.getCompId();
      this.galleryId = window.galleryId; //TD: move to props
      this.currentWindowWidth = window.innerWidth; //TD: move to WixWrapper
      this.currentWindowHeight = window.innerHeight;

      if (!_utils2.default.isSemiNative()) {
        _WixSdkWrapper2.default.getCurrentPageId(function (res) {
          _this2.pageId = res;
          _WixSdkWrapper2.default.Styles.getStyleId(function (res) {
            _this2.styleId = res;
            _WixSdkWrapper2.default.Utils.getSectionUrl({
              sectionId: _utils2.default.getFullscreenSectionId()
            }, function (res) {
              _this2.fullscreenUrl = res.url;
              _this2.setState({
                itemActionsInit: _itemActions.itemActions.initWidgetData({
                  compId: _this2.compId,
                  pageId: _this2.pageId,
                  styleId: _this2.styleId,
                  galleryId: _this2.galleryId,
                  fullscreenUrl: _this2.fullscreenUrl
                })
              });
              _utils2.default.getWorkerWindow()['pro-gallery-data-' + _this2.compId] = {
                info: {
                  compId: _this2.compId,
                  pageId: _this2.pageId,
                  styleId: _this2.styleId,
                  galleryId: _this2.galleryId,
                  dateCreated: _utils2.default.getDateCreatedTicksFromStr(window.dateCreated)
                },
                window: {
                  infiniteScrollUrl: window.infiniteScrollUrl,
                  instance: window.instance
                }
              };
            });
          });
        });

        _WixSdkWrapper2.default.getBoundingRectAndOffsets(function (rect) {
          _this2.scrollBase = rect.offsets.y * rect.scale || 0;
          if (rect && rect.rect && !_lodash2.default.isUndefined(rect.rect.width)) {
            _this2.maxGalleryWidth = _lodash2.default.get(rect, 'rect.width') || 0;
          }
        });
      }

      this.initEventsFunction();

      if (initPromises.length) {
        return _promise2.default.all(initPromises);
      }
    }
  }, {
    key: 'initEventsFunction',
    value: function initEventsFunction() {
      this.windowEventsFunctions = [];
      this.wixEventsFunctions = [];
      // this.pubsubFunctions = [];

      if (_utils2.default.isInWix() || _utils2.default.isWixIframe()) {
        this.wixEventsFunctions.push([_WixSdkWrapper2.default.Events.STYLE_PARAMS_CHANGE, this.reRenderForStyles]);
        this.wixEventsFunctions.push([_WixSdkWrapper2.default.Events.SETTINGS_UPDATED, this.reRenderForSettings]);
        this.wixEventsFunctions.push([_WixSdkWrapper2.default.Events.DEVICE_TYPE_CHANGED, this.reRenderForDevice]);
        this.wixEventsFunctions.push([_WixSdkWrapper2.default.Events.EDIT_MODE_CHANGE, this.reRenderForEditMode]);
        if (!this.props.ignoreWixScrollEvent) {
          this.wixEventsFunctions.push([_WixSdkWrapper2.default.Events.SCROLL, this.reRenderForScroll]);
        }
        // this.pubsubFunctions.push(['multishare2gallery', this.updateMultishareItems]);
      } else {
        this.windowEventsFunctions.push(['scroll', this.reRenderForScroll]);
      }
      //global events
      this.windowEventsFunctions.push(['resize', this.onResizeEvent]);
      this.windowEventsFunctions.push(['orientationchange', this.reRenderForOrientation]);

      // MUST be 'CustomEvent'
      if (_utils2.default.isSemiNative()) {
        this.onItemClickEvent = new window.CustomEvent('on_item_click');
      } else {
        this.onItemClickEvent = document.createEvent('CustomEvent');
        this.onItemClickEvent.initCustomEvent('on_item_click', false, false, null);
      }
    }
  }, {
    key: 'initEventListeners',
    value: function initEventListeners() {
      if (!_utils2.default.isInWix() && !_utils2.default.isSemiNative()) {
        window.addEventListener('beforeunload', function () {
          window.scrollTop = 0;
        });
      }

      this.windowEventsFunctions.forEach(function (x) {
        var _window;

        return (_window = window).addEventListener.apply(_window, (0, _toConsumableArray3.default)(x));
      });
      document.addEventListener('scroll', this.reRenderForHorizontalScroll, true);
      if (!_utils2.default.isSemiNative()) {
        // this.pubsubFunctions.forEach(x => Wix.PubSub.subscribe(...x));
        this.wixEventsFunctions.forEach(function (x) {
          return _WixSdkWrapper2.default.addEventListener && _WixSdkWrapper2.default.addEventListener.apply(_WixSdkWrapper2.default, (0, _toConsumableArray3.default)(x));
        });
      }
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      this.windowEventsFunctions.forEach(function (x) {
        var _window2;

        return (_window2 = window).removeEventListener.apply(_window2, (0, _toConsumableArray3.default)(x));
      });
      document.removeEventListener('scroll', this.reRenderForHorizontalScroll, true);
      if (!_utils2.default.isSemiNative()) {
        this.wixEventsFunctions.forEach(function (x) {
          return _WixSdkWrapper2.default.removeEventListener && _WixSdkWrapper2.default.removeEventListener.apply(_WixSdkWrapper2.default, (0, _toConsumableArray3.default)(x));
        });
        // this.pubsubFunctions.forEach(x => Wix.PubSub.unsubscribe(...x));
      }
    }
  }, {
    key: 'dispatchNavigationOutIfNeeded',
    value: function dispatchNavigationOutIfNeeded() {
      if (!this.tabFocused || !this.wixFocused) window.dispatchEvent(this.navigationOutEvent);
    }
  }, {
    key: 'dispatchNavigationInIfNeeded',
    value: function dispatchNavigationInIfNeeded() {
      if (this.tabFocused && this.wixFocused) window.dispatchEvent(this.navigationInEvent);
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange() {
      var hidden = void 0;
      if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hidden = 'hidden';
      } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
      }
      if (document[hidden]) {
        this.tabFocused = false;
        this.dispatchNavigationOutIfNeeded();
      } else {
        this.tabFocused = true;
        this.dispatchNavigationInIfNeeded();
      }
    }
  }, {
    key: 'initNavigationEventListeners',
    value: function initNavigationEventListeners() {
      var _this3 = this;

      if (!_utils2.default.isSemiNative()) {
        _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.PAGE_NAVIGATION_IN, function () {
          _this3.initEventListeners();
          _this3.props.actions.navigationIn();
          _itemActions.itemActions.getStats();
          _this3.wixFocused = true;
          _this3.dispatchNavigationInIfNeeded();
        });
        _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.PAGE_NAVIGATION_OUT, function () {
          _this3.removeEventListeners();
          _this3.wixFocused = false;
          _this3.dispatchNavigationOutIfNeeded();
        });
        var visibilityChange = void 0;
        if (typeof document.hidden !== 'undefined') {
          // Opera 12.10 and Firefox 18 and later support
          visibilityChange = 'visibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
          visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
          visibilityChange = 'webkitvisibilitychange';
        }
        window.addEventListener(visibilityChange, this.handleVisibilityChange, false);
      }
    }
  }, {
    key: 'initPersistentEventListeners',
    value: function initPersistentEventListeners() {
      window.addEventListener('fullscreen_closed', this.closeFullscreenCallback); //TD: this shouldnt be an event
    }
  }, {
    key: 'initCustomEvents',
    value: function initCustomEvents() {
      if (_utils2.default.isSemiNative()) {
        this.galleryScrollEvent = new window.CustomEvent('gallery_scroll'); // MUST be 'CustomEvent'
        this.navigationOutEvent = new window.CustomEvent('gallery_navigation_out'); // MUST be 'CustomEvent'
        this.navigationInEvent = new window.CustomEvent('gallery_navigation_in'); // MUST be 'CustomEvent'
      } else {
        this.galleryScrollEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.galleryScrollEvent.initCustomEvent('gallery_scroll', false, false, null);
        this.navigationOutEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.navigationOutEvent.initCustomEvent('gallery_navigation_out', false, false, null);
        this.navigationInEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.navigationInEvent.initCustomEvent('gallery_navigation_in', false, false, null);
      }
    }
  }, {
    key: 'preloadItem',
    value: function preloadItem(item, onload) {
      if (!item || !item.itemId || !item.isGalleryItem) {
        return;
      }
      try {
        var id = item.itemId;
        if (typeof this.preloadedItems[id] !== 'undefined') {
          return;
        }
        this.preloadedItems[id] = new Image();
        if (_utils2.default.isVerbose()) {
          console.log('Preloading item #' + item);
        }
        // console.log('[DIMENSIONS] preloading item', item.idx, item.thumbnail_url.img);
        console.time('[DIMENSIONS] preloading item #' + item.idx);
        this.preloadedItems[id].src = item.thumbnail_url.img;
        if (typeof onload === 'function') {
          this.preloadedItems[id].onload = function (e) {
            console.timeEnd('[DIMENSIONS] preloading item #' + item.idx);
            onload(e);
          };
        }
        return this.preloadedItems[id];
      } catch (e) {
        console.error('Could not preload item', item);
        return;
      }
    }
  }, {
    key: 'loadItemsDimensions',
    value: function loadItemsDimensions() {
      var _this4 = this;

      //TD: move to item logic
      if (!this.galleryItems()) {
        return;
      }

      var itemsWithoutDimensions = this.galleryItems().filter(function (item, idx) {
        try {
          return item.isVisible && item.isDimensionless;
        } catch (e) {
          return false;
        }
      });

      // console.log(`[DIMENSIONS] calculating ${itemsWithoutDimensions.length} / ${this.layoutItems().length} elements dimensions`);
      itemsWithoutDimensions.forEach(function (item, idx, items) {
        _this4.preloadItem(item, function (e) {
          try {
            if (_utils2.default.isVerbose()) {
              console.log('item loaded event', idx, e);
            }
            var ele = e.srcElement;
            var itemIdx = _this4.items.findIndex(function (itm) {
              return itm.itemId === item.itemId;
            });
            _this4.items[itemIdx].metaData.width = ele.width;
            _this4.items[itemIdx].metaData.height = ele.height;
            // console.log('[DIMENSIONS] Calculated element dimensions', itemIdx, this.items[itemIdx].metaData.width, this.items[itemIdx].metaData.height);
            // console.count('[DIMENSIONS] Calculated element dimensions');
          } catch (e) {
            console.error('Could not calc element dimensions', e);
          }
          _this4.reRender(_this4.renderTriggers.ITEMS);
        });
      });
    }

    //-----------------------------------------| STYLES |--------------------------------------------//

  }, {
    key: 'getStyleBySeed',
    value: function getStyleBySeed(seed) {
      if (!seed > 0) {
        seed = 999999;
      }
      seed = Math.floor(seed);

      var strToSeed = function strToSeed(str) {
        str = String(str);
        var total = 0;
        for (var s = 0; s < str.length; s++) {
          total += str.charCodeAt(s);
        }
        return total;
      };

      var mergeSeeds = function mergeSeeds(s1, s2) {
        return Math.floor((s1 / s2 - Math.floor(s1 / s2)) * 10000000);
      };

      if (_utils2.default.isSite() && _lodash2.default.get(this, 'state.styleParams.gotStyleParams') && !this.props.styleParams) {
        if (_utils2.default.isVerbose()) {
          console.log('already got style params, not fetching again', this.state.styleParams);
        }
        return;
      }

      var numFromSeed = function numFromSeed(min, max, strSeed) {
        var seed2 = strToSeed(strSeed);
        var range = max - min + 1;
        return mergeSeeds(seed, seed2) % range + min;
      };

      var boolFromSeed = function boolFromSeed(strSeed) {
        return !!numFromSeed(0, 1, strSeed);
      };

      var style = {
        cubeImages: boolFromSeed('cubeImages'),
        cubeRatio: numFromSeed(1, 25, 'cubeRatio') / 5,
        isVertical: boolFromSeed('isVertical'),
        gallerySize: numFromSeed(300, 800, 'gallerySize'),
        collageAmount: numFromSeed(5, 10, 'collageAmount') / 10,
        collageDensity: (_spacing.spacingVersionManager.isNewSpacing() ? numFromSeed(1, 100, 'collageDensity') : numFromSeed(5, 10, 'collageDensity')) / 100,
        groupTypes: ['1'].concat(_lodash2.default.filter('2h,2v,3t,3b,3l,3r,3h,3v'.split(','), function (type, i) {
          return boolFromSeed('groupTypes' + i);
        })),
        oneRow: boolFromSeed('oneRow'),
        borderRadius: 0,
        boxShadow: 0,
        imageMargin: numFromSeed(0, _spacing.spacingVersionManager.isNewSpacing() ? numFromSeed(300, 800, 'gallerySize') / 5 : 5, 'imageMargin'),
        galleryMargin: _spacing.spacingVersionManager.isNewSpacing() ? 0 : numFromSeed(0, 5, 'imageMargin'),
        floatingImages: 0,
        chooseBestGroup: boolFromSeed('chooseBestGroup'),
        smartCrop: boolFromSeed('smartCrop'),
        showArrows: false,
        cubeType: 'fill',
        hasThumbnails: false,
        enableScroll: true,
        isGrid: false,
        isSlideshow: false,
        isSlider: false,
        isColumns: false,
        cropOnlyFill: false,
        fixedColumns: 0,
        enableInfiniteScroll: 1
      };

      //force adjustments
      if (style.oneRow) {
        style.isVertical = false;
      }
      style.galleryType = style.isVertical ? 'Columns' : 'Strips';
      style.groupSize = parseInt(_lodash2.default.last(style.groupTypes));
      style.groupTypes = style.groupTypes.join(',');
      style.minItemSize = style.gallerySize / style.groupSize / 2;

      if (_utils2.default.isVerbose()) {
        console.log('Created magic layout style', seed, style);
      }

      return style;
    }
  }, {
    key: 'getStyleByGalleryType',
    value: function getStyleByGalleryType(galleryType, gallerySize) {
      //legacy layouts

      var galleryTypes = {
        collage_ver: {
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 3,
          groupTypes: '1,2h,2v,3t,3b,3l,3r',
          gallerySize: Math.round(gallerySize * 5 + 500),
          fixedColumns: 0
        },
        collage_hor: {
          cubeImages: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 3,
          groupTypes: '1,2h,2v,3t,3b,3l,3r',
          gallerySize: Math.round(gallerySize * 5 + 500),
          fixedColumns: 0
        },
        grid: {
          cubeImages: true,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: Math.round(gallerySize * 8.5 + 150),
          fixedColumns: 0,
          placeGroupsLtr: true,
          isGrid: true
        },
        masonry_ver: {
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: Math.round(gallerySize * 8 + 200),
          fixedColumns: 0
        },
        masonry_hor: {
          cubeImages: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: Math.round(gallerySize * 5 + 200),
          fixedColumns: 0
        },
        one_col: {
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryWidth(),
          fixedColumns: 1
        },
        one_row: {
          cubeImages: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryHeight(),
          fixedColumns: 0
        },
        slideshow: {
          showArrows: true,
          cubeImages: true,
          cubeRatio: this.getGalleryRatio(),
          isVertical: true,
          gallerySize: this.getGalleryWidth(),
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          fixedColumns: 1
        }
      };

      var styleState = void 0;

      switch (galleryType) {
        case '-1':
          //empty
          styleState = {
            gallerySize: gallerySize
          };
          break;
        case '0':
          //vertical collage
          styleState = galleryTypes.collage_ver;
          break;
        default:
        case '1':
          //horizontal collage
          styleState = galleryTypes.collage_hor;
          break;
        case '2':
          //grid
          styleState = galleryTypes.grid;
          break;
        case '3':
          //vertical masonry
          styleState = galleryTypes.masonry_ver;
          break;
        case '4':
          //horizontal masonry
          styleState = galleryTypes.masonry_hor;
          break;
        case '5':
          //one column
          styleState = galleryTypes.one_col;
          break;
        case '6':
          //one row
          styleState = galleryTypes.one_row;
          break;
        case '7':
          //slideshow
          styleState = galleryTypes.slideshow;
          break;
      }

      return styleState;
    }
  }, {
    key: 'getStyleByLayout',
    value: function getStyleByLayout(wixStyles, selectedLayout) {
      var _this5 = this;

      //new layouts
      var gallerySize = wixStyles.gallerySize,
          magicLayoutSeed = wixStyles.magicLayoutSeed;


      var galleryLayout = selectedLayout || wixStyles.galleryLayout;

      var layouts = {
        collage: {
          showArrows: false,
          cubeImages: false,
          groupSize: 3,
          groupTypes: '1,2h,2v,3t,3b,3l,3r',
          gallerySize: Math.round(gallerySize * 5 + 500),
          fixedColumns: 0,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isSlider: false,
          isMasonry: false,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: false
        },
        masonry: {
          showArrows: false,
          cubeImages: false,
          groupSize: 1,
          groupTypes: '1',
          gallerySize: gallerySize,
          fixedColumns: 0,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isSlider: false,
          isMasonry: true,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: false,
          oneRow: false
        },
        grid: {
          showArrows: false,
          cubeImages: true,
          smartCrop: false,
          imageResize: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          fixedColumns: undefined,
          gallerySize: Math.round(gallerySize * 8.5 + 150),
          hasThumbnails: false,
          enableScroll: true,
          cropOnlyFill: false,
          isSlider: false,
          isColumns: false,
          isGrid: true,
          placeGroupsLtr: true,
          isMasonry: false,
          isSlideshow: false,
          minItemSize: 50
        },
        thumbnails: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeType: 'fill',
          cubeRatio: function cubeRatio() {
            var dims = _this5.getGalleryDimensions();
            return dims.galleryWidth / dims.galleryHeight;
          },
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          gallerySize: this.getGalleryWidth(),
          groupTypes: '1',
          oneRow: true,
          hasThumbnails: true,
          enableScroll: false,
          isGrid: false,
          isSlider: false,
          isMasonry: false,
          isColumns: false,
          isSlideshow: false,
          cropOnlyFill: false,
          floatingImages: 0,
          galleryMargin: 0,
          imageMargin: 0
        },
        slider: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryHeight(),
          oneRow: true,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isSlider: true,
          isColumns: false,
          isMasonry: false,
          isSlideshow: false,
          cropOnlyFill: true
        },
        slideshow: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeRatio: function cubeRatio() {
            var dims = _this5.getGalleryDimensions();
            return dims.galleryWidth / dims.galleryHeight;
          },
          cubeType: 'fill',
          isVertical: false,
          gallerySize: 550,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          fixedColumns: 1,
          oneRow: true,
          hasThumbnails: false,
          enableScroll: false,
          isGrid: false,
          isColumns: false,
          isMasonry: false,
          isSlider: false,
          isSlideshow: true,
          cropOnlyFill: false,
          floatingImages: 0,
          galleryMargin: 0,
          imageMargin: 0
        },
        panorama: {
          showArrows: false,
          cubeImages: false,
          isVertical: true,
          galleryType: 'Columns',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryWidth(),
          oneRow: false,
          fixedColumns: 1,
          hasThumbnails: false,
          enableScroll: true,
          isGrid: false,
          isColumns: false,
          isMasonry: false,
          isSlider: false,
          isSlideshow: false,
          cropOnlyFill: false
        },
        column: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeType: 'fill',
          cubeRatio: 0.35,
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          groupTypes: '1',
          gallerySize: this.getGalleryHeight(),
          fixedColumns: 0,
          hasThumbnails: false,
          oneRow: true,
          enableScroll: true,
          isGrid: false,
          isColumns: true,
          isMasonry: false,
          isSlider: false,
          isSlideshow: false,
          cropOnlyFill: false
        },
        fullsize: {
          showArrows: true,
          cubeImages: true,
          smartCrop: false,
          cubeType: 'fill',
          cubeRatio: function cubeRatio() {
            var dims = _this5.getGalleryDimensions();
            return dims.galleryWidth / dims.galleryHeight;
          },
          isVertical: false,
          galleryType: 'Strips',
          groupSize: 1,
          gallerySize: this.getGalleryWidth(),
          groupTypes: '1',
          oneRow: true,
          hasThumbnails: false,
          enableScroll: false,
          isGrid: false,
          isSlider: false,
          isColumns: false,
          isMasonry: false,
          isSlideshow: false,
          cropOnlyFill: false,
          floatingImages: 0,
          galleryMargin: 0,
          imageMargin: 0
        },
        empty: {
          gallerySize: Math.round(gallerySize * 9 + 100)
        },
        magic: this.getStyleBySeed(magicLayoutSeed)
      };

      var galleyLayoutList = ['empty', // -1
      'collage', // 0
      'masonry', // 1
      'grid', // 2
      'thumbnails', // 3
      'slider', // 4
      'slideshow', // 5
      'panorama', // 6
      'column', // 7
      'magic', // 8
      'fullsize' // 9
      ];

      var layoutName = galleyLayoutList[galleryLayout + 1]; //the empty layout is -1, collage is 0 etc.
      if (_lodash2.default.isUndefined(layoutName)) {
        if (_utils2.default.isStoreGallery()) {
          galleryLayout = 2;
          layoutName = 'grid';
        } else {
          galleryLayout = 0;
          layoutName = 'collage';
        }
      }

      var specialMobileStoreConfig = {};
      if (_utils2.default.isStoreGallery() && _utils2.default.isMobile()) {
        galleryLayout = 2;
        layoutName = 'grid';
        specialMobileStoreConfig.forceMobileCustomButton = true;
      }

      if (_utils2.default.isVerbose()) {
        console.log('chosen layout is', layoutName);
      }

      return _lodash2.default.merge(layouts[layoutName], specialMobileStoreConfig, {
        galleryLayout: galleryLayout
      });
    }
  }, {
    key: 'getStyleParamsState',
    value: function getStyleParamsState() {

      var wixStyles = {};
      var stateStyles = (0, _assign2.default)({}, this.props.styles || {}, this.props.behaviour || {}, this.newProps.styles || {}, this.newProps.behaviour || {}, window.styles || {}, window.behaviour || {});

      function canSet(wixParam, stateParam) {
        // wixStyles    =>  Styles arrived directly from wix
        // stateStyles  =>  The result of the styles format
        // wixParam     =>  The name of the parameter in wixParams
        // stateParam   =>  The name of the parameter in the formatted styles result
        if (_lodash2.default.isUndefined(stateParam)) {
          // the wixParam and stateParam have the same names
          // check that the wixParam is not already set in the stateStyles AND wixStyles have it
          return _lodash2.default.isUndefined(stateStyles[wixParam]) && !_lodash2.default.isUndefined(wixStyles[wixParam]);
        } else {
          // the stateParam and wixParam have different names
          // check that the stateParam is not already set in the stateStyles AND wixStyles have the wixParam
          return _lodash2.default.isUndefined(stateStyles[stateParam]) && !_lodash2.default.isUndefined(wixStyles[wixParam]);
        }
      }

      if (_utils2.default.isSite() && _lodash2.default.get(this, 'state.styleParams.gotStyleParams') && _lodash2.default.isEmpty(stateStyles)) {
        if (_utils2.default.isVerbose()) {
          console.log('already got style params, not fetching again', this.state.styleParams);
        }
        return this.state.styleParams;
      }

      var gotStyleParams = !(_utils2.default.isInWix() && !_utils2.default.isDemo()); // if in Wix wait for real (not default) style params

      wixStyles = {};
      if (_utils2.default.isInWix() && _WixSdkWrapper2.default && _WixSdkWrapper2.default.Styles && _WixSdkWrapper2.default.Styles.getStyleParams()) {
        var sp = _WixSdkWrapper2.default.Styles.getStyleParams();
        _lodash2.default.merge(wixStyles, sp.booleans, sp.numbers, sp.colors, sp.fonts);
        gotStyleParams = true;
      }
      if (_lodash2.default.isObject(window.galleryStyle)) {
        _lodash2.default.merge(wixStyles, window.galleryStyle);
      }
      if (_utils2.default.parseGetParam('galleryStyle')) {
        var galleryStyle = _utils2.default.parseGetParam('galleryStyle');

        if (/^[\],:{}\s]*$/.test(galleryStyle.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
          //the json is ok
          _lodash2.default.merge(wixStyles, JSON.parse(decodeURIComponent(galleryStyle)));
        }
      }

      if (this.props.styleParams) {
        _lodash2.default.merge(wixStyles, this.props.styleParams);
      }

      wixStyles.gallerySize = stateStyles.gallerySize || wixStyles.gallerySize || 30;

      var emptyLayout = {
        galleryType: undefined,
        groupSize: undefined,
        showArrows: undefined,
        cubeImages: undefined,
        cubeType: undefined,
        cubeRatio: undefined,
        isVertical: undefined,
        gallerySize: undefined,
        collageAmount: undefined,
        collageDensity: undefined,
        groupTypes: undefined,
        oneRow: undefined,
        borderRadius: undefined,
        boxShadow: undefined,
        imageMargin: undefined,
        galleryMargin: undefined,
        floatingImages: undefined,
        chooseBestGroup: undefined,
        smartCrop: undefined,
        hasThumbnails: undefined,
        enableScroll: undefined,
        isGrid: undefined,
        isSlider: undefined,
        isColumns: undefined,
        isSlideshow: undefined,
        cropOnlyFill: undefined,
        fixedColumns: undefined,
        enableInfiniteScroll: undefined
      };

      if (String(wixStyles.mobilePanorama) === '1' && _utils2.default.isMobile()) {
        stateStyles.galleryLayout = 6;
        stateStyles.rotatingGroupTypes = '1';
        stateStyles.isVertical = true;
        stateStyles.numberOfImagesPerRow = 1;
        stateStyles.oneRow = false;
      }

      var galleryLayoutV1 = _lodash2.default.isUndefined(stateStyles.galleryType) ? wixStyles.galleryType : stateStyles.galleryType;
      var galleryLayoutV2 = _lodash2.default.isUndefined(stateStyles.galleryLayout) ? wixStyles.galleryLayout : stateStyles.galleryLayout;

      if (!_lodash2.default.isUndefined(galleryLayoutV1) && _lodash2.default.isUndefined(galleryLayoutV2)) {
        //legacy layouts - only if galleyrType parameter is specifically defined (i.e. layout had changed)
        if (_utils2.default.isVerbose()) {
          console.log('Using galleryType for defaults', wixStyles);
        }

        stateStyles = (0, _assign2.default)(stateStyles, this.getStyleByGalleryType(String(galleryLayoutV1), wixStyles.gallerySize)); //legacy layouts
        stateStyles.layoutsVersion = 1;
        var selectedLayoutVars = ['galleryType', 'galleryThumbnailsAlignment', 'magicLayoutSeed', 'imageResize', 'isVertical', 'scrollDirection', 'enableInfiniteScroll'];
        stateStyles.selectedLayout = selectedLayoutVars.map(function (key) {
          return String(wixStyles[key]);
        }).join('|');
      } else {
        //new layouts
        if (_utils2.default.isVerbose()) {
          console.log('Using galleryLayout for defaults', wixStyles);
        }
        stateStyles = (0, _assign2.default)(emptyLayout, stateStyles, this.getStyleByLayout(wixStyles, galleryLayoutV2)); //legacy layouts
        var _selectedLayoutVars = ['galleryLayout', 'galleryThumbnailsAlignment', 'magicLayoutSeed', 'imageResize', 'isVertical', 'scrollDirection', 'enableInfiniteScroll'];
        stateStyles.selectedLayout = _selectedLayoutVars.map(function (key) {
          return String(wixStyles[key]);
        }).join('|');
        stateStyles.layoutsVersion = 2;
        stateStyles.selectedLayoutV2 = galleryLayoutV2;
        if (_utils2.default.isVerbose()) {
          console.log('new selected layout', stateStyles.selectedLayout);
        }
      }

      //behaviour
      if (canSet('fullscreen')) {
        stateStyles.fullscreen = wixStyles.fullscreen.toString() === '0';
      } else {
        stateStyles.fullscreen = true;
      }

      if (canSet('allowSocial')) {
        stateStyles.allowSocial = wixStyles.allowSocial;
      }

      if (canSet('allowTitle')) {
        stateStyles.allowTitle = _utils2.default.isOnBoarding() ? true : wixStyles.allowTitle;
      }

      if (canSet('isInAdi')) {
        stateStyles.isInAdi = wixStyles.isInAdi;
      }

      if (canSet('useCustomButton')) {
        stateStyles.useCustomButton = wixStyles.useCustomButton;
      }

      if (canSet('allowDescription')) {
        stateStyles.allowDescription = wixStyles.allowDescription;
      }

      if (canSet('allowDownload')) {
        stateStyles.allowDownload = wixStyles.allowDownload;
      }

      if (canSet('loveButton')) {
        stateStyles.loveButton = wixStyles.loveButton;
      }

      //note: 0 is true and false is 1 - super confusing (can't change it - because of backwards compatibility)
      if (canSet('loveCounter')) {
        stateStyles.loveCounter = String(wixStyles.loveCounter) === '0';
      }

      if (canSet('enableInfiniteScroll')) {
        stateStyles.enableInfiniteScroll = String(wixStyles.enableInfiniteScroll) === '1';
      }

      //design
      if (canSet('isVertical')) {
        stateStyles.isVertical = String(wixStyles.isVertical) === '1';
      }
      if (canSet('imageOrientation', 'isVertical')) {
        stateStyles.isVertical = String(wixStyles.imageOrientation) === '1';
      }

      if (canSet('collageAmount')) {
        stateStyles.collageAmount = Number(wixStyles.collageAmount) / 10;
      }

      if (canSet('collageDensity')) {
        stateStyles.collageDensity = Number(wixStyles.collageDensity) / 100;
      }

      if (canSet('minItemSize')) {
        stateStyles.minItemSize = wixStyles.minItemSize;
      }

      if (canSet('gallerySize')) {
        stateStyles.gallerySize = wixStyles.gallerySize;
      }

      if (canSet('gallerySizePx')) {
        stateStyles.gallerySizePx = wixStyles.gallerySizePx;
      }

      if (canSet('gallerySizeRatio')) {
        stateStyles.gallerySizeRatio = wixStyles.gallerySizeRatio;
      }

      if (canSet('gallerySizeType')) {
        stateStyles.gallerySizeType = ['smart', 'px', 'ratio'][Number(wixStyles.gallerySizeType)];
      }

      if (canSet('gridStyle')) {
        stateStyles.gridStyle = wixStyles.gridStyle;
      }

      if (canSet('groupSize')) {
        stateStyles.groupSize = Number(wixStyles.groupSize);
      }

      if (canSet('chooseBestGroup')) {
        stateStyles.chooseBestGroup = String(wixStyles.chooseBestGroup) === '1';
      }

      if (canSet('groupTypes')) {
        stateStyles.groupTypes = String(wixStyles.groupTypes);
      }

      if (canSet('rotatingGroupTypes')) {
        stateStyles.rotatingGroupTypes = String(wixStyles.rotatingGroupTypes);
      }

      if (canSet('rotatingCropRatios')) {
        stateStyles.rotatingCropRatios = String(wixStyles.rotatingCropRatios);
      }

      if (canSet('borderRadius')) {
        stateStyles.borderRadius = Number(wixStyles.borderRadius);
      }

      if (canSet('boxShadow')) {
        stateStyles.boxShadow = Number(wixStyles.boxShadow) / 100;
      }

      if (canSet('imageMargin')) {
        stateStyles.imageMargin = Number(wixStyles.imageMargin);
      }
      if (stateStyles.imageMargin > 0) {
        if (_utils2.default.isMobile()) {
          stateStyles.imageMargin = Math.min(stateStyles.imageMargin, 50); //limit mobile spacing to 50px (25 on each side)
        }
        stateStyles.imageMargin /= 2;
      }

      if (canSet('galleryMargin')) {
        stateStyles.galleryMargin = Number(wixStyles.galleryMargin);
      }

      if (canSet('floatingImages')) {
        stateStyles.floatingImages = Number(wixStyles.floatingImages) / 100;
      }

      if (canSet('thumbnailSpacings')) {
        stateStyles.thumbnailSpacings = Number(wixStyles.thumbnailSpacings) / 2;
      }

      if (canSet('cubeImages')) {
        stateStyles.cubeImages = String(wixStyles.cubeImages) === '1';
      }

      if (canSet('smartCrop')) {
        stateStyles.smartCrop = String(wixStyles.smartCrop) === '1';
      }

      if (canSet('cubeRatio')) {
        stateStyles.cubeRatio = Number(eval(wixStyles.cubeRatio));
      }

      if (canSet('imageResize', 'cubeType')) {
        stateStyles.cubeType = String(wixStyles.imageResize) === '1' ? 'fit' : 'fill';
        if (stateStyles.cubeType === 'fit') {
          if (stateStyles.cropOnlyFill === true) {
            stateStyles.cubeImages = false;
          }
        }
      }

      if (stateStyles.isSlider && canSet('gallerySliderImageRatio', 'cubeRatio')) {
        stateStyles.cubeRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(wixStyles.gallerySliderImageRatio)]));
      } else if (stateStyles.isSlider && _lodash2.default.isUndefined(stateStyles.cubeRatio)) {
        stateStyles.cubeRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(this.defaultStateStyles.gallerySliderImageRatio)]));
      } else if (stateStyles.isGrid && canSet('galleryImageRatio', 'cubeRatio')) {
        stateStyles.cubeRatio = Number(eval(['16/9', '4/3', '1', '3/4', '9/16'][Number(wixStyles.galleryImageRatio)]));
      }

      if (canSet('fixedColumns')) {
        stateStyles.fixedColumns = Number(wixStyles.fixedColumns);
      }

      if (canSet('groupsPerStrip')) {
        stateStyles.groupsPerStrip = Number(wixStyles.groupsPerStrip);
      }

      if (canSet('scrollDirection', 'oneRow')) {
        stateStyles.oneRow = String(wixStyles.scrollDirection) === '1';

        if (stateStyles.oneRow) {
          //if oneRow is true, use horizontal layouts only
          stateStyles.isVertical = false;
        }
      }

      if (stateStyles.isGrid && !stateStyles.oneRow || _layouts.layoutsVersionManager.allowFixedColumnsInMasonry() && stateStyles.isMasonry && stateStyles.isVertical) {
        // if (canSet('numberOfImagesPerRow', 'fixedColumns')) {
        //If toggle is for Items per row, fill the fixedColumns with the number of items
        //If toggle is responsive, make fixedColumns to be 0 or undefined;
        //Show the new controls only on Vertical scroll (one ow is false)
        stateStyles.fixedColumns = String(stateStyles.gridStyle) === '1' ? Number(wixStyles.numberOfImagesPerRow || stateStyles.numberOfImagesPerRow || this.defaultStateStyles.numberOfImagesPerRow) : 0;
        stateStyles.groupTypes = '1';
        stateStyles.groupSize = 1;
        stateStyles.collageAmount = 0;
        stateStyles.collageDensity = 0;
        // }
      }

      if (canSet('numberOfImagesPerCol')) {
        if (stateStyles.isGrid && stateStyles.oneRow) {
          stateStyles.numberOfImagesPerCol = Number(wixStyles.numberOfImagesPerCol);
          stateStyles.fixedColumns = 0;
          switch (stateStyles.numberOfImagesPerCol) {
            case 1:
            default:
              stateStyles.groupTypes = '1';
              stateStyles.groupSize = 1;
              stateStyles.collageAmount = 0;
              stateStyles.collageDensity = 0;
              break;
            case 2:
              stateStyles.groupTypes = '2v';
              stateStyles.groupSize = 2;
              stateStyles.collageAmount = 1;
              stateStyles.collageDensity = 1;
              break;
            case 3:
              stateStyles.groupTypes = '3v';
              stateStyles.groupSize = 3;
              stateStyles.collageAmount = 1;
              stateStyles.collageDensity = 1;
              break;
          }
        }
      }

      if (canSet('galleryThumbnailsAlignment')) {
        stateStyles.galleryThumbnailsAlignment = ['bottom', 'left', 'top', 'right'][wixStyles.galleryThumbnailsAlignment];
      }

      if (canSet('allowMultishare')) {
        //ODEDS: changed to hardcoded false, disabling all occurences of multishare for now
        stateStyles.allowMultishare = false; // !!(wixStyles.allowMultishare) && utils.isWidgetInSite('multishare_widget'); //the widget must be present to show the multishare
      }

      //There's some kunch-ptant here so support opacity, checkout .default css className usage
      // (If this style isn't defined, we add 'default' to the className, and there we all the default params)
      if (canSet('itemOpacity')) {
        stateStyles.itemOpacity = wixStyles.itemOpacity;
      }

      if (canSet('galleryLayout')) {
        stateStyles.galleryLayout = wixStyles.galleryLayout;
      }

      if (canSet('titlePlacement')) {
        var selectedPlacement = void 0;
        if (String(wixStyles.titlePlacement) === '1') {
          selectedPlacement = _consts2.default.placements.SHOW_ON_HOVER;
        } else if (String(wixStyles.titlePlacement) === '0') {
          selectedPlacement = _consts2.default.placements.SHOW_ALWAYS;
        }

        if (!stateStyles.isVertical || stateStyles.groupSize > 1 || stateStyles.oneRow === true) {
          stateStyles.titlePlacement = _consts2.default.placements.SHOW_ON_HOVER;
        } else {
          var defaultValue = _utils2.default.isStoreGallery() ? _consts2.default.placements.SHOW_ALWAYS : _consts2.default.placements.SHOW_ON_HOVER;
          stateStyles.titlePlacement = selectedPlacement || defaultValue;
        }
      }

      if (canSet('itemFont')) {
        stateStyles.itemFont = wixStyles.itemFont;
      }

      if (canSet('itemFontSlideshow')) {
        stateStyles.itemFontSlideshow = wixStyles.itemFontSlideshow;
      }

      if (canSet('galleryHorizontalAlign')) {
        var horizontalAlign = void 0;
        var textAlign = void 0;
        switch (wixStyles.galleryHorizontalAlign) {
          case 0:
            horizontalAlign = 'flex-start';
            textAlign = 'left';
            break;
          case 1:
          default:
            horizontalAlign = 'center';
            textAlign = 'center';
            break;
          case 2:
            horizontalAlign = 'flex-end';
            textAlign = 'right';
            break;
        }

        stateStyles.galleryHorizontalAlign = horizontalAlign;
        stateStyles.galleryTextAlign = textAlign;
      }

      if (canSet('galleryVerticalAlign')) {
        var verticalAlign = void 0;
        switch (wixStyles.galleryVerticalAlign) {
          case 0:
          default:
            verticalAlign = 'flex-start';
            break;
          case 1:
            verticalAlign = 'center';
            break;
          case 2:
            verticalAlign = 'flex-end';
            break;
        }
        stateStyles.galleryVerticalAlign = verticalAlign;
      }

      if (canSet('itemClick')) {
        switch (wixStyles.itemClick) {
          case 0:
          default:
            stateStyles.itemClick = 'expand';
            break;
          case 1:
            stateStyles.itemClick = 'link';
            break;
          case 2:
            stateStyles.itemClick = 'nothing';
            break;
        }
      }

      if (canSet('loadMoreButtonText')) {
        stateStyles.loadMoreButtonText = String(wixStyles.loadMoreButtonText);
      }

      if (canSet('customButtonText')) {
        stateStyles.customButtonText = String(wixStyles.customButtonText);
      }

      stateStyles.sharpParams = {
        quality: 90,
        usm: {}
      };

      if (canSet('imageQuality')) {
        stateStyles.sharpParams.quality = wixStyles.imageQuality;
      }

      if (canSet('usmToggle') && wixStyles.usmToggle === true) {
        if (canSet('usm_a')) {
          stateStyles.sharpParams.usm.usm_a = (wixStyles.usm_a || 0) / 100;
        }
        if (canSet('usm_r')) {
          stateStyles.sharpParams.usm.usm_r = wixStyles.usm_r;
        }
        if (canSet('usm_t')) {
          stateStyles.sharpParams.usm.usm_t = (wixStyles.usm_t || 0) / 255;
        }
      }

      if (canSet('videoPlay')) {
        switch (wixStyles.videoPlay) {
          case 0:
          default:
            stateStyles.videoPlay = 'hover';
            break;
          case 1:
            stateStyles.videoPlay = 'auto';
            break;
          case 2:
            stateStyles.videoPlay = 'onClick';
            break;
        }
      }
      if (canSet('videoSpeed')) {
        stateStyles.videoSpeed = wixStyles.videoSpeed;
      }
      if (canSet('videoLoop')) {
        stateStyles.videoLoop = wixStyles.videoLoop;
      }
      if (canSet('mobilePanorama')) {
        stateStyles.mobilePanorama = String(wixStyles.mobilePanorama) === '1';
      }
      if (canSet('placeGroupsLtr')) {
        stateStyles.placeGroupsLtr = String(wixStyles.placeGroupsLtr) === '1';
      }
      if (canSet('isAutoSlideshow')) {
        stateStyles.isAutoSlideshow = String(wixStyles.isAutoSlideshow) === '1';
      }
      if (canSet('autoSlideshowInterval')) {
        stateStyles.autoSlideshowInterval = Number(wixStyles.autoSlideshowInterval) || 0;
      }

      //Backwards compatibility for masonry layout
      if (String(stateStyles.selectedLayoutV2) === '1') {
        if (stateStyles.isVertical) {
          stateStyles.gallerySize = Math.round(stateStyles.gallerySize * 8 + 200);
        } else {
          stateStyles.gallerySize = Math.round(stateStyles.gallerySize * 5 + 200);
        }
      }

      if (stateStyles.forceMobileCustomButton) {
        stateStyles.gallerySize = Math.round(30 * 8.5 + 150);
        stateStyles.titlePlacement = _consts2.default.placements.SHOW_ALWAYS;
        stateStyles.galleryLayout = 2;
        stateStyles.fixedColumns = 1;
        stateStyles.numberOfImagesPerRow = 1;
      }

      if (stateStyles.fixedColumns > 0 && _utils2.default.isMobile()) {
        stateStyles.fixedColumns = 1;
      }

      //in case a special gallery size was specified, use it
      if (stateStyles.gallerySizeType === 'px' && stateStyles.gallerySizePx > 0) {
        stateStyles.gallerySize = stateStyles.gallerySizePx;
      } else if (stateStyles.gallerySizeType === 'ratio' && stateStyles.gallerySizeRatio > 0) {
        stateStyles.gallerySize = this.getGalleryWidth() * (stateStyles.gallerySizeRatio / 100);
      }

      stateStyles.gotStyleParams = gotStyleParams;

      if (_utils2.default.isVerbose()) {
        console.log('Got styles from Wix', stateStyles);
      }

      var finalStyleParams = _lodash2.default.merge({}, this.defaultStateStyles, stateStyles);

      finalStyleParams.bottomInfoHeight = this.getBottomInfoHeight(finalStyleParams);

      return finalStyleParams;
    }

    //-----------------------------------------| REACT |--------------------------------------------//

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this6 = this;

      if (_utils2.default.isVerbose()) {
        console.log('Received new props', newProps);
      }
      try {
        this.newProps = newProps;
        if (newProps.items) {
          if (this.getHashtagFilter()) {
            this.initHashtagFilter(function () {
              _utils2.default.setStateAndLog(_this6, 'Receiving Props', {
                items: _this6.sortItemsByHashtag(newProps.items),
                totalItemsCount: newProps.totalItemsCount
              }, function () {
                _this6.reRender(_this6.renderTriggers.ALL);
              });
            });
          } else {

            var canSetItems = //replacing the gallery items is allowed when:
            newProps.items.length > this.state.items.length || //infinite scroll - adding new items to the list
            _lodash2.default.includes(['manuallySetImages', 'albumSetFromBuilder'], newProps.galleryDataSrc) || //manual set of new items (managePhotos, wixCode, photoAlbums etc.)
            _utils2.default.isPlayground(); //in the playground

            if (canSetItems) {
              if (_utils2.default.isVerbose()) {
                console.log('Got new props with new items', newProps, this.state.items);
              }
              this.items = newProps.items;
              _utils2.default.setStateAndLog(this, 'Receiving Props', {
                items: this.itemsIds(newProps.items),
                totalItemsCount: newProps.totalItemsCount
              }, function () {
                _this6.reRender(_this6.renderTriggers.ALL);
              });
            } else if (newProps.items.length < this.state.items.length && _utils2.default.isDev()) {
              console.warn('Got new props with fewer items', newProps, this.state.items);
            }
          }
        }
        if (newProps.styles && !_lodash2.default.isEqual(this.props.styles, newProps.styles)) {
          this.reRender(this.renderTriggers.STYLES);
        }
        if (newProps.offsetTop !== this.props.offsetTop) {
          this.reRender(this.renderTriggers.RESIZE);
        }
        if (_lodash2.default.isUndefined(this.galleryWrapper) || newProps.domId !== this.props.domId) {
          try {
            this.galleryWrapper = document.getElementById('pro-gallery-' + newProps.domId);
            this.boundingRect = this.galleryWrapper.getBoundingClientRect();
            // console.log(`Calculating bounding rect for domId ${newProps.domId}`, this.boundingRect);
          } catch (e) {
            this.galleryWrapper = null;
            this.boundingRect = null;
          }
        }
      } catch (e) {
        console.error('Failed settings new props', e);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initEventListeners();
      this.initPersistentEventListeners();
      this.initCustomEvents();
      this.initNavigationEventListeners();
      this.initHashtagFilter();
      this.wixFocused = true;
      this.tabFocused = true;
      if (!_utils2.default.isInWix() || _utils2.default.isTest()) {
        //in wix the stylesParamsChanged event will be the first reRender
        this.reRender(this.renderTriggers.ALL);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }

    //-----------------------------------------| ITEMS |--------------------------------------------//

  }, {
    key: 'itemsIds',
    value: function itemsIds(items) {
      return items.map(function (item) {
        return item.itemId;
      });
    }
  }, {
    key: 'allItems',
    value: function allItems() {
      return this.items;
    }
  }, {
    key: 'currentItems',
    value: function currentItems() {
      if (this.state) {
        return this.allItems().slice(0, this.state.renderedItemsCount);
      } else {
        return this.allItems().slice(0, 50);
      }
    }
  }, {
    key: 'layoutItems',
    value: function layoutItems() {
      return this.galleryStructure.layoutItems;
    }
  }, {
    key: 'galleryItems',
    value: function galleryItems() {
      return this.galleryStructure.galleryItems;
    }
  }, {
    key: 'findVisibleItems',
    value: function findVisibleItems() {

      var container = this.getLatestState('container', {});
      var styleParams = this.getLatestState('styleParams', {});
      var galleryWidth = this.getLatestState('container.galleryWidth', 980);

      if (this.getHashtagFilter()) {
        return this.state.totalItemsCount;
      }

      if (!this.galleryStructure.ready) {
        return this.state.renderedItemsCount;
      }

      var toGroup = _lodash2.default.last(this.galleryStructure.groups);
      var galleryHeight = this.galleryStructure.height * _utils2.default.getViewportScaleRatio();

      var addAfter = this.getLatestState('gotScrollEvent') && galleryHeight - container.galleryHeight <= (10 + styleParams.imageMargin + styleParams.galleryMargin) * 2 && (!toGroup || toGroup.rendered); //if the last item is already rendered - get more items

      var to = toGroup ? _lodash2.default.last(toGroup.items).idx + 1 : 0;

      if (addAfter) {

        if (_utils2.default.shouldLog('infinite_scroll')) {
          console.log('INFINITE SCROLL - Adding new items', galleryHeight, to, toGroup);
        }

        //find the number of extra images to bring - according to the number of images that fit in the screen
        var averageItemHeight = galleryHeight > 0 && to > 0 ? galleryHeight / to : styleParams.gallerySize / styleParams.groupSize / (galleryWidth / styleParams.gallerySize); //calc the average item height according to the real gallery or using an estimate
        var itemsOnScreen = Math.ceil(_utils2.default.getScreenHeight() / averageItemHeight);

        var itemsToAdd = itemsOnScreen * 10; //bring 10 screens at a time
        if (_utils2.default.isMobile() || itemsToAdd < 100) {
          //round to 100 or 500 items per fetch
          itemsToAdd = 100;
        } else {
          itemsToAdd = 500;
        }

        to += itemsToAdd;
      } else if (_utils2.default.shouldLog('infinite_scroll')) {
        console.log('INFINITE SCROLL - NOT adding new items', galleryHeight, to, toGroup);
      }

      return to;
    }
  }, {
    key: 'concatNewItems',
    value: function concatNewItems(newItems) {

      //add new items to the gallery - make sure there are no overlapping items and the order is correct
      var curItems = this.currentItems();

      if (!newItems || !newItems.length > 0) {
        return curItems;
      }

      curItems = curItems.concat(newItems);
      // curItems = _.uniqBy(curItems, (item) => item.itemId || item.photoId || item.url);
      // curItems = _.sortBy(curItems, (item) => item.orderIndex);
      // curItems = curItems.slice(0, this.state.totalItemsCount);

      return curItems;
    }
  }, {
    key: 'getRequiredItemsFromDbIfNeeded',
    value: function getRequiredItemsFromDbIfNeeded(toItem) {
      var _this7 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.noop;


      toItem = Math.min(this.state.totalItemsCount, toItem);

      //check which items are missing
      var curTo = this.state.renderedItemsCount || 0;
      var propsTo = this.allItems().length || 0;

      var defaultRes = {
        items: [],
        totalItemsCount: this.state.totalItemsCount
      };

      var counts = '\n(current items count: ' + curTo + ' | new items count: ' + toItem + ' | items in memory: ' + propsTo + ' | total items: ' + this.state.totalItemsCount + ' | rendered items: ' + this.state.renderedItemsCount + ')';

      if (this.alreadyGettingItems === true) {
        callback(defaultRes);
        return false;
      } else if (Math.min(propsTo, toItem) > curTo) {

        if (_utils2.default.shouldLog('infinite_scroll')) {
          console.log('Infinite Scroll - Fetching items from MEMORY ' + counts);
        }

        this.alreadyGettingItems = false;

        callback({
          items: this.allItems().slice(curTo, toItem),
          totalItemsCount: this.state.totalItemsCount
        });
      } else if (toItem > curTo) {
        if (_utils2.default.shouldLog('infinite_scroll')) {
          console.log('Infinite Scroll - Fetching items from DB ' + counts);
          console.time('Fetching items from DB');
        }
        this.alreadyGettingItems = true;

        var storeParameter = '';
        if (_utils2.default.isStoreGallery()) {
          storeParameter = '&isStore=true';
        }

        (0, _axios2.default)({
          url: window.infiniteScrollUrl + 'from/' + curTo + '/to/' + (toItem + 1) + '?instance=' + window.instance + storeParameter,
          method: 'GET',
          withCredentials: true,
          xsrfCookieName: null
        }).then(function (res) {
          return res.data;
        }).then(function (res) {
          if (res) {
            if (_utils2.default.shouldLog('infinite_scroll')) {
              console.timeEnd('Infinite Scroll - Fetching items from DB');
              console.log('Infinite Scroll - Fetched items from DB', res);
            }
            _this7.alreadyGettingItems = false;
            callback(res || defaultRes);
          } else {
            _this7.alreadyGettingItems = false;
            callback(defaultRes);
          }
        }).catch(function (e) {
          _this7.alreadyGettingItems = false;
          console.error('Cannot fetch items from server', e);
        });
      } else {
        if (_utils2.default.shouldLog('infinite_scroll')) {
          console.log('Infinite Scroll - Not fetching items ' + counts);
        }
        callback(defaultRes);
      }
    }
  }, {
    key: 'scrollToItemIfNeeded',
    value: function scrollToItemIfNeeded() {
      var _this8 = this;

      //after height is changed - scroll to an item if needed
      if (this.shouldScrollTo >= 0) {
        setTimeout(function () {
          var scrolled = _this8.scrollToItem(_this8.shouldScrollTo);
          if (scrolled) {
            _this8.shouldScrollTo = -1;
          }
        }, 10);
      }
    }
  }, {
    key: 'scrollToItem',
    value: function scrollToItem(itemIdx, fixedScroll, isManual) {
      var _this9 = this;

      var durationInMS = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      //400 was the default untill now

      var pos = void 0;
      var horizontalElement = void 0;

      if (this.state.styleParams.oneRow) {
        var galleryWrapper = this.galleryWrapper || document;
        horizontalElement = galleryWrapper.querySelector('#gallery-horizontal-scroll');
      }

      if (fixedScroll === true) {
        //scroll by half the container size

        if (this.state.styleParams.oneRow) {
          pos = horizontalElement.scrollLeft + itemIdx * this.state.container.galleryWidth / 2;
        } else {
          pos = this.state.scroll.top + itemIdx * this.state.container.galleryHeight / 2;
        }
      } else {

        //scroll to specific item
        if (_utils2.default.isVerbose()) {
          console.log('Scrolling to items #' + itemIdx);
        }

        var items = this.galleryStructure.items;

        var item = _lodash2.default.find(items, function (item) {
          return item.idx === itemIdx;
        });
        pos = this.state.styleParams.oneRow ? _lodash2.default.get(item, 'offset.left') : _lodash2.default.get(item, 'offset.top');

        if (_utils2.default.isVerbose()) {
          console.log('Scrolling to position ' + pos, item);
        }

        if (!(pos >= 0)) {
          console.warn('Position not found, not scrolling');
          return false;
        }

        if (this.state.styleParams.oneRow) {

          if (isManual && _lodash2.default.isFunction(_lodash2.default.get(window, 'galleryWixCodeApi.onItemChanged'))) {
            window.galleryWixCodeApi.onItemChanged(item);
          }

          //set scroll to place the item in the middle of the component
          var diff = (this.state.container.galleryWidth - item.width) / 2;
          if (diff > 0) {
            pos -= diff;
          }
          pos = Math.max(0, pos) / _utils2.default.getViewportScaleRatio();
          if (_utils2.default.isVerbose()) {
            console.log('Scrolling to new position ' + pos, this);
          }
        }
      }

      //pos -= item.height; //don't scroll too much so that the item is not too close to the edge of the container

      _utils2.default.setStateAndLog(this, 'Scroll To Item', {
        scrollTop: pos
      }, function () {
        if (_this9.state.styleParams.oneRow) {
          if (_utils2.default.isVerbose()) {
            console.log('Scrolling horiontally', pos, horizontalElement);
          }
          _utils2.default.scrollTo(horizontalElement, Math.round(pos * _utils2.default.getViewportScaleRatio()), durationInMS, true);
        } else if (_utils2.default.isInWix()) {
          if (_utils2.default.isVerbose()) {
            console.log('Scrolling vertically (in wix)');
          }
          if (_utils2.default.getViewModeFromCache() !== 'editor') {
            //All of this code should be removed once SDK fix the scrollTo Issue WEED-5804 with this line of code: Wix.scrollTo(0, Math.round(this.scrollBase + (pos * utils.getViewportScaleRatio())));
            var scrollToPoint = Math.round(_this9.scrollBase + pos * _utils2.default.getViewportScaleRatio());
            var shouldScroll = true;
            if (shouldScroll) {
              var shouldStop = false;
              var retriesLeft = 10;
              var scrollListener = function scrollListener(e) {
                if (e.scrollTop > 0 && e.scrollTop !== scrollToPoint) {
                  shouldStop = true;
                  _WixSdkWrapper2.default.removeEventListener(_WixSdkWrapper2.default.Events.SCROLL, scrollListener);
                }
              };
              _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.SCROLL, scrollListener);

              var retryScroll = function retryScroll() {
                if (!shouldStop && retriesLeft > 0) {
                  _WixSdkWrapper2.default.scrollTo(0, scrollToPoint);
                  if (retriesLeft === 0) {
                    shouldStop = true;
                  }
                  retriesLeft--;
                  setTimeout(retryScroll, 500);
                }
              };
              retryScroll();
              shouldScroll = false;
            }
          }
        } else {
          if (_utils2.default.isVerbose()) {
            console.log('Scrolling vertically (not in wix)');
          }
          //$(window).animate({scrollTop: pos + 'px'});
          window.scrollTop = Math.round(pos * _utils2.default.getViewportScaleRatio());
        }
      });

      return true;
    }
  }, {
    key: 'resetItems',
    value: function resetItems(items) {
      for (var item, i = 0; item = items[i]; i++) {
        item.width = item.maxWidth;
        item.height = item.maxHeight;
      }

      return items;
    }

    //-----------------------------------------| UTILS |--------------------------------------------//

  }, {
    key: 'getLatestState',
    value: function getLatestState(key, defaultValue) {
      try {
        if (!_lodash2.default.isUndefined(this.newState) && !_lodash2.default.isUndefined(_lodash2.default.get(this.newState, key))) {
          return _lodash2.default.get(this.newState, key);
        } else if (this.state) {
          return _lodash2.default.get(this.state, key);
        } else if (!_lodash2.default.isUndefined(defaultValue)) {
          return defaultValue;
        } else {
          return undefined;
        }
      } catch (e) {
        console.warn('Cannot find key in newState', key, e);
        return null;
      }
    }
  }, {
    key: 'getDimensionFix',
    value: function getDimensionFix() {
      return Number(this.getLatestState('styleParams.imageMargin', 0)) - Number(this.getLatestState('styleParams.galleryMargin', 0));
    }
  }, {
    key: 'getGalleryWidth',
    value: function getGalleryWidth() {
      // const DomWidth = window.innerWidth && document.documentElement.clientWidth ?
      //   Math.min(window.innerWidth, document.documentElement.clientWidth) :
      //   window.innerWidth ||
      //   document.documentElement.clientWidth ||
      //   document.getElementsByTagName('body')[0].clientWidth;
      var domWidth = this.protectGalleryWidth(_utils2.default.isMobile() ? document.body.clientWidth : window.innerWidth); //on mobile we use the document width - which takes in account the pixel ratio fix (width more that 100% and scale down)
      var propsWidth = _lodash2.default.get(this.props, 'layout.width') || _lodash2.default.get(this.props, 'container.width');
      return Math.floor((propsWidth > 0 ? propsWidth : domWidth) + this.getDimensionFix() * 2); //add margins to width and then remove them in css negative margins
    }
  }, {
    key: 'getGalleryHeight',
    value: function getGalleryHeight() {
      var offsetTop = _lodash2.default.get(this, 'state.styleParams.oneRow') ? this.props.offsetTop || 0 : 0;
      var domHeight = this.protectGalleryHeight(window.innerHeight, offsetTop);
      var propsHeight = _lodash2.default.get(this.props, 'layout.height') || _lodash2.default.get(this.props, 'container.height');
      return Math.floor((propsHeight > 0 ? propsHeight : domHeight) + this.getDimensionFix());
    }
  }, {
    key: 'getGalleryRatio',
    value: function getGalleryRatio() {
      return this.getGalleryWidth() / this.getGalleryHeight();
    }
  }, {
    key: 'getVisibleBounds',
    value: function getVisibleBounds(scrollTop, pageScale) {

      if (this.debugScroll) {
        console.time('SCROLL - getVisibleBounds time');
      }

      if (typeof scrollTop === 'undefined') {
        scrollTop = 0;
      }
      if (typeof pageScale === 'undefined') {
        pageScale = 1;
      }

      var screenSize = _utils2.default.getScreenHeight() / pageScale;
      var renderedPadding = _utils2.default.parseGetParam('renderedPadding') || screenSize * 10;
      var visiblePadding = _utils2.default.parseGetParam('displayPadding') || screenSize * 1.5;
      var onscreenPadding = _utils2.default.parseGetParam('onscreenPadding') || 0;

      if (this.state.styleParams.oneRow) {
        screenSize = _utils2.default.getScreenWidth() / pageScale; //horizontal layouts will use the same infinite scroll mechanism for horizonal scroll (left => top, right => bottom)
        renderedPadding = _utils2.default.parseGetParam('renderedPadding') || screenSize * 10;
        visiblePadding = _utils2.default.parseGetParam('displayPadding') || screenSize * 5;
        onscreenPadding = _utils2.default.parseGetParam('onscreenPadding') || 0;
        //slideshows required more padding (it usually has larger images and one image per row)
      }

      var docViewTop = scrollTop;
      var docViewBottom = docViewTop + screenSize; //cannot get the real document height - using the screen as default

      if (!this.isInfiniteScroll() && !this.state.styleParams.oneRow) {
        docViewTop = 0;
        docViewBottom = this.getGalleryHeight() / pageScale;
      }

      // viewport window on both sides
      var onscreenTop = docViewTop - onscreenPadding;
      var onscreenBottom = docViewBottom + onscreenPadding;

      var visibleTop = docViewTop - visiblePadding;
      var visibleBottom = docViewBottom + visiblePadding;

      var renderedTop = docViewTop - renderedPadding;
      var renderedBottom = docViewBottom + renderedPadding;

      var bounds = {
        docViewTop: docViewTop,
        docViewBottom: docViewBottom,
        onscreenTop: onscreenTop,
        onscreenBottom: onscreenBottom,
        visibleTop: visibleTop,
        visibleBottom: visibleBottom,
        renderedTop: renderedTop,
        renderedBottom: renderedBottom
      };

      if (this.debugScroll) {
        console.timeEnd('SCROLL - getVisibleBounds time');
      }

      return {
        bounds: bounds
      };
    }
  }, {
    key: 'getGalleryScroll',
    value: function getGalleryScroll(params) {
      if (this.state.styleParams.oneRow) {
        var galleryWrapper = this.galleryWrapper || document;
        var horizontalElement = galleryWrapper.querySelector('#gallery-horizontal-scroll');
        this.currentScrollPosition = horizontalElement && horizontalElement.scrollLeft || 0;
      } else if (params && _lodash2.default.isNumber(params.customScrollTop)) {
        this.currentScrollPosition = params.customScrollTop;
        return this.currentScrollPosition;
      } else if (_utils2.default.isInWix() || _utils2.default.isWixIframe()) {
        if (params && _lodash2.default.isNumber(params.scrollTop) && _lodash2.default.isNumber(params.y)) {
          var scrollBase = params.y || 0;
          if (this.boundingRect) {
            scrollBase += this.boundingRect.y;
          }
          var scrollTop = params.scrollTop;
          this.pageScale = params.scale || 1;
          if (this.scrollBase !== scrollBase && _lodash2.default.isNumber(scrollBase) && !_lodash2.default.isNaN(scrollBase)) {
            if (_utils2.default.isDev()) {
              console.log('gallery ' + this.compId + ' scroll base has changed from ' + this.scrollBase + ' to ' + scrollBase);
            }
            this.scrollBase = scrollBase * this.pageScale;
          }
          this.currentScrollPosition = (scrollTop - this.scrollBase) / _utils2.default.getViewportScaleRatio() * this.pageScale;
        }
        return this.currentScrollPosition;
      } else {
        this.currentScrollPosition = window.scrollTop;
        return this.currentScrollPosition;
      }
    }
  }, {
    key: 'getGalleryDimensions',
    value: function getGalleryDimensions() {

      var res = {
        galleryWidth: this.getGalleryWidth(),
        galleryHeight: this.getGalleryHeight()
      };

      var thumbnailSize = this.thumbnailSize + this.getLatestState('styleParams.galleryMargin', 0) + 3 * this.getLatestState('styleParams.thumbnailSpacings', 0);

      if (this.getLatestState('styleParams.hasThumbnails', false)) {
        switch (this.getLatestState('styleParams.galleryThumbnailsAlignment', '')) {
          case 'top':
          case 'bottom':
            res.galleryHeight -= thumbnailSize;
            break;
          case 'left':
          case 'right':
            res.galleryWidth -= thumbnailSize;
            break;
          default:
            break;
        }
      } else if (this.getLatestState('styleParams.isSlideshow', false)) {
        // res.galleryHeight = 550; //if the height of the image is constant
        res.galleryHeight -= this.slideshowInfoSize; //if the height of the text is constant
      }

      return res;
    }
  }, {
    key: 'protectGalleryHeight',
    value: function protectGalleryHeight(height) {
      var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


      var galleryHeight = Math.floor(height - offsetTop);
      if (_utils2.default.isMobile() && !_utils2.default.isiOS()) {
        galleryHeight = Math.floor(galleryHeight / _utils2.default.getViewportScaleRatio());
      }
      return galleryHeight;
    }
  }, {
    key: 'protectGalleryWidth',
    value: function protectGalleryWidth(width) {

      var maxGalleryWidth = void 0;
      if (_utils2.default.isSite()) {
        maxGalleryWidth = Number(_utils2.default.parseGetParam('width'));
      }

      if (_utils2.default.browserIs('chromeIos')) {
        // This can be the width calc for all galleries, but in chromeIos it must be used otherwise there is a gap on the left of the gallery.
        // Currently there is a bug with Mitzi that the width parmeter is not updating fast enough once it is fixed, use this code always.
        maxGalleryWidth = maxGalleryWidth || document.body.clientWidth;
      } else {
        maxGalleryWidth = document.body.clientWidth;
      }

      if (_utils2.default.isMobile()) {
        maxGalleryWidth = Math.floor(maxGalleryWidth / _utils2.default.getViewportScaleRatio());
      }
      return Math.min(Math.floor(width), maxGalleryWidth);
    }
  }, {
    key: 'setWixHeight',
    value: function setWixHeight(height, lastHeight, trigger) {
      var _this10 = this;

      var offsetTop = this.props.offsetTop || 0;
      var offsetTopChanged = this.lastOffsetTop !== offsetTop;
      if (height <= 0) {
        console.warn('Wix setHeight called with height less than 0');
        return;
      }

      if (this.state.styleParams.oneRow && this.horizontalLayoutHeight) {
        //hack for albums
        _WixSdkWrapper2.default.setHeight(this.horizontalLayoutHeight + offsetTop);
        return;
      }

      this.lastHeight = Math.round(lastHeight + offsetTop);
      this.newHeight = Math.round(height + offsetTop);

      //resize wix tpa window if needed
      var getNeededHeight = function getNeededHeight(height, trigger) {

        var getMaxRowHeight = function getMaxRowHeight() {
          var maxByScreen = window.screen.height * 0.6; //make sure that the gallery is not heigher than the screen
          var maxByFirstGroup = _this10.state.container.galleryWidth / _this10.galleryStructure.firstGroup.ratio * 0.8; //make sure more than 1 group is visible
          var maxBySlideshow = _this10.state.container.galleryWidth * 9 / 16 + _this10.slideshowInfoSize; //in slideshow and thumbnails, the group ratio is calculated by the height so we need a fixed value

          if (_this10.state.styleParams.isSlideshow || _this10.state.styleParams.hasThumbnails) {
            return maxBySlideshow;
          } else if (_this10.state.styleParams.oneRow) {
            return Math.min(maxByScreen, maxByFirstGroup);
          } else if (!_this10.state.styleParams.enableInfiniteScroll) {
            //vertical with show more
            return maxByScreen;
          } else {
            return false;
          }
        };

        var newHeight = Math.round(height * _utils2.default.getViewportScaleRatio());
        var should = true;

        var isHorizontalGallery = _lodash2.default.get(_this10, 'state.styleParams.oneRow');
        var isLoadMoreEnabled = !_this10.isInfiniteScroll();
        var isGalleryHeightStatic = !offsetTopChanged && (isHorizontalGallery || isLoadMoreEnabled);
        if (isGalleryHeightStatic) {
          should = false;
        }

        if (_this10.state.styleParams.hasThumbnails && ['top', 'bottom'].indexOf(_this10.state.styleParams.galleryThumbnailsAlignment) >= 0) {
          newHeight += _this10.thumbnailSize;
        }

        var maxRowHeight = getMaxRowHeight();
        if ((_utils2.default.isEditor() || _utils2.default.isInAlbumsBuilder()) && maxRowHeight) {
          if (trigger === _this10.renderTriggers.LAYOUT) {
            if (_lodash2.default.get(_this10, 'state.styleParams.oneRow') || !_lodash2.default.get(_this10, 'state.styleParams.enableInfiniteScroll')) {
              //when the layout changes, if the new layout is horizontal or with the show more button, adjust the height
              should = false;
              if (newHeight > maxRowHeight) {
                //only reduce the size of the gallery
                newHeight = maxRowHeight;
                should = true;
              } else if (_this10.state.styleParams.isSlideshow) {
                newHeight = maxRowHeight;
                should = true;
              }
            }
          } else if (_this10.state.styleParams.isInAdi) {
            var adiLoadMoreMaxHeight = _utils2.default.isMobile() ? 700 : 2000;
            var adiHorizontalHeight = _utils2.default.isMobile() ? 300 : 600;
            if (!_this10.state.styleParams.oneRow && !_this10.state.styleParams.enableInfiniteScroll) {
              newHeight = Math.min(newHeight, adiLoadMoreMaxHeight);
              should = true;
            } else if (_this10.state.styleParams.oneRow) {
              newHeight = adiHorizontalHeight;
              should = true;
            }
          }
        }

        return should && newHeight;
      };

      var neededHeight = getNeededHeight(this.newHeight, trigger);
      if (neededHeight) {
        if (_utils2.default.isVerbose()) {
          console.log('updating height', neededHeight);
        }

        if (Math.abs(lastHeight - neededHeight) < 6 || neededHeight === 0) {
          if (_utils2.default.isVerbose()) {
            console.log('Skipping Wix height change: was ' + this.lastHeight + ', now it\'s ' + neededHeight);
          }
        } else {

          _utils2.default.setStateAndLog(this, 'setWixHeight', _lodash2.default.merge(this.state.container, {
            galleryHeight: neededHeight
          }));

          if (_utils2.default.isInWix()) {
            if (_utils2.default.isVerbose()) {
              console.warn('Changing wix height from: ' + lastHeight + '  to: ' + neededHeight + ' inner gallery height is: ' + this.newHeight);
            }
            //if (this.lastSetHeight !== neededHeight) {
            _WixSdkWrapper2.default.setHeight(neededHeight);
            this.lastOffsetTop = offsetTop;
            //this.lastSetHeight = neededHeight;
            //}
            this.heightWasSetInternally = true;
          }
        }
      }

      this.scrollToItemIfNeeded();
    }
  }, {
    key: 'getBottomInfoHeight',
    value: function getBottomInfoHeight(styleParams) {
      var titlePlacement = styleParams.titlePlacement,
          itemFontSlideshow = styleParams.itemFontSlideshow,
          allowTitle = styleParams.allowTitle,
          galleryLayout = styleParams.galleryLayout,
          useCustomButton = styleParams.useCustomButton;


      if (titlePlacement !== 'SHOW_ALWAYS') {
        return 0;
      }

      var paddingTopAndBottom = 30;
      var spaceBetweenElements = 16;
      var defaultButtonHeight = useCustomButton ? 33 : 0;
      var defaultItemFontSize = 22;

      var isGrid = galleryLayout === 2;
      var fontSize = 0;
      var isLayoutSupportsNoTitle = isGrid && !_utils2.default.isMobile();
      var shouldSaveSpaceForTitle = allowTitle || isLayoutSupportsNoTitle;
      if (shouldSaveSpaceForTitle) {
        fontSize = itemFontSlideshow ? itemFontSlideshow.size : defaultItemFontSize;
      } else {
        spaceBetweenElements = 0;
      }

      return fontSize + paddingTopAndBottom + spaceBetweenElements + defaultButtonHeight;
    }
  }, {
    key: 'isInfiniteScroll',
    value: function isInfiniteScroll() {

      var styleParamsInfiniteScroll = _lodash2.default.get(this, 'state.styleParams.enableInfiniteScroll'); //if undefined -> enable infinite scroll
      var stateInfiniteScroll = _lodash2.default.get(this, 'state.scroll.isInfinite'); //if defined -> override style params
      var gotStylesParams = _lodash2.default.get(this, 'state.styleParams.gotStyleParams'); //if false -> do not allow infinite scroll yet

      if (!gotStylesParams) {
        return false;
      } else {
        //DO NOT allow infinite scroll only if both styleParams and state are FALSE
        return styleParamsInfiniteScroll || stateInfiniteScroll;
      }
    }

    //----------------------------------------| ACTIONS |-------------------------------------------//

  }, {
    key: 'onResizeEvent',
    value: function onResizeEvent(e) {

      //workaround for safari issue - calling resize on style change
      if (!_utils2.default.isiPhone() || this.currentWindowWidth !== window.innerWidth || Math.abs(this.currentWindowHeight - window.innerHeight) > 50) {
        this.currentWindowWidth = window.innerWidth;
        this.currentWindowHeight = window.innerHeight;
        this.reRenderForResize(e);
      }
    }
  }, {
    key: 'toggleInfiniteScroll',
    value: function toggleInfiniteScroll(forceVal) {
      var _this11 = this;

      _utils2.default.setStateAndLog(this, 'Toggle Infinite Scroll', {
        scroll: _lodash2.default.merge(this.state.scroll, {
          isInfinite: true
        })
      }, function () {
        _this11.reRenderForResize();
      });
    }
  }, {
    key: 'getConnectedProviders',
    value: function getConnectedProviders() {
      var connectedProviders = window.connectedProviders;
      try {
        if (!connectedProviders && window.prerenderedGallery && prerenderedGallery.gallerySettings) {
          var gallerySettings = prerenderedGallery.gallerySettings;
          if (typeof gallerySettings === 'string') {
            gallerySettings = JSON.parse(_utils2.default.stripSlashes(gallerySettings));
          }
          if (gallerySettings && (typeof gallerySettings === 'undefined' ? 'undefined' : (0, _typeof3.default)(gallerySettings)) === 'object' && gallerySettings.connectedProviders) {
            connectedProviders = gallerySettings.connectedProviders;
          }
        }
      } catch (error) {
        console.error('Error getting connected providers', error);
      }

      if (!connectedProviders) {
        console.error('No connected providers');
      }

      return connectedProviders;
    }
  }, {
    key: 'toggleFullscreen',
    value: function toggleFullscreen(itemIdx) {
      var _this12 = this;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.state.styleParams.fullscreen) {
        return;
      }

      if (this.state.styleParams.itemClick === 'nothing') {
        return;
      }

      if (typeof itemIdx !== 'undefined' && itemIdx !== false) {

        if (this.state.totalItemsCount > 0) {
          itemIdx = (itemIdx + this.state.totalItemsCount) % this.state.totalItemsCount;
        }

        var itemDto = this.allItems()[itemIdx];
        var item = new _galleryItem2.default({
          dto: itemDto.dto || itemDto,
          createdBy: 'toggleFullscreen'
        });

        if (this.state.styleParams.itemClick === 'link') {
          if (item.linkType && item.linkType !== 'none') {
            if (item.linkType === 'web') {
              window.open((0, _prependHttpExtra2.default)(item.linkUrl), item.linkOpenType);
            } else if (item.linkType === 'wix') {
              _WixSdkWrapper2.default.navigateTo(item.linkData);
            } else {
              _WixSdkWrapper2.default.navigateToPage(item.linkUrl, {
                noTransition: true
              });
            }
          }
        } else {

          if (_utils2.default.isVerbose()) {
            console.log('Time to Fullscreen VM - START');
          }

          var prefix = '//' + (window.staticsVersion === 'debug' ? 'local.wix.com:9001' : 'progallery.wix.com') + '/';

          window.currentGalleryItems = this.allItems();
          window.totalItemsCount = this.state.totalItemsCount;
          if (_utils2.default.isInWix()) {

            //data to be read by the fullscreen iframe
            window.onunload = function () {
              if (_utils2.default.isVerbose()) {
                console.log('Fullscreen iFrame unloaded');
              }
            };

            var connectedProviders = null;
            var watermarkData = null;

            if (_utils2.default.isStoreGallery()) {
              watermarkData = this.props.watermarkData;
              connectedProviders = this.getConnectedProviders();
            }

            var worker = _utils2.default.getWorkerWindow();

            _WixSdkWrapper2.default.Styles.getStyleId(function (styleId) {
              worker['pro-gallery-data-' + _this12.compId] = {
                createdAt: Date.now(),
                info: {
                  config: config,
                  itemIdx: itemIdx,
                  itemId: item.id,
                  compId: _this12.compId,
                  pageId: _this12.pageId,
                  galleryId: _this12.galleryId,
                  styleId: styleId,
                  watermarkData: watermarkData,
                  connectedProviders: connectedProviders,
                  dateCreated: _utils2.default.getDateCreatedTicksFromStr(window.dateCreated)
                },
                items: {
                  galleryStructure: _this12.galleryStructure,
                  totalItemsCount: _this12.state.totalItemsCount,
                  currentGalleryItems: _this12.allItems()
                },
                window: {
                  infiniteScrollUrl: window.infiniteScrollUrl,
                  instance: window.instance,
                  gallerySettings: _utils2.default.getGallerySettingsFromWindow() //window.gallerySettings,
                }
              };

              //always open the default fullscreen - then read the window date and use replace state to change the url
              //this prevents the iframe from being refreshed

              worker['pro-gallery-fullscreen-comp-id'] = _this12.compId;
              _this12.fullscreenOpenedAt = Date.now();

              _WixSdkWrapper2.default.Utils.navigateToSection({
                sectionId: _utils2.default.getFullscreenSectionId(),
                // shouldRefreshIframe: false,
                noTransition: true /* , utils.getFullscreenUrlState(this.compId, item.id, itemIdx, this.pageId, styleId) */ });
            });
          } else {
            var fullscreen = document.getElementById('gallery-fullscreen');
            if (fullscreen) {
              this.fullscreenElem = _react2.default.createElement(this.props.FullscreenContainer, {
                demoModeParams: {
                  items: this.allItems(),
                  galleryStructure: this.galleryStructure,
                  item: itemIdx,
                  closeFullscreenCallback: this.closeFullscreenCallback
                },
                store: this.props.store
              });
              _reactDom2.default.render(this.fullscreenElem, fullscreen);
              window.history.pushState({}, '', _utils2.default.addItemHashParam(window.location.href, this.props.items[itemIdx].photoId));
            }

            if (!_utils2.default.isSemiNative()) {
              document.getElementById('fullscreen').style.display = 'block';
              document.getElementById('gallery-fullscreen').style.display = 'block';
              document.getElementById('content').style.display = 'none';
            }
          }
        }
        _biLogger.logger.track('expand', {
          selection: 'expand'
        });
      }
    }
  }, {
    key: 'closeFullscreenCallback',
    value: function closeFullscreenCallback() {

      if (_utils2.default.isDev()) {
        console.log('Fullscreen closed callback');
      }

      var fullscreenData = (_utils2.default.getWorkerWindow()['pro-gallery-data-' + this.compId] || {}).fullscreenData;

      if (!fullscreenData) {
        console.warn('Closed fullscreen without data');
        return;
      }

      // this.items = this.resetItems(fullscreenData.currentGalleryItems);

      if (!_utils2.default.isSemiNative()) {
        document.getElementById('content').style.display = 'block';
      }

      //get current items from window - it was placed there by the fullscreen
      _utils2.default.setStateAndLog(this, 'Fullscreen Callback', {
        items: this.itemsIds(fullscreenData.currentGalleryItems)
      });

      this.shouldScrollTo = fullscreenData.currentGalleryItemIdx;

      this.scrollToItemIfNeeded();

      //state might not be changed but the gallery must be rerendred (for loves counts)
      //this.forceUpdate();
    }

    //---------------------------------------| MULTISHARE |-----------------------------------------//

  }, {
    key: 'initHashtagFilter',
    value: function initHashtagFilter(callback) {
      var _this13 = this;

      var hashtagFilter = this.getHashtagFilter();

      var hashtag = {
        filter: hashtagFilter
      };

      //get the items for the hashtag
      if (hashtagFilter) {
        if (!_utils2.default.isSemiNative()) {
          _axios2.default.get(_utils2.default.getApiUrlPrefix() + 'gallery/' + this.galleryId + '/hashtags/' + hashtagFilter + '/items?instance=' + window.instance).then(function (_ref) {
            var data = _ref.data;

            if (data && data.items && data.items.length > 0) {
              hashtag.items = data.items;
              if (_utils2.default.isVerbose()) {
                console.log('Got hashtag items', hashtag);
              }
              _utils2.default.setStateAndLog(_this13, 'Get Hashtag Items', {
                hashtag: hashtag
              }, function () {
                if (callback && _lodash2.default.isFunction(callback)) {
                  callback();
                }
              });
            }
          });
        }
      }
    }
  }, {
    key: 'getHashtagFilter',
    value: function getHashtagFilter() {
      var hashtag = this.state.hashtagFilter || _utils2.default.getWorkerWindow()['pro-gallery-hashtag-filter'] || _utils2.default.parseGetParam('ht', _itemActions.itemActions.getSiteUrl());
      return hashtag;
    }
  }, {
    key: 'sortItemsByHashtag',
    value: function sortItemsByHashtag(curItems) {

      var hashtagItems = _lodash2.default.get(this, 'state.hashtag.items');

      if (!hashtagItems) {
        return curItems;
      }

      /*
          const taggedItems = [], otherItems = [];
          for (const itemDto, i = 0; itemDto = curItems[i]; i++) {
            const isInHashtag = _.findIndex(hashtagItems, (item) => (item.itemId === itemDto.itemId)) >= 0;
            if (isInHashtag) {
              taggedItems.push(itemDto);
            } else {
              otherItems.push(itemDto);
            }
          }
           curItems = _.concat(_.sortBy(taggedItems, (item) => item.orderIndex), otherItems);
       */

      try {
        var otherItems = _lodash2.default.differenceBy(curItems, hashtagItems, 'itemId');
        return _lodash2.default.concat(hashtagItems, otherItems);
      } catch (e) {
        console.warn('Could not sort hashtag items', e, hashtagItems, curItems);
        return curItems;
      }
    }
  }, {
    key: 'updateMultishareItems',
    value: function updateMultishareItems(event) {
      if (_utils2.default.isVerbose()) {
        console.log('multishare pubsub', event);
      }
      var data = event.data;
      if (_lodash2.default.isBoolean(data.update) && data.update === true && _lodash2.default.isArray(data.items)) {
        _utils2.default.setStateAndLog(this, 'updateMultishareItems', {
          multishare: {
            items: data.items,
            isMultisharing: this.props.defaultSelectMode === true || !!data.items.length
          }
        });
      }
    }
  }, {
    key: 'addItemToMultishare',
    value: function addItemToMultishare(itemDto) {
      if (_utils2.default.isInWix()) {
        itemDto.compId = this.compId; //add a refernce to the gallery that started this share
        _WixSdkWrapper2.default.PubSub.publish('gallery2multishare', {
          call: 'addItemToMultishare',
          data: itemDto
        }, true);
      } else {
        this.onItemClickEvent.itemId = itemDto.id;
        window.dispatchEvent(this.onItemClickEvent);

        _utils2.default.setStateAndLog(this, 'updateMultishareItems', {
          multishare: {
            items: this.state.multishare.items.concat([itemDto]),
            isMultisharing: true
          }
        });
      }
    }
  }, {
    key: 'removeItemFromMultishare',
    value: function removeItemFromMultishare(itemProps) {
      if (_utils2.default.isInWix()) {
        _WixSdkWrapper2.default.PubSub.publish('gallery2multishare', {
          call: 'removeItemFromMultishare',
          data: itemProps
        }, true);
      } else {
        var multishareItems = this.state.multishare.items;
        multishareItems = _lodash2.default.filter(multishareItems, function (item) {
          return (item.itemId || item.photoId) !== (itemProps.itemId || itemProps.photoId);
        });
        _utils2.default.setStateAndLog(this, 'updateMultishareItems', {
          multishare: {
            items: multishareItems,
            isMultisharing: true
          }
        });
      }
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'createGalleryStructure',
    value: function createGalleryStructure(structureState) {
      var _this14 = this;

      var getState = function getState(key, defaultValue) {
        return _lodash2.default.get(structureState, key) || _this14.getLatestState(key, defaultValue);
      };

      //either create a new gallery or rerender the existing (if a substential change happend) or just set visibilities (on scroll)
      var layoutParams = {
        items: this.items.slice(0, getState('renderedItemsCount', 50)).map(function (item) {
          return GalleryContainer.convertDtoToLayoutItem(item);
        }),
        container: getState('container'),
        styleParams: getState('styleParams'),
        gotScrollEvent: getState('gotScrollEvent'),
        showAllItems: !!this.props.ignoreWixScrollEvent
      };

      if (_utils2.default.isVerbose()) {
        console.count('galleryContainer createGalleryStructure');
        console.log('creating Gallery Structure', layoutParams);
      }

      var galleryStructure = this.galleryStructure;

      if (!this.galleryStructure.ready) {

        if (_utils2.default.isVerbose()) {
          console.time('Recalculating Gallery - new');
        }
        galleryStructure = new _proGalleryLayouter.Layouter(layoutParams);
        if (_utils2.default.isVerbose()) {
          console.timeEnd('Recalculating Gallery - new');
        }
      } else if (this.renderTrigger === this.renderTriggers.SCROLL) {

        // if (!utils.browserIs('explorer')) {
        if (_utils2.default.isVerbose()) {
          console.time('Recalculating Gallery - visibilities');
        }
        galleryStructure.calcVisibilities(getState('container.bounds'));
        if (_utils2.default.isVerbose()) {
          console.timeEnd('Recalculating Gallery - visibilities');
        }
        // }
      } else {

        //recalculate gallery only if a crucial field has change
        //when only scrolling, and items don't change - do not recalculate the gallery object

        if (_utils2.default.isVerbose()) {
          console.time('Recalculating Gallery - prepare');
        }
        galleryStructure.createLayout(layoutParams);
        if (_utils2.default.isVerbose()) {
          console.timeEnd('Recalculating Gallery - prepare');
        }
      }
      galleryStructure = GalleryContainer.convertToGalleryItems(galleryStructure, {
        watermark: this.props.watermarkData,
        sharpParams: layoutParams.styleParams.sharpParams
      });

      window.galleryStructure = galleryStructure; //save on window for fullscreen access

      return galleryStructure;
    }
  }, {
    key: 'reRenderForEditMode',
    value: function reRenderForEditMode() {

      if (_utils2.default.isDev()) {
        console.count('galleryContainer reRenderForEditMode');
      }

      _utils2.default.updateViewMode();
      this.reRender(this.renderTriggers.MODE);
    }
  }, {
    key: 'reRenderForSettings',
    value: function reRenderForSettings() {
      if (_utils2.default.isDev()) {
        console.count('galleryContainer reRenderForSettings');
      }

      this.reRender(this.renderTriggers.STYLES);
    }
  }, {
    key: 'reRenderForDevice',
    value: function reRenderForDevice() {
      if (_utils2.default.isDev()) {
        console.count('galleryContainer reRenderForDevice');
      }

      this.reRender(this.renderTriggers.MODE);
    }
  }, {
    key: 'reRenderForStyles',
    value: function reRenderForStyles() {

      if (_utils2.default.isDev()) {
        console.count('galleryContainer reRenderForStyles');
      }

      _WixSdkWrapper2.default.Styles.getStyleParams(function (style) {
        window.postMessage({
          type: _WixSdkWrapper2.default.Events.STYLE_PARAMS_CHANGE,
          payload: style
        }, _utils2.default.getUrlPrefix());
      });
      this.reRender(this.renderTriggers.STYLES);
    }
  }, {
    key: 'reRenderForScroll',
    value: function reRenderForScroll(params) {
      var _this15 = this;

      if (this.state.styleParams.oneRow) {
        return true;
      }

      if (_utils2.default.isVerbose()) {
        console.count('galleryContainer reRenderForScroll');
        console.log('SCROLL - got vertical scroll event', params);
      }

      try {
        if (_utils2.default.shouldDebug('paralax_raf') && window && window.requestAnimationFrame) {
          window.requestAnimationFrame(function () {
            _this15._reRenderForScroll(params);
          });
        } else if (_utils2.default.browserIs('explorer') || _utils2.default.isTest()) {
          this._reRenderForScroll(params);
        } else {
          setTimeout(function () {
            _this15._reRenderForScroll(params);
          }, 500);
        }
      } catch (e) {
        console.error('Could not delay scroll handling', e);
        this._reRenderForScroll(params);
      }
    }
  }, {
    key: 'reRenderForHorizontalScroll',
    value: function reRenderForHorizontalScroll(event) {

      var isScrollingHorizontalGallery = void 0;
      try {
        isScrollingHorizontalGallery = this.state.styleParams.oneRow && event.target.className.indexOf('gallery-horizontal-scroll') >= 0;
      } catch (e) {
        isScrollingHorizontalGallery = false;
      }

      if (isScrollingHorizontalGallery) {

        if (_utils2.default.isVerbose()) {
          console.count('galleryContainer reRenderForHorizontalScroll');
          console.log('SCROLL - got horizontal scroll event');
        }

        this._reRenderForScroll();
      }

      return true; //continue with native scroll event
    }
  }, {
    key: '_reRenderForScroll',
    value: function _reRenderForScroll(params) {

      if (_utils2.default.shouldLog('scroll')) {
        this.debugScroll = Date.now();
        console.time('SCROLL - full cycle time');
        console.time('SCROLL - js logic time');
      }

      window.dispatchEvent(this.galleryScrollEvent);

      this.reRender(this.renderTriggers.SCROLL, params);
    }
  }, {
    key: 'reRenderForResize',
    value: function reRenderForResize(e) {
      if (_utils2.default.isVerbose()) {
        if (!_utils2.default.isSemiNative()) {
          console.log('Got resize event (' + this.lastWindowHeight + ' > ' + window.innerHeight + ')', e);
        }
        console.count('galleryContainer reRenderForResize');
      }
      if (this.heightWasSetInternally === true) {
        //disable reRender for resize when calling wix.setHeight
        this.heightWasSetInternally = false;
        if (!this.state.styleParams.oneRow) {
          if (_utils2.default.isVerbose()) {
            console.warn('Not reRendering on resize event after Wix.setHeight was called!', e);
          }
          // todo - removed return when checking it does not affect the editor
          // return;
        }
      }

      this.lastWindowHeight = this.getGalleryHeight();

      this.resizeCount = this.resizeCount + 1;

      var trigger = this.state.styleParams.gallerySizeType === 'ratio' ? this.renderTriggers.STYLES : this.renderTriggers.RESIZE; //when the gallery size is relative to the window width, resize should trigger styles recalc
      this.reRender(trigger);
    }
  }, {
    key: 'reRenderForOrientation',
    value: function reRenderForOrientation() {
      var _this16 = this;

      if (_utils2.default.isVerbose()) {
        console.count('galleryContainer reRenderForOrientation');
      }

      var reRenderForOrientationInternal = function reRenderForOrientationInternal() {
        _this16.orientationCount = _this16.orientationCount + 1;
        _utils2.default.fixViewport('Gallery orientation');
        _this16.reRender(_this16.renderTriggers.ORIENTATION);
        if (_utils2.default.getViewModeFromCache() !== 'editor') {
          _WixSdkWrapper2.default.scrollBy(0, 1); //patch to get the right scroll position
        }
      };

      reRenderForOrientationInternal();
    }
  }, {
    key: 'reRender',
    value: function reRender(trigger, params) {
      var _this17 = this;

      var _renderTriggers = this.renderTriggers,
          ALL = _renderTriggers.ALL,
          STYLES = _renderTriggers.STYLES,
          RESIZE = _renderTriggers.RESIZE,
          ORIENTATION = _renderTriggers.ORIENTATION,
          LAYOUT = _renderTriggers.LAYOUT,
          MODE = _renderTriggers.MODE,
          SCROLL = _renderTriggers.SCROLL,
          ITEMS = _renderTriggers.ITEMS,
          NONE = _renderTriggers.NONE;


      if (_utils2.default.isVerbose()) {
        console.count('galleryContainer reRender');
        console.count('reRendering (trigger: ' + trigger + ')');
        console.log('reRendering', trigger, params);
      }

      var triggerIs = function triggerIs(triggerTypes) {
        if (!_lodash2.default.isArray(triggerTypes)) {
          triggerTypes = [triggerTypes];
        }
        return trigger === ALL || _lodash2.default.indexOf(triggerTypes, trigger) >= 0;
      };

      //------| SCROLL STATE |------//
      this.getGalleryScroll(params);
      var scrollState = {
        scroll: _lodash2.default.merge(this.state.scroll, {
          top: this.currentScrollPosition,
          base: this.scrollBase
        }),
        container: _lodash2.default.merge(this.state.container, this.getVisibleBounds(this.currentScrollPosition, this.pageScale)),
        gotScrollEvent: this.state.gotScrollEvent || triggerIs(SCROLL)
      };
      this.newState = scrollState;

      //------| STYLES STATE |------//
      var stylesState = {
        styleParams: triggerIs(STYLES) ? this.getStyleParamsState() : this.state.styleParams
      };
      var isNewLayout = triggerIs(STYLES) && stylesState.styleParams && this.state.styleParams && stylesState.styleParams.selectedLayout !== this.state.styleParams.selectedLayout;
      if (isNewLayout) {
        trigger = LAYOUT;
      }
      this.newState.styleParams = stylesState.styleParams;

      //------| RESIZE STATE |------//
      var shouldGetNewGalleryDimensions = triggerIs([STYLES, ORIENTATION, LAYOUT]) || !_utils2.default.isiOS() && triggerIs([RESIZE]); //on iOS resize event is triggered on random events (without real change to the window size) https://jira.wixpress.com/browse/PHOT-555
      var resizeState = {
        container: shouldGetNewGalleryDimensions ? this.getGalleryDimensions(stylesState.styleParams) : this.state.container
      };
      if (shouldGetNewGalleryDimensions) {
        _lodash2.default.merge(this.newState.container, resizeState.container);
      }

      //------| VIEW STATE |------//
      var viewState = {};
      if (triggerIs(MODE)) {
        viewState = {
          container: {
            viewMode: _utils2.default.isInWix() ? _utils2.default.getViewModeFromCache() : 'view'
          }
        };
        _lodash2.default.merge(this.newState.container, viewState.container);
      }

      //------| TOTAL ITEMS |------//
      var shouldGetVisibleItems = triggerIs([MODE, SCROLL, RESIZE, ORIENTATION, STYLES, LAYOUT]);
      var totalItems = shouldGetVisibleItems ? this.findVisibleItems() : this.allItems();

      //------| DB ITEMS |------//
      if (this.debugScroll) {
        console.time('SCROLL - time of getRequiredItemsFromDbIfNeeded');
      }
      this.getRequiredItemsFromDbIfNeeded(totalItems, function (res) {
        if (_this17.debugScroll) {
          console.timeEnd('SCROLL - time of getRequiredItemsFromDbIfNeeded');
        }

        var itemsState = {};
        if (res.items.length > 0) {
          if (_this17.items.length > _this17.state.renderedItemsCount) {
            //there are more items in memory than rendered
            itemsState = {
              items: _this17.state.items,
              renderedItemsCount: _this17.state.renderedItemsCount + res.items.length,
              totalItemsCount: res.totalItemsCount
            };
          } else {
            _this17.items = _this17.concatNewItems(res.items);
            itemsState = {
              items: _this17.itemsIds(_this17.items),
              renderedItemsCount: _this17.items.length,
              totalItemsCount: res.totalItemsCount
            };
          }
          _lodash2.default.merge(_this17.newState, itemsState);

          // allItems = this.sortItemsByHashtag(allItems); //assuming all hashtag items are fetched with prerenderedItems - better perfomance

          //if the items where changed - change the trigger
          if (_this17.items.length !== _this17.state.renderedItemsCount) {
            trigger = ITEMS;
          }
        }

        _this17.renderTrigger = trigger;

        if (_this17.debugScroll) {
          console.time('SCROLL - (' + trigger + ') create new gallery');
        }

        // this.newState = newState;
        _this17.galleryStructure = _this17.createGalleryStructure();
        _this17.loadItemsDimensions();

        if (_this17.debugScroll) {
          console.timeEnd('SCROLL - (' + trigger + ') create new gallery');
          console.time('SCROLL - (' + trigger + ') time of setting new state for gallery');
        }

        var isLayoutDefined = function isLayoutDefined(layout) {
          return String(layout) && String(layout).replace(/(undefined)[|]?/g, '') !== '';
        };
        var isChangedLayout = isNewLayout && isLayoutDefined(_this17.newState.styleParams.selectedLayout) && isLayoutDefined(_this17.state.styleParams.selectedLayout); //used to prevent setting height on first layout reRender
        var galleryHeight = Math.round(_this17.getGalleryHeight());

        _utils2.default.setStateAndLog(_this17, 'Gallery ReRender', _this17.newState, function () {
          if (_this17.debugScroll) {
            console.timeEnd('SCROLL - (' + trigger + ') time of setting new state for gallery');
            console.timeEnd('SCROLL - full cycle time');
          }
          if (_this17.isInfiniteScroll() && !_this17.state.styleParams.oneRow || _this17.state.styleParams.isInAdi || trigger !== LAYOUT || isChangedLayout) {
            // auto change height when:
            //  - Vertical gallery with infinite scroll
            //  - ADI galleries
            //  - Changed layout in the editor
            //  - The trigger is not a new layout
            // (this is used to prevent auto change of height when the editor loads)
            _this17.setWixHeight(_this17.galleryStructure.height, galleryHeight, trigger);
          }

          if (isNewLayout && _utils2.default.isEditor()) {
            _this17.scrollToItem(0);
          } //in the editor, the layout change can be triggered by the settings, so we need to scroll to the first item. In sites, this is triggered once on load and the scroll is unneccessary (could cause problem with anchors_
        });

        var actions = _this17.props.actions;

        switch (trigger) {
          case SCROLL:
            if (params && actions.galleryWindowLayoutChanged) {
              actions.galleryWindowLayoutChanged(params);
            }
            break;
          case MODE:
            actions.editorModeChanged();
            break;
          case STYLES:
            actions.videoPlayModeChanged(_this17.newState.styleParams.videoPlay);
            break;
        }
      });

      if (triggerIs(LAYOUT)) {
        //hack for albums
        _WixSdkWrapper2.default.Styles.getStyleParams(function (style) {
          _this17.horizontalLayoutHeight = style.numbers.horizontalLayoutHeight;
          _this17.newState.styleParams.oneRow && _this17.horizontalLayoutHeight && _this17.setWixHeight(_this17.horizontalLayoutHeight);
        });
      }

      this.scrollToItemIfNeeded();
    }
  }, {
    key: 'shouldRender',
    value: function shouldRender() {
      var _this18 = this;

      if (_utils2.default.isVerbose()) {
        console.count('galleryContainer shouldRender');
      }

      var state = this.state;

      if (_lodash2.default.get(state, 'styleParams.gotStyleParams') === false) {
        if (_utils2.default.isVerbose()) {
          console.warn('Could not render gallery - did not get style params', state.styleParams);
        }
        return false;
      }

      if (_lodash2.default.get(state, 'container.galleryWidth') <= 0) {
        if (_utils2.default.isVerbose()) {
          console.warn('Could not render gallery - width is 0');
        }
        return false;
      }

      if (!this.galleryStructure.ready) {
        if (_utils2.default.isVerbose()) {
          console.warn('Could not render gallery - preparation failed', state.galleryStructure.reason);
        }
        setTimeout(function () {
          if (!_this18.galleryStructure.ready) {
            console.error('galleryStructure.ready === false');
          }
        }, 4000);
        return false;
      }

      return true;
    }
  }, {
    key: 'render',
    value: function render() {

      if (!this.shouldRender()) {
        return false;
      }

      if (_utils2.default.isVerbose()) {
        console.count('galleryContainer render');
        console.timeEnd('SCROLL - js logic time');
        console.log('[DEBUG_RENDER] GalleryContainer props changed', _utils2.default.printableObjectsDiff(this.lastProps || {}, this.state));
        this.lastProps = _lodash2.default.cloneDeep(this.props);
        console.log('[DEBUG_RENDER] GalleryContainer state changed', _utils2.default.printableObjectsDiff(this.lastState || {}, this.state));
        this.lastState = _lodash2.default.cloneDeep(this.state);
        this.renderCount = (this.renderCount || 0) + 1;
      }

      return this.shouldRender() && (this.state.styleParams.oneRow ? _react2.default.createElement(_slideshowView2.default, (0, _extends3.default)({
        totalItemsCount: this.state.totalItemsCount,
        renderedItemsCount: this.state.renderedItemsCount,
        items: this.currentItems(),
        galleryStructure: this.galleryStructure,
        styleParams: this.state.styleParams,
        container: this.state.container,
        scroll: _lodash2.default.merge({}, this.state.scroll, {
          isInfinite: this.isInfiniteScroll()
        }),
        thumbnailSize: this.thumbnailSize,
        multishare: this.state.multishare,
        watermark: this.props.watermarkData,
        settings: this.props.settings,
        gotScrollEvent: this.state.gotScrollEvent,
        convertToGalleryItems: GalleryContainer.convertToGalleryItems,
        convertDtoToLayoutItem: GalleryContainer.convertDtoToLayoutItem,
        domId: this.props.domId,
        actions: _lodash2.default.merge(this.props.actions, {
          toggleInfiniteScroll: this.toggleInfiniteScroll,
          toggleFullscreen: this.toggleFullscreen,
          setWixHeight: this.setWixHeight,
          scrollToItem: this.scrollToItem,
          addItemToMultishare: this.addItemToMultishare,
          removeItemFromMultishare: this.removeItemFromMultishare
        }),
        debug: {
          lastHeight: this.lastHeight,
          newHeight: this.newHeight,
          resizeCount: this.resizeCount,
          orientationCount: this.orientationCount,
          maxGalleryWidth: this.props.maxGalleryWidth
        },
        store: this.props.store
      }, this.props.gallery)) : _react2.default.createElement(_galleryView2.default, (0, _extends3.default)({
        totalItemsCount: this.state.totalItemsCount,
        renderedItemsCount: this.state.renderedItemsCount,
        items: this.currentItems(),
        galleryStructure: this.galleryStructure,
        styleParams: this.state.styleParams,
        container: this.state.container,
        scroll: _lodash2.default.merge({}, this.state.scroll, {
          isInfinite: this.isInfiniteScroll()
        }),
        multishare: this.state.multishare,
        watermark: this.props.watermarkData,
        settings: this.props.settings,
        gotScrollEvent: this.state.gotScrollEvent,
        domId: this.props.domId,
        actions: _lodash2.default.merge(this.props.actions, {
          toggleInfiniteScroll: this.toggleInfiniteScroll,
          toggleFullscreen: this.toggleFullscreen,
          setWixHeight: this.setWixHeight,
          scrollToItem: this.scrollToItem,
          addItemToMultishare: this.addItemToMultishare,
          removeItemFromMultishare: this.removeItemFromMultishare
        }),
        debug: {
          lastHeight: this.lastHeight,
          newHeight: this.newHeight,
          resizeCount: this.resizeCount,
          orientationCount: this.orientationCount,
          maxGalleryWidth: this.props.maxGalleryWidth
        },
        store: this.props.store }, this.props.gallery)));
    }
  }], [{
    key: 'convertDtoToLayoutItem',
    value: function convertDtoToLayoutItem(dto) {
      var dtoMetadata = dto.metadata || dto.metaData;
      var metadata = _lodash2.default.isObject(dtoMetadata) ? dtoMetadata : _utils2.default.parseStringObject(dtoMetadata) || {};
      return (0, _extends3.default)({
        id: dto.itemId || dto.photoId,
        width: metadata.width,
        height: metadata.height
      }, dto);
    }
  }, {
    key: 'convertToGalleryItems',
    value: function convertToGalleryItems(galleryStructure) {
      var itemConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pointer = 0;
      galleryStructure.galleryItems = [];
      for (var c = 0; c < galleryStructure.columns.length; c++) {
        var column = galleryStructure.columns[c];
        column.galleryGroups = [];
        var groups = column.groups || column;
        for (var g = 0; g < groups.length; g++) {
          var group = groups[g];
          var groupItems = [];
          for (var i = 0; i < group.items.length; i++) {
            var item = group.items[i];
            groupItems[i] = new _galleryItem2.default((0, _assign2.default)({
              scheme: item.scheme,
              dto: item.dto
            }, itemConfig));
            galleryStructure.galleryItems[item.idx] = groupItems[i];
            pointer++;
          }
          column.galleryGroups[g] = new _galleryGroup2.default({
            scheme: group.scheme,
            dto: group.dto,
            items: groupItems
          });
        }
      }

      return galleryStructure;
    }
  }]);
  return GalleryContainer;
}(_react2.default.Component);

function mapStateToProps(state) {
  return state.gallery;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actions, dispatch)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GalleryContainer);

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(222);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(223), __esModule: true };

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(224);
module.exports = __webpack_require__(8).Array.from;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(24);
var $export = __webpack_require__(14);
var toObject = __webpack_require__(35);
var call = __webpack_require__(107);
var isArrayIter = __webpack_require__(108);
var toLength = __webpack_require__(56);
var createProperty = __webpack_require__(225);
var getIterFn = __webpack_require__(72);

$export($export.S + $export.F * !__webpack_require__(109)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(16);
var createDesc = __webpack_require__(31);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
__webpack_require__(36);
__webpack_require__(44);
__webpack_require__(227);
__webpack_require__(235);
__webpack_require__(236);
module.exports = __webpack_require__(8).Promise;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(34);
var global = __webpack_require__(11);
var ctx = __webpack_require__(24);
var classof = __webpack_require__(71);
var $export = __webpack_require__(14);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(40);
var anInstance = __webpack_require__(228);
var forOf = __webpack_require__(229);
var speciesConstructor = __webpack_require__(110);
var task = __webpack_require__(111).set;
var microtask = __webpack_require__(231)();
var newPromiseCapabilityModule = __webpack_require__(75);
var perform = __webpack_require__(112);
var userAgent = __webpack_require__(232);
var promiseResolve = __webpack_require__(113);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(233)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(43)($Promise, PROMISE);
__webpack_require__(234)(PROMISE);
Wrapper = __webpack_require__(8)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(109)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(24);
var call = __webpack_require__(107);
var isArrayIter = __webpack_require__(108);
var anObject = __webpack_require__(15);
var toLength = __webpack_require__(56);
var getIterFn = __webpack_require__(72);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var macrotask = __webpack_require__(111).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(33)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var core = __webpack_require__(8);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(18);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(14);
var core = __webpack_require__(8);
var global = __webpack_require__(11);
var speciesConstructor = __webpack_require__(110);
var promiseResolve = __webpack_require__(113);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(14);
var newPromiseCapability = __webpack_require__(75);
var perform = __webpack_require__(112);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(238), __esModule: true };

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(240);
module.exports = __webpack_require__(8).Object.keys;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(35);
var $keys = __webpack_require__(32);

__webpack_require__(88)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _itemView = __webpack_require__(242);

var _itemView2 = _interopRequireDefault(_itemView);

var _commonItemContainer = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemContainer = function (_React$Component) {
  (0, _inherits3.default)(ItemContainer, _React$Component);

  function ItemContainer(props, context) {
    (0, _classCallCheck3.default)(this, ItemContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemContainer.__proto__ || (0, _getPrototypeOf2.default)(ItemContainer)).call(this, props, context));

    _this.displayName = 'ItemContainer';

    return _this;
  }

  (0, _createClass3.default)(ItemContainer, [{
    key: 'isSmallItem',
    value: function isSmallItem() {
      var maxWidth = 90;
      var maxHeight = 90;

      if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fit') {
        if (this.props.style.orientation === 'landscape') {
          //wide image
          return this.props.style.width / this.props.style.ratio <= maxHeight;
        } else {
          //tall image
          return this.props.style.height * this.props.style.ratio <= maxWidth;
        }
      } else {
        return this.props.style.width <= maxWidth || this.props.style.height <= maxHeight;
      }
    }
  }, {
    key: 'isNarrow',
    value: function isNarrow() {
      return this.props.style.width < 200;
    }
  }, {
    key: 'isShort',
    value: function isShort() {
      return this.props.style.height < 150;
    }
  }, {
    key: 'render',
    value: function render() {
      this.props.love.showCounter = this.props.styleParams.loveCounter && !this.isSmallItem() && !this.isNarrow();
      return _react2.default.createElement(_itemView2.default, (0, _extends3.default)({
        layout: 'galleryItem',
        className: 'image',
        isSmallItem: this.isSmallItem(),
        isNarrow: this.isNarrow(),
        isShort: this.isShort()
      }, this.props));
    }
  }]);
  return ItemContainer;
}(_react2.default.Component);

exports.default = (0, _commonItemContainer.CommonItemContainer)(ItemContainer);

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(114);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _imageItem = __webpack_require__(243);

var _imageItem2 = _interopRequireDefault(_imageItem);

var _videoItem = __webpack_require__(244);

var _videoItem2 = _interopRequireDefault(_videoItem);

var _textItem = __webpack_require__(254);

var _textItem2 = _interopRequireDefault(_textItem);

var _videoItemPlaceholder = __webpack_require__(255);

var _videoItemPlaceholder2 = _interopRequireDefault(_videoItemPlaceholder);

var _itemHover = __webpack_require__(256);

var _itemHover2 = _interopRequireDefault(_itemHover);

var _texts = __webpack_require__(257);

var _texts2 = _interopRequireDefault(_texts);

var _social = __webpack_require__(266);

var _social2 = _interopRequireDefault(_social);

var _share = __webpack_require__(269);

var _share2 = _interopRequireDefault(_share);

var _customButton = __webpack_require__(117);

var _customButton2 = _interopRequireDefault(_customButton);

var _itemTitle = __webpack_require__(118);

var _itemTitle2 = _interopRequireDefault(_itemTitle);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _itemActions = __webpack_require__(22);

var _consts = __webpack_require__(49);

var _consts2 = _interopRequireDefault(_consts);

var _performanceUtils = __webpack_require__(79);

var performanceUtils = _interopRequireWildcard(_performanceUtils);

var _classnames = __webpack_require__(286);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemView = function (_React$Component) {
  (0, _inherits3.default)(ItemView, _React$Component);

  function ItemView(props) {
    (0, _classCallCheck3.default)(this, ItemView);

    performanceUtils.itemLoadStart();

    var _this = (0, _possibleConstructorReturn3.default)(this, (ItemView.__proto__ || (0, _getPrototypeOf2.default)(ItemView)).call(this, props));

    _this.init();

    _this.state = {
      failed: false,
      loaded: false,
      retries: 0,
      showShare: false,
      showHover: false
    };
    return _this;
  }

  //-------------------------------------------| INIT |--------------------------------------------//

  (0, _createClass3.default)(ItemView, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      this.onItemClick = this.onItemClick.bind(this);
      this.onKeyPress = this.onKeyPress.bind(this);
      this.toggleFullscreenIfNeeded = this.toggleFullscreenIfNeeded.bind(this);
      this.toggleMultishareSelection = this.toggleMultishareSelection.bind(this);
      this.handleItemMouseDown = this.handleItemMouseDown.bind(this);
      this.handleItemMouseUp = this.handleItemMouseUp.bind(this);
      this.setItemLoaded = this.setItemLoaded.bind(this);
      this.setItemError = this.setItemError.bind(this);
      this.isMultishared = this.isMultishared.bind(this);
      this.isMultisharing = this.isMultisharing.bind(this);
      this.isVerticalContainer = this.isVerticalContainer.bind(this);
      this.isHighlight = this.isHighlight.bind(this);
      this.toggleShare = this.toggleShare.bind(this);
      this.getShare = this.getShare.bind(this);
      this.getItemHover = this.getItemHover.bind(this);
      this.getImageItem = this.getImageItem.bind(this);
      this.getVideoItem = this.getVideoItem.bind(this);
      this.getVideoItemPlaceholder = this.getVideoItemPlaceholder.bind(this);
      this.getTextItem = this.getTextItem.bind(this);
      this.getItemInner = this.getItemInner.bind(this);
      this.getItemContainerStyles = this.getItemContainerStyles.bind(this);
      this.getItemWrapperStyles = this.getItemWrapperStyles.bind(this);
      this.getItemAriaLabel = this.getItemAriaLabel.bind(this);
      this.getItemContainerClass = this.getItemContainerClass.bind(this);
      this.getItemWrapperClass = this.getItemWrapperClass.bind(this);
      this.getItemContainerTabIndex = this.getItemContainerTabIndex.bind(this);
      this.getSEOLink = this.getSEOLink.bind(this);
      this.isIconTag = this.isIconTag.bind(this);
      this.onMouseOver = this.onMouseOver.bind(this);

      if (_index2.default.isEditor()) {
        _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.SETTINGS_UPDATED, function (data) {
          setTimeout(function () {
            _this2.setState({
              showHover: data.detail === 2
            });
          }, 50);
        });
      }

      if (_index2.default.isSemiNative()) {
        this.onMouseOverEvent = new window.CustomEvent('on_mouse_over'); // MUST be 'CustomEvent'
      } else {
        this.onMouseOverEvent = document.createEvent('CustomEvent'); // MUST be 'CustomEvent'
        this.onMouseOverEvent.initCustomEvent('on_mouse_over', false, false, null);
      }
    }

    //----------------------------------------| ACTIONS |-------------------------------------------//

  }, {
    key: 'setItemError',
    value: function setItemError() {
      this.setState({
        retries: this.state.retries + 1,
        failed: this.state.retries >= 3
      });
    }
  }, {
    key: 'setItemLoaded',
    value: function setItemLoaded() {
      performanceUtils.itemLoaded();
      performanceUtils.appLoaded();
      this.setState({
        failed: false,
        loaded: true
      });
    }
  }, {
    key: 'isIconTag',
    value: function isIconTag(tagName) {
      return ['button', 'i', 'a'].indexOf(tagName.toLowerCase()) >= 0;
    }
  }, {
    key: 'toggleShare',
    value: function toggleShare(event, forceVal) {
      event.stopPropagation();
      if (event.type === 'mouseout' && (this.isIconTag(event.target.tagName) || event.relatedTarget && this.isIconTag(event.relatedTarget.tagName))) {
        //mouseout event should not be fired if hovering over icons (tag name === I)
        return;
      }
      this.setState({
        showShare: _lodash2.default.isUndefined(forceVal) ? !this.state.showShare : !!forceVal
      });
    }
  }, {
    key: 'toggleHoverOnMobile',
    value: function toggleHoverOnMobile() {
      this.setState({
        showHover: !this.state.showHover
      });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.onMouseOverEvent.itemIdx = this.props.idx;
      window.dispatchEvent(this.onMouseOverEvent);
      if (this.props.type === 'video') {
        this.onVideoHover();
      }
    }
  }, {
    key: 'onVideoHover',
    value: function onVideoHover() {
      var videoPlay = this.props.styleParams.videoPlay;

      if (videoPlay === 'hover' && !_index2.default.isMobile()) {
        this.props.playVideo(this.props.idx);
      }
    }
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e) {
      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          e.stopPropagation();
          this.onItemClick(e, false); //pressing enter or space always behaves as click on main image, even if the click is on a thumbnail
          return false;
      }
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(e, isThumbnail) {

      e.preventDefault();

      var _props$styleParams = this.props.styleParams,
          itemClick = _props$styleParams.itemClick,
          videoPlay = _props$styleParams.videoPlay;


      if (!_lodash2.default.isBoolean(isThumbnail)) {
        isThumbnail = !!this.props.thumbnailHighlightId;
      }
      if (!isThumbnail && _lodash2.default.isFunction(_lodash2.default.get(window, 'galleryWixCodeApi.onItemClicked'))) {
        window.galleryWixCodeApi.onItemClicked(this.props);
      }

      if (isThumbnail === true && _lodash2.default.isFunction(this.props.actions.scrollToItem)) {
        //the click is on a thumbnail
        this.props.actions.scrollToItem(this.props.idx);
      } else if (itemClick === 'expand' || itemClick === 'link') {
        this.props.actions.toggleFullscreen(this.props.idx);
      } else if (this.props.type === 'video') {
        var shouldTogglePlay = itemClick !== 'expand' && (videoPlay === 'onClick' || _index2.default.isMobile());
        if (shouldTogglePlay) {
          this.props.playing ? this.props.pauseVideo(this.props.idx) : this.props.playVideo(this.props.idx);
        }
      } else if (this.shouldShowHoverOnMobile()) {
        this.toggleHoverOnMobile();
      }
    }
  }, {
    key: 'toggleFullscreenIfNeeded',
    value: function toggleFullscreenIfNeeded(e) {
      var targetClass = _lodash2.default.get(e, 'target.className');
      if (_lodash2.default.isObject(targetClass)) {
        targetClass = _lodash2.default.valuesIn(targetClass);
      }

      if (_lodash2.default.isFunction(targetClass.indexOf) && targetClass.indexOf('block-fullscreen') >= 0) {
        console.warn('Blocked fullscreen!', e);
        return;
      } else if (this.props.styleParams.fullscreen) {
        this.props.actions.toggleFullscreen(this.props.idx);
      }
    }
  }, {
    key: 'toggleMultishareSelection',
    value: function toggleMultishareSelection(e) {
      if (e && e.stopPropagation) {
        e.stopPropagation();
      }
      var itemContainer = this.itemContainer;
      itemContainer.style.transform = 'scale(' + (this.props.style.width - 8) / this.props.style.width + ')';
      setTimeout(function () {
        itemContainer.style.transform = 'scale(1)';
      }, 80);

      if (this.isMultishared()) {
        this.props.actions.removeItemFromMultishare(this.props);
      } else {
        this.props.actions.addItemToMultishare(this.props);
      }
    }
  }, {
    key: 'handleItemMouseDown',
    value: function handleItemMouseDown(e) {
      var _this3 = this;

      if (_index2.default.isMobile() && this.props.styleParams.allowMultishare) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = setTimeout(function () {
          e.preventDefault(); //prevent default only after a long press (so that scroll will not break)
          _this3.toggleMultishareSelection(e);
        }, 500);
      }
      return true; //make sure the default event behaviour continues
    }
  }, {
    key: 'handleItemMouseUp',
    value: function handleItemMouseUp(e) {
      if (_index2.default.isMobile() && this.longPressTimer) {
        clearTimeout(this.longPressTimer);
      }
      return true; //make sure the default event behaviour continues
    }

    //-----------------------------------------| UTILS |--------------------------------------------//

  }, {
    key: 'isSmallItem',
    value: function isSmallItem() {
      return this.props.isSmallItem && !this.props.styleParams.isSlideshow;
    }
  }, {
    key: 'isVerticalContainer',
    value: function isVerticalContainer() {
      return this.props.style.width < this.props.style.height + 1;
    }
  }, {
    key: 'shouldShowHoverOnMobile',
    value: function shouldShowHoverOnMobile() {
      return _index2.default.isMobile() && this.props.styleParams.itemClick === 'nothing';
    }
  }, {
    key: 'isHighlight',
    value: function isHighlight() {
      return this.props.thumbnailHighlightId && this.props.thumbnailHighlightId === this.props.id;
    }
  }, {
    key: 'shouldHover',
    value: function shouldHover() {
      if (this.isMultisharing()) {
        return true;
      } else if (this.props.styleParams.isSlideshow) {
        return false;
      } else if (this.props.styleParams.allowHover === false) {
        return false;
      } else if (_index2.default.isMobile()) {
        return this.shouldShowHoverOnMobile();
      } else if (_index2.default.isEditor()) {
        return this.state.showHover;
      } else {
        return true;
      }
    }
  }, {
    key: 'isMultishared',
    value: function isMultishared() {
      var _this4 = this;

      var items = _lodash2.default.get(this, 'props.multishare.items');
      return items && !!_lodash2.default.find(items, function (itemProps) {
        return itemProps.id === _this4.props.id;
      });
    }
  }, {
    key: 'isMultisharing',
    value: function isMultisharing() {
      return _lodash2.default.get(this, 'props.multishare.isMultisharing');
    }

    //---------------------------------------| COMPONENTS |-----------------------------------------//

  }, {
    key: 'getImageDimensions',
    value: function getImageDimensions() {
      //image dimensions are for images in grid fit - placing the image with positive margins to show it within the square
      var imageIsWider = this.props.style.ratio >= this.props.cubeRatio;
      var imageMarginLeft = Math.round((this.props.style.height * this.props.style.ratio - this.props.style.width) / -2);
      var imageMarginTop = Math.round((this.props.style.width / this.props.style.ratio - this.props.style.height) / -2);
      return !(this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fit') ? {} : !imageIsWider ? {
        width: 'calc(100% - ' + 2 * imageMarginLeft + 'px)',
        marginLeft: imageMarginLeft
      } : {
        height: 'calc(100% - ' + 2 * imageMarginTop + 'px)',
        marginTop: imageMarginTop
      };
    }
  }, {
    key: 'isVisible',
    value: function isVisible(elment, clientRect) {
      if (typeof clientRect === 'undefined') {
        var domElment = _reactDom2.default.findDOMNode(elment.video);
        if (!domElment) {
          return false;
        }
        clientRect = domElment.getBoundingClientRect();
      }
      var _clientRect = clientRect,
          top = _clientRect.top,
          bottom = _clientRect.bottom;

      var windowHeight = this.props.documentHeight;
      var scrollPosition = this.props.scroll.top;
      var videoHeight = bottom - top;
      var tolerance = videoHeight / 2;
      var res = top + tolerance > scrollPosition && bottom - tolerance < scrollPosition + windowHeight;
      return res;
    }
  }, {
    key: 'getButtonPlacement',
    value: function getButtonPlacement() {
      return this.props.styleParams.titlePlacement;
    }
  }, {
    key: 'videoOnMount',
    value: function videoOnMount(videoElment) {
      var _this5 = this;

      this.props.videoAdded({ idx: this.props.idx, isVisible: function isVisible() {
          return _this5.isVisible(videoElment);
        } });
    }
  }, {
    key: 'videoOnUnmount',
    value: function videoOnUnmount() {
      this.props.videoRemoved(this.props.idx);
    }
  }, {
    key: 'getItemTextsDetails',
    value: function getItemTextsDetails() {
      var props = _lodash2.default.pick(this.props, ['title', 'description', 'fileName', 'id', 'styleParams', 'style', 'isNarrow']);
      var isButtonPlacementOnHover = this.getButtonPlacement() === _consts2.default.placements.SHOW_ON_HOVER;
      var isImage = this.props.type === 'image' || this.props.type === 'picture';
      var useCustomButton = this.props.styleParams.useCustomButton === true;
      var shouldShowButton = isButtonPlacementOnHover && (isImage || !_index2.default.isStoreGallery()) && useCustomButton;
      return _react2.default.createElement(_texts2.default, (0, _extends3.default)({}, props, {
        key: 'item-texts-' + props.id,
        showShare: this.state.showShare,
        isSmallItem: this.isSmallItem(),
        titlePlacement: this.props.styleParams.titlePlacement,
        shouldShowButton: shouldShowButton }));
    }
  }, {
    key: 'getSocial',
    value: function getSocial() {
      var props = _lodash2.default.pick(this.props, ['html', 'hashtag', 'photoId', 'item', 'idx', 'id', 'styleParams', 'style', 'love', 'isDemo', 'type', 'download_url', 'originalsUrl', 'isNarrow', 'isShort']);
      return _react2.default.createElement(_social2.default, (0, _extends3.default)({}, props, {
        showShare: this.state.showShare,
        isSmallItem: this.isSmallItem(),
        isVerticalContainer: this.isVerticalContainer(),
        key: 'item-social-' + props.id,
        actions: {
          openItemShopInFullScreen: this.openItemShopInFullScreen,
          toggleMultishareSelection: this.toggleMultishareSelection,
          toggleShare: this.toggleShare,
          getShare: this.getShare,
          showTooltip: _itemActions.itemActions.showTooltip,
          hideTooltip: _itemActions.itemActions.hideTooltip
        }
      }));
    }
  }, {
    key: 'getShare',
    value: function getShare() {
      var props = _lodash2.default.pick(this.props, ['styleParams', 'id', 'type', 'style', 'currentIdx', 'idx']);
      return _react2.default.createElement(_share2.default, (0, _extends3.default)({}, props, {
        allProps: this.props,
        key: 'item-share-' + props.id,
        showShare: this.state.showShare,
        isVerticalContainer: this.isVerticalContainer(),
        actions: {
          toggleShare: this.toggleShare
        }
      }));
    }
  }, {
    key: 'getItemHover',
    value: function getItemHover(children, imageDimensions) {
      var props = _lodash2.default.pick(this.props, ['styleParams', 'type', 'idx', 'type']);
      return _react2.default.createElement(
        _itemHover2.default,
        (0, _extends3.default)({}, props, {
          forceShowHover: this.props.previewHover || this.state.showHover,
          isMultisharing: this.isMultisharing(),
          isMultishared: this.isMultishared(),
          shouldHover: this.shouldHover(),
          imageDimensions: imageDimensions,
          key: 'hover',
          actions: {
            handleItemMouseDown: this.handleItemMouseDown,
            handleItemMouseUp: this.handleItemMouseUp,
            toggleMultishareSelection: this.toggleMultishareSelection
          }
        }),
        children
      );
    }
  }, {
    key: 'getImageItem',
    value: function getImageItem(imageDimensions) {
      var props = _lodash2.default.pick(this.props, ['alt', 'title', 'description', 'visible', 'id', 'styleParams', 'resized_url', 'settings']);
      return _react2.default.createElement(_imageItem2.default, (0, _extends3.default)({}, props, {
        key: 'imageItem',
        loaded: this.state.loaded,
        imageDimensions: imageDimensions,
        isThumbnail: !!this.props.thumbnailHighlightId,
        actions: {
          handleItemMouseDown: this.handleItemMouseDown,
          handleItemMouseUp: this.handleItemMouseUp,
          setItemLoaded: this.setItemLoaded,
          setItemError: this.setItemError
        }
      }));
    }
  }, {
    key: 'getVideoItem',
    value: function getVideoItem(imageDimensions, itemHover) {
      return _react2.default.createElement(_videoItem2.default, (0, _extends3.default)({}, this.props, {
        onMount: this.videoOnMount.bind(this),
        onUnmount: this.videoOnUnmount.bind(this),
        onEnd: this.props.videoEnded.bind(this),
        key: 'video' + this.props.idx,
        hover: itemHover,
        imageDimensions: imageDimensions,
        loadingStatus: {
          failed: this.state.failed,
          loaded: this.state.loaded
        },
        onClick: this.handleVideoClick,
        actions: _lodash2.default.merge({}, this.props.actions, {
          setItemLoaded: this.setItemLoaded,
          setItemError: this.setItemError,
          handleItemMouseDown: this.handleItemMouseDown,
          handleItemMouseUp: this.handleItemMouseUp,
          toggleMultishareSelection: this.toggleMultishareSelection,
          isMultishared: this.isMultishared,
          isMultisharing: this.isMultisharing
        })
      }));
    }
  }, {
    key: 'getVideoItemPlaceholder',
    value: function getVideoItemPlaceholder(itemHover) {
      return _react2.default.createElement(_videoItemPlaceholder2.default, { id: this.props.idx, resized_url: this.props.resized_url, hover: itemHover });
    }
  }, {
    key: 'getTextItem',
    value: function getTextItem() {
      var props = _lodash2.default.pick(this.props, ['visible', 'id', 'styleParams', 'style', 'html', 'cubeRatio']);
      return _react2.default.createElement(_textItem2.default, (0, _extends3.default)({}, props, {
        key: 'textItem',
        actions: {
          handleItemMouseDown: this.handleItemMouseDown,
          handleItemMouseUp: this.handleItemMouseUp,
          setItemLoaded: this.setItemLoaded
        }
      }));
    }
  }, {
    key: 'getItemInner',
    value: function getItemInner() {
      var _props = this.props,
          styleParams = _props.styleParams,
          type = _props.type,
          visible = _props.visible;

      var itemInner = void 0;
      var imageDimensions = this.getImageDimensions();
      var itemTexts = this.getItemTextsDetails();
      var social = this.getSocial();
      var share = this.getShare();
      var itemHover = this.getItemHover([itemTexts, social, share], imageDimensions);
      switch (type) {
        case 'dummy':
          itemInner = _react2.default.createElement('div', null);
          break;
        case 'video':
          if (!visible) {
            itemInner = this.getVideoItemPlaceholder(itemHover);
          } else {
            itemInner = this.getVideoItem(imageDimensions, itemHover);
          }
          break;
        case 'text':
          itemInner = [this.getTextItem(), itemHover];
          break;
        case 'image':
        case 'picture':
        default:
          itemInner = [this.getImageItem(imageDimensions), itemHover];
      }

      if (styleParams.isSlideshow) {
        itemInner = _react2.default.createElement(
          'div',
          null,
          itemInner,
          this.props.currentIdx === this.props.idx ? _react2.default.createElement(
            'div',
            { className: 'gallery-item-info gallery-item-bottom-info', 'data-hook': 'gallery-item-info-buttons' },
            _react2.default.createElement(
              'div',
              null,
              itemTexts,
              social,
              share
            )
          ) : false
        );
      }

      return itemInner;
    }
  }, {
    key: 'openItemShopInFullScreen',
    value: function openItemShopInFullScreen(e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleFullscreenIfNeeded(e);
    }
  }, {
    key: 'getBottomInfoElement',
    value: function getBottomInfoElement() {
      var _this6 = this;

      var _props2 = this.props,
          styleParams = _props2.styleParams,
          title = _props2.title,
          type = _props2.type;
      var placements = _consts2.default.placements;

      var buttonPlacement = this.getButtonPlacement();
      var bottomInfo = null;

      if (styleParams.titlePlacement === placements.SHOW_ALWAYS) {
        var isImage = type === 'image' || type === 'picture';
        var shouldShowButton = buttonPlacement === placements.SHOW_ALWAYS && styleParams.useCustomButton === true && (isImage || !_index2.default.isStoreGallery());
        var buttonElem = shouldShowButton ? _react2.default.createElement(_customButton2.default, { styleParams: styleParams }) : null;
        var isTitleAvailable = styleParams.allowTitle && title;
        var titleElem = isTitleAvailable ? _react2.default.createElement(_itemTitle2.default, { title: title }) : null;
        if (titleElem || buttonElem) {
          bottomInfo = _react2.default.createElement(
            'div',
            { style: { height: styleParams.bottomInfoHeight, textAlign: styleParams.galleryTextAlign },
              className: 'gallery-item-bottom-info',
              onMouseOver: function onMouseOver() {
                _this6.setState({ showHover: true });
              },
              onMouseOut: function onMouseOut() {
                _this6.setState({ showHover: false });
              } },
            titleElem,
            buttonElem
          );
        }
      }
      return bottomInfo;
    }
  }, {
    key: 'getItemContainerStyles',
    value: function getItemContainerStyles() {
      var _props3 = this.props,
          styleParams = _props3.styleParams,
          style = _props3.style,
          transform = _props3.transform;

      var wrapperWidth = style.width;
      var borderRadius = styleParams.borderRadius < 100 ? styleParams.borderRadius : Math.min(parseInt(style.width), parseInt(style.height));

      var boxShadow = {};
      if (styleParams.boxShadow > 0) {
        var shadowOffset = Math.round(styleParams.imageMargin * styleParams.boxShadow / 5);
        var shadowSpread = Math.min(15, Math.round(styleParams.imageMargin * styleParams.boxShadow / 2));
        boxShadow = {
          boxShadow: shadowOffset + 'px ' + shadowOffset + 'px ' + shadowSpread + 'px 0 rgba(0,0,0,0.2)'
        };
      }
      var styles = _lodash2.default.merge({
        width: wrapperWidth,
        margin: styleParams.imageMargin + 'px',
        position: style.position,
        top: style.top,
        left: style.left,
        right: style.right,
        bottom: style.bottom,
        overflowY: styleParams.isSlideshow ? 'visible' : 'inherit',
        borderRadius: borderRadius + 'px'
      }, transform, boxShadow);
      return styles;
    }
  }, {
    key: 'getItemWrapperStyles',
    value: function getItemWrapperStyles() {
      var _props4 = this.props,
          styleParams = _props4.styleParams,
          style = _props4.style,
          transform = _props4.transform;

      var borderRadius = styleParams.borderRadius < 100 ? styleParams.borderRadius : Math.min(parseInt(style.width), parseInt(style.height));
      var height = style.height;
      var styles = {};
      styles.backgroundColor = styleParams.cubeType !== 'fit' ? style.bgColor : 'inherit';
      styles.height = height + 'px';
      styles.borderRadius = borderRadius + 'px';
      return styles;
    }
  }, {
    key: 'getItemAriaLabel',
    value: function getItemAriaLabel() {
      var _props5 = this.props,
          type = _props5.type,
          title = _props5.title;

      var typeName = void 0;
      switch (type) {
        case 'dummy':
          typeName = '';
          break;
        case 'text':
          typeName = 'Text Box';
          break;
        case 'video':
          typeName = 'Video';
          break;
        default:
          typeName = 'Graphic';
          break;
      }
      var label = typeName + ', ' + title + (_index2.default.isStoreGallery() ? ', Buy Now' : '');
      return label;
    }
  }, {
    key: 'getSEOLink',
    value: function getSEOLink() {
      var styleParams = this.props.styleParams;

      var link = {};
      if (styleParams.itemClick === 'expand') {
        // For SEO only! - don't add it if the user chose not to open in expand mode.
        link.href = _itemActions.itemActions.getShareUrl(this.props);
      }
      return link;
    }
  }, {
    key: 'getItemContainerClass',
    value: function getItemContainerClass() {
      var styleParams = this.props.styleParams;

      var className = (0, _classnames2.default)('gallery-item-container', 'visible', {
        highlight: this.isHighlight(),
        clickable: styleParams.itemClick !== 'nothing'
      });
      return className;
    }
  }, {
    key: 'getItemWrapperClass',
    value: function getItemWrapperClass() {
      var styleParams = this.props.styleParams;

      var className = 'gallery-item-wrapper visible ' + (styleParams.cubeImages ? 'cube-type-' + styleParams.cubeType : '');
      return className;
    }
  }, {
    key: 'getItemContainerTabIndex',
    value: function getItemContainerTabIndex() {
      var tabIndex = this.isHighlight() ? _index2.default.getTabIndex('currentThumbnail') : this.props.currentIdx === this.props.idx ? _index2.default.getTabIndex('currentGalleryItem') : -1;
      return tabIndex;
    }
    //-----------------------------------------| REACT |--------------------------------------------//

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_index2.default.isMobile()) {
        try {
          _react2.default.initializeTouchEvents(true);
        } catch (e) {}
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      //
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (_index2.default.isSite() && !_index2.default.isMobile() && document && document.activeElement && document.activeElement.className) {
        //check if thumbnailId has changed to the current item
        var isAnotherItemInFocus = document.activeElement.className.indexOf('gallery-item-container') >= 0;
        var isShowMoreInFocus = document.activeElement.className.indexOf('show-more') >= 0;
        if (isAnotherItemInFocus || isShowMoreInFocus) {
          if (this.props.thumbnailHighlightId !== prevProps.thumbnailHighlightId && this.props.thumbnailHighlightId === this.props.id) {
            // if the highlighted thumbnail changed and it is the same as this itemview's
            this.itemContainer.focus();
          } else if (this.props.currentIdx !== prevProps.currentIdx && this.props.currentIdx === this.props.idx) {
            //check if currentIdx has changed to the current item
            this.itemContainer.focus();
          }
        }
      }
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props6 = this.props,
          photoId = _props6.photoId,
          id = _props6.id,
          hash = _props6.hash,
          idx = _props6.idx;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: this.getItemContainerClass(),
          ref: function ref(e) {
            return _this7.itemContainer = e;
          },
          onMouseOver: this.onMouseOver,
          onClick: this.onItemClick,
          onKeyDown: this.onKeyPress,
          tabIndex: this.getItemContainerTabIndex(),
          'data-hash': hash,
          'data-id': photoId,
          'data-idx': idx,
          'aria-label': this.getItemAriaLabel(),
          role: 'link',
          'aria-level': '0',
          'data-hook': 'item-container',
          key: 'item-container-' + id,
          style: this.getItemContainerStyles()
        }, this.getSEOLink()),
        _react2.default.createElement(
          'div',
          { 'data-hook': 'item-wrapper', className: this.getItemWrapperClass(),
            key: 'item-wrapper-' + id,
            style: this.getItemWrapperStyles()
          },
          this.getItemInner()
        ),
        this.getBottomInfoElement()
      );
    }
  }]);
  return ItemView;
}(_react2.default.Component);

exports.default = ItemView;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageItem = function (_React$Component) {
  (0, _inherits3.default)(ImageItem, _React$Component);

  function ImageItem() {
    (0, _classCallCheck3.default)(this, ImageItem);
    return (0, _possibleConstructorReturn3.default)(this, (ImageItem.__proto__ || (0, _getPrototypeOf2.default)(ImageItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ImageItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isThumbnail = _props.isThumbnail,
          alt = _props.alt,
          visible = _props.visible,
          loaded = _props.loaded,
          styleParams = _props.styleParams,
          imageDimensions = _props.imageDimensions,
          resized_url = _props.resized_url,
          id = _props.id,
          actions = _props.actions,
          settings = _props.settings;

      var imageProps = settings && settings.imageProps && typeof settings.imageProps === 'function' ? settings.imageProps(id) : {};
      if (visible) {
        return _react2.default.createElement(
          'div',
          {
            className: 'gallery-item-visible gallery-item gallery-item-preloaded ' + (styleParams.cubeImages && styleParams.cubeType === 'fit' ? ' grid-fit ' : '') + (loaded ? 'gallery-item-loaded' : ''),
            onTouchStart: actions.handleItemMouseDown,
            onTouchEnd: actions.handleItemMouseUp,
            key: 'image_container-' + id,
            'data-hook': 'image-item',
            style: loaded || _index2.default.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + resized_url.thumb + ')' }
          },
          _react2.default.createElement('img', (0, _extends3.default)({ onLoad: actions.setItemLoaded,
            key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
            className: 'gallery-item-visible gallery-item ' + (loaded ? 'gallery-item-loaded' : 'gallery-item-hidden'),
            src: resized_url.img,
            alt: isThumbnail ? '' : alt,
            onError: actions.setItemError,
            style: imageDimensions
          }, imageProps)),
          isThumbnail ? false : _react2.default.createElement('div', { className: 'pro-circle-preloader', key: 'image-preloader-' + id })
        );
      } else {
        return _react2.default.createElement(
          'div',
          {
            className: 'gallery-item-visible gallery-item gallery-item-preloaded ' + (styleParams.cubeImages && styleParams.cubeType === 'fit' ? ' grid-fit ' : '') + (loaded ? 'gallery-item-loaded' : ''),
            key: 'image_container-' + id,
            style: _index2.default.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + resized_url.thumb + ')' },
            'data-hook': 'image-item'
          },
          _react2.default.createElement('img', { onLoad: actions.setItemLoaded,
            key: 'image-' + id,
            className: 'gallery-item-hidden gallery-item',
            style: imageDimensions,
            alt: isThumbnail ? '' : alt,
            src: ''
          })
        );
      }
    }
  }]);
  return ImageItem;
}(_react2.default.Component);

exports.default = ImageItem;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactPlayerFork = __webpack_require__(245);

var _reactPlayerFork2 = _interopRequireDefault(_reactPlayerFork);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoItem = function (_React$Component) {
  (0, _inherits3.default)(VideoItem, _React$Component);

  function VideoItem(props) {
    (0, _classCallCheck3.default)(this, VideoItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoItem.__proto__ || (0, _getPrototypeOf2.default)(VideoItem)).call(this, props));

    _this.pause = _this.pause.bind(_this);
    _this.play = _this.play.bind(_this);
    _this.state = {
      playedOnce: false,
      playing: false
    };
    return _this;
  }

  (0, _createClass3.default)(VideoItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.playing) {
        this.setState({ playedOnce: true });
      }
    }
  }, {
    key: 'play',
    value: function play() {
      this.props.playVideo(this.props.idx);
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.props.pauseVideo();
    }

    //-----------------------------------------| UTILS |--------------------------------------------//

  }, {
    key: 'createPlayerElement',
    value: function createPlayerElement() {
      var _this2 = this;

      //video dimensions are for videos in grid fill - placing the video with negative margins to crop into a square
      var isWiderThenContainer = this.props.style.ratio >= this.props.cubeRatio;

      var videoDimensionsCss = {
        width: isWiderThenContainer ? '100%' : 'auto',
        height: isWiderThenContainer ? 'auto' : '100%'
      };

      if (this.props.styleParams.cubeImages && this.props.styleParams.cubeType === 'fill') {
        var _ref = [videoDimensionsCss.height, videoDimensionsCss.width]; //grid crop mode

        videoDimensionsCss.width = _ref[0];
        videoDimensionsCss.height = _ref[1];

        videoDimensionsCss.position = 'absolute';
        videoDimensionsCss.margin = 'auto';
        videoDimensionsCss.minHeight = '100%';
        videoDimensionsCss.minWidth = '100%';
        videoDimensionsCss.left = '-100%';
        videoDimensionsCss.right = '-100%';
        videoDimensionsCss.top = '-100%';
        videoDimensionsCss.bottom = '-100%';
      }
      return _react2.default.createElement(_reactPlayerFork2.default, {
        className: 'gallery-item-visible video gallery-item',
        width: '100%',
        height: '100%',
        onReady: this.props.actions.setItemLoaded,
        url: this.props.videoUrl ? this.props.videoUrl : this.props.resized_url.mp4,
        loop: !!this.props.styleParams.videoLoop,
        ref: function ref(player) {
          return _this2.video = player;
        },
        volume: 0,
        playing: this.props.playing,
        poster: this.props.resized_url.img,
        mockPlayer: !this.state.playedOnce && (this.props.isExternalVideo || _utils2.default.isMobile()),
        onEnded: function onEnded() {
          _this2.setState({ playing: false });
          _this2.props.onEnd();
        },
        onPause: function onPause() {
          _this2.setState({ playing: false });
        },
        playbackRate: this.props.styleParams.videoSpeed || 1,
        onPlay: function onPlay() {
          _this2.setState({ playing: true });
        },
        fileConfig: {
          attributes: {
            preload: 'metadata',
            poster: this.props.resized_url.img,
            style: videoDimensionsCss
          }
        },
        key: 'video-' + this.props.id
      });
    }
  }, {
    key: 'createImageElement',
    value: function createImageElement() {
      return _react2.default.createElement('img', { onLoad: this.props.actions.setItemLoaded,
        onError: this.props.actions.setItemError,
        key: 'image-' + this.props.id,
        className: 'gallery-item-hidden gallery-item-visible gallery-item ' + (this.props.loadingStatus.loaded ? ' gallery-item-loaded ' : '') + (this.props.loadingStatus.failed ? ' failed ' : ''),
        src: this.props.resized_url.img
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onMount(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onUnmount();
    }
  }, {
    key: 'canVideoPlayInGallery',
    value: function canVideoPlayInGallery(itemClick, videoPlay) {
      if (_utils2.default.isMobile() && itemClick !== 'expand') return true;else if (!_utils2.default.isMobile() && itemClick !== 'expand') return true;else if (!_utils2.default.isMobile() && videoPlay !== 'onClick') return true;else return false;
    }

    //-----------------------------------------| RENDER |--------------------------------------------//

  }, {
    key: 'render',
    value: function render() {
      var baseClassName = 'gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item' + (_utils2.default.isiPhone() ? ' ios' : '') + (this.props.loaded ? 'gallery-item-loaded' : '');
      if (this.state.playing) {
        baseClassName += ' playing';
      }
      var videoControls = this.props.hidePlay ? false : [_react2.default.createElement('i', { key: 'play-triangle', 'data-hook': 'play-triangle', className: 'gallery-item-video-play-triangle progallery-svg-font-icons-play-triangle ' }), _react2.default.createElement('i', { key: 'play-bg', 'data-hook': 'play-background', className: 'gallery-item-video-play-background progallery-svg-font-icons-play-background ' })];

      var videoPreloader = _react2.default.createElement('div', { className: 'pro-circle-preloader', key: 'video-preloader-' + this.props.idx });

      var _props$styleParams = this.props.styleParams,
          videoPlay = _props$styleParams.videoPlay,
          itemClick = _props$styleParams.itemClick;

      var video = this.canVideoPlayInGallery(itemClick, videoPlay) ? _react2.default.createElement(
        'div',
        {
          className: baseClassName + ' animated fadeIn ',
          'data-hook': 'video_container-video-player-element',
          key: 'video_container-' + this.props.id,
          style: this.props.loaded || _utils2.default.deviceHasMemoryIssues() ? {} : (0, _extends3.default)({ backgroundImage: 'url(' + this.props.resized_url.thumb + ')' }, this.props.imageDimensions)
        },
        this.createPlayerElement(),
        videoControls,
        videoPreloader
      ) : _react2.default.createElement(
        'div',
        {
          className: baseClassName,
          'data-hook': 'video_container-image-element',
          key: 'video_container-' + this.props.id,
          style: (0, _extends3.default)({ backgroundImage: 'url(' + this.props.resized_url.thumb + ')' }, this.props.imageDimensions)
        },
        this.createImageElement(),
        videoControls,
        videoPreloader
      );

      var hover = this.props.hover;

      return _react2.default.createElement(
        'div',
        { key: 'video-and-hover-container' + this.props.idx
        },
        [video, hover]
      );
    }
  }]);
  return VideoItem;
}(_react2.default.Component);

exports.default = VideoItem;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _props3 = __webpack_require__(77);

var _YouTube = __webpack_require__(246);

var _YouTube2 = _interopRequireDefault(_YouTube);

var _SoundCloud = __webpack_require__(249);

var _SoundCloud2 = _interopRequireDefault(_SoundCloud);

var _Vimeo = __webpack_require__(251);

var _Vimeo2 = _interopRequireDefault(_Vimeo);

var _FilePlayer = __webpack_require__(48);

var _FilePlayer2 = _interopRequireDefault(_FilePlayer);

var _Streamable = __webpack_require__(252);

var _Streamable2 = _interopRequireDefault(_Streamable);

var _Vidme = __webpack_require__(253);

var _Vidme2 = _interopRequireDefault(_Vidme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactPlayer = function (_Component) {
  _inherits(ReactPlayer, _Component);

  function ReactPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
      if (_this.player) {
        _this.player.seekTo(fraction);
      }
    }, _this.stopBuffering = function () {
      if (_this.player && _this.player.stopBuffering) {
        _this.player.stopBuffering();
      }
    }, _this.progress = function () {
      if (_this.props.url && _this.player) {
        var loaded = _this.player.getFractionLoaded() || 0;
        var played = _this.player.getFractionPlayed() || 0;
        var progress = {};
        if (loaded !== _this.prevLoaded) {
          progress.loaded = loaded;
        }
        if (_this.props.playing) {
          if (played !== _this.prevPlayed) {
            progress.played = played;
          }
          var buffering = !progress.played;
          if (buffering !== _this.prevBuffering) {
            _this.props.onBuffer(buffering);
            _this.prevBuffering = buffering;
          }
        }
        if (progress.loaded || progress.played) {
          _this.props.onProgress(progress);
        }
        _this.prevLoaded = loaded;
        _this.prevPlayed = played;
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
    }, _this.ref = function (player) {
      _this.player = player;
    }, _this.renderPlayer = function (Player) {
      var active = Player.canPlay(_this.props.url);

      var _this$props = _this.props,
          youtubeConfig = _this$props.youtubeConfig,
          soundcloudConfig = _this$props.soundcloudConfig,
          vimeoConfig = _this$props.vimeoConfig,
          fileConfig = _this$props.fileConfig,
          activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig', 'fileConfig']);

      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
      return _react2['default'].createElement(Player, _extends({
        key: Player.displayName,
        youtubeConfig: youtubeConfig,
        soundcloudConfig: soundcloudConfig,
        vimeoConfig: vimeoConfig,
        fileConfig: fileConfig
      }, props));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onProgress) {
        this.progress();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden || this.props.fileConfig !== nextProps.fileConfig;
    }
  }, {
    key: 'renderPlayers',
    value: function renderPlayers() {
      // Build array of players to render based on URL and preload config
      var _props = this.props,
          url = _props.url,
          youtubeConfig = _props.youtubeConfig,
          vimeoConfig = _props.vimeoConfig;

      var players = [];
      if (_YouTube2['default'].canPlay(url)) {
        players.push(_YouTube2['default']);
      } else if (_SoundCloud2['default'].canPlay(url)) {
        players.push(_SoundCloud2['default']);
      } else if (_Vimeo2['default'].canPlay(url)) {
        players.push(_Vimeo2['default']);
      } else if (_Streamable2['default'].canPlay(url)) {
        players.push(_Streamable2['default']);
      } else if (_Vidme2['default'].canPlay(url)) {
        players.push(_Vidme2['default']);
      } else if (url) {
        // Fall back to FilePlayer if nothing else can play the URL
        players.push(_FilePlayer2['default']);
      }
      // Render additional players if preload config is set
      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
        players.push(_YouTube2['default']);
      }
      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
        players.push(_Vimeo2['default']);
      }
      return players.map(this.renderPlayer);
    }
  }, {
    key: 'onWrapperClick',
    value: function onWrapperClick() {
      if (this.props.onWrapperClick) {
        this.props.onWrapperClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          width = _props2.width,
          height = _props2.height,
          className = _props2.className,
          hidden = _props2.hidden;

      var players = this.renderPlayers();
      // const isExternalPlayer = YouTube.canPlay(this.props.url) || Vimeo.canPlay(this.props.url)
      var thumbnail = _react2['default'].createElement('img', { src: this.props.poster, width: this.props.width + 'px', height: this.props.height + 'px', className: 'gallery--placeholder-item' });

      return _react2['default'].createElement(
        'div',
        { style: _extends({}, style, { width: width, height: height }), className: className, hidden: hidden, onClick: this.onWrapperClick.bind(this) },
        this.props.mockPlayer ? thumbnail : players
      );
    }
  }]);

  return ReactPlayer;
}(_react.Component);

ReactPlayer.displayName = 'ReactPlayer';
ReactPlayer.propTypes = _props3.propTypes;
ReactPlayer.defaultProps = _props3.defaultProps;
exports['default'] = ReactPlayer;
module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _loadScript = __webpack_require__(247);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _BasePlayer2 = __webpack_require__(78);

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

var _utils = __webpack_require__(248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
var DEFAULT_PLAYER_VARS = {
  autoplay: 0,
  playsinline: 1,
  showinfo: 0,
  rel: 0,
  iv_load_policy: 3
};

var YouTube = function (_BasePlayer) {
  _inherits(YouTube, _BasePlayer);

  function YouTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
      var data = _ref2.data;
      var _this$props = _this.props,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) _this.onPlay();
      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();
      if (data === ENDED) _this.onEnded();
      if (data === CUED) _this.onReady();
    }, _this.onEnded = function () {
      var _this$props2 = _this.props,
          loop = _this$props2.loop,
          onEnded = _this$props2.onEnded;

      if (loop) {
        _this.seekTo(0);
      }
      onEnded();
    }, _this.ref = function (container) {
      _this.container = container;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          youtubeConfig = _props.youtubeConfig;

      if (!url && youtubeConfig.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }
      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'getSDK',
    value: function getSDK() {
      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
        return Promise.resolve(window[SDK_GLOBAL]);
      }
      return new Promise(function (resolve, reject) {
        var previousOnReady = window[SDK_GLOBAL_READY];
        window[SDK_GLOBAL_READY] = function () {
          if (previousOnReady) previousOnReady();
          resolve(window[SDK_GLOBAL]);
        };
        (0, _loadScript2['default'])(SDK_URL, function (err) {
          if (err) reject(err);
        });
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var _props2 = this.props,
          controls = _props2.controls,
          youtubeConfig = _props2.youtubeConfig,
          _onError = _props2.onError;

      var id = url && url.match(MATCH_URL)[1];
      if (this.isReady) {
        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url)
        });
        return;
      }
      if (this.loadingSDK) {
        this.loadOnReady = url;
        return;
      }
      this.loadingSDK = true;
      this.getSDK().then(function (YT) {
        _this2.player = new YT.Player(_this2.container, {
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
            controls: controls ? 1 : 0
          }, youtubeConfig.playerVars, {
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }),
          events: {
            onReady: function onReady() {
              _this2.loadingSDK = false;
              _this2.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        });
      }, _onError);
    }
  }, {
    key: 'play',
    value: function play() {
      if (!this.isReady || !this.player.playVideo) return;
      this.player.playVideo();
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (!this.isReady || !this.player.pauseVideo) return;
      this.player.pauseVideo();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!this.isReady || !this.player.stopVideo) return;
      this.player.stopVideo();
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
      if (!this.isReady || !this.player.seekTo) return;
      this.player.seekTo(this.getDuration() * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      if (!this.isReady || !this.player.setVolume) return;
      this.player.setVolume(fraction * 100);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      if (!this.isReady || !this.player.setPlaybackRate) return;
      this.player.setPlaybackRate(rate);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      if (!this.isReady || !this.player.getDuration) return null;
      return this.player.getDuration();
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      if (!this.isReady || !this.getDuration()) return null;
      return this.player.getCurrentTime() / this.getDuration();
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
      return this.player.getVideoLoadedFraction();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        width: '100%',
        height: '100%',
        display: this.props.url ? 'block' : 'none'
      };
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('div', { ref: this.ref })
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return YouTube;
}(_BasePlayer3['default']);

YouTube.displayName = 'YouTube';
exports['default'] = YouTube;
module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseStartTime = parseStartTime;
var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/;

// Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds
function parseStartTime(url) {
  var match = url.match(MATCH_START_QUERY);
  if (match) {
    var stamp = match[1];
    if (stamp.match(MATCH_START_STAMP)) {
      return parseStartStamp(stamp);
    }
    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp, 10);
    }
  }
  return 0;
}

function parseStartStamp(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);
  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }
  return seconds;
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _fetchJsonp = __webpack_require__(250);

var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);

var _FilePlayer2 = __webpack_require__(48);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

var _props3 = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;

var songData = {}; // Cache song data requests

var SoundCloud = function (_FilePlayer) {
  _inherits(SoundCloud, _FilePlayer);

  function SoundCloud() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      image: null
    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SoundCloud, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
    }
  }, {
    key: 'getSongData',
    value: function getSongData(url) {
      var _this2 = this;

      if (songData[url]) {
        return Promise.resolve(songData[url]);
      }
      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
        if (response.ok) {
          songData[url] = response.json();
          return songData[url];
        } else {
          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this3 = this;

      var _props = this.props,
          soundcloudConfig = _props.soundcloudConfig,
          onError = _props.onError;

      this.stop();
      this.getSongData(url).then(function (data) {
        if (!_this3.mounted) return;
        if (!data.streamable) {
          onError(new Error('SoundCloud track is not streamable'));
          return;
        }
        var image = data.artwork_url || data.user.avatar_url;
        if (image && soundcloudConfig.showArtwork) {
          _this3.setState({ image: image.replace('-large', '-t500x500') });
        }
        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
      }, onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          url = _props2.url,
          loop = _props2.loop,
          controls = _props2.controls;

      var style = {
        display: url ? 'block' : 'none',
        height: '100%',
        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
      return _react2['default'].createElement(
        'div',
        { style: style },
        _react2['default'].createElement('audio', {
          ref: this.ref,
          type: 'audio/mpeg',
          preload: 'auto',
          style: {
            width: '100%',
            height: '100%'
          },
          controls: controls,
          loop: loop
        })
      );
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return SoundCloud;
}(_FilePlayer3['default']);

SoundCloud.displayName = 'SoundCloud';
exports['default'] = SoundCloud;
module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _queryString = __webpack_require__(73);

var _BasePlayer2 = __webpack_require__(78);

var _BasePlayer3 = _interopRequireDefault(_BasePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IFRAME_SRC = 'https://player.vimeo.com/video/';
var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
var DEFAULT_IFRAME_PARAMS = {
  api: 1,
  autoplay: 0,
  badge: 0,
  byline: 0,
  fullscreen: 1,
  portrait: 0,
  title: 0
};

var Vimeo = function (_BasePlayer) {
  _inherits(Vimeo, _BasePlayer);

  function Vimeo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
      _this.origin = _this.origin || e.origin;
      var data = JSON.parse(e.data);
      if (data.event === 'ready') {
        _this.postMessage('getDuration');
        _this.postMessage('addEventListener', 'playProgress');
        _this.postMessage('addEventListener', 'loadProgress');
        _this.postMessage('addEventListener', 'play');
        _this.postMessage('addEventListener', 'pause');
        _this.postMessage('addEventListener', 'finish');
      }
      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
      if (data.event === 'play') _this.onPlay();
      if (data.event === 'pause') _this.props.onPause();
      if (data.event === 'finish') _this.onEnded();
      if (data.method === 'getDuration') {
        _this.duration = data.value; // Store for use later
        _this.onReady();
      }
    }, _this.onEnded = function () {
      var _this$props = _this.props,
          loop = _this$props.loop,
          onEnded = _this$props.onEnded;

      if (loop) {
        _this.seekTo(0);
      }
      onEnded();
    }, _this.postMessage = function (method, value) {
      if (!_this.origin) return;
      var data = JSON.stringify({ method: method, value: value });
      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
    }, _this.ref = function (iframe) {
      _this.iframe = iframe;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Vimeo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          url = _props.url,
          vimeoConfig = _props.vimeoConfig;

      window.addEventListener('message', this.onMessage, false);

      if (!url && vimeoConfig.preload) {
        this.preloading = true;
        this.load(BLANK_VIDEO_URL);
      }

      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.onMessage, false);
      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentWillUnmount', this).call(this);
    }
  }, {
    key: 'getIframeParams',
    value: function getIframeParams() {
      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
    }
  }, {
    key: 'load',
    value: function load(url) {
      var id = url.match(MATCH_URL)[3];
      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
    }
  }, {
    key: 'play',
    value: function play() {
      this.postMessage('play');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.postMessage('pause');
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.iframe.src = '';
    }
  }, {
    key: 'seekTo',
    value: function seekTo(fraction) {
      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
      this.postMessage('seekTo', this.duration * fraction);
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {
      this.postMessage('setVolume', fraction);
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      return null;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: 'getFractionPlayed',
    value: function getFractionPlayed() {
      return this.fractionPlayed || null;
    }
  }, {
    key: 'getFractionLoaded',
    value: function getFractionLoaded() {
      return this.fractionLoaded || null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _getIframeParams = this.getIframeParams(),
          fullscreen = _getIframeParams.fullscreen;

      var style = {
        display: this.props.url ? 'block' : 'none',
        width: '100%',
        height: '100%'
      };
      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        frameBorder: '0',
        style: style,
        allowFullScreen: fullscreen
      });
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Vimeo;
}(_BasePlayer3['default']);

Vimeo.displayName = 'Vimeo';
exports['default'] = Vimeo;
module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FilePlayer2 = __webpack_require__(48);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = 'https://api.streamable.com/videos/';
var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;

var cache = {}; // Cache song data requests

var Streamable = function (_FilePlayer) {
  _inherits(Streamable, _FilePlayer);

  function Streamable() {
    _classCallCheck(this, Streamable);

    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
  }

  _createClass(Streamable, [{
    key: 'getData',
    value: function getData(url) {
      var onError = this.props.onError;

      var id = url.match(MATCH_URL)[1];
      if (cache[id]) {
        return Promise.resolve(cache[id]);
      }
      return window.fetch(RESOLVE_URL + id).then(function (response) {
        if (response.status === 200) {
          cache[id] = response.json();
          return cache[id];
        } else {
          onError(new Error('Streamable track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var onError = this.props.onError;

      this.stop();
      this.getData(url).then(function (data) {
        if (!_this2.mounted) return;
        _this2.player.src = data.files.mp4.url;
      }, onError);
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Streamable;
}(_FilePlayer3['default']);

Streamable.displayName = 'Streamable';
exports['default'] = Streamable;
module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FilePlayer2 = __webpack_require__(48);

var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/;

var cache = {}; // Cache song data requests

var Vidme = function (_FilePlayer) {
  _inherits(Vidme, _FilePlayer);

  function Vidme() {
    _classCallCheck(this, Vidme);

    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
  }

  _createClass(Vidme, [{
    key: 'getData',
    value: function getData(url) {
      var onError = this.props.onError;

      var id = url.match(MATCH_URL)[1];
      if (cache[id]) {
        return Promise.resolve(cache[id]);
      }
      return window.fetch(RESOLVE_URL + id).then(function (response) {
        if (response.status === 200) {
          cache[id] = response.json();
          return cache[id];
        } else {
          onError(new Error('Vidme track could not be resolved'));
        }
      });
    }
  }, {
    key: 'load',
    value: function load(url) {
      var _this2 = this;

      var onError = this.props.onError;

      this.stop();
      this.getData(url).then(function (data) {
        if (!_this2.mounted) return;
        _this2.player.src = data.video.complete_url;
      }, onError);
    }
  }], [{
    key: 'canPlay',
    value: function canPlay(url) {
      return MATCH_URL.test(url);
    }
  }]);

  return Vidme;
}(_FilePlayer3['default']);

Vidme.displayName = 'Vidme';
exports['default'] = Vidme;
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextItem = function (_React$Component) {
  (0, _inherits3.default)(TextItem, _React$Component);

  function TextItem() {
    (0, _classCallCheck3.default)(this, TextItem);
    return (0, _possibleConstructorReturn3.default)(this, (TextItem.__proto__ || (0, _getPrototypeOf2.default)(TextItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(TextItem, [{
    key: 'getTextDimensions',
    value: function getTextDimensions() {
      var _props = this.props,
          style = _props.style,
          styleParams = _props.styleParams,
          cubeRatio = _props.cubeRatio;

      var isVerticalItem = style.ratio < cubeRatio - 0.01;
      //text dimensions include scaling
      var transform = 'translate(0, 0) scale(' + (isVerticalItem ? style.height / style.maxHeight : style.width / style.maxWidth) + ')';
      return {
        margin: Math.floor(style.maxHeight - style.height) / -2 + 'px ' + Math.floor(style.maxWidth - style.width) / -2 + 'px',
        width: style.maxWidth + 'px',
        height: style.maxHeight + 'px',
        WebkitTransform: transform,
        MsTransform: transform,
        OTransform: transform,
        transform: transform
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.setItemLoaded();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          visible = _props2.visible,
          id = _props2.id,
          styleParams = _props2.styleParams,
          html = _props2.html,
          style = _props2.style,
          actions = _props2.actions;

      var dimensions = this.getTextDimensions();
      var htmlParam = { dangerouslySetInnerHTML: { __html: html } };
      var styleIsDimensions = { style: { dimensions: dimensions } };
      var changeBgColor = { style: (0, _assign2.default)(dimensions, styleParams.cubeType === 'fit' ? { backgroundColor: style.bgColor } : {}) };
      var show = visible || styleParams.hasThumbnails;
      var attributes = show ? (0, _extends3.default)({}, htmlParam, changeBgColor) : (0, _extends3.default)({}, styleIsDimensions);

      return _react2.default.createElement('div', (0, _extends3.default)({ className: 'gallery-item-visible gallery-item gallery-item-loaded text-item',
        key: 'item-text-' + id,
        onTouchStart: actions.handleItemMouseDown,
        onTouchEnd: actions.handleItemMouseUp,
        'data-hook': 'text-item'
      }, attributes));
    }
  }]);
  return TextItem;
}(_react2.default.Component);

exports.default = TextItem;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoItemPlaceholder = function (_React$Component) {
  (0, _inherits3.default)(VideoItemPlaceholder, _React$Component);

  function VideoItemPlaceholder() {
    (0, _classCallCheck3.default)(this, VideoItemPlaceholder);
    return (0, _possibleConstructorReturn3.default)(this, (VideoItemPlaceholder.__proto__ || (0, _getPrototypeOf2.default)(VideoItemPlaceholder)).apply(this, arguments));
  }

  (0, _createClass3.default)(VideoItemPlaceholder, [{
    key: 'render',
    value: function render() {
      var baseClassName = 'gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item';
      return _react2.default.createElement(
        'div',
        { key: 'video-and-hover-container' + this.props.id },
        _react2.default.createElement(
          'div',
          { className: baseClassName, key: 'video-placeholder-container-' + this.props.id,
            style: _utils2.default.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + this.props.resized_url.thumb + ')' } },
          this.props.hover,
          _react2.default.createElement('div', { className: 'gallery--placeholder-item', key: 'video-' + this.props.id })
        )
      );
    }
  }]);
  return VideoItemPlaceholder;
}(_react2.default.Component);

exports.default = VideoItemPlaceholder;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemHover = function (_React$Component) {
  (0, _inherits3.default)(ItemHover, _React$Component);

  function ItemHover() {
    (0, _classCallCheck3.default)(this, ItemHover);
    return (0, _possibleConstructorReturn3.default)(this, (ItemHover.__proto__ || (0, _getPrototypeOf2.default)(ItemHover)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemHover, [{
    key: 'getHoverClass',
    value: function getHoverClass() {
      var _props = this.props,
          styleParams = _props.styleParams,
          forceShowHover = _props.forceShowHover,
          isMultisharing = _props.isMultisharing,
          itemType = _props.itemType;

      var hoverClass = itemType === 'video' ? ['gallery-item-hover-video'] : ['gallery-item-hover'];

      if (styleParams.isSlider || styleParams.isSlideshow || styleParams.hasThumbnails) {
        hoverClass.push(styleParams.galleryVerticalAlign);
      }

      hoverClass.push('fullscreen-' + (styleParams.fullscreen ? 'enabled' : 'disabled'));

      if (_lodash2.default.isUndefined(styleParams.itemOpacity)) {
        hoverClass.push('default');
      }

      // if (forceShowHover && utils.isEditor()) {
      if (forceShowHover) {
        hoverClass.push('hovered');
      } else if (_index2.default.isMobile()) {
        hoverClass.push('hide-hover');
      }

      if (isMultisharing) {
        hoverClass.push('hovered no-hover-bg');
      }
      return hoverClass.join(' ');
    }
  }, {
    key: 'getMultishareHover',
    value: function getMultishareHover() {
      var _props2 = this.props,
          isVideo = _props2.isVideo,
          isMultishared = _props2.isMultishared;

      return _react2.default.createElement(
        'div',
        {
          className: 'gallery-item-social' + (isVideo ? ' gradient-top' : ''),
          'data-hook': 'multisharing-hover'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'gallery-item-social-button gallery-item-social-multishare visible ' + (_index2.default.isMobile() ? 'mobile' : '') },
          !isMultishared ? _react2.default.createElement(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
            _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
              d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z' })
          ) : _react2.default.createElement(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
            _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
              d: 'M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM8.59,13.46l-4-4,.71-.71,3.16,3.16,4.44-6.67.83.55Z' }),
            _react2.default.createElement('polygon', { className: 'gallery-item-svg-background',
              points: '8.43 11.89 5.27 8.74 4.57 9.44 8.59 13.46 13.71 5.78 12.87 5.22 8.43 11.89' })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          shouldHover = _props3.shouldHover,
          isMultisharing = _props3.isMultisharing,
          imageDimensions = _props3.imageDimensions,
          actions = _props3.actions,
          idx = _props3.idx;

      if (!shouldHover) {
        return null;
      }
      var hoverClass = this.getHoverClass();

      return _react2.default.createElement(
        'div',
        {
          className: hoverClass,
          key: 'item-hover-' + idx,
          'data-hook': 'item-hover-' + idx,
          style: imageDimensions,
          onClick: isMultisharing && actions.toggleMultishareSelection,
          onTouchStart: actions.handleItemMouseDown,
          onTouchEnd: actions.handleItemMouseUp
        },
        isMultisharing ? this.getMultishareHover() : this.props.children
      );
    }
  }]);
  return ItemHover;
}(_react2.default.Component);

exports.default = ItemHover;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _customButton = __webpack_require__(117);

var _customButton2 = _interopRequireDefault(_customButton);

var _itemTitle = __webpack_require__(118);

var _itemTitle2 = _interopRequireDefault(_itemTitle);

var _itemDescription = __webpack_require__(264);

var _itemDescription2 = _interopRequireDefault(_itemDescription);

var _lineHeightFixer = __webpack_require__(265);

var _lineHeightFixer2 = _interopRequireDefault(_lineHeightFixer);

var _consts = __webpack_require__(49);

var _consts2 = _interopRequireDefault(_consts);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Texts = function (_React$Component) {
  (0, _inherits3.default)(Texts, _React$Component);

  function Texts() {
    (0, _classCallCheck3.default)(this, Texts);
    return (0, _possibleConstructorReturn3.default)(this, (Texts.__proto__ || (0, _getPrototypeOf2.default)(Texts)).apply(this, arguments));
  }

  (0, _createClass3.default)(Texts, [{
    key: 'getElementClassNames',
    value: function getElementClassNames() {
      var _props = this.props,
          showShare = _props.showShare,
          styleParams = _props.styleParams,
          isNarrow = _props.isNarrow;

      var classNames = ['gallery-item-text'];
      if (showShare) {
        classNames.push('hidden');
      }
      if (styleParams.showArrows) {
        classNames.push('padded-horizontal');
      }
      if (styleParams.allowMultishare) {
        classNames.push('push-down');
      }
      if (isNarrow) {
        classNames.push('narrow-item');
      }

      return classNames.join(' ');
    }
  }, {
    key: 'allowAnyAction',
    value: function allowAnyAction() {
      var styleParams = this.props.styleParams;

      return styleParams.loveButton || styleParams.allowSocial || styleParams.allowDownload;
    }
  }, {
    key: 'getElementStyle',
    value: function getElementStyle() {
      var _props2 = this.props,
          styleParams = _props2.styleParams,
          style = _props2.style;

      var textsDisplayOnHover = !styleParams.isSlideshow && !styleParams.isSlider && !styleParams.hasThumbnails;
      var isCentered = style.justifyContent === 'center';

      var elementStyle = {
        justifyContent: styleParams.galleryVerticalAlign,
        alignItems: styleParams.galleryHorizontalAlign,
        textAlign: styleParams.galleryTextAlign
      };

      //Set the texts fixed height considering the height of the love and share buttons which is about 100px;
      if (textsDisplayOnHover && this.allowAnyAction()) {
        elementStyle.paddingBottom = 45;
      }

      if (isCentered) {
        elementStyle.marginTop = style.height / 15;
      }

      return elementStyle;
    }
  }, {
    key: 'getItemTexts',
    value: function getItemTexts() {
      var _this2 = this;

      var _props3 = this.props,
          title = _props3.title,
          description = _props3.description,
          id = _props3.id,
          styleParams = _props3.styleParams,
          style = _props3.style,
          isSmallItem = _props3.isSmallItem,
          isNarrow = _props3.isNarrow,
          shouldShowButton = _props3.shouldShowButton;

      var shouldShowTitle = title && !isSmallItem && styleParams.allowTitle && styleParams.titlePlacement === _consts2.default.placements.SHOW_ON_HOVER;
      var shouldShowDescription = !isSmallItem && styleParams.allowDescription && description;
      //if there is a description, it will take care of the bottom part.
      //if no description: if there are actions, we will add marginBottom of 20. if no actions, we will add marginBottom of 0.
      var titleStyle = shouldShowDescription ? {} : this.allowAnyAction() ? { marginBottom: 20 } : { marginBottom: 0 };

      var titleElem = shouldShowTitle && _react2.default.createElement(_itemTitle2.default, {
        key: 'item-title-' + id,
        title: title,
        style: titleStyle
      });
      var descriptionElem = shouldShowDescription && _react2.default.createElement(_itemDescription2.default, { description: description, key: 'item-description-' + id });
      var buttonElem = shouldShowButton && _react2.default.createElement(_customButton2.default, { type: 'button', styleParams: styleParams, style: style, small: isNarrow });

      var shouldHideElement = !titleElem && !descriptionElem && !buttonElem;
      if (shouldHideElement) {
        return null;
      }

      var elementStyle = this.getElementStyle();
      var classNames = this.getElementClassNames();

      return _react2.default.createElement(
        'div',
        { style: elementStyle,
          ref: function ref(x) {
            return _this2.container = x;
          },
          className: classNames,
          dir: 'auto' },
        titleElem,
        descriptionElem,
        buttonElem
      );
    }
  }, {
    key: 'tryFixLineHeight',
    value: function tryFixLineHeight() {
      try {
        _lineHeightFixer2.default.fix(this.props, this.container);
      } catch (e) {
        if (_utils2.default.isVerbose()) {
          console.error('Error on componentDidUpdate', e);
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (_lineHeightFixer2.default.shouldFix(prevProps, this.props)) {
        this.tryFixLineHeight();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.tryFixLineHeight();
      setTimeout(function () {
        _this3.tryFixLineHeight(); //waiting for wix inline styles to take affect
      }, 1000);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.getItemTexts();
    }
  }]);
  return Texts;
}(_react2.default.Component);

exports.default = Texts;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomButtonIcon;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomButtonIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "buy-icon", xmlns: "http://www.w3.org/2000/svg", width: "38", height: "34", viewBox: "0 0 38 34" },
    _react2.default.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      _react2.default.createElement("path", { stroke: "currentColor", d: "M.7870039 2.59301758h6.9136797l3.7205137 22.89656932 22.3489443.012", strokeLinecap: "round", strokeLinejoin: "round" }),
      _react2.default.createElement("path", { stroke: "currentColor", d: "M28.0140389 4.49572754h9.017334L34.1188973 19.4727783H11.0089119", strokeLinecap: "round", strokeLinejoin: "round" }),
      _react2.default.createElement("path", { stroke: "currentColor", d: "M15.002193 28.5c1.3971616 0 2.502193 1.1042242 2.502193 2.5s-1.1050314 2.5-2.502193 2.5S12.5 32.3957758 12.5 31s1.1050314-2.5 2.502193-2.5zM27.5 31c0-1.3957758 1.1050314-2.5 2.502193-2.5s2.502193 1.1042242 2.502193 2.5-1.1050314 2.5-2.502193 2.5S27.5 32.3957758 27.5 31z" }),
      _react2.default.createElement("path", { fill: "currentColor", d: "M23 .50625185V11.4270815c0 .2795952-.2319336.5062518-.5.5062518-.2761424 0-.5-.2261351-.5-.5062518V.50625185C22 .22665667 22.2319336 0 22.5 0c.2761424 0 .5.2261351.5.50625185zM8 4h9v1H8z" }),
      _react2.default.createElement("path", { fill: "currentColor", d: "M25.53553353 8.0000001l.7071068.7071068-3.53553392 3.5355339-.70710676-.7071068z" }),
      _react2.default.createElement("path", { fill: "currentColor", d: "M19.0000001 8.70710647l.7071068-.7071068 3.5355339 3.53553392-.7071068.70710676z" })
    )
  );
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var W = __webpack_require__(260);
module.exports = W;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(261)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (a0) {
      return (root['W'] = factory(a0));
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("./wix-bi-parsers"));
  } else {
    root['W'] = factory(root["W"]);
  }
}(this, function (W) {

/* global Image, setTimeout */
'use strict';

var W = W || {};
W.BI = W.BI || {};

W.BI.ErrorSeverity = {
  RECOVERABLE: 10,
  WARNING: 20,
  ERROR: 30,
  FATAL: 40
};

W.BI.Categories = {
  EDITOR: 1,
  VIEWER: 2,
  TIMEOUTS: 3,
  SERVER: 4
};

W.BI.initialLoadIsReported = false;

W.BI.Logger = (function () {
  function now() {
    return new Date().getTime();
  }

  function cacheKiller() {
    return '' + now() + cacheKillerCounter++;
  }

  function performanceInMs() {
    var res = window.performance && window.performance.now ? window.performance.now() : -1;

    return Math.round(res);
  }

  var cacheKillerCounter = 0;

  var startTime = now();

  var defaultEventArgs = {
    _: cacheKiller,
    ms: performanceInMs
  };

  var defaultErrorArgs = {
    _: cacheKiller,
    ts: function () {
      return now() - startTime;
    },
    cat: W.BI.Categories.VIEWER,
    sev: W.BI.ErrorSeverity.WARNING,
    iss: 1,
    ver: '1'
  };

  var _initOptions = {
    // The BI server's hostname
    hostName: 'frog.wix.com',

    // The default event args that will be sent with each BI log call (src, time?)
    defaultEventArgs: {},

    // The default event args that will be sent with each error log (src, cat, iss, ver)
    defaultErrorArgs: {},

    // The BI server URL
    biUrl: '//frog.wix.com/',

    // Schemas validators, should look like this:
    // {match: () => true, execute: () => undefined}
    schemaValidators: [],

    // The BI adapter (maps to a path in the url)
    adapter: '',

    // error output stream
    error: function (str) {
      throw str;
    }
  };

  var EVENT_IDS = {
    ERROR: 10,
    ON_READY: 302,
    ROUTE_CHANGE: 300
  };

  function _extend(dst) {
    for (var i = 1; i < arguments.length; i++) {
      var extending = arguments[i];
      if (extending) {
        for (var key in extending) {
          dst[key] = extending[key];
        }
      }
    }
    return dst;
  }

  function biLogger(args) {
    var _lastBiUrl = {
      url: undefined,
      assertEmpty: function () {
        if (this.url !== undefined) {
          throw 'last bi is not empty!!!';
        }
      },
      resolve: function () {
        this.callback();
      },
      clear: function () {
        this.url = undefined;
      }
    };

    var _options;
    var fieldParsers = new W.BI.FieldParsers(args.injector);

    if (args.hostName) {
      args.biUrl = '//' + args.hostName + '/';
    }
    _options = _extend({}, _initOptions, args);

    function _log(eventArgs, callback) {
      var _biFieldsRestrictions = {
        src: { type: 'number' },
        evid: { type: 'number' }
      };

      var eventParams = _extend({}, defaultEventArgs, _options.defaultEventArgs, eventArgs);

      var schemaValidators = _options.schemaValidators || [];
      var validatorsResult = schemaValidators.length > 0 ?
                                schemaValidators.some(function (validator) {
                                  return validator.match(eventParams) && (validator.execute(eventParams) || true);
                                }) : true;

      if (!validatorsResult) {
        throw new Error('No validator accepted the event');
      }

      if (_validateBiEventArgs(eventParams, ['evid'], _biFieldsRestrictions)) {
        _sendBiEvent(eventParams, callback);
      }
    }

    function _error(errorArgs, callback) {
      var _requiredErrorFields = ['evid', 'cat', 'iss',  'sev', 'errc', 'ver'];
      var _errorFieldsRestrictions = {
        src: { type: 'number' },
        evid: { type: 'number', values: [EVENT_IDS.ERROR] },
        cat: { type: 'number', values: [W.BI.Categories.EDITOR, W.BI.Categories.VIEWER, W.BI.Categories.TIMEOUTS, W.BI.Categories.SERVER] },
        iss: { type: 'number' },
        sev: { type: 'number', values: [W.BI.ErrorSeverity.RECOVERABLE, W.BI.ErrorSeverity.WARNING, W.BI.ErrorSeverity.ERROR, W.BI.ErrorSeverity.FATAL] },
        errc: { type: 'number' },
        httpc: { type: 'number' },
        ver: { type: 'string', maxLength: 16 },
        errscp: { type: 'string', subStr: 64 },
        trgt: { type: 'string', subStr: 64 },
        gsi: { type: 'string', length: 36 },
        ts: { type: 'number' },
        uid: { type: 'number' },
        ut: { type: 'string', maxLength: 16 },
        did: { type: 'string', maxLength: 36 },
        cid: { type: 'string', length: 36 },
        lng: { type: 'string', maxLength: 5 },
        dsc: { type: 'string', subStr: 512 }
      };

      var errorParams = _extend({}, defaultErrorArgs, _options.defaultErrorArgs, errorArgs, {evid: EVENT_IDS.ERROR});

      if (_validateBiEventArgs(errorParams, _requiredErrorFields, _errorFieldsRestrictions)) {
        _sendBiEvent(errorParams, callback);
      }
    }

    function _reportOnReady(viewName, eventArgs, callback) {
      var _onReadyFieldsRestrictions =  {
        view: { type: 'string' }
      };

      var eventParams = _extend({}, eventArgs, {evid: EVENT_IDS.ON_READY, view: viewName});
      if (_validateBiEventArgs(eventParams, ['view'], _onReadyFieldsRestrictions)) {
        _log(eventParams, callback);
      }
    }

    function _reportRouteChange(viewName, eventArgs, callback) {
      var _routeChangeFieldsRestrictions =  {
        view: { type: 'string' }
      };

      var eventParams = _extend({}, eventArgs, {evid: EVENT_IDS.ROUTE_CHANGE, view: viewName});
      if (_validateBiEventArgs(eventParams, ['view'], _routeChangeFieldsRestrictions)) {
        _log(eventParams, callback);
      }
    }

    function _validateBiEventArgs(eventArgs, requiredArgs, restrictions) {
      var missingRequiredArgs = requiredArgs.slice(0);
      for (var key in eventArgs) {
        // validate & parse the key
        var currentRestrictions = restrictions[key] || {};

        eventArgs[key] = fieldParsers.parse(eventArgs[key], currentRestrictions);
        if (!fieldParsers.valid(eventArgs[key], currentRestrictions)) {
          _options.error('Bad event param (key: ' + key + ', value: ' + eventArgs[key] + ')');
          return;
        }

        // remove the key from the required fields
        var missingIndex;
        if ((missingIndex = missingRequiredArgs.indexOf(key)) > -1) {
          missingRequiredArgs.splice(missingIndex, 1);
        }
      }

      if (missingRequiredArgs.length > 0) {
        _options.error('Missing required params: ' + missingRequiredArgs.join(', '));
        return false;
      }

      return true;
    }

    function _addUrlParams(url, params) {
      var delimiter = url.match(/\?./) ? '&' : '?';
      return url.replace(/\?$/, '') + delimiter + Object.keys(params).filter(function (key) {
        return !_options.removeUndefinedValues || params[key] !== undefined;
      }).map(function (key) {
        return [encodeURIComponent(key), '=', encodeURIComponent(params[key])].join('');
      }).join('&');
    }

    function _sendPixel(url, image, onComplete) {
      var onFinish = function () {
        onComplete('pixel');
      };

      var biImage = image || new Image(0, 0);
      biImage.onload = onFinish;
      biImage.onerror = onFinish;
      biImage.src = url;
    }

    function _sendBeacon(url, onComplete) {
      if (!window.navigator || !window.navigator.sendBeacon) {
        return false;
      }

      return window.navigator.sendBeacon(url) && setTimeout(function () {
        onComplete('beacon');
      }, 0);
    }

    function _sendBiEvent(eventArgs, callback) {
      // set the adapter
      var frogAdapter = eventArgs.adapter || _options.adapter;
      delete eventArgs.adapter;

      var url = _addUrlParams(_options.biUrl + frogAdapter, eventArgs);
      var onComplete = callback || function () {};

      if (!W.BI.DryRun) {
        if (!_options.useBeacon || !_sendBeacon(url, onComplete)) {
          _sendPixel(url, _options.image, onComplete);
        }
      } else {
        setTimeout(onComplete, 0);
      }

      // for UT purpose
      _lastBiUrl.url = url;
      _lastBiUrl.callback = callback;
    }

    return {
      log: _log,
      reportOnReady: _reportOnReady,
      reportRouteChange: _reportRouteChange,
      error: _error,

      getLastBiUrl: function () {
        return _lastBiUrl; // for UT purpose
      }
    };
  }

  return biLogger;
}());

return W;

}));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(262)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (a0) {
      return (root['W'] = factory(a0));
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("./wix-bi-event-handler"));
  } else {
    root['W'] = factory(root["W"]);
  }
}(this, function (W) {

'use strict';

var W = W || {};
W.BI = W.BI || {};
W.BI.FieldParsers = function ($injector) {
  var validators = {
    length: function (val, length) {
      return val && val.length !== undefined && val.length === length;
    },
    maxLength: function (val, maxLength) {
      return val && val.length !== undefined && val.length <= maxLength;
    },
    values: function (val, values) {
      return values && values.indexOf(val) !== -1;
    },
    type: function (val, type) {
      return val && typeof val === type;
    }
  };

  var parsers = {
    subStr: function (val, length) {
      if (val && val.substr) {
        return val.substr(0, Math.min(val.length, length));
      }
      return val;
    }
  };

  this.valid = function (value, restrictions) {
    for (var key in restrictions) {
      if (validators[key] && !validators[key](value, restrictions[key])) {
        return false;
      }
    }
    return true;
  };

  this.parse = function (value, restrictions) {
    if (typeof value === 'function') {
      value = $injector ? $injector.invoke(value) : value();
    }
    for (var key in restrictions) {
      value = parsers[key] ? parsers[key](value, restrictions[key]) : value;
    }
    return value;
  };
};

return W;

}));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return (root['W'] = factory());
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    root['W'] = factory();
  }
}(this, function (W) {

/* global document */
'use strict';

var W = W || {};
W.BI = W.BI || {};

W.BI.DomEventHandler = (function () {
  var _wixBiAttributeSelector = 'wix-bi',
    _wixBiArgsAttribute = 'wix-bi-args',
    _initOptions = {
      // A dictionary containing event names and event args
      // The key is the event name that should match the parameter passed to the log() function.
      // The value is a parameter map: parameter name to value (value could be a parameterless delegate to be evaluated)
      // Sample:
      // { EVENT_1: { param1: 'value1', param2: W.Functions.func1, param3: 3 } }
      eventMap: {},

      // A dictionary containing error names and error args. Same structure as eventMap.
      errorMap: {},

      // error output stream
      error: function (str) {
        throw str;
      }
    };

  function _extend(dst) {
    for (var i = 1; i < arguments.length; i++) {
      var extending = arguments[i];
      if (extending) {
        for (var key in extending) {
          dst[key] = extending[key];
        }
      }
    }
    return dst;
  }

  function eventHandler(biLogger, args) {
    var _options;
    var _biLogger = biLogger;

    _options = _extend({}, _initOptions, args);

    function _safeGetEventParams(eventName, eventMap, explicitParams) {
      var params;

      // get the event params
      if (!eventMap || !eventMap[eventName]) {
        _options.error('Invalid event name');
        params = {};
      } else {
        params = eventMap[eventName];
      }

      // extend the specific params with the event params
      return _extend({}, params, explicitParams);
    }

    function _log(eventName, eventArgs, callback) {
      var eventParams = _safeGetEventParams(eventName, _options.eventMap, eventArgs);
      _biLogger.log(eventParams, callback);
    }

    function _error(errorName, errorArgs, callback) {
      var errorParams = _safeGetEventParams(errorName, _options.errorMap, errorArgs);
      _biLogger.error(errorParams, callback);
    }

    function _getAttr(element, name) {
      for (var i = 0; i < element.attributes.length; i++) {
        if (element.attributes[i].name === name) {
          return element.attributes[i].value;
        }
      }
    }

    function _handleTriggeredBiEvent(event) {
      var eventName = _getAttr(event.target, _wixBiAttributeSelector);
      if (eventName) {
        var eventArgsStr = _getAttr(event.target, _wixBiArgsAttribute);
        /* jshint -W061 */
        var eventArgs = eventArgsStr ? eval('eventArgs = ' + eventArgsStr) : {};
        /* jshint +W061 */
        _log(eventName, eventArgs);
      }
    }

    function _bind() {
      document.body.addEventListener('click', _handleTriggeredBiEvent);
    }

    function _unbind() {
      document.body.removeEventListener('click', _handleTriggeredBiEvent);
    }

    return {
      bind: _bind,
      unbind: _unbind,
      log: _log,
      error: _error
    };
  }

  return eventHandler;
}());

return W;

}));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ENRICHERS = {
    _msid: function (SDK) { return SDK.Utils.getInstanceValue('metaSiteId'); },
    _appId: function (SDK) { return SDK.Utils.getInstanceValue('appDefId'); },
    _instanceId: function (SDK) { return SDK.Utils.getInstanceId(); },
    _siteOwnerId: function (SDK) { return SDK.Utils.getSiteOwnerId(); },
    _siteMemberId: function (SDK) { return SDK.Utils.getUid() || ''; },
    _visitorId: function (SDK) { return SDK.Utils.getInstanceValue('aid'); },
    _viewMode: function (SDK) { return SDK.Utils.getViewMode(); }
};
function getBiContext(SDK) {
    return Object.keys(ENRICHERS).reduce(function (res, field) {
        res[field] = ENRICHERS[field](SDK);
        return res;
    }, {});
}
exports.getBiContext = getBiContext;
//# sourceMappingURL=index.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDescription = function (_React$Component) {
  (0, _inherits3.default)(ItemDescription, _React$Component);

  function ItemDescription() {
    (0, _classCallCheck3.default)(this, ItemDescription);
    return (0, _possibleConstructorReturn3.default)(this, (ItemDescription.__proto__ || (0, _getPrototypeOf2.default)(ItemDescription)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemDescription, [{
    key: 'render',
    value: function render() {
      var description = this.props.description;

      return _react2.default.createElement(
        'div',
        { className: 'gallery-item-description', 'data-hook': 'item-description' },
        description.split('\n').map(function (i, key) {
          return _react2.default.createElement(
            'span',
            { key: key },
            i,
            _react2.default.createElement('br', null)
          );
        })
      );
    }
  }]);
  return ItemDescription;
}(_react2.default.Component);

exports.default = ItemDescription;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spaceBetweenElements = 20;
var minWidthToShowContent = 135;
var minWithForNormalSizedItem = 190;

var LineHeightFixer = function () {
  function LineHeightFixer() {
    (0, _classCallCheck3.default)(this, LineHeightFixer);
  }

  (0, _createClass3.default)(LineHeightFixer, [{
    key: 'getDimensions',
    value: function getDimensions(element) {
      var cs = window.getComputedStyle(element);
      var paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      var paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);

      var borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
      var borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

      return {
        width: element.clientWidth - paddingX - borderX,
        height: element.clientHeight - paddingY - borderY
      };
    }
  }, {
    key: 'saveCurrentDisplay',
    value: function saveCurrentDisplay(element) {
      element && element.setAttribute('data-display', this.getCss(element, 'display'));
    }
  }, {
    key: 'getSavedDisplay',
    value: function getSavedDisplay(element) {
      return element && element.getAttribute('data-display') || '-webkit-box';
    }
  }, {
    key: 'removeElement',
    value: function removeElement(element) {
      this.saveCurrentDisplay(element);
      this.setCss(element, { display: 'none' });
    }
  }, {
    key: 'hideElement',
    value: function hideElement(element) {
      var display = this.getSavedDisplay(element);
      this.setCss(element, { visibility: 'hidden', display: display });
    }
  }, {
    key: 'showElement',
    value: function showElement(element) {
      var display = this.getSavedDisplay(element);
      this.setCss(element, { visibility: 'visible', display: display });
    }
  }, {
    key: 'getCss',
    value: function getCss(element, rule) {
      return window.getComputedStyle(element)[rule];
    }
  }, {
    key: 'setCss',
    value: function setCss(element, styles) {
      try {
        (0, _assign2.default)(element.style, styles);
      } catch (e) {
        //
      }
    }
  }, {
    key: 'shouldFix',
    value: function shouldFix(oldOptions, newOptions) {
      var styleParams = oldOptions.styleParams,
          title = oldOptions.title,
          description = oldOptions.description,
          isSmallItem = oldOptions.isSmallItem;

      var newStyleParams = newOptions.styleParams;
      var newTitle = newOptions.title;
      var newDescription = newOptions.description;
      var newIsSmallItems = newOptions.isSmallItem;
      return styleParams.isSlideshow !== newStyleParams.isSlideshow || styleParams.allowTitle !== newStyleParams.allowTitle || styleParams.allowDescription !== newStyleParams.allowDescription || title !== newTitle || description !== newDescription || isSmallItem !== newIsSmallItems;
    }
  }, {
    key: 'fix',
    value: function fix(options, container) {
      if (_index2.default.isTest()) {
        return;
      }

      var styleParams = options.styleParams,
          title = options.title,
          description = options.description,
          isSmallItem = options.isSmallItem;


      if (!container || styleParams.isSlideshow) {
        return;
      }
      var dimensions = this.getDimensions(container);
      var availableHeight = dimensions.height;

      var customButtonElements = container.getElementsByClassName('custom-button-wrapper');
      var titleElements = container.getElementsByClassName('gallery-item-title');
      var descriptionElements = container.getElementsByClassName('gallery-item-description');
      var customButtonExists = customButtonElements.length > 0;

      var customButtonElement = customButtonExists && customButtonElements[0];
      var titleElement = titleElements.length > 0 && titleElements[0];
      var descriptionElement = descriptionElements.length > 0 && descriptionElements[0];

      var isItemWidthToSmall = dimensions.width < minWidthToShowContent;
      this.hideElement(titleElement);
      this.hideElement(descriptionElement);
      this.hideElement(customButtonElement);

      if (customButtonExists) {
        this.showElement(customButtonElement);
        var buttonHeight = this.getDimensions(customButtonElement).height;
        if (availableHeight + 30 < buttonHeight) {
          this.removeElement(customButtonElement);
        } else if (isItemWidthToSmall) {
          this.setCss(customButtonElement.querySelector('button'), { 'min-width': 0 + 'px', 'max-width': minWidthToShowContent + 'px' });
        } else if (dimensions.width < minWithForNormalSizedItem) {
          this.setCss(customButtonElement.querySelector('button'), { 'min-width': minWidthToShowContent + 'px', 'max-width': dimensions.width + 'px' });
        }

        var isButtonHeightAvailable = !_lodash2.default.isNaN(buttonHeight);
        if (isButtonHeightAvailable) {
          availableHeight -= buttonHeight;
          availableHeight -= spaceBetweenElements;
          if (availableHeight < 0) {
            availableHeight = 0;
          }
        }
      }

      var shouldDisplayTitle = title && !isSmallItem && styleParams.allowTitle;
      if (shouldDisplayTitle) {
        this.showElement(titleElement);
        this.setCss(titleElement, { overflow: 'visible' });
        if (titleElements.length === 1) {
          var titleHeight = parseInt(titleElement.clientHeight);
          var titleLineHeight = parseInt(this.getCss(titleElement, 'line-height'));
          var numOfTitleLines = Math.floor(titleHeight / titleLineHeight);
          var numOfAvailableLines = Math.floor(availableHeight / titleLineHeight);

          if (numOfAvailableLines === 0) {
            this.removeElement(titleElement);
          } else {
            this.setCss(titleElement, { overflow: 'hidden' });

            var isTitleFitInAvailableHeight = numOfAvailableLines <= numOfTitleLines;
            if (isTitleFitInAvailableHeight) {
              this.setCss(titleElement, { '-webkit-line-clamp': numOfAvailableLines + '' });
              titleHeight = titleLineHeight * numOfAvailableLines;
            } else {
              this.setCss(titleElement, { '-webkit-line-clamp': 'none' });
              titleHeight = titleLineHeight * numOfTitleLines;
            }

            var isThereAnyAvailableHeightLeft = availableHeight > titleHeight;
            if (isThereAnyAvailableHeightLeft) {
              availableHeight -= titleHeight;
            } else {
              availableHeight = 0;
            }
          }
        }
      }

      var shouldDisplayDescription = descriptionElement && !isSmallItem && styleParams.allowDescription && description && availableHeight > 0;
      if (shouldDisplayDescription) {
        this.showElement(descriptionElement);
        availableHeight -= spaceBetweenElements * 2;
        if (availableHeight < 0) {
          availableHeight = 0;
        }
        var lineHeight = parseInt(this.getCss(descriptionElement, 'line-height'));
        var numOfLines = Math.floor(availableHeight / lineHeight);
        if (numOfLines === 0) {
          this.removeElement(descriptionElement);
        } else {
          this.setCss(descriptionElement, { overflow: 'hidden', '-webkit-line-clamp': numOfLines + '' });
        }
      }
    }
  }]);
  return LineHeightFixer;
}();

exports.default = new LineHeightFixer();

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _loveButton = __webpack_require__(119);

var _loveButton2 = _interopRequireDefault(_loveButton);

var _itemActions = __webpack_require__(22);

var _biLogger = __webpack_require__(29);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Social = function (_React$Component) {
  (0, _inherits3.default)(Social, _React$Component);

  function Social() {
    (0, _classCallCheck3.default)(this, Social);
    return (0, _possibleConstructorReturn3.default)(this, (Social.__proto__ || (0, _getPrototypeOf2.default)(Social)).apply(this, arguments));
  }

  (0, _createClass3.default)(Social, [{
    key: 'getSocialShare',
    value: function getSocialShare() {
      var _props = this.props,
          styleParams = _props.styleParams,
          id = _props.id,
          actions = _props.actions;

      if (styleParams.allowSocial) {
        var slideshowShareButton = _react2.default.createElement('i', { className: 'block-fullscreen progallery-svg-font-icons-share-store' });
        if (_index2.default.isSite()) {
          var slideshowShare = styleParams.isSlideshow ? actions.getShare() : '';
          return _react2.default.createElement(
            'div',
            { className: 'block-fullscreen gallery-item-social-share gallery-item-social-button',
              'data-hook': 'gallery-item-social-button',
              key: 'item-social-share-' + id,
              onClick: function onClick(e) {
                return actions.toggleShare(e, true);
              } },
            slideshowShareButton,
            slideshowShare
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'show-tooltip block-fullscreen gallery-item-social-share gallery-item-social-button',
              'data-hook': 'gallery-item-social-button',
              key: 'item-social-share-' + id,
              onMouseOver: function onMouseOver(e) {
                return _itemActions.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
              },
              onMouseOut: function onMouseOut() {
                return _itemActions.itemActions.hideTooltip();
              },
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            },
            slideshowShareButton
          );
        }
      }
      return '';
    }
  }, {
    key: 'getMultishare',
    value: function getMultishare() {
      var _props2 = this.props,
          styleParams = _props2.styleParams,
          id = _props2.id,
          actions = _props2.actions;

      if (styleParams.allowMultishare) {
        if (_index2.default.isSite()) {
          return _react2.default.createElement(
            'div',
            { className: 'block-fullscreen gallery-item-social-multishare gallery-item-social-button',
              key: 'item-social-multishare-' + id,
              onClick: actions.toggleMultishareSelection },
            _react2.default.createElement(
              'svg',
              { className: 'block-fullscreen', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
              _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
                d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z' })
            )
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'show-tooltip block-fullscreen gallery-item-social-multishare gallery-item-social-button ',
              onMouseOver: function onMouseOver(e) {
                return _itemActions.itemActions.showTooltip(e, 'Gallery_Sharing_Disabled_In_Editor');
              },
              onMouseOut: function onMouseOut() {
                return _itemActions.itemActions.hideTooltip();
              },
              key: 'item-social-multishare-' + id
            },
            _react2.default.createElement(
              'svg',
              { className: 'block-fullscreen inactive', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 18 18' },
              _react2.default.createElement('path', { className: 'gallery-item-svg-foreground',
                d: 'M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z' })
            )
          );
        }
      }
      return false;
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      var _props3 = this.props,
          styleParams = _props3.styleParams,
          love = _props3.love;

      var props = _lodash2.default.pick(this.props, ['id', 'item', 'idx', 'styleParams', 'hashtag', 'love']);
      return styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, (0, _extends3.default)({}, props, {
        itemId: this.props.photoId,
        layout: styleParams.isSlideshow ? 'slideshow' : 'gallery',
        showCounter: love && love.showCounter
      })) : '';
    }
  }, {
    key: 'getDownload',
    value: function getDownload() {
      var item = _lodash2.default.pick(this.props, ['html', 'style']);
      var _props4 = this.props,
          styleParams = _props4.styleParams,
          isDemo = _props4.isDemo,
          type = _props4.type,
          download_url = _props4.download_url;

      if (styleParams.allowDownload && !_index2.default.isiOS() && !(_index2.default.isSite() && isDemo)) {
        var className = 'block-fullscreen gallery-item-social-download ' + (styleParams.allowSocial ? '' : ' pull-right ') + ' gallery-item-social-button';
        var downloadIcon = _react2.default.createElement('i', { className: 'block-fullscreen progallery-svg-font-icons-download' + (isDemo ? ' inactive' : '') });

        var genralProps = {
          className: className,
          'data-hook': 'item-download'
        };
        var downloadLink = download_url.mp4 || download_url.webm || download_url.img;
        var itemProps = {
          target: '_blank',
          href: downloadLink,
          onClick: function onClick(e) {
            e.stopPropagation();
            e.preventDefault();
            window.location.assign(downloadLink);
            _biLogger.logger.trackBi(_biLogger.logger.biEvents.download, { origin: 'gallery' });
          }
        };
        if (type === 'text') {
          return _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, genralProps, {
              onClick: function onClick(e) {
                e.stopPropagation();
                _itemActions.itemActions.downloadTextItem(item, 'gallery');
              } }),
            downloadIcon
          );
        } else {
          var props = isDemo ? {
            onMouseOver: function onMouseOver(e) {
              return _itemActions.itemActions.showTooltip(e, 'Gallery_Hover_Download_FreeImages_Text');
            },
            onMouseOut: function onMouseOut() {
              return _itemActions.itemActions.hideTooltip();
            }
          } : itemProps;
          return _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, genralProps, {
              download: 'download',
              role: 'button'
            }, props),
            downloadIcon
          );
        }
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          styleParams = _props5.styleParams,
          id = _props5.id,
          showShare = _props5.showShare,
          actions = _props5.actions,
          isSmallItem = _props5.isSmallItem,
          isNarrow = _props5.isNarrow,
          isShort = _props5.isShort,
          isVerticalContainer = _props5.isVerticalContainer;

      var socialShare = this.getSocialShare();
      var multishare = this.getMultishare();
      var loveButton = this.getLoveButton();
      var download = this.getDownload();
      //var shopIcons = this.getShopIcons();
      var isShowArrows = styleParams.hasThumbnails;

      var classes = [[showShare, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows']].filter(function (x) {
        return x[0];
      }).map(function (x) {
        return x[1];
      }).join(' ');

      return _react2.default.createElement(
        'div',
        {
          className: 'gallery-item-social gallery-item-direction-' + styleParams.galleryTextAlign + ' ' + classes,
          key: 'item-social-' + id,
          'data-hook': 'item-social'
        },
        multishare,
        loveButton,
        download,
        socialShare
      );
    }
  }]);
  return Social;
}(_react2.default.Component);

exports.default = Social;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*
  html2canvas 0.5.0-beta4 <http://html2canvas.hertzen.com>
  Copyright (c) 2016 Niklas von Hertzen

  Released under  License
*/

(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.html2canvas = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
var log = _dereq_('./log');

function restoreOwnerScroll(ownerDocument, x, y) {
    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
        ownerDocument.defaultView.scrollTo(x, y);
    }
}

function cloneCanvasContents(canvas, clonedCanvas) {
    try {
        if (clonedCanvas) {
            clonedCanvas.width = canvas.width;
            clonedCanvas.height = canvas.height;
            clonedCanvas.getContext("2d").putImageData(canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height), 0, 0);
        }
    } catch(e) {
        log("Unable to copy canvas content from", canvas, e);
    }
}

function cloneNode(node, javascriptEnabled) {
    var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);

    var child = node.firstChild;
    while(child) {
        if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') {
            clone.appendChild(cloneNode(child, javascriptEnabled));
        }
        child = child.nextSibling;
    }

    if (node.nodeType === 1) {
        clone._scrollTop = node.scrollTop;
        clone._scrollLeft = node.scrollLeft;
        if (node.nodeName === "CANVAS") {
            cloneCanvasContents(node, clone);
        } else if (node.nodeName === "TEXTAREA" || node.nodeName === "SELECT") {
            clone.value = node.value;
        }
    }

    return clone;
}

function initNode(node) {
    if (node.nodeType === 1) {
        node.scrollTop = node._scrollTop;
        node.scrollLeft = node._scrollLeft;

        var child = node.firstChild;
        while(child) {
            initNode(child);
            child = child.nextSibling;
        }
    }
}

module.exports = function(ownerDocument, containerDocument, width, height, options, x ,y) {
    var documentElement = cloneNode(ownerDocument.documentElement, options.javascriptEnabled);
    var container = containerDocument.createElement("iframe");

    container.className = "html2canvas-container";
    container.style.visibility = "hidden";
    container.style.position = "fixed";
    container.style.left = "-10000px";
    container.style.top = "0px";
    container.style.border = "0";
    container.width = width;
    container.height = height;
    container.scrolling = "no"; // ios won't scroll without it
    containerDocument.body.appendChild(container);

    return new Promise(function(resolve) {
        var documentClone = container.contentWindow.document;

        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
         if window url is about:blank, we can assign the url to current by writing onto the document
         */
        container.contentWindow.onload = container.onload = function() {
            var interval = setInterval(function() {
                if (documentClone.body.childNodes.length > 0) {
                    initNode(documentClone.documentElement);
                    clearInterval(interval);
                    if (options.type === "view") {
                        container.contentWindow.scrollTo(x, y);
                        if ((/(iPad|iPhone|iPod)/g).test(navigator.userAgent) && (container.contentWindow.scrollY !== y || container.contentWindow.scrollX !== x)) {
                            documentClone.documentElement.style.top = (-y) + "px";
                            documentClone.documentElement.style.left = (-x) + "px";
                            documentClone.documentElement.style.position = 'absolute';
                        }
                    }
                    resolve(container);
                }
            }, 50);
        };

        documentClone.open();
        documentClone.write("<!DOCTYPE html><html></html>");
        // Chrome scrolls the parent document for some reason after the write to the cloned window???
        restoreOwnerScroll(ownerDocument, x, y);
        documentClone.replaceChild(documentClone.adoptNode(documentElement), documentClone.documentElement);
        documentClone.close();
    });
};

},{"./log":13}],3:[function(_dereq_,module,exports){
// http://dev.w3.org/csswg/css-color/

function Color(value) {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = null;
    var result = this.fromArray(value) ||
        this.namedColor(value) ||
        this.rgb(value) ||
        this.rgba(value) ||
        this.hex6(value) ||
        this.hex3(value);
}

Color.prototype.darken = function(amount) {
    var a = 1 - amount;
    return  new Color([
        Math.round(this.r * a),
        Math.round(this.g * a),
        Math.round(this.b * a),
        this.a
    ]);
};

Color.prototype.isTransparent = function() {
    return this.a === 0;
};

Color.prototype.isBlack = function() {
    return this.r === 0 && this.g === 0 && this.b === 0;
};

Color.prototype.fromArray = function(array) {
    if (Array.isArray(array)) {
        this.r = Math.min(array[0], 255);
        this.g = Math.min(array[1], 255);
        this.b = Math.min(array[2], 255);
        if (array.length > 3) {
            this.a = array[3];
        }
    }

    return (Array.isArray(array));
};

var _hex3 = /^#([a-f0-9]{3})$/i;

Color.prototype.hex3 = function(value) {
    var match = null;
    if ((match = value.match(_hex3)) !== null) {
        this.r = parseInt(match[1][0] + match[1][0], 16);
        this.g = parseInt(match[1][1] + match[1][1], 16);
        this.b = parseInt(match[1][2] + match[1][2], 16);
    }
    return match !== null;
};

var _hex6 = /^#([a-f0-9]{6})$/i;

Color.prototype.hex6 = function(value) {
    var match = null;
    if ((match = value.match(_hex6)) !== null) {
        this.r = parseInt(match[1].substring(0, 2), 16);
        this.g = parseInt(match[1].substring(2, 4), 16);
        this.b = parseInt(match[1].substring(4, 6), 16);
    }
    return match !== null;
};


var _rgb = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;

Color.prototype.rgb = function(value) {
    var match = null;
    if ((match = value.match(_rgb)) !== null) {
        this.r = Number(match[1]);
        this.g = Number(match[2]);
        this.b = Number(match[3]);
    }
    return match !== null;
};

var _rgba = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;

Color.prototype.rgba = function(value) {
    var match = null;
    if ((match = value.match(_rgba)) !== null) {
        this.r = Number(match[1]);
        this.g = Number(match[2]);
        this.b = Number(match[3]);
        this.a = Number(match[4]);
    }
    return match !== null;
};

Color.prototype.toString = function() {
    return this.a !== null && this.a !== 1 ?
    "rgba(" + [this.r, this.g, this.b, this.a].join(",") + ")" :
    "rgb(" + [this.r, this.g, this.b].join(",") + ")";
};

Color.prototype.namedColor = function(value) {
    value = value.toLowerCase();
    var color = colors[value];
    if (color) {
        this.r = color[0];
        this.g = color[1];
        this.b = color[2];
    } else if (value === "transparent") {
        this.r = this.g = this.b = this.a = 0;
        return true;
    }

    return !!color;
};

Color.prototype.isColor = true;

// JSON.stringify([].slice.call($$('.named-color-table tr'), 1).map(function(row) { return [row.childNodes[3].textContent, row.childNodes[5].textContent.trim().split(",").map(Number)] }).reduce(function(data, row) {data[row[0]] = row[1]; return data}, {}))
var colors = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
};

module.exports = Color;

},{}],4:[function(_dereq_,module,exports){
var Support = _dereq_('./support');
var CanvasRenderer = _dereq_('./renderers/canvas');
var ImageLoader = _dereq_('./imageloader');
var NodeParser = _dereq_('./nodeparser');
var NodeContainer = _dereq_('./nodecontainer');
var log = _dereq_('./log');
var utils = _dereq_('./utils');
var createWindowClone = _dereq_('./clone');
var loadUrlDocument = _dereq_('./proxy').loadUrlDocument;
var getBounds = utils.getBounds;

var html2canvasNodeAttribute = "data-html2canvas-node";
var html2canvasCloneIndex = 0;

function html2canvas(nodeList, options) {
    var index = html2canvasCloneIndex++;
    options = options || {};
    if (options.logging) {
        log.options.logging = true;
        log.options.start = Date.now();
    }

    options.async = typeof(options.async) === "undefined" ? true : options.async;
    options.allowTaint = typeof(options.allowTaint) === "undefined" ? false : options.allowTaint;
    options.removeContainer = typeof(options.removeContainer) === "undefined" ? true : options.removeContainer;
    options.javascriptEnabled = typeof(options.javascriptEnabled) === "undefined" ? false : options.javascriptEnabled;
    options.imageTimeout = typeof(options.imageTimeout) === "undefined" ? 10000 : options.imageTimeout;
    options.renderer = typeof(options.renderer) === "function" ? options.renderer : CanvasRenderer;
    options.strict = !!options.strict;

    if (typeof(nodeList) === "string") {
        if (typeof(options.proxy) !== "string") {
            return Promise.reject("Proxy must be used when rendering url");
        }
        var width = options.width != null ? options.width : window.innerWidth;
        var height = options.height != null ? options.height : window.innerHeight;
        return loadUrlDocument(absoluteUrl(nodeList), options.proxy, document, width, height, options).then(function(container) {
            return renderWindow(container.contentWindow.document.documentElement, container, options, width, height);
        });
    }

    var node = ((nodeList === undefined) ? [document.documentElement] : ((nodeList.length) ? nodeList : [nodeList]))[0];
    node.setAttribute(html2canvasNodeAttribute + index, index);
    return renderDocument(node.ownerDocument, options, node.ownerDocument.defaultView.innerWidth, node.ownerDocument.defaultView.innerHeight, index).then(function(canvas) {
        if (typeof(options.onrendered) === "function") {
            log("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas");
            options.onrendered(canvas);
        }
        return canvas;
    });
}

html2canvas.CanvasRenderer = CanvasRenderer;
html2canvas.NodeContainer = NodeContainer;
html2canvas.log = log;
html2canvas.utils = utils;

var html2canvasExport = (typeof(document) === "undefined" || typeof(Object.create) !== "function" || typeof(document.createElement("canvas").getContext) !== "function") ? function() {
    return Promise.reject("No canvas support");
} : html2canvas;

module.exports = html2canvasExport;

if (typeof(define) === 'function' && define.amd) {
    define('html2canvas', [], function() {
        return html2canvasExport;
    });
}

function renderDocument(document, options, windowWidth, windowHeight, html2canvasIndex) {
    return createWindowClone(document, document, windowWidth, windowHeight, options, document.defaultView.pageXOffset, document.defaultView.pageYOffset).then(function(container) {
        log("Document cloned");
        var attributeName = html2canvasNodeAttribute + html2canvasIndex;
        var selector = "[" + attributeName + "='" + html2canvasIndex + "']";
        document.querySelector(selector).removeAttribute(attributeName);
        var clonedWindow = container.contentWindow;
        var node = clonedWindow.document.querySelector(selector);
        var oncloneHandler = (typeof(options.onclone) === "function") ? Promise.resolve(options.onclone(clonedWindow.document)) : Promise.resolve(true);
        return oncloneHandler.then(function() {
            return renderWindow(node, container, options, windowWidth, windowHeight);
        });
    });
}

function renderWindow(node, container, options, windowWidth, windowHeight) {
    var clonedWindow = container.contentWindow;
    var support = new Support(clonedWindow.document);
    var imageLoader = new ImageLoader(options, support);
    var bounds = getBounds(node);
    var width = options.type === "view" ? windowWidth : documentWidth(clonedWindow.document);
    var height = options.type === "view" ? windowHeight : documentHeight(clonedWindow.document);
    var renderer = new options.renderer(width, height, imageLoader, options, document);
    var parser = new NodeParser(node, renderer, support, imageLoader, options);
    return parser.ready.then(function() {
        log("Finished rendering");
        var canvas;

        if (options.type === "view") {
            canvas = crop(renderer.canvas, {width: renderer.canvas.width, height: renderer.canvas.height, top: 0, left: 0, x: 0, y: 0});
        } else if (node === clonedWindow.document.body || node === clonedWindow.document.documentElement || options.canvas != null) {
            canvas = renderer.canvas;
        } else {
            canvas = crop(renderer.canvas, {width:  options.width != null ? options.width : bounds.width, height: options.height != null ? options.height : bounds.height, top: bounds.top, left: bounds.left, x: 0, y: 0});
        }

        cleanupContainer(container, options);
        return canvas;
    });
}

function cleanupContainer(container, options) {
    if (options.removeContainer) {
        container.parentNode.removeChild(container);
        log("Cleaned up container");
    }
}

function crop(canvas, bounds) {
    var croppedCanvas = document.createElement("canvas");
    var x1 = Math.min(canvas.width - 1, Math.max(0, bounds.left));
    var x2 = Math.min(canvas.width, Math.max(1, bounds.left + bounds.width));
    var y1 = Math.min(canvas.height - 1, Math.max(0, bounds.top));
    var y2 = Math.min(canvas.height, Math.max(1, bounds.top + bounds.height));
    croppedCanvas.width = bounds.width;
    croppedCanvas.height =  bounds.height;
    var width = x2-x1;
    var height = y2-y1;
    log("Cropping canvas at:", "left:", bounds.left, "top:", bounds.top, "width:", width, "height:", height);
    log("Resulting crop with width", bounds.width, "and height", bounds.height, "with x", x1, "and y", y1);
    croppedCanvas.getContext("2d").drawImage(canvas, x1, y1, width, height, bounds.x, bounds.y, width, height);
    return croppedCanvas;
}

function documentWidth (doc) {
    return Math.max(
        Math.max(doc.body.scrollWidth, doc.documentElement.scrollWidth),
        Math.max(doc.body.offsetWidth, doc.documentElement.offsetWidth),
        Math.max(doc.body.clientWidth, doc.documentElement.clientWidth)
    );
}

function documentHeight (doc) {
    return Math.max(
        Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight),
        Math.max(doc.body.offsetHeight, doc.documentElement.offsetHeight),
        Math.max(doc.body.clientHeight, doc.documentElement.clientHeight)
    );
}

function absoluteUrl(url) {
    var link = document.createElement("a");
    link.href = url;
    link.href = link.href;
    return link;
}

},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(_dereq_,module,exports){
var log = _dereq_('./log');
var smallImage = _dereq_('./utils').smallImage;

function DummyImageContainer(src) {
    this.src = src;
    log("DummyImageContainer for", src);
    if (!this.promise || !this.image) {
        log("Initiating DummyImageContainer");
        DummyImageContainer.prototype.image = new Image();
        var image = this.image;
        DummyImageContainer.prototype.promise = new Promise(function(resolve, reject) {
            image.onload = resolve;
            image.onerror = reject;
            image.src = smallImage();
            if (image.complete === true) {
                resolve(image);
            }
        });
    }
}

module.exports = DummyImageContainer;

},{"./log":13,"./utils":26}],6:[function(_dereq_,module,exports){
var smallImage = _dereq_('./utils').smallImage;

function Font(family, size) {
    var container = document.createElement('div'),
        img = document.createElement('img'),
        span = document.createElement('span'),
        sampleText = 'Hidden Text',
        baseline,
        middle;

    container.style.visibility = "hidden";
    container.style.fontFamily = family;
    container.style.fontSize = size;
    container.style.margin = 0;
    container.style.padding = 0;

    document.body.appendChild(container);

    img.src = smallImage();
    img.width = 1;
    img.height = 1;

    img.style.margin = 0;
    img.style.padding = 0;
    img.style.verticalAlign = "baseline";

    span.style.fontFamily = family;
    span.style.fontSize = size;
    span.style.margin = 0;
    span.style.padding = 0;

    span.appendChild(document.createTextNode(sampleText));
    container.appendChild(span);
    container.appendChild(img);
    baseline = (img.offsetTop - span.offsetTop) + 1;

    container.removeChild(span);
    container.appendChild(document.createTextNode(sampleText));

    container.style.lineHeight = "normal";
    img.style.verticalAlign = "super";

    middle = (img.offsetTop-container.offsetTop) + 1;

    document.body.removeChild(container);

    this.baseline = baseline;
    this.lineWidth = 1;
    this.middle = middle;
}

module.exports = Font;

},{"./utils":26}],7:[function(_dereq_,module,exports){
var Font = _dereq_('./font');

function FontMetrics() {
    this.data = {};
}

FontMetrics.prototype.getMetrics = function(family, size) {
    if (this.data[family + "-" + size] === undefined) {
        this.data[family + "-" + size] = new Font(family, size);
    }
    return this.data[family + "-" + size];
};

module.exports = FontMetrics;

},{"./font":6}],8:[function(_dereq_,module,exports){
var utils = _dereq_('./utils');
var getBounds = utils.getBounds;
var loadUrlDocument = _dereq_('./proxy').loadUrlDocument;

function FrameContainer(container, sameOrigin, options) {
    this.image = null;
    this.src = container;
    var self = this;
    var bounds = getBounds(container);
    this.promise = (!sameOrigin ? this.proxyLoad(options.proxy, bounds, options) : new Promise(function(resolve) {
        if (container.contentWindow.document.URL === "about:blank" || container.contentWindow.document.documentElement == null) {
            container.contentWindow.onload = container.onload = function() {
                resolve(container);
            };
        } else {
            resolve(container);
        }
    })).then(function(container) {
        var html2canvas = _dereq_('./core');
        return html2canvas(container.contentWindow.document.documentElement, {type: 'view', width: container.width, height: container.height, proxy: options.proxy, javascriptEnabled: options.javascriptEnabled, removeContainer: options.removeContainer, allowTaint: options.allowTaint, imageTimeout: options.imageTimeout / 2});
    }).then(function(canvas) {
        return self.image = canvas;
    });
}

FrameContainer.prototype.proxyLoad = function(proxy, bounds, options) {
    var container = this.src;
    return loadUrlDocument(container.src, proxy, container.ownerDocument, bounds.width, bounds.height, options);
};

module.exports = FrameContainer;

},{"./core":4,"./proxy":16,"./utils":26}],9:[function(_dereq_,module,exports){
function GradientContainer(imageData) {
    this.src = imageData.value;
    this.colorStops = [];
    this.type = null;
    this.x0 = 0.5;
    this.y0 = 0.5;
    this.x1 = 0.5;
    this.y1 = 0.5;
    this.promise = Promise.resolve(true);
}

GradientContainer.TYPES = {
    LINEAR: 1,
    RADIAL: 2
};

// TODO: support hsl[a], negative %/length values
// TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
GradientContainer.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i;

module.exports = GradientContainer;

},{}],10:[function(_dereq_,module,exports){
function ImageContainer(src, cors) {
    this.src = src;
    this.image = new Image();
    var self = this;
    this.tainted = null;
    this.promise = new Promise(function(resolve, reject) {
        self.image.onload = resolve;
        self.image.onerror = reject;
        if (cors) {
            self.image.crossOrigin = "anonymous";
        }
        self.image.src = src;
        if (self.image.complete === true) {
            resolve(self.image);
        }
    });
}

module.exports = ImageContainer;

},{}],11:[function(_dereq_,module,exports){
var log = _dereq_('./log');
var ImageContainer = _dereq_('./imagecontainer');
var DummyImageContainer = _dereq_('./dummyimagecontainer');
var ProxyImageContainer = _dereq_('./proxyimagecontainer');
var FrameContainer = _dereq_('./framecontainer');
var SVGContainer = _dereq_('./svgcontainer');
var SVGNodeContainer = _dereq_('./svgnodecontainer');
var LinearGradientContainer = _dereq_('./lineargradientcontainer');
var WebkitGradientContainer = _dereq_('./webkitgradientcontainer');
var bind = _dereq_('./utils').bind;

function ImageLoader(options, support) {
    this.link = null;
    this.options = options;
    this.support = support;
    this.origin = this.getOrigin(window.location.href);
}

ImageLoader.prototype.findImages = function(nodes) {
    var images = [];
    nodes.reduce(function(imageNodes, container) {
        switch(container.node.nodeName) {
        case "IMG":
            return imageNodes.concat([{
                args: [container.node.src],
                method: "url"
            }]);
        case "svg":
        case "IFRAME":
            return imageNodes.concat([{
                args: [container.node],
                method: container.node.nodeName
            }]);
        }
        return imageNodes;
    }, []).forEach(this.addImage(images, this.loadImage), this);
    return images;
};

ImageLoader.prototype.findBackgroundImage = function(images, container) {
    container.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(images, this.loadImage), this);
    return images;
};

ImageLoader.prototype.addImage = function(images, callback) {
    return function(newImage) {
        newImage.args.forEach(function(image) {
            if (!this.imageExists(images, image)) {
                images.splice(0, 0, callback.call(this, newImage));
                log('Added image #' + (images.length), typeof(image) === "string" ? image.substring(0, 100) : image);
            }
        }, this);
    };
};

ImageLoader.prototype.hasImageBackground = function(imageData) {
    return imageData.method !== "none";
};

ImageLoader.prototype.loadImage = function(imageData) {
    if (imageData.method === "url") {
        var src = imageData.args[0];
        if (this.isSVG(src) && !this.support.svg && !this.options.allowTaint) {
            return new SVGContainer(src);
        } else if (src.match(/data:image\/.*;base64,/i)) {
            return new ImageContainer(src.replace(/url\(['"]{0,}|['"]{0,}\)$/ig, ''), false);
        } else if (this.isSameOrigin(src) || this.options.allowTaint === true || this.isSVG(src)) {
            return new ImageContainer(src, false);
        } else if (this.support.cors && !this.options.allowTaint && this.options.useCORS) {
            return new ImageContainer(src, true);
        } else if (this.options.proxy) {
            return new ProxyImageContainer(src, this.options.proxy);
        } else {
            return new DummyImageContainer(src);
        }
    } else if (imageData.method === "linear-gradient") {
        return new LinearGradientContainer(imageData);
    } else if (imageData.method === "gradient") {
        return new WebkitGradientContainer(imageData);
    } else if (imageData.method === "svg") {
        return new SVGNodeContainer(imageData.args[0], this.support.svg);
    } else if (imageData.method === "IFRAME") {
        return new FrameContainer(imageData.args[0], this.isSameOrigin(imageData.args[0].src), this.options);
    } else {
        return new DummyImageContainer(imageData);
    }
};

ImageLoader.prototype.isSVG = function(src) {
    return src.substring(src.length - 3).toLowerCase() === "svg" || SVGContainer.prototype.isInline(src);
};

ImageLoader.prototype.imageExists = function(images, src) {
    return images.some(function(image) {
        return image.src === src;
    });
};

ImageLoader.prototype.isSameOrigin = function(url) {
    return (this.getOrigin(url) === this.origin);
};

ImageLoader.prototype.getOrigin = function(url) {
    var link = this.link || (this.link = document.createElement("a"));
    link.href = url;
    link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
    return link.protocol + link.hostname + link.port;
};

ImageLoader.prototype.getPromise = function(container) {
    return this.timeout(container, this.options.imageTimeout)['catch'](function() {
        var dummy = new DummyImageContainer(container.src);
        return dummy.promise.then(function(image) {
            container.image = image;
        });
    });
};

ImageLoader.prototype.get = function(src) {
    var found = null;
    return this.images.some(function(img) {
        return (found = img).src === src;
    }) ? found : null;
};

ImageLoader.prototype.fetch = function(nodes) {
    this.images = nodes.reduce(bind(this.findBackgroundImage, this), this.findImages(nodes));
    this.images.forEach(function(image, index) {
        image.promise.then(function() {
            log("Succesfully loaded image #"+ (index+1), image);
        }, function(e) {
            log("Failed loading image #"+ (index+1), image, e);
        });
    });
    this.ready = Promise.all(this.images.map(this.getPromise, this));
    log("Finished searching images");
    return this;
};

ImageLoader.prototype.timeout = function(container, timeout) {
    var timer;
    var promise = Promise.race([container.promise, new Promise(function(res, reject) {
        timer = setTimeout(function() {
            log("Timed out loading image", container);
            reject(container);
        }, timeout);
    })]).then(function(container) {
        clearTimeout(timer);
        return container;
    });
    promise['catch'](function() {
        clearTimeout(timer);
    });
    return promise;
};

module.exports = ImageLoader;

},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(_dereq_,module,exports){
var GradientContainer = _dereq_('./gradientcontainer');
var Color = _dereq_('./color');

function LinearGradientContainer(imageData) {
    GradientContainer.apply(this, arguments);
    this.type = GradientContainer.TYPES.LINEAR;

    var hasDirection = LinearGradientContainer.REGEXP_DIRECTION.test( imageData.args[0] ) ||
        !GradientContainer.REGEXP_COLORSTOP.test( imageData.args[0] );

    if (hasDirection) {
        imageData.args[0].split(/\s+/).reverse().forEach(function(position, index) {
            switch(position) {
            case "left":
                this.x0 = 0;
                this.x1 = 1;
                break;
            case "top":
                this.y0 = 0;
                this.y1 = 1;
                break;
            case "right":
                this.x0 = 1;
                this.x1 = 0;
                break;
            case "bottom":
                this.y0 = 1;
                this.y1 = 0;
                break;
            case "to":
                var y0 = this.y0;
                var x0 = this.x0;
                this.y0 = this.y1;
                this.x0 = this.x1;
                this.x1 = x0;
                this.y1 = y0;
                break;
            case "center":
                break; // centered by default
            // Firefox internally converts position keywords to percentages:
            // http://www.w3.org/TR/2010/WD-CSS2-20101207/colors.html#propdef-background-position
            default: // percentage or absolute length
                // TODO: support absolute start point positions (e.g., use bounds to convert px to a ratio)
                var ratio = parseFloat(position, 10) * 1e-2;
                if (isNaN(ratio)) { // invalid or unhandled value
                    break;
                }
                if (index === 0) {
                    this.y0 = ratio;
                    this.y1 = 1 - this.y0;
                } else {
                    this.x0 = ratio;
                    this.x1 = 1 - this.x0;
                }
                break;
            }
        }, this);
    } else {
        this.y0 = 0;
        this.y1 = 1;
    }

    this.colorStops = imageData.args.slice(hasDirection ? 1 : 0).map(function(colorStop) {
        var colorStopMatch = colorStop.match(GradientContainer.REGEXP_COLORSTOP);
        var value = +colorStopMatch[2];
        var unit = value === 0 ? "%" : colorStopMatch[3]; // treat "0" as "0%"
        return {
            color: new Color(colorStopMatch[1]),
            // TODO: support absolute stop positions (e.g., compute gradient line length & convert px to ratio)
            stop: unit === "%" ? value / 100 : null
        };
    });

    if (this.colorStops[0].stop === null) {
        this.colorStops[0].stop = 0;
    }

    if (this.colorStops[this.colorStops.length - 1].stop === null) {
        this.colorStops[this.colorStops.length - 1].stop = 1;
    }

    // calculates and fills-in explicit stop positions when omitted from rule
    this.colorStops.forEach(function(colorStop, index) {
        if (colorStop.stop === null) {
            this.colorStops.slice(index).some(function(find, count) {
                if (find.stop !== null) {
                    colorStop.stop = ((find.stop - this.colorStops[index - 1].stop) / (count + 1)) + this.colorStops[index - 1].stop;
                    return true;
                } else {
                    return false;
                }
            }, this);
        }
    }, this);
}

LinearGradientContainer.prototype = Object.create(GradientContainer.prototype);

// TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
LinearGradientContainer.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i;

module.exports = LinearGradientContainer;

},{"./color":3,"./gradientcontainer":9}],13:[function(_dereq_,module,exports){
var logger = function() {
    if (logger.options.logging && window.console && window.console.log) {
        Function.prototype.bind.call(window.console.log, (window.console)).apply(window.console, [(Date.now() - logger.options.start) + "ms", "html2canvas:"].concat([].slice.call(arguments, 0)));
    }
};

logger.options = {logging: false};
module.exports = logger;

},{}],14:[function(_dereq_,module,exports){
var Color = _dereq_('./color');
var utils = _dereq_('./utils');
var getBounds = utils.getBounds;
var parseBackgrounds = utils.parseBackgrounds;
var offsetBounds = utils.offsetBounds;

function NodeContainer(node, parent) {
    this.node = node;
    this.parent = parent;
    this.stack = null;
    this.bounds = null;
    this.borders = null;
    this.clip = [];
    this.backgroundClip = [];
    this.offsetBounds = null;
    this.visible = null;
    this.computedStyles = null;
    this.colors = {};
    this.styles = {};
    this.backgroundImages = null;
    this.transformData = null;
    this.transformMatrix = null;
    this.isPseudoElement = false;
    this.opacity = null;
}

NodeContainer.prototype.cloneTo = function(stack) {
    stack.visible = this.visible;
    stack.borders = this.borders;
    stack.bounds = this.bounds;
    stack.clip = this.clip;
    stack.backgroundClip = this.backgroundClip;
    stack.computedStyles = this.computedStyles;
    stack.styles = this.styles;
    stack.backgroundImages = this.backgroundImages;
    stack.opacity = this.opacity;
};

NodeContainer.prototype.getOpacity = function() {
    return this.opacity === null ? (this.opacity = this.cssFloat('opacity')) : this.opacity;
};

NodeContainer.prototype.assignStack = function(stack) {
    this.stack = stack;
    stack.children.push(this);
};

NodeContainer.prototype.isElementVisible = function() {
    return this.node.nodeType === Node.TEXT_NODE ? this.parent.visible : (
        this.css('display') !== "none" &&
        this.css('visibility') !== "hidden" &&
        !this.node.hasAttribute("data-html2canvas-ignore") &&
        (this.node.nodeName !== "INPUT" || this.node.getAttribute("type") !== "hidden")
    );
};

NodeContainer.prototype.css = function(attribute) {
    if (!this.computedStyles) {
        this.computedStyles = this.isPseudoElement ? this.parent.computedStyle(this.before ? ":before" : ":after") : this.computedStyle(null);
    }

    return this.styles[attribute] || (this.styles[attribute] = this.computedStyles[attribute]);
};

NodeContainer.prototype.prefixedCss = function(attribute) {
    var prefixes = ["webkit", "moz", "ms", "o"];
    var value = this.css(attribute);
    if (value === undefined) {
        prefixes.some(function(prefix) {
            value = this.css(prefix + attribute.substr(0, 1).toUpperCase() + attribute.substr(1));
            return value !== undefined;
        }, this);
    }
    return value === undefined ? null : value;
};

NodeContainer.prototype.computedStyle = function(type) {
    return this.node.ownerDocument.defaultView.getComputedStyle(this.node, type);
};

NodeContainer.prototype.cssInt = function(attribute) {
    var value = parseInt(this.css(attribute), 10);
    return (isNaN(value)) ? 0 : value; // borders in old IE are throwing 'medium' for demo.html
};

NodeContainer.prototype.color = function(attribute) {
    return this.colors[attribute] || (this.colors[attribute] = new Color(this.css(attribute)));
};

NodeContainer.prototype.cssFloat = function(attribute) {
    var value = parseFloat(this.css(attribute));
    return (isNaN(value)) ? 0 : value;
};

NodeContainer.prototype.fontWeight = function() {
    var weight = this.css("fontWeight");
    switch(parseInt(weight, 10)){
    case 401:
        weight = "bold";
        break;
    case 400:
        weight = "normal";
        break;
    }
    return weight;
};

NodeContainer.prototype.parseClip = function() {
    var matches = this.css('clip').match(this.CLIP);
    if (matches) {
        return {
            top: parseInt(matches[1], 10),
            right: parseInt(matches[2], 10),
            bottom: parseInt(matches[3], 10),
            left: parseInt(matches[4], 10)
        };
    }
    return null;
};

NodeContainer.prototype.parseBackgroundImages = function() {
    return this.backgroundImages || (this.backgroundImages = parseBackgrounds(this.css("backgroundImage")));
};

NodeContainer.prototype.cssList = function(property, index) {
    var value = (this.css(property) || '').split(',');
    value = value[index || 0] || value[0] || 'auto';
    value = value.trim().split(' ');
    if (value.length === 1) {
        value = [value[0], isPercentage(value[0]) ? 'auto' : value[0]];
    }
    return value;
};

NodeContainer.prototype.parseBackgroundSize = function(bounds, image, index) {
    var size = this.cssList("backgroundSize", index);
    var width, height;

    if (isPercentage(size[0])) {
        width = bounds.width * parseFloat(size[0]) / 100;
    } else if (/contain|cover/.test(size[0])) {
        var targetRatio = bounds.width / bounds.height, currentRatio = image.width / image.height;
        return (targetRatio < currentRatio ^ size[0] === 'contain') ?  {width: bounds.height * currentRatio, height: bounds.height} : {width: bounds.width, height: bounds.width / currentRatio};
    } else {
        width = parseInt(size[0], 10);
    }

    if (size[0] === 'auto' && size[1] === 'auto') {
        height = image.height;
    } else if (size[1] === 'auto') {
        height = width / image.width * image.height;
    } else if (isPercentage(size[1])) {
        height =  bounds.height * parseFloat(size[1]) / 100;
    } else {
        height = parseInt(size[1], 10);
    }

    if (size[0] === 'auto') {
        width = height / image.height * image.width;
    }

    return {width: width, height: height};
};

NodeContainer.prototype.parseBackgroundPosition = function(bounds, image, index, backgroundSize) {
    var position = this.cssList('backgroundPosition', index);
    var left, top;

    if (isPercentage(position[0])){
        left = (bounds.width - (backgroundSize || image).width) * (parseFloat(position[0]) / 100);
    } else {
        left = parseInt(position[0], 10);
    }

    if (position[1] === 'auto') {
        top = left / image.width * image.height;
    } else if (isPercentage(position[1])){
        top =  (bounds.height - (backgroundSize || image).height) * parseFloat(position[1]) / 100;
    } else {
        top = parseInt(position[1], 10);
    }

    if (position[0] === 'auto') {
        left = top / image.height * image.width;
    }

    return {left: left, top: top};
};

NodeContainer.prototype.parseBackgroundRepeat = function(index) {
    return this.cssList("backgroundRepeat", index)[0];
};

NodeContainer.prototype.parseTextShadows = function() {
    var textShadow = this.css("textShadow");
    var results = [];

    if (textShadow && textShadow !== 'none') {
        var shadows = textShadow.match(this.TEXT_SHADOW_PROPERTY);
        for (var i = 0; shadows && (i < shadows.length); i++) {
            var s = shadows[i].match(this.TEXT_SHADOW_VALUES);
            results.push({
                color: new Color(s[0]),
                offsetX: s[1] ? parseFloat(s[1].replace('px', '')) : 0,
                offsetY: s[2] ? parseFloat(s[2].replace('px', '')) : 0,
                blur: s[3] ? s[3].replace('px', '') : 0
            });
        }
    }
    return results;
};

NodeContainer.prototype.parseTransform = function() {
    if (!this.transformData) {
        if (this.hasTransform()) {
            var offset = this.parseBounds();
            var origin = this.prefixedCss("transformOrigin").split(" ").map(removePx).map(asFloat);
            origin[0] += offset.left;
            origin[1] += offset.top;
            this.transformData = {
                origin: origin,
                matrix: this.parseTransformMatrix()
            };
        } else {
            this.transformData = {
                origin: [0, 0],
                matrix: [1, 0, 0, 1, 0, 0]
            };
        }
    }
    return this.transformData;
};

NodeContainer.prototype.parseTransformMatrix = function() {
    if (!this.transformMatrix) {
        var transform = this.prefixedCss("transform");
        var matrix = transform ? parseMatrix(transform.match(this.MATRIX_PROPERTY)) : null;
        this.transformMatrix = matrix ? matrix : [1, 0, 0, 1, 0, 0];
    }
    return this.transformMatrix;
};

NodeContainer.prototype.parseBounds = function() {
    return this.bounds || (this.bounds = this.hasTransform() ? offsetBounds(this.node) : getBounds(this.node));
};

NodeContainer.prototype.hasTransform = function() {
    return this.parseTransformMatrix().join(",") !== "1,0,0,1,0,0" || (this.parent && this.parent.hasTransform());
};

NodeContainer.prototype.getValue = function() {
    var value = this.node.value || "";
    if (this.node.tagName === "SELECT") {
        value = selectionValue(this.node);
    } else if (this.node.type === "password") {
        value = Array(value.length + 1).join('\u2022'); // jshint ignore:line
    }
    return value.length === 0 ? (this.node.placeholder || "") : value;
};

NodeContainer.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/;
NodeContainer.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g;
NodeContainer.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g;
NodeContainer.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/;

function selectionValue(node) {
    var option = node.options[node.selectedIndex || 0];
    return option ? (option.text || "") : "";
}

function parseMatrix(match) {
    if (match && match[1] === "matrix") {
        return match[2].split(",").map(function(s) {
            return parseFloat(s.trim());
        });
    } else if (match && match[1] === "matrix3d") {
        var matrix3d = match[2].split(",").map(function(s) {
          return parseFloat(s.trim());
        });
        return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
    }
}

function isPercentage(value) {
    return value.toString().indexOf("%") !== -1;
}

function removePx(str) {
    return str.replace("px", "");
}

function asFloat(str) {
    return parseFloat(str);
}

module.exports = NodeContainer;

},{"./color":3,"./utils":26}],15:[function(_dereq_,module,exports){
var log = _dereq_('./log');
var punycode = _dereq_('punycode');
var NodeContainer = _dereq_('./nodecontainer');
var TextContainer = _dereq_('./textcontainer');
var PseudoElementContainer = _dereq_('./pseudoelementcontainer');
var FontMetrics = _dereq_('./fontmetrics');
var Color = _dereq_('./color');
var StackingContext = _dereq_('./stackingcontext');
var utils = _dereq_('./utils');
var bind = utils.bind;
var getBounds = utils.getBounds;
var parseBackgrounds = utils.parseBackgrounds;
var offsetBounds = utils.offsetBounds;

function NodeParser(element, renderer, support, imageLoader, options) {
    log("Starting NodeParser");
    this.renderer = renderer;
    this.options = options;
    this.range = null;
    this.support = support;
    this.renderQueue = [];
    this.stack = new StackingContext(true, 1, element.ownerDocument, null);
    var parent = new NodeContainer(element, null);
    if (options.background) {
        renderer.rectangle(0, 0, renderer.width, renderer.height, new Color(options.background));
    }
    if (element === element.ownerDocument.documentElement) {
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var canvasBackground = new NodeContainer(parent.color('backgroundColor').isTransparent() ? element.ownerDocument.body : element.ownerDocument.documentElement, null);
        renderer.rectangle(0, 0, renderer.width, renderer.height, canvasBackground.color('backgroundColor'));
    }
    parent.visibile = parent.isElementVisible();
    this.createPseudoHideStyles(element.ownerDocument);
    this.disableAnimations(element.ownerDocument);
    this.nodes = flatten([parent].concat(this.getChildren(parent)).filter(function(container) {
        return container.visible = container.isElementVisible();
    }).map(this.getPseudoElements, this));
    this.fontMetrics = new FontMetrics();
    log("Fetched nodes, total:", this.nodes.length);
    log("Calculate overflow clips");
    this.calculateOverflowClips();
    log("Start fetching images");
    this.images = imageLoader.fetch(this.nodes.filter(isElement));
    this.ready = this.images.ready.then(bind(function() {
        log("Images loaded, starting parsing");
        log("Creating stacking contexts");
        this.createStackingContexts();
        log("Sorting stacking contexts");
        this.sortStackingContexts(this.stack);
        this.parse(this.stack);
        log("Render queue created with " + this.renderQueue.length + " items");
        return new Promise(bind(function(resolve) {
            if (!options.async) {
                this.renderQueue.forEach(this.paint, this);
                resolve();
            } else if (typeof(options.async) === "function") {
                options.async.call(this, this.renderQueue, resolve);
            } else if (this.renderQueue.length > 0){
                this.renderIndex = 0;
                this.asyncRenderer(this.renderQueue, resolve);
            } else {
                resolve();
            }
        }, this));
    }, this));
}

NodeParser.prototype.calculateOverflowClips = function() {
    this.nodes.forEach(function(container) {
        if (isElement(container)) {
            if (isPseudoElement(container)) {
                container.appendToDOM();
            }
            container.borders = this.parseBorders(container);
            var clip = (container.css('overflow') === "hidden") ? [container.borders.clip] : [];
            var cssClip = container.parseClip();
            if (cssClip && ["absolute", "fixed"].indexOf(container.css('position')) !== -1) {
                clip.push([["rect",
                        container.bounds.left + cssClip.left,
                        container.bounds.top + cssClip.top,
                        cssClip.right - cssClip.left,
                        cssClip.bottom - cssClip.top
                ]]);
            }
            container.clip = hasParentClip(container) ? container.parent.clip.concat(clip) : clip;
            container.backgroundClip = (container.css('overflow') !== "hidden") ? container.clip.concat([container.borders.clip]) : container.clip;
            if (isPseudoElement(container)) {
                container.cleanDOM();
            }
        } else if (isTextNode(container)) {
            container.clip = hasParentClip(container) ? container.parent.clip : [];
        }
        if (!isPseudoElement(container)) {
            container.bounds = null;
        }
    }, this);
};

function hasParentClip(container) {
    return container.parent && container.parent.clip.length;
}

NodeParser.prototype.asyncRenderer = function(queue, resolve, asyncTimer) {
    asyncTimer = asyncTimer || Date.now();
    this.paint(queue[this.renderIndex++]);
    if (queue.length === this.renderIndex) {
        resolve();
    } else if (asyncTimer + 20 > Date.now()) {
        this.asyncRenderer(queue, resolve, asyncTimer);
    } else {
        setTimeout(bind(function() {
            this.asyncRenderer(queue, resolve);
        }, this), 0);
    }
};

NodeParser.prototype.createPseudoHideStyles = function(document) {
    this.createStyles(document, '.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }' +
        '.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');
};

NodeParser.prototype.disableAnimations = function(document) {
    this.createStyles(document, '* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; ' +
        '-webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}');
};

NodeParser.prototype.createStyles = function(document, styles) {
    var hidePseudoElements = document.createElement('style');
    hidePseudoElements.innerHTML = styles;
    document.body.appendChild(hidePseudoElements);
};

NodeParser.prototype.getPseudoElements = function(container) {
    var nodes = [[container]];
    if (container.node.nodeType === Node.ELEMENT_NODE) {
        var before = this.getPseudoElement(container, ":before");
        var after = this.getPseudoElement(container, ":after");

        if (before) {
            nodes.push(before);
        }

        if (after) {
            nodes.push(after);
        }
    }
    return flatten(nodes);
};

function toCamelCase(str) {
    return str.replace(/(\-[a-z])/g, function(match){
        return match.toUpperCase().replace('-','');
    });
}

NodeParser.prototype.getPseudoElement = function(container, type) {
    var style = container.computedStyle(type);
    if(!style || !style.content || style.content === "none" || style.content === "-moz-alt-content" || style.display === "none") {
        return null;
    }

    var content = stripQuotes(style.content);
    var isImage = content.substr(0, 3) === 'url';
    var pseudoNode = document.createElement(isImage ? 'img' : 'html2canvaspseudoelement');
    var pseudoContainer = new PseudoElementContainer(pseudoNode, container, type);

    for (var i = style.length-1; i >= 0; i--) {
        var property = toCamelCase(style.item(i));
        pseudoNode.style[property] = style[property];
    }

    pseudoNode.className = PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER;

    if (isImage) {
        pseudoNode.src = parseBackgrounds(content)[0].args[0];
        return [pseudoContainer];
    } else {
        var text = document.createTextNode(content);
        pseudoNode.appendChild(text);
        return [pseudoContainer, new TextContainer(text, pseudoContainer)];
    }
};


NodeParser.prototype.getChildren = function(parentContainer) {
    return flatten([].filter.call(parentContainer.node.childNodes, renderableNode).map(function(node) {
        var container = [node.nodeType === Node.TEXT_NODE ? new TextContainer(node, parentContainer) : new NodeContainer(node, parentContainer)].filter(nonIgnoredElement);
        return node.nodeType === Node.ELEMENT_NODE && container.length && node.tagName !== "TEXTAREA" ? (container[0].isElementVisible() ? container.concat(this.getChildren(container[0])) : []) : container;
    }, this));
};

NodeParser.prototype.newStackingContext = function(container, hasOwnStacking) {
    var stack = new StackingContext(hasOwnStacking, container.getOpacity(), container.node, container.parent);
    container.cloneTo(stack);
    var parentStack = hasOwnStacking ? stack.getParentStack(this) : stack.parent.stack;
    parentStack.contexts.push(stack);
    container.stack = stack;
};

NodeParser.prototype.createStackingContexts = function() {
    this.nodes.forEach(function(container) {
        if (isElement(container) && (this.isRootElement(container) || hasOpacity(container) || isPositionedForStacking(container) || this.isBodyWithTransparentRoot(container) || container.hasTransform())) {
            this.newStackingContext(container, true);
        } else if (isElement(container) && ((isPositioned(container) && zIndex0(container)) || isInlineBlock(container) || isFloating(container))) {
            this.newStackingContext(container, false);
        } else {
            container.assignStack(container.parent.stack);
        }
    }, this);
};

NodeParser.prototype.isBodyWithTransparentRoot = function(container) {
    return container.node.nodeName === "BODY" && container.parent.color('backgroundColor').isTransparent();
};

NodeParser.prototype.isRootElement = function(container) {
    return container.parent === null;
};

NodeParser.prototype.sortStackingContexts = function(stack) {
    stack.contexts.sort(zIndexSort(stack.contexts.slice(0)));
    stack.contexts.forEach(this.sortStackingContexts, this);
};

NodeParser.prototype.parseTextBounds = function(container) {
    return function(text, index, textList) {
        if (container.parent.css("textDecoration").substr(0, 4) !== "none" || text.trim().length !== 0) {
            if (this.support.rangeBounds && !container.parent.hasTransform()) {
                var offset = textList.slice(0, index).join("").length;
                return this.getRangeBounds(container.node, offset, text.length);
            } else if (container.node && typeof(container.node.data) === "string") {
                var replacementNode = container.node.splitText(text.length);
                var bounds = this.getWrapperBounds(container.node, container.parent.hasTransform());
                container.node = replacementNode;
                return bounds;
            }
        } else if(!this.support.rangeBounds || container.parent.hasTransform()){
            container.node = container.node.splitText(text.length);
        }
        return {};
    };
};

NodeParser.prototype.getWrapperBounds = function(node, transform) {
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    var parent = node.parentNode,
        backupText = node.cloneNode(true);

    wrapper.appendChild(node.cloneNode(true));
    parent.replaceChild(wrapper, node);
    var bounds = transform ? offsetBounds(wrapper) : getBounds(wrapper);
    parent.replaceChild(backupText, wrapper);
    return bounds;
};

NodeParser.prototype.getRangeBounds = function(node, offset, length) {
    var range = this.range || (this.range = node.ownerDocument.createRange());
    range.setStart(node, offset);
    range.setEnd(node, offset + length);
    return range.getBoundingClientRect();
};

function ClearTransform() {}

NodeParser.prototype.parse = function(stack) {
    // http://www.w3.org/TR/CSS21/visuren.html#z-index
    var negativeZindex = stack.contexts.filter(negativeZIndex); // 2. the child stacking contexts with negative stack levels (most negative first).
    var descendantElements = stack.children.filter(isElement);
    var descendantNonFloats = descendantElements.filter(not(isFloating));
    var nonInlineNonPositionedDescendants = descendantNonFloats.filter(not(isPositioned)).filter(not(inlineLevel)); // 3 the in-flow, non-inline-level, non-positioned descendants.
    var nonPositionedFloats = descendantElements.filter(not(isPositioned)).filter(isFloating); // 4. the non-positioned floats.
    var inFlow = descendantNonFloats.filter(not(isPositioned)).filter(inlineLevel); // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
    var stackLevel0 = stack.contexts.concat(descendantNonFloats.filter(isPositioned)).filter(zIndex0); // 6. the child stacking contexts with stack level 0 and the positioned descendants with stack level 0.
    var text = stack.children.filter(isTextNode).filter(hasText);
    var positiveZindex = stack.contexts.filter(positiveZIndex); // 7. the child stacking contexts with positive stack levels (least positive first).
    negativeZindex.concat(nonInlineNonPositionedDescendants).concat(nonPositionedFloats)
        .concat(inFlow).concat(stackLevel0).concat(text).concat(positiveZindex).forEach(function(container) {
            this.renderQueue.push(container);
            if (isStackingContext(container)) {
                this.parse(container);
                this.renderQueue.push(new ClearTransform());
            }
        }, this);
};

NodeParser.prototype.paint = function(container) {
    try {
        if (container instanceof ClearTransform) {
            this.renderer.ctx.restore();
        } else if (isTextNode(container)) {
            if (isPseudoElement(container.parent)) {
                container.parent.appendToDOM();
            }
            this.paintText(container);
            if (isPseudoElement(container.parent)) {
                container.parent.cleanDOM();
            }
        } else {
            this.paintNode(container);
        }
    } catch(e) {
        log(e);
        if (this.options.strict) {
            throw e;
        }
    }
};

NodeParser.prototype.paintNode = function(container) {
    if (isStackingContext(container)) {
        this.renderer.setOpacity(container.opacity);
        this.renderer.ctx.save();
        if (container.hasTransform()) {
            this.renderer.setTransform(container.parseTransform());
        }
    }

    if (container.node.nodeName === "INPUT" && container.node.type === "checkbox") {
        this.paintCheckbox(container);
    } else if (container.node.nodeName === "INPUT" && container.node.type === "radio") {
        this.paintRadio(container);
    } else {
        this.paintElement(container);
    }
};

NodeParser.prototype.paintElement = function(container) {
    var bounds = container.parseBounds();
    this.renderer.clip(container.backgroundClip, function() {
        this.renderer.renderBackground(container, bounds, container.borders.borders.map(getWidth));
    }, this);

    this.renderer.clip(container.clip, function() {
        this.renderer.renderBorders(container.borders.borders);
    }, this);

    this.renderer.clip(container.backgroundClip, function() {
        switch (container.node.nodeName) {
        case "svg":
        case "IFRAME":
            var imgContainer = this.images.get(container.node);
            if (imgContainer) {
                this.renderer.renderImage(container, bounds, container.borders, imgContainer);
            } else {
                log("Error loading <" + container.node.nodeName + ">", container.node);
            }
            break;
        case "IMG":
            var imageContainer = this.images.get(container.node.src);
            if (imageContainer) {
                this.renderer.renderImage(container, bounds, container.borders, imageContainer);
            } else {
                log("Error loading <img>", container.node.src);
            }
            break;
        case "CANVAS":
            this.renderer.renderImage(container, bounds, container.borders, {image: container.node});
            break;
        case "SELECT":
        case "INPUT":
        case "TEXTAREA":
            this.paintFormValue(container);
            break;
        }
    }, this);
};

NodeParser.prototype.paintCheckbox = function(container) {
    var b = container.parseBounds();

    var size = Math.min(b.width, b.height);
    var bounds = {width: size - 1, height: size - 1, top: b.top, left: b.left};
    var r = [3, 3];
    var radius = [r, r, r, r];
    var borders = [1,1,1,1].map(function(w) {
        return {color: new Color('#A5A5A5'), width: w};
    });

    var borderPoints = calculateCurvePoints(bounds, radius, borders);

    this.renderer.clip(container.backgroundClip, function() {
        this.renderer.rectangle(bounds.left + 1, bounds.top + 1, bounds.width - 2, bounds.height - 2, new Color("#DEDEDE"));
        this.renderer.renderBorders(calculateBorders(borders, bounds, borderPoints, radius));
        if (container.node.checked) {
            this.renderer.font(new Color('#424242'), 'normal', 'normal', 'bold', (size - 3) + "px", 'arial');
            this.renderer.text("\u2714", bounds.left + size / 6, bounds.top + size - 1);
        }
    }, this);
};

NodeParser.prototype.paintRadio = function(container) {
    var bounds = container.parseBounds();

    var size = Math.min(bounds.width, bounds.height) - 2;

    this.renderer.clip(container.backgroundClip, function() {
        this.renderer.circleStroke(bounds.left + 1, bounds.top + 1, size, new Color('#DEDEDE'), 1, new Color('#A5A5A5'));
        if (container.node.checked) {
            this.renderer.circle(Math.ceil(bounds.left + size / 4) + 1, Math.ceil(bounds.top + size / 4) + 1, Math.floor(size / 2), new Color('#424242'));
        }
    }, this);
};

NodeParser.prototype.paintFormValue = function(container) {
    var value = container.getValue();
    if (value.length > 0) {
        var document = container.node.ownerDocument;
        var wrapper = document.createElement('html2canvaswrapper');
        var properties = ['lineHeight', 'textAlign', 'fontFamily', 'fontWeight', 'fontSize', 'color',
            'paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom',
            'width', 'height', 'borderLeftStyle', 'borderTopStyle', 'borderLeftWidth', 'borderTopWidth',
            'boxSizing', 'whiteSpace', 'wordWrap'];

        properties.forEach(function(property) {
            try {
                wrapper.style[property] = container.css(property);
            } catch(e) {
                // Older IE has issues with "border"
                log("html2canvas: Parse: Exception caught in renderFormValue: " + e.message);
            }
        });
        var bounds = container.parseBounds();
        wrapper.style.position = "fixed";
        wrapper.style.left = bounds.left + "px";
        wrapper.style.top = bounds.top + "px";
        wrapper.textContent = value;
        document.body.appendChild(wrapper);
        this.paintText(new TextContainer(wrapper.firstChild, container));
        document.body.removeChild(wrapper);
    }
};

NodeParser.prototype.paintText = function(container) {
    container.applyTextTransform();
    var characters = punycode.ucs2.decode(container.node.data);
    var textList = (!this.options.letterRendering || noLetterSpacing(container)) && !hasUnicode(container.node.data) ? getWords(characters) : characters.map(function(character) {
        return punycode.ucs2.encode([character]);
    });

    var weight = container.parent.fontWeight();
    var size = container.parent.css('fontSize');
    var family = container.parent.css('fontFamily');
    var shadows = container.parent.parseTextShadows();

    this.renderer.font(container.parent.color('color'), container.parent.css('fontStyle'), container.parent.css('fontVariant'), weight, size, family);
    if (shadows.length) {
        // TODO: support multiple text shadows
        this.renderer.fontShadow(shadows[0].color, shadows[0].offsetX, shadows[0].offsetY, shadows[0].blur);
    } else {
        this.renderer.clearShadow();
    }

    this.renderer.clip(container.parent.clip, function() {
        textList.map(this.parseTextBounds(container), this).forEach(function(bounds, index) {
            if (bounds) {
                this.renderer.text(textList[index], bounds.left, bounds.bottom);
                this.renderTextDecoration(container.parent, bounds, this.fontMetrics.getMetrics(family, size));
            }
        }, this);
    }, this);
};

NodeParser.prototype.renderTextDecoration = function(container, bounds, metrics) {
    switch(container.css("textDecoration").split(" ")[0]) {
    case "underline":
        // Draws a line at the baseline of the font
        // TODO As some browsers display the line as more than 1px if the font-size is big, need to take that into account both in position and size
        this.renderer.rectangle(bounds.left, Math.round(bounds.top + metrics.baseline + metrics.lineWidth), bounds.width, 1, container.color("color"));
        break;
    case "overline":
        this.renderer.rectangle(bounds.left, Math.round(bounds.top), bounds.width, 1, container.color("color"));
        break;
    case "line-through":
        // TODO try and find exact position for line-through
        this.renderer.rectangle(bounds.left, Math.ceil(bounds.top + metrics.middle + metrics.lineWidth), bounds.width, 1, container.color("color"));
        break;
    }
};

var borderColorTransforms = {
    inset: [
        ["darken", 0.60],
        ["darken", 0.10],
        ["darken", 0.10],
        ["darken", 0.60]
    ]
};

NodeParser.prototype.parseBorders = function(container) {
    var nodeBounds = container.parseBounds();
    var radius = getBorderRadiusData(container);
    var borders = ["Top", "Right", "Bottom", "Left"].map(function(side, index) {
        var style = container.css('border' + side + 'Style');
        var color = container.color('border' + side + 'Color');
        if (style === "inset" && color.isBlack()) {
            color = new Color([255, 255, 255, color.a]); // this is wrong, but
        }
        var colorTransform = borderColorTransforms[style] ? borderColorTransforms[style][index] : null;
        return {
            width: container.cssInt('border' + side + 'Width'),
            color: colorTransform ? color[colorTransform[0]](colorTransform[1]) : color,
            args: null
        };
    });
    var borderPoints = calculateCurvePoints(nodeBounds, radius, borders);

    return {
        clip: this.parseBackgroundClip(container, borderPoints, borders, radius, nodeBounds),
        borders: calculateBorders(borders, nodeBounds, borderPoints, radius)
    };
};

function calculateBorders(borders, nodeBounds, borderPoints, radius) {
    return borders.map(function(border, borderSide) {
        if (border.width > 0) {
            var bx = nodeBounds.left;
            var by = nodeBounds.top;
            var bw = nodeBounds.width;
            var bh = nodeBounds.height - (borders[2].width);

            switch(borderSide) {
            case 0:
                // top border
                bh = borders[0].width;
                border.args = drawSide({
                        c1: [bx, by],
                        c2: [bx + bw, by],
                        c3: [bx + bw - borders[1].width, by + bh],
                        c4: [bx + borders[3].width, by + bh]
                    }, radius[0], radius[1],
                    borderPoints.topLeftOuter, borderPoints.topLeftInner, borderPoints.topRightOuter, borderPoints.topRightInner);
                break;
            case 1:
                // right border
                bx = nodeBounds.left + nodeBounds.width - (borders[1].width);
                bw = borders[1].width;

                border.args = drawSide({
                        c1: [bx + bw, by],
                        c2: [bx + bw, by + bh + borders[2].width],
                        c3: [bx, by + bh],
                        c4: [bx, by + borders[0].width]
                    }, radius[1], radius[2],
                    borderPoints.topRightOuter, borderPoints.topRightInner, borderPoints.bottomRightOuter, borderPoints.bottomRightInner);
                break;
            case 2:
                // bottom border
                by = (by + nodeBounds.height) - (borders[2].width);
                bh = borders[2].width;
                border.args = drawSide({
                        c1: [bx + bw, by + bh],
                        c2: [bx, by + bh],
                        c3: [bx + borders[3].width, by],
                        c4: [bx + bw - borders[3].width, by]
                    }, radius[2], radius[3],
                    borderPoints.bottomRightOuter, borderPoints.bottomRightInner, borderPoints.bottomLeftOuter, borderPoints.bottomLeftInner);
                break;
            case 3:
                // left border
                bw = borders[3].width;
                border.args = drawSide({
                        c1: [bx, by + bh + borders[2].width],
                        c2: [bx, by],
                        c3: [bx + bw, by + borders[0].width],
                        c4: [bx + bw, by + bh]
                    }, radius[3], radius[0],
                    borderPoints.bottomLeftOuter, borderPoints.bottomLeftInner, borderPoints.topLeftOuter, borderPoints.topLeftInner);
                break;
            }
        }
        return border;
    });
}

NodeParser.prototype.parseBackgroundClip = function(container, borderPoints, borders, radius, bounds) {
    var backgroundClip = container.css('backgroundClip'),
        borderArgs = [];

    switch(backgroundClip) {
    case "content-box":
    case "padding-box":
        parseCorner(borderArgs, radius[0], radius[1], borderPoints.topLeftInner, borderPoints.topRightInner, bounds.left + borders[3].width, bounds.top + borders[0].width);
        parseCorner(borderArgs, radius[1], radius[2], borderPoints.topRightInner, borderPoints.bottomRightInner, bounds.left + bounds.width - borders[1].width, bounds.top + borders[0].width);
        parseCorner(borderArgs, radius[2], radius[3], borderPoints.bottomRightInner, borderPoints.bottomLeftInner, bounds.left + bounds.width - borders[1].width, bounds.top + bounds.height - borders[2].width);
        parseCorner(borderArgs, radius[3], radius[0], borderPoints.bottomLeftInner, borderPoints.topLeftInner, bounds.left + borders[3].width, bounds.top + bounds.height - borders[2].width);
        break;

    default:
        parseCorner(borderArgs, radius[0], radius[1], borderPoints.topLeftOuter, borderPoints.topRightOuter, bounds.left, bounds.top);
        parseCorner(borderArgs, radius[1], radius[2], borderPoints.topRightOuter, borderPoints.bottomRightOuter, bounds.left + bounds.width, bounds.top);
        parseCorner(borderArgs, radius[2], radius[3], borderPoints.bottomRightOuter, borderPoints.bottomLeftOuter, bounds.left + bounds.width, bounds.top + bounds.height);
        parseCorner(borderArgs, radius[3], radius[0], borderPoints.bottomLeftOuter, borderPoints.topLeftOuter, bounds.left, bounds.top + bounds.height);
        break;
    }

    return borderArgs;
};

function getCurvePoints(x, y, r1, r2) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
    var ox = (r1) * kappa, // control point offset horizontal
        oy = (r2) * kappa, // control point offset vertical
        xm = x + r1, // x-middle
        ym = y + r2; // y-middle
    return {
        topLeft: bezierCurve({x: x, y: ym}, {x: x, y: ym - oy}, {x: xm - ox, y: y}, {x: xm, y: y}),
        topRight: bezierCurve({x: x, y: y}, {x: x + ox,y: y}, {x: xm, y: ym - oy}, {x: xm, y: ym}),
        bottomRight: bezierCurve({x: xm, y: y}, {x: xm, y: y + oy}, {x: x + ox, y: ym}, {x: x, y: ym}),
        bottomLeft: bezierCurve({x: xm, y: ym}, {x: xm - ox, y: ym}, {x: x, y: y + oy}, {x: x, y:y})
    };
}

function calculateCurvePoints(bounds, borderRadius, borders) {
    var x = bounds.left,
        y = bounds.top,
        width = bounds.width,
        height = bounds.height,

        tlh = borderRadius[0][0] < width / 2 ? borderRadius[0][0] : width / 2,
        tlv = borderRadius[0][1] < height / 2 ? borderRadius[0][1] : height / 2,
        trh = borderRadius[1][0] < width / 2 ? borderRadius[1][0] : width / 2,
        trv = borderRadius[1][1] < height / 2 ? borderRadius[1][1] : height / 2,
        brh = borderRadius[2][0] < width / 2 ? borderRadius[2][0] : width / 2,
        brv = borderRadius[2][1] < height / 2 ? borderRadius[2][1] : height / 2,
        blh = borderRadius[3][0] < width / 2 ? borderRadius[3][0] : width / 2,
        blv = borderRadius[3][1] < height / 2 ? borderRadius[3][1] : height / 2;

    var topWidth = width - trh,
        rightHeight = height - brv,
        bottomWidth = width - brh,
        leftHeight = height - blv;

    return {
        topLeftOuter: getCurvePoints(x, y, tlh, tlv).topLeft.subdivide(0.5),
        topLeftInner: getCurvePoints(x + borders[3].width, y + borders[0].width, Math.max(0, tlh - borders[3].width), Math.max(0, tlv - borders[0].width)).topLeft.subdivide(0.5),
        topRightOuter: getCurvePoints(x + topWidth, y, trh, trv).topRight.subdivide(0.5),
        topRightInner: getCurvePoints(x + Math.min(topWidth, width + borders[3].width), y + borders[0].width, (topWidth > width + borders[3].width) ? 0 :trh - borders[3].width, trv - borders[0].width).topRight.subdivide(0.5),
        bottomRightOuter: getCurvePoints(x + bottomWidth, y + rightHeight, brh, brv).bottomRight.subdivide(0.5),
        bottomRightInner: getCurvePoints(x + Math.min(bottomWidth, width - borders[3].width), y + Math.min(rightHeight, height + borders[0].width), Math.max(0, brh - borders[1].width),  brv - borders[2].width).bottomRight.subdivide(0.5),
        bottomLeftOuter: getCurvePoints(x, y + leftHeight, blh, blv).bottomLeft.subdivide(0.5),
        bottomLeftInner: getCurvePoints(x + borders[3].width, y + leftHeight, Math.max(0, blh - borders[3].width), blv - borders[2].width).bottomLeft.subdivide(0.5)
    };
}

function bezierCurve(start, startControl, endControl, end) {
    var lerp = function (a, b, t) {
        return {
            x: a.x + (b.x - a.x) * t,
            y: a.y + (b.y - a.y) * t
        };
    };

    return {
        start: start,
        startControl: startControl,
        endControl: endControl,
        end: end,
        subdivide: function(t) {
            var ab = lerp(start, startControl, t),
                bc = lerp(startControl, endControl, t),
                cd = lerp(endControl, end, t),
                abbc = lerp(ab, bc, t),
                bccd = lerp(bc, cd, t),
                dest = lerp(abbc, bccd, t);
            return [bezierCurve(start, ab, abbc, dest), bezierCurve(dest, bccd, cd, end)];
        },
        curveTo: function(borderArgs) {
            borderArgs.push(["bezierCurve", startControl.x, startControl.y, endControl.x, endControl.y, end.x, end.y]);
        },
        curveToReversed: function(borderArgs) {
            borderArgs.push(["bezierCurve", endControl.x, endControl.y, startControl.x, startControl.y, start.x, start.y]);
        }
    };
}

function drawSide(borderData, radius1, radius2, outer1, inner1, outer2, inner2) {
    var borderArgs = [];

    if (radius1[0] > 0 || radius1[1] > 0) {
        borderArgs.push(["line", outer1[1].start.x, outer1[1].start.y]);
        outer1[1].curveTo(borderArgs);
    } else {
        borderArgs.push([ "line", borderData.c1[0], borderData.c1[1]]);
    }

    if (radius2[0] > 0 || radius2[1] > 0) {
        borderArgs.push(["line", outer2[0].start.x, outer2[0].start.y]);
        outer2[0].curveTo(borderArgs);
        borderArgs.push(["line", inner2[0].end.x, inner2[0].end.y]);
        inner2[0].curveToReversed(borderArgs);
    } else {
        borderArgs.push(["line", borderData.c2[0], borderData.c2[1]]);
        borderArgs.push(["line", borderData.c3[0], borderData.c3[1]]);
    }

    if (radius1[0] > 0 || radius1[1] > 0) {
        borderArgs.push(["line", inner1[1].end.x, inner1[1].end.y]);
        inner1[1].curveToReversed(borderArgs);
    } else {
        borderArgs.push(["line", borderData.c4[0], borderData.c4[1]]);
    }

    return borderArgs;
}

function parseCorner(borderArgs, radius1, radius2, corner1, corner2, x, y) {
    if (radius1[0] > 0 || radius1[1] > 0) {
        borderArgs.push(["line", corner1[0].start.x, corner1[0].start.y]);
        corner1[0].curveTo(borderArgs);
        corner1[1].curveTo(borderArgs);
    } else {
        borderArgs.push(["line", x, y]);
    }

    if (radius2[0] > 0 || radius2[1] > 0) {
        borderArgs.push(["line", corner2[0].start.x, corner2[0].start.y]);
    }
}

function negativeZIndex(container) {
    return container.cssInt("zIndex") < 0;
}

function positiveZIndex(container) {
    return container.cssInt("zIndex") > 0;
}

function zIndex0(container) {
    return container.cssInt("zIndex") === 0;
}

function inlineLevel(container) {
    return ["inline", "inline-block", "inline-table"].indexOf(container.css("display")) !== -1;
}

function isStackingContext(container) {
    return (container instanceof StackingContext);
}

function hasText(container) {
    return container.node.data.trim().length > 0;
}

function noLetterSpacing(container) {
    return (/^(normal|none|0px)$/.test(container.parent.css("letterSpacing")));
}

function getBorderRadiusData(container) {
    return ["TopLeft", "TopRight", "BottomRight", "BottomLeft"].map(function(side) {
        var value = container.css('border' + side + 'Radius');
        var arr = value.split(" ");
        if (arr.length <= 1) {
            arr[1] = arr[0];
        }
        return arr.map(asInt);
    });
}

function renderableNode(node) {
    return (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE);
}

function isPositionedForStacking(container) {
    var position = container.css("position");
    var zIndex = (["absolute", "relative", "fixed"].indexOf(position) !== -1) ? container.css("zIndex") : "auto";
    return zIndex !== "auto";
}

function isPositioned(container) {
    return container.css("position") !== "static";
}

function isFloating(container) {
    return container.css("float") !== "none";
}

function isInlineBlock(container) {
    return ["inline-block", "inline-table"].indexOf(container.css("display")) !== -1;
}

function not(callback) {
    var context = this;
    return function() {
        return !callback.apply(context, arguments);
    };
}

function isElement(container) {
    return container.node.nodeType === Node.ELEMENT_NODE;
}

function isPseudoElement(container) {
    return container.isPseudoElement === true;
}

function isTextNode(container) {
    return container.node.nodeType === Node.TEXT_NODE;
}

function zIndexSort(contexts) {
    return function(a, b) {
        return (a.cssInt("zIndex") + (contexts.indexOf(a) / contexts.length)) - (b.cssInt("zIndex") + (contexts.indexOf(b) / contexts.length));
    };
}

function hasOpacity(container) {
    return container.getOpacity() < 1;
}

function asInt(value) {
    return parseInt(value, 10);
}

function getWidth(border) {
    return border.width;
}

function nonIgnoredElement(nodeContainer) {
    return (nodeContainer.node.nodeType !== Node.ELEMENT_NODE || ["SCRIPT", "HEAD", "TITLE", "OBJECT", "BR", "OPTION"].indexOf(nodeContainer.node.nodeName) === -1);
}

function flatten(arrays) {
    return [].concat.apply([], arrays);
}

function stripQuotes(content) {
    var first = content.substr(0, 1);
    return (first === content.substr(content.length - 1) && first.match(/'|"/)) ? content.substr(1, content.length - 2) : content;
}

function getWords(characters) {
    var words = [], i = 0, onWordBoundary = false, word;
    while(characters.length) {
        if (isWordBoundary(characters[i]) === onWordBoundary) {
            word = characters.splice(0, i);
            if (word.length) {
                words.push(punycode.ucs2.encode(word));
            }
            onWordBoundary =! onWordBoundary;
            i = 0;
        } else {
            i++;
        }

        if (i >= characters.length) {
            word = characters.splice(0, i);
            if (word.length) {
                words.push(punycode.ucs2.encode(word));
            }
        }
    }
    return words;
}

function isWordBoundary(characterCode) {
    return [
        32, // <space>
        13, // \r
        10, // \n
        9, // \t
        45 // -
    ].indexOf(characterCode) !== -1;
}

function hasUnicode(string) {
    return (/[^\u0000-\u00ff]/).test(string);
}

module.exports = NodeParser;

},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,"punycode":1}],16:[function(_dereq_,module,exports){
var XHR = _dereq_('./xhr');
var utils = _dereq_('./utils');
var log = _dereq_('./log');
var createWindowClone = _dereq_('./clone');
var decode64 = utils.decode64;

function Proxy(src, proxyUrl, document) {
    var supportsCORS = ('withCredentials' in new XMLHttpRequest());
    if (!proxyUrl) {
        return Promise.reject("No proxy configured");
    }
    var callback = createCallback(supportsCORS);
    var url = createProxyUrl(proxyUrl, src, callback);

    return supportsCORS ? XHR(url) : (jsonp(document, url, callback).then(function(response) {
        return decode64(response.content);
    }));
}
var proxyCount = 0;

function ProxyURL(src, proxyUrl, document) {
    var supportsCORSImage = ('crossOrigin' in new Image());
    var callback = createCallback(supportsCORSImage);
    var url = createProxyUrl(proxyUrl, src, callback);
    return (supportsCORSImage ? Promise.resolve(url) : jsonp(document, url, callback).then(function(response) {
        return "data:" + response.type + ";base64," + response.content;
    }));
}

function jsonp(document, url, callback) {
    return new Promise(function(resolve, reject) {
        var s = document.createElement("script");
        var cleanup = function() {
            delete window.html2canvas.proxy[callback];
            document.body.removeChild(s);
        };
        window.html2canvas.proxy[callback] = function(response) {
            cleanup();
            resolve(response);
        };
        s.src = url;
        s.onerror = function(e) {
            cleanup();
            reject(e);
        };
        document.body.appendChild(s);
    });
}

function createCallback(useCORS) {
    return !useCORS ? "html2canvas_" + Date.now() + "_" + (++proxyCount) + "_" + Math.round(Math.random() * 100000) : "";
}

function createProxyUrl(proxyUrl, src, callback) {
    return proxyUrl + "?url=" + encodeURIComponent(src) + (callback.length ? "&callback=html2canvas.proxy." + callback : "");
}

function documentFromHTML(src) {
    return function(html) {
        var parser = new DOMParser(), doc;
        try {
            doc = parser.parseFromString(html, "text/html");
        } catch(e) {
            log("DOMParser not supported, falling back to createHTMLDocument");
            doc = document.implementation.createHTMLDocument("");
            try {
                doc.open();
                doc.write(html);
                doc.close();
            } catch(ee) {
                log("createHTMLDocument write not supported, falling back to document.body.innerHTML");
                doc.body.innerHTML = html; // ie9 doesnt support writing to documentElement
            }
        }

        var b = doc.querySelector("base");
        if (!b || !b.href.host) {
            var base = doc.createElement("base");
            base.href = src;
            doc.head.insertBefore(base, doc.head.firstChild);
        }

        return doc;
    };
}

function loadUrlDocument(src, proxy, document, width, height, options) {
    return new Proxy(src, proxy, window.document).then(documentFromHTML(src)).then(function(doc) {
        return createWindowClone(doc, document, width, height, options, 0, 0);
    });
}

exports.Proxy = Proxy;
exports.ProxyURL = ProxyURL;
exports.loadUrlDocument = loadUrlDocument;

},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(_dereq_,module,exports){
var ProxyURL = _dereq_('./proxy').ProxyURL;

function ProxyImageContainer(src, proxy) {
    var link = document.createElement("a");
    link.href = src;
    src = link.href;
    this.src = src;
    this.image = new Image();
    var self = this;
    this.promise = new Promise(function(resolve, reject) {
        self.image.crossOrigin = "Anonymous";
        self.image.onload = resolve;
        self.image.onerror = reject;

        new ProxyURL(src, proxy, document).then(function(url) {
            self.image.src = url;
        })['catch'](reject);
    });
}

module.exports = ProxyImageContainer;

},{"./proxy":16}],18:[function(_dereq_,module,exports){
var NodeContainer = _dereq_('./nodecontainer');

function PseudoElementContainer(node, parent, type) {
    NodeContainer.call(this, node, parent);
    this.isPseudoElement = true;
    this.before = type === ":before";
}

PseudoElementContainer.prototype.cloneTo = function(stack) {
    PseudoElementContainer.prototype.cloneTo.call(this, stack);
    stack.isPseudoElement = true;
    stack.before = this.before;
};

PseudoElementContainer.prototype = Object.create(NodeContainer.prototype);

PseudoElementContainer.prototype.appendToDOM = function() {
    if (this.before) {
        this.parent.node.insertBefore(this.node, this.parent.node.firstChild);
    } else {
        this.parent.node.appendChild(this.node);
    }
    this.parent.node.className += " " + this.getHideClass();
};

PseudoElementContainer.prototype.cleanDOM = function() {
    this.node.parentNode.removeChild(this.node);
    this.parent.node.className = this.parent.node.className.replace(this.getHideClass(), "");
};

PseudoElementContainer.prototype.getHideClass = function() {
    return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before ? "BEFORE" : "AFTER")];
};

PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";

module.exports = PseudoElementContainer;

},{"./nodecontainer":14}],19:[function(_dereq_,module,exports){
var log = _dereq_('./log');

function Renderer(width, height, images, options, document) {
    this.width = width;
    this.height = height;
    this.images = images;
    this.options = options;
    this.document = document;
}

Renderer.prototype.renderImage = function(container, bounds, borderData, imageContainer) {
    var paddingLeft = container.cssInt('paddingLeft'),
        paddingTop = container.cssInt('paddingTop'),
        paddingRight = container.cssInt('paddingRight'),
        paddingBottom = container.cssInt('paddingBottom'),
        borders = borderData.borders;

    var width = bounds.width - (borders[1].width + borders[3].width + paddingLeft + paddingRight);
    var height = bounds.height - (borders[0].width + borders[2].width + paddingTop + paddingBottom);
    this.drawImage(
        imageContainer,
        0,
        0,
        imageContainer.image.width || width,
        imageContainer.image.height || height,
        bounds.left + paddingLeft + borders[3].width,
        bounds.top + paddingTop + borders[0].width,
        width,
        height
    );
};

Renderer.prototype.renderBackground = function(container, bounds, borderData) {
    if (bounds.height > 0 && bounds.width > 0) {
        this.renderBackgroundColor(container, bounds);
        this.renderBackgroundImage(container, bounds, borderData);
    }
};

Renderer.prototype.renderBackgroundColor = function(container, bounds) {
    var color = container.color("backgroundColor");
    if (!color.isTransparent()) {
        this.rectangle(bounds.left, bounds.top, bounds.width, bounds.height, color);
    }
};

Renderer.prototype.renderBorders = function(borders) {
    borders.forEach(this.renderBorder, this);
};

Renderer.prototype.renderBorder = function(data) {
    if (!data.color.isTransparent() && data.args !== null) {
        this.drawShape(data.args, data.color);
    }
};

Renderer.prototype.renderBackgroundImage = function(container, bounds, borderData) {
    var backgroundImages = container.parseBackgroundImages();
    backgroundImages.reverse().forEach(function(backgroundImage, index, arr) {
        switch(backgroundImage.method) {
        case "url":
            var image = this.images.get(backgroundImage.args[0]);
            if (image) {
                this.renderBackgroundRepeating(container, bounds, image, arr.length - (index+1), borderData);
            } else {
                log("Error loading background-image", backgroundImage.args[0]);
            }
            break;
        case "linear-gradient":
        case "gradient":
            var gradientImage = this.images.get(backgroundImage.value);
            if (gradientImage) {
                this.renderBackgroundGradient(gradientImage, bounds, borderData);
            } else {
                log("Error loading background-image", backgroundImage.args[0]);
            }
            break;
        case "none":
            break;
        default:
            log("Unknown background-image type", backgroundImage.args[0]);
        }
    }, this);
};

Renderer.prototype.renderBackgroundRepeating = function(container, bounds, imageContainer, index, borderData) {
    var size = container.parseBackgroundSize(bounds, imageContainer.image, index);
    var position = container.parseBackgroundPosition(bounds, imageContainer.image, index, size);
    var repeat = container.parseBackgroundRepeat(index);
    switch (repeat) {
    case "repeat-x":
    case "repeat no-repeat":
        this.backgroundRepeatShape(imageContainer, position, size, bounds, bounds.left + borderData[3], bounds.top + position.top + borderData[0], 99999, size.height, borderData);
        break;
    case "repeat-y":
    case "no-repeat repeat":
        this.backgroundRepeatShape(imageContainer, position, size, bounds, bounds.left + position.left + borderData[3], bounds.top + borderData[0], size.width, 99999, borderData);
        break;
    case "no-repeat":
        this.backgroundRepeatShape(imageContainer, position, size, bounds, bounds.left + position.left + borderData[3], bounds.top + position.top + borderData[0], size.width, size.height, borderData);
        break;
    default:
        this.renderBackgroundRepeat(imageContainer, position, size, {top: bounds.top, left: bounds.left}, borderData[3], borderData[0]);
        break;
    }
};

module.exports = Renderer;

},{"./log":13}],20:[function(_dereq_,module,exports){
var Renderer = _dereq_('../renderer');
var LinearGradientContainer = _dereq_('../lineargradientcontainer');
var log = _dereq_('../log');

function CanvasRenderer(width, height) {
    Renderer.apply(this, arguments);
    this.canvas = this.options.canvas || this.document.createElement("canvas");
    if (!this.options.canvas) {
        this.canvas.width = width;
        this.canvas.height = height;
    }
    this.ctx = this.canvas.getContext("2d");
    this.taintCtx = this.document.createElement("canvas").getContext("2d");
    this.ctx.textBaseline = "bottom";
    this.variables = {};
    log("Initialized CanvasRenderer with size", width, "x", height);
}

CanvasRenderer.prototype = Object.create(Renderer.prototype);

CanvasRenderer.prototype.setFillStyle = function(fillStyle) {
    this.ctx.fillStyle = typeof(fillStyle) === "object" && !!fillStyle.isColor ? fillStyle.toString() : fillStyle;
    return this.ctx;
};

CanvasRenderer.prototype.rectangle = function(left, top, width, height, color) {
    this.setFillStyle(color).fillRect(left, top, width, height);
};

CanvasRenderer.prototype.circle = function(left, top, size, color) {
    this.setFillStyle(color);
    this.ctx.beginPath();
    this.ctx.arc(left + size / 2, top + size / 2, size / 2, 0, Math.PI*2, true);
    this.ctx.closePath();
    this.ctx.fill();
};

CanvasRenderer.prototype.circleStroke = function(left, top, size, color, stroke, strokeColor) {
    this.circle(left, top, size, color);
    this.ctx.strokeStyle = strokeColor.toString();
    this.ctx.stroke();
};

CanvasRenderer.prototype.drawShape = function(shape, color) {
    this.shape(shape);
    this.setFillStyle(color).fill();
};

CanvasRenderer.prototype.taints = function(imageContainer) {
    if (imageContainer.tainted === null) {
        this.taintCtx.drawImage(imageContainer.image, 0, 0);
        try {
            this.taintCtx.getImageData(0, 0, 1, 1);
            imageContainer.tainted = false;
        } catch(e) {
            this.taintCtx = document.createElement("canvas").getContext("2d");
            imageContainer.tainted = true;
        }
    }

    return imageContainer.tainted;
};

CanvasRenderer.prototype.drawImage = function(imageContainer, sx, sy, sw, sh, dx, dy, dw, dh) {
    if (!this.taints(imageContainer) || this.options.allowTaint) {
        this.ctx.drawImage(imageContainer.image, sx, sy, sw, sh, dx, dy, dw, dh);
    }
};

CanvasRenderer.prototype.clip = function(shapes, callback, context) {
    this.ctx.save();
    shapes.filter(hasEntries).forEach(function(shape) {
        this.shape(shape).clip();
    }, this);
    callback.call(context);
    this.ctx.restore();
};

CanvasRenderer.prototype.shape = function(shape) {
    this.ctx.beginPath();
    shape.forEach(function(point, index) {
        if (point[0] === "rect") {
            this.ctx.rect.apply(this.ctx, point.slice(1));
        } else {
            this.ctx[(index === 0) ? "moveTo" : point[0] + "To" ].apply(this.ctx, point.slice(1));
        }
    }, this);
    this.ctx.closePath();
    return this.ctx;
};

CanvasRenderer.prototype.font = function(color, style, variant, weight, size, family) {
    this.setFillStyle(color).font = [style, variant, weight, size, family].join(" ").split(",")[0];
};

CanvasRenderer.prototype.fontShadow = function(color, offsetX, offsetY, blur) {
    this.setVariable("shadowColor", color.toString())
        .setVariable("shadowOffsetY", offsetX)
        .setVariable("shadowOffsetX", offsetY)
        .setVariable("shadowBlur", blur);
};

CanvasRenderer.prototype.clearShadow = function() {
    this.setVariable("shadowColor", "rgba(0,0,0,0)");
};

CanvasRenderer.prototype.setOpacity = function(opacity) {
    this.ctx.globalAlpha = opacity;
};

CanvasRenderer.prototype.setTransform = function(transform) {
    this.ctx.translate(transform.origin[0], transform.origin[1]);
    this.ctx.transform.apply(this.ctx, transform.matrix);
    this.ctx.translate(-transform.origin[0], -transform.origin[1]);
};

CanvasRenderer.prototype.setVariable = function(property, value) {
    if (this.variables[property] !== value) {
        this.variables[property] = this.ctx[property] = value;
    }

    return this;
};

CanvasRenderer.prototype.text = function(text, left, bottom) {
    this.ctx.fillText(text, left, bottom);
};

CanvasRenderer.prototype.backgroundRepeatShape = function(imageContainer, backgroundPosition, size, bounds, left, top, width, height, borderData) {
    var shape = [
        ["line", Math.round(left), Math.round(top)],
        ["line", Math.round(left + width), Math.round(top)],
        ["line", Math.round(left + width), Math.round(height + top)],
        ["line", Math.round(left), Math.round(height + top)]
    ];
    this.clip([shape], function() {
        this.renderBackgroundRepeat(imageContainer, backgroundPosition, size, bounds, borderData[3], borderData[0]);
    }, this);
};

CanvasRenderer.prototype.renderBackgroundRepeat = function(imageContainer, backgroundPosition, size, bounds, borderLeft, borderTop) {
    var offsetX = Math.round(bounds.left + backgroundPosition.left + borderLeft), offsetY = Math.round(bounds.top + backgroundPosition.top + borderTop);
    this.setFillStyle(this.ctx.createPattern(this.resizeImage(imageContainer, size), "repeat"));
    this.ctx.translate(offsetX, offsetY);
    this.ctx.fill();
    this.ctx.translate(-offsetX, -offsetY);
};

CanvasRenderer.prototype.renderBackgroundGradient = function(gradientImage, bounds) {
    if (gradientImage instanceof LinearGradientContainer) {
        var gradient = this.ctx.createLinearGradient(
            bounds.left + bounds.width * gradientImage.x0,
            bounds.top + bounds.height * gradientImage.y0,
            bounds.left +  bounds.width * gradientImage.x1,
            bounds.top +  bounds.height * gradientImage.y1);
        gradientImage.colorStops.forEach(function(colorStop) {
            gradient.addColorStop(colorStop.stop, colorStop.color.toString());
        });
        this.rectangle(bounds.left, bounds.top, bounds.width, bounds.height, gradient);
    }
};

CanvasRenderer.prototype.resizeImage = function(imageContainer, size) {
    var image = imageContainer.image;
    if(image.width === size.width && image.height === size.height) {
        return image;
    }

    var ctx, canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height );
    return canvas;
};

function hasEntries(array) {
    return array.length > 0;
}

module.exports = CanvasRenderer;

},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(_dereq_,module,exports){
var NodeContainer = _dereq_('./nodecontainer');

function StackingContext(hasOwnStacking, opacity, element, parent) {
    NodeContainer.call(this, element, parent);
    this.ownStacking = hasOwnStacking;
    this.contexts = [];
    this.children = [];
    this.opacity = (this.parent ? this.parent.stack.opacity : 1) * opacity;
}

StackingContext.prototype = Object.create(NodeContainer.prototype);

StackingContext.prototype.getParentStack = function(context) {
    var parentStack = (this.parent) ? this.parent.stack : null;
    return parentStack ? (parentStack.ownStacking ? parentStack : parentStack.getParentStack(context)) : context.stack;
};

module.exports = StackingContext;

},{"./nodecontainer":14}],22:[function(_dereq_,module,exports){
function Support(document) {
    this.rangeBounds = this.testRangeBounds(document);
    this.cors = this.testCORS();
    this.svg = this.testSVG();
}

Support.prototype.testRangeBounds = function(document) {
    var range, testElement, rangeBounds, rangeHeight, support = false;

    if (document.createRange) {
        range = document.createRange();
        if (range.getBoundingClientRect) {
            testElement = document.createElement('boundtest');
            testElement.style.height = "123px";
            testElement.style.display = "block";
            document.body.appendChild(testElement);

            range.selectNode(testElement);
            rangeBounds = range.getBoundingClientRect();
            rangeHeight = rangeBounds.height;

            if (rangeHeight === 123) {
                support = true;
            }
            document.body.removeChild(testElement);
        }
    }

    return support;
};

Support.prototype.testCORS = function() {
    return typeof((new Image()).crossOrigin) !== "undefined";
};

Support.prototype.testSVG = function() {
    var img = new Image();
    var canvas = document.createElement("canvas");
    var ctx =  canvas.getContext("2d");
    img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";

    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch(e) {
        return false;
    }
    return true;
};

module.exports = Support;

},{}],23:[function(_dereq_,module,exports){
var XHR = _dereq_('./xhr');
var decode64 = _dereq_('./utils').decode64;

function SVGContainer(src) {
    this.src = src;
    this.image = null;
    var self = this;

    this.promise = this.hasFabric().then(function() {
        return (self.isInline(src) ? Promise.resolve(self.inlineFormatting(src)) : XHR(src));
    }).then(function(svg) {
        return new Promise(function(resolve) {
            window.html2canvas.svg.fabric.loadSVGFromString(svg, self.createCanvas.call(self, resolve));
        });
    });
}

SVGContainer.prototype.hasFabric = function() {
    return !window.html2canvas.svg || !window.html2canvas.svg.fabric ? Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg")) : Promise.resolve();
};

SVGContainer.prototype.inlineFormatting = function(src) {
    return (/^data:image\/svg\+xml;base64,/.test(src)) ? this.decode64(this.removeContentType(src)) : this.removeContentType(src);
};

SVGContainer.prototype.removeContentType = function(src) {
    return src.replace(/^data:image\/svg\+xml(;base64)?,/,'');
};

SVGContainer.prototype.isInline = function(src) {
    return (/^data:image\/svg\+xml/i.test(src));
};

SVGContainer.prototype.createCanvas = function(resolve) {
    var self = this;
    return function (objects, options) {
        var canvas = new window.html2canvas.svg.fabric.StaticCanvas('c');
        self.image = canvas.lowerCanvasEl;
        canvas
            .setWidth(options.width)
            .setHeight(options.height)
            .add(window.html2canvas.svg.fabric.util.groupSVGElements(objects, options))
            .renderAll();
        resolve(canvas.lowerCanvasEl);
    };
};

SVGContainer.prototype.decode64 = function(str) {
    return (typeof(window.atob) === "function") ? window.atob(str) : decode64(str);
};

module.exports = SVGContainer;

},{"./utils":26,"./xhr":28}],24:[function(_dereq_,module,exports){
var SVGContainer = _dereq_('./svgcontainer');

function SVGNodeContainer(node, _native) {
    this.src = node;
    this.image = null;
    var self = this;

    this.promise = _native ? new Promise(function(resolve, reject) {
        self.image = new Image();
        self.image.onload = resolve;
        self.image.onerror = reject;
        self.image.src = "data:image/svg+xml," + (new XMLSerializer()).serializeToString(node);
        if (self.image.complete === true) {
            resolve(self.image);
        }
    }) : this.hasFabric().then(function() {
        return new Promise(function(resolve) {
            window.html2canvas.svg.fabric.parseSVGDocument(node, self.createCanvas.call(self, resolve));
        });
    });
}

SVGNodeContainer.prototype = Object.create(SVGContainer.prototype);

module.exports = SVGNodeContainer;

},{"./svgcontainer":23}],25:[function(_dereq_,module,exports){
var NodeContainer = _dereq_('./nodecontainer');

function TextContainer(node, parent) {
    NodeContainer.call(this, node, parent);
}

TextContainer.prototype = Object.create(NodeContainer.prototype);

TextContainer.prototype.applyTextTransform = function() {
    this.node.data = this.transform(this.parent.css("textTransform"));
};

TextContainer.prototype.transform = function(transform) {
    var text = this.node.data;
    switch(transform){
        case "lowercase":
            return text.toLowerCase();
        case "capitalize":
            return text.replace(/(^|\s|:|-|\(|\))([a-z])/g, capitalize);
        case "uppercase":
            return text.toUpperCase();
        default:
            return text;
    }
};

function capitalize(m, p1, p2) {
    if (m.length > 0) {
        return p1 + p2.toUpperCase();
    }
}

module.exports = TextContainer;

},{"./nodecontainer":14}],26:[function(_dereq_,module,exports){
exports.smallImage = function smallImage() {
    return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
};

exports.bind = function(callback, context) {
    return function() {
        return callback.apply(context, arguments);
    };
};

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

exports.decode64 = function(base64) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var len = base64.length, i, encoded1, encoded2, encoded3, encoded4, byte1, byte2, byte3;

    var output = "";

    for (i = 0; i < len; i+=4) {
        encoded1 = chars.indexOf(base64[i]);
        encoded2 = chars.indexOf(base64[i+1]);
        encoded3 = chars.indexOf(base64[i+2]);
        encoded4 = chars.indexOf(base64[i+3]);

        byte1 = (encoded1 << 2) | (encoded2 >> 4);
        byte2 = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        byte3 = ((encoded3 & 3) << 6) | encoded4;
        if (encoded3 === 64) {
            output += String.fromCharCode(byte1);
        } else if (encoded4 === 64 || encoded4 === -1) {
            output += String.fromCharCode(byte1, byte2);
        } else{
            output += String.fromCharCode(byte1, byte2, byte3);
        }
    }

    return output;
};

exports.getBounds = function(node) {
    if (node.getBoundingClientRect) {
        var clientRect = node.getBoundingClientRect();
        var width = node.offsetWidth == null ? clientRect.width : node.offsetWidth;
        return {
            top: clientRect.top,
            bottom: clientRect.bottom || (clientRect.top + clientRect.height),
            right: clientRect.left + width,
            left: clientRect.left,
            width:  width,
            height: node.offsetHeight == null ? clientRect.height : node.offsetHeight
        };
    }
    return {};
};

exports.offsetBounds = function(node) {
    var parent = node.offsetParent ? exports.offsetBounds(node.offsetParent) : {top: 0, left: 0};

    return {
        top: node.offsetTop + parent.top,
        bottom: node.offsetTop + node.offsetHeight + parent.top,
        right: node.offsetLeft + parent.left + node.offsetWidth,
        left: node.offsetLeft + parent.left,
        width: node.offsetWidth,
        height: node.offsetHeight
    };
};

exports.parseBackgrounds = function(backgroundImage) {
    var whitespace = ' \r\n\t',
        method, definition, prefix, prefix_i, block, results = [],
        mode = 0, numParen = 0, quote, args;
    var appendResult = function() {
        if(method) {
            if (definition.substr(0, 1) === '"') {
                definition = definition.substr(1, definition.length - 2);
            }
            if (definition) {
                args.push(definition);
            }
            if (method.substr(0, 1) === '-' && (prefix_i = method.indexOf('-', 1 ) + 1) > 0) {
                prefix = method.substr(0, prefix_i);
                method = method.substr(prefix_i);
            }
            results.push({
                prefix: prefix,
                method: method.toLowerCase(),
                value: block,
                args: args,
                image: null
            });
        }
        args = [];
        method = prefix = definition = block = '';
    };
    args = [];
    method = prefix = definition = block = '';
    backgroundImage.split("").forEach(function(c) {
        if (mode === 0 && whitespace.indexOf(c) > -1) {
            return;
        }
        switch(c) {
        case '"':
            if(!quote) {
                quote = c;
            } else if(quote === c) {
                quote = null;
            }
            break;
        case '(':
            if(quote) {
                break;
            } else if(mode === 0) {
                mode = 1;
                block += c;
                return;
            } else {
                numParen++;
            }
            break;
        case ')':
            if (quote) {
                break;
            } else if(mode === 1) {
                if(numParen === 0) {
                    mode = 0;
                    block += c;
                    appendResult();
                    return;
                } else {
                    numParen--;
                }
            }
            break;

        case ',':
            if (quote) {
                break;
            } else if(mode === 0) {
                appendResult();
                return;
            } else if (mode === 1) {
                if (numParen === 0 && !method.match(/^url$/i)) {
                    args.push(definition);
                    definition = '';
                    block += c;
                    return;
                }
            }
            break;
        }

        block += c;
        if (mode === 0) {
            method += c;
        } else {
            definition += c;
        }
    });

    appendResult();
    return results;
};

},{}],27:[function(_dereq_,module,exports){
var GradientContainer = _dereq_('./gradientcontainer');

function WebkitGradientContainer(imageData) {
    GradientContainer.apply(this, arguments);
    this.type = imageData.args[0] === "linear" ? GradientContainer.TYPES.LINEAR : GradientContainer.TYPES.RADIAL;
}

WebkitGradientContainer.prototype = Object.create(GradientContainer.prototype);

module.exports = WebkitGradientContainer;

},{"./gradientcontainer":9}],28:[function(_dereq_,module,exports){
function XHR(url) {
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);

        xhr.onload = function() {
            if (xhr.status === 200) {
                resolve(xhr.responseText);
            } else {
                reject(new Error(xhr.statusText));
            }
        };

        xhr.onerror = function() {
            reject(new Error("Network Error"));
        };

        xhr.send();
    });
}

module.exports = XHR;

},{}]},{},[4])(4)
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loved":"_2nUN5"};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

var _itemActions = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Share = function (_React$Component) {
  (0, _inherits3.default)(Share, _React$Component);

  function Share(props) {
    (0, _classCallCheck3.default)(this, Share);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Share.__proto__ || (0, _getPrototypeOf2.default)(Share)).call(this, props));

    _this.handleShareArrowNavigation = _this.handleShareArrowNavigation.bind(_this);
    _this.getShareArr = _this.getShareArr.bind(_this);
    _this.buttons = [];
    _this.shareArr = _this.getShareArr(_this.props.type);
    _this.state = {
      showShare: false,
      focusedShareIcon: 0
    };

    return _this;
  }

  (0, _createClass3.default)(Share, [{
    key: 'getShareArr',
    value: function getShareArr(type) {
      return type === 'text' ? ['facebook', 'twitter', 'tumblr', 'email'] : ['facebook', 'twitter', 'pinterest', 'tumblr', 'email'];
    }
  }, {
    key: 'handleShareArrowNavigation',
    value: function handleShareArrowNavigation(e) {
      if (this.state.showShare) {
        switch (e.keyCode || e.charCode) {
          case 38: //up
          case 37: //left
          case 33:
            //page up
            e.preventDefault();
            e.stopPropagation();
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
            });
            return false;
          case 39: //right
          case 40: //down
          case 34:
            //page down
            e.preventDefault();
            e.stopPropagation();
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              focusedShareIcon: Math.min(5, this.state.focusedShareIcon + 1)
            });
            return false;
          case 9: //tab
          case 27:
            //esc
            e.preventDefault();
            e.stopPropagation();
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              showShare: false,
              focusedShareIcon: 0
            });
            return false;

        }
      }

      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          e.stopPropagation();
          if (this.state.showShare) {
            _itemActions.itemActions.share(this.shareArr[this.state.focusedShareIcon - 1], this.props, 'gallery');
            this.props.actions.toggleShare(e, false);
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              showShare: false,
              focusedShareIcon: 0
            });
          } else {
            this.props.actions.toggleShare(e, true);
            _index2.default.setStateAndLog(this, 'Share Keypress', {
              showShare: true,
              focusedShareIcon: 1
            });
          }

          return false;
      }

      return true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      try {
        var focusedButton = this.state.focusedShareIcon;
        if (focusedButton > 0) {
          this.buttons[focusedButton - 1].focus();
        }
      } catch (e) {
        console.warn('Cannot focus on share icon', this.props.focus, e);
      }
    }
  }, {
    key: 'getShareItem',
    value: function getShareItem(network, idx) {
      var _this2 = this;

      var allProps = this.props.allProps;

      var shareIconsNumber = this.shareArr.length;
      return _react2.default.createElement('button', {
        className: 'block-fullscreen network-' + (idx + 1) + ' progallery-svg-font-icons-' + network + (_index2.default.isSite() ? '' : ' inactive '),
        style: {
          top: this.props.isVerticalContainer ? 'calc(100% / 6 * ' + (idx + 1) + ' + -10px ' + (shareIconsNumber === 4 ? '+ 100% / 12' : '') + ')' : '',
          left: this.props.isVerticalContainer ? '' : 'calc(100% / 6 * ' + (idx + 1) + ' + -10px ' + (shareIconsNumber === 4 ? '+ 100% / 12' : '') + ')'
        },
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          _itemActions.itemActions.share(network, allProps, 'gallery');
        },
        'data-hook': network + '-share-button',
        ref: function ref(button) {
          return _this2.buttons[idx] = button;
        },
        title: 'Share on ' + network,
        'aria-label': 'Share on ' + network + ', ' + (idx + 1) + ' of ' + this.shareArr.length,
        'aria-live': 'assertive',
        role: 'button',
        tabIndex: -1,
        key: network + '-share-icon' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          styleParams = _props.styleParams,
          type = _props.type,
          id = _props.id,
          isVerticalContainer = _props.isVerticalContainer,
          actions = _props.actions,
          style = _props.style;

      var share = false;
      if (styleParams.allowSocial) {
        var minDimension = 200;
        return _react2.default.createElement(
          'div',
          {
            'data-hook': 'social-share-box',
            className: 'block-fullscreen gallery-item-social-share-box ' + (this.props.showShare ? '' : ' hidden ') + (this.state.showShare ? ' hovered ' : '') + (isVerticalContainer ? ' vertical-item ' : ''),
            onClick: function onClick(e) {
              return actions.toggleShare(e, false);
            },
            onMouseOut: function onMouseOut(e) {
              return actions.toggleShare(e, false);
            },
            style: {
              transform: isVerticalContainer ? 'translateY(-50%) ' + (style.height > minDimension ? '' : 'scale(' + style.height / minDimension + ')') : 'translateX(-50%) ' + (style.width > minDimension ? '' : 'scale(' + style.width / minDimension + ')')
            },
            tabIndex: this.props.currentIdx === this.props.idx ? _index2.default.getTabIndex('slideshowShare') : -1,
            onKeyDown: this.handleShareArrowNavigation,
            'aria-label': 'Share',
            role: 'button',
            key: 'item-social-share-container-' + id
          },
          _lodash2.default.map(this.shareArr, function (network, i) {
            return _this3.getShareItem(network, i);
          })
        );
      }
      return false;
    }
  }]);
  return Share;
}(_react2.default.Component);

exports.default = Share;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = create;

var _loggerBuilder = __webpack_require__(271);

var _loggerBuilder2 = _interopRequireDefault(_loggerBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a logger instance, initialized with application name.
 *
 * @param {String} appName application name (will be used as an application identifier in the monitoring tool, e.g. Grafana)
 * @param {Boolean} isWidgetLogger
 */
function create(appName) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$appId = _ref.appId,
        appId = _ref$appId === undefined ? null : _ref$appId,
        _ref$isWidgetLogger = _ref.isWidgetLogger,
        isWidgetLogger = _ref$isWidgetLogger === undefined ? false : _ref$isWidgetLogger,
        _ref$errorHandlerTogg = _ref.errorHandlerToggle,
        errorHandlerToggle = _ref$errorHandlerTogg === undefined ? false : _ref$errorHandlerTogg,
        _ref$disableAutoLoadF = _ref.disableAutoLoadFinish,
        disableAutoLoadFinish = _ref$disableAutoLoadF === undefined ? false : _ref$disableAutoLoadF,
        _ref$swallowException = _ref.swallowExceptions,
        swallowExceptions = _ref$swallowException === undefined ? false : _ref$swallowException,
        _ref$interactionTimeo = _ref.interactionTimeout,
        interactionTimeout = _ref$interactionTimeo === undefined ? null : _ref$interactionTimeo,
        _ref$timeoutHook = _ref.timeoutHook,
        timeoutHook = _ref$timeoutHook === undefined ? null : _ref$timeoutHook,
        _ref$startHook = _ref.startHook,
        startHook = _ref$startHook === undefined ? null : _ref$startHook,
        _ref$endHook = _ref.endHook,
        endHook = _ref$endHook === undefined ? null : _ref$endHook,
        _ref$networkAnalysis = _ref.networkAnalysis,
        networkAnalysis = _ref$networkAnalysis === undefined ? false : _ref$networkAnalysis;

    var appVersion = typeof window !== 'undefined' ? "1.0.0-SNAPSHOT" : null;

    return new _loggerBuilder2.default().setAppName(appName).setAppVersion(appVersion).setBaseUrl(baseUrl).setAppId(appId).setErrorHandlerToggle(errorHandlerToggle).setSwallowExceptions(swallowExceptions).setWidgetLogger(isWidgetLogger).setInteractionTimeout(interactionTimeout).setTimeoutHook(timeoutHook).setStartHook(startHook).setEndHook(endHook).setDisableAutoLoadFinish(disableAutoLoadFinish).setNetworkAnalysis(networkAnalysis).build();
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setFactory = setFactory;

var _tools = __webpack_require__(121);

var _tools2 = _interopRequireDefault(_tools);

var _storage = __webpack_require__(272);

var _storage2 = _interopRequireDefault(_storage);

var _reporter = __webpack_require__(273);

var _reporter2 = _interopRequireDefault(_reporter);

var _loggerInstance = __webpack_require__(275);

var _loggerInstance2 = _interopRequireDefault(_loggerInstance);

var _widgetLoggerInstance = __webpack_require__(282);

var _widgetLoggerInstance2 = _interopRequireDefault(_widgetLoggerInstance);

var _errorHandler = __webpack_require__(284);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _conf = __webpack_require__(285);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getSessionId() {
  var res = typeof window !== 'undefined' && window.fedops && window.fedops.sessionId;
  res = res || _storage2.default.getItem(_conf.SESSION_ID_STORAGE_KEY);
  res = res || _tools2.default.generateGuid();

  _storage2.default.setItem(_conf.SESSION_ID_STORAGE_KEY, res);

  return res;
}

var ReporterFactory = _reporter2.default; // good for tests

function setFactory(factory) {
  ReporterFactory = factory;
}
/**
 * Builds a logger instance.
 */

var LoggerBuilder = function () {
  function LoggerBuilder() {
    _classCallCheck(this, LoggerBuilder);
  }

  _createClass(LoggerBuilder, [{
    key: 'setAppName',
    value: function setAppName(name) {
      this.appName = name;
      return this;
    }
  }, {
    key: 'setAppVersion',
    value: function setAppVersion(version) {
      this.appVersion = version;
      return this;
    }
  }, {
    key: 'setErrorHandlerToggle',
    value: function setErrorHandlerToggle(toggle) {
      this.errorHandlerToggle = toggle;
      return this;
    }
  }, {
    key: 'setSwallowExceptions',
    value: function setSwallowExceptions(swallow) {
      this.swallowExceptions = swallow;
      return this;
    }
  }, {
    key: 'setAppId',
    value: function setAppId(appId) {
      this.appId = appId;
      return this;
    }
  }, {
    key: 'setBaseUrl',
    value: function setBaseUrl(url) {
      this.baseUrl = url;
      return this;
    }
  }, {
    key: 'setWidgetLogger',
    value: function setWidgetLogger(isWidgetLogger) {
      this.isWidgetLogger = isWidgetLogger;
      return this;
    }
  }, {
    key: 'setInteractionTimeout',
    value: function setInteractionTimeout(interactionTimeout) {
      this.interactionTimeout = interactionTimeout;
      return this;
    }
  }, {
    key: 'setTimeoutHook',
    value: function setTimeoutHook(timeoutHook) {
      this.timeoutHook = timeoutHook;
      return this;
    }
  }, {
    key: 'setStartHook',
    value: function setStartHook(startHook) {
      this.startHook = startHook;
      return this;
    }
  }, {
    key: 'setEndHook',
    value: function setEndHook(endHook) {
      this.endHook = endHook;
      return this;
    }
  }, {
    key: 'setDisableAutoLoadFinish',
    value: function setDisableAutoLoadFinish(disableAutoLoadFinish) {
      this.disableAutoLoadFinish = disableAutoLoadFinish;
      return this;
    }
  }, {
    key: 'setNetworkAnalysis',
    value: function setNetworkAnalysis() {
      // TODO - remove this API once no usage across wix
      return this;
    }
  }, {
    key: 'build',
    value: function build() {
      if (!this.appName) {
        return null;
      }

      if (!this.appVersion) {
        this.appVersion = _conf.DEFAULT_APP_VERSION;
      }

      var reporter = new ReporterFactory(this.baseUrl || _conf.BI_BASE_URL);
      var errorHandlerToggle = this.errorHandlerToggle;
      var swallowExceptions = this.swallowExceptions;
      var interactionTimeout = this.interactionTimeout;
      var timeoutHook = this.timeoutHook;
      var startHook = this.startHook;
      var endHook = this.endHook;
      var disableAutoLoadFinish = this.disableAutoLoadFinish;

      if (errorHandlerToggle) {
        window.fedopsLoggerErrorHandler = window.fedopsLoggerErrorHandler || new _errorHandler2.default({ swallowExceptions: swallowExceptions });
      }

      var logger = null;

      if (this.isWidgetLogger) {
        logger = new _widgetLoggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish });
      } else {
        logger = new _loggerInstance2.default(this.appName, this.appVersion, reporter, { sessionId: getSessionId(), errorHandlerToggle: errorHandlerToggle, swallowExceptions: swallowExceptions, disableAutoLoadFinish: disableAutoLoadFinish, interactionTimeout: interactionTimeout, timeoutHook: timeoutHook, startHook: startHook, endHook: endHook });
      }

      return logger;
    }
  }]);

  return LoggerBuilder;
}();

exports.default = LoggerBuilder;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local storage wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getItem: function getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return window.localStorage.setItem(key, value);
    } catch (e) {}
  }
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pixel = __webpack_require__(274);

var _pixel2 = _interopRequireDefault(_pixel);

var _tools = __webpack_require__(121);

var _tools2 = _interopRequireDefault(_tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter(baseUrl) {
    _classCallCheck(this, Reporter);

    this.baseUrl = baseUrl;
  }

  _createClass(Reporter, [{
    key: 'getBaseUrl',
    value: function getBaseUrl() {
      return this.baseUrl;
    }
  }, {
    key: 'report',
    value: function report(data) {
      if (!data) {
        return null;
      }

      return _pixel2.default.fetch(this.baseUrl + '?' + _tools2.default.mapToQuery(data));
    }
  }]);

  return Reporter;
}();

exports.default = Reporter;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Simple GET request wrapper (for tests mainly)
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  fetch: function fetch(url) {
    return new window.Image().src = url;
  }
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(122);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadFinishItem = __webpack_require__(279);

var _biLoadFinishItem2 = _interopRequireDefault(_biLoadFinishItem);

var _durationItem = __webpack_require__(123);

var _durationItem2 = _interopRequireDefault(_durationItem);

var _biInteractionStartItem = __webpack_require__(280);

var _biInteractionStartItem2 = _interopRequireDefault(_biInteractionStartItem);

var _biInteractionEndItem = __webpack_require__(281);

var _biInteractionEndItem2 = _interopRequireDefault(_biInteractionEndItem);

var _biErrorItem = __webpack_require__(127);

var _biErrorItem2 = _interopRequireDefault(_biErrorItem);

var _performance = __webpack_require__(50);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var LoggerInstance = function (_BaseLogger) {
  _inherits(LoggerInstance, _BaseLogger);

  function LoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        errorHandlerToggle = _ref.errorHandlerToggle,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish,
        interactionTimeout = _ref.interactionTimeout,
        timeoutHook = _ref.timeoutHook,
        startHook = _ref.startHook,
        endHook = _ref.endHook;

    _classCallCheck(this, LoggerInstance);

    var _this = _possibleConstructorReturn(this, (LoggerInstance.__proto__ || Object.getPrototypeOf(LoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, errorHandlerToggle: errorHandlerToggle, disableAutoLoadFinish: disableAutoLoadFinish }));

    _this._outgoingInteractions = {};
    _this.interactionTimeout = interactionTimeout;
    _this.timeoutHook = timeoutHook;
    _this.startHook = startHook;
    _this.endHook = endHook;
    return _this;
  }

  /**
   * Final phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11)
   * Call this method when your application finishes loading and after all custom phases.
   */


  _createClass(LoggerInstance, [{
    key: 'appLoaded',
    value: function appLoaded() {
      if (this._appLoadedCalled) {
        return;
      }

      if (window && window.fedops && typeof window.fedops.clearLoadTimeout === 'function') {
        window.fedops.clearLoadTimeout();
      }

      var dataSource = this.dataSource.clone().addItem(new _biLoadFinishItem2.default(this.sessionId)).addItem(new _durationItem2.default(this.appName).setFirstRequestDuration());

      this._appLoadedCalled = true;
      _performance2.default.mark('[fedops] app-loaded');
      _performance2.default.measure('[fedops] app-loaded', 'navigationStart', '[fedops] app-loaded');
      this.reportNetworkAnalysis();
      return this._report(dataSource);
    }

    /**
     * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionStarted',
    value: function interactionStarted(interactionName) {
      var _this2 = this;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          interactionTimeout = _ref2.interactionTimeout,
          startHook = _ref2.startHook,
          timeoutHook = _ref2.timeoutHook;

      _performance2.default.mark(interactionName + ' started');
      var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
        if (interactionTimeout || _this2.interactionTimeout) {
          return setTimeout(function () {
            var dataSource = _this2.dataSource.clone().addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(new _biErrorItem2.default(_this2.sessionId));

            _this2._report(dataSource);
            callHook(timeoutHook || _this2.timeoutHook, { name: interactionName, timeout: interactionTimeout || _this2.interactionTimeout });
          }, interactionTimeout || _this2.interactionTimeout);
        }
      };
      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem(new _biInteractionStartItem2.default(this.sessionId));

      this._outgoingInteractions[interactionName] = {
        timestamp: _performance2.default.now(),
        timeout: interactionTimeout || this.interactionTimeout
      };
      this._report(dataSource);
      callHook(startHook || this.startHook, { name: interactionName });

      var timeoutId = scheduleTimeoutEvent();
      return {
        timeoutId: timeoutId
      };
    }

    /**
     * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
     *
     * @param {String} interactionName  interaction name
     */

  }, {
    key: 'interactionEnded',
    value: function interactionEnded(interactionName) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          timeoutId = _ref3.timeoutId,
          endHook = _ref3.endHook;

      _performance2.default.mark(interactionName + ' ended');
      _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      var duration = this._outgoingInteractions[interactionName] ? Math.floor(_performance2.default.now() - this._outgoingInteractions[interactionName].timestamp) : '';

      callHook(endHook || this.endHook, {
        name: interactionName,
        duration: duration,
        timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
      });

      var dataSource = this.dataSource.clone().addItem({ name: interactionName }).addItem({ duration: duration }).addItem(new _biInteractionEndItem2.default(this.sessionId));

      delete this._outgoingInteractions[interactionName];

      this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return LoggerInstance;
}(_baseLogger2.default);

// vim: set ts=2 sw=2 tw=80 et :


exports.default = LoggerInstance;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dataItem = __webpack_require__(80);

var _dataItem2 = _interopRequireDefault(_dataItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data accumulator
 */
var DataSource = function () {
  function DataSource() {
    var _this = this;

    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, DataSource);

    this.items = [];

    if (item) {
      (typeof item.length === 'undefined' ? [item] : item).forEach(function (item) {
        return _this.addItem(item);
      });
    }
  }

  /**
   * Creates a new DataSource instance and clones internal state.
   *
   * @returns {DataSource}
   */


  _createClass(DataSource, [{
    key: 'clone',
    value: function clone() {
      return new DataSource(this.items.slice());
    }

    /**
     * Adds a new item.
     *
     * @param {Object | DataItem} item
     *
     * @return {DataSource} self
     */

  }, {
    key: 'addItem',
    value: function addItem(item) {
      this.items.push(item instanceof _dataItem2.default ? item : new _dataItem2.default(item));

      return this;
    }

    /**
     * Merges all added items into one plain object.
     *
     * @returns {Object}
     */

  }, {
    key: 'mergeItems',
    value: function mergeItems() {
      var res = {};

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];

        if (!item.isActive()) {
          res = null;
          break;
        }

        var data = item.export();

        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            // eslint-disable-line
            res[key] = data[key];
          }
        }
      }

      return res;
    }
  }]);

  return DataSource;
}();

exports.default = DataSource;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
var BiLoadPhaseDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadPhaseDataItem, _BiBaseDataItem);

  function BiLoadPhaseDataItem(sessionId) {
    _classCallCheck(this, BiLoadPhaseDataItem);

    return _possibleConstructorReturn(this, (BiLoadPhaseDataItem.__proto__ || Object.getPrototypeOf(BiLoadPhaseDataItem)).call(this, 13, sessionId));
  }

  return BiLoadPhaseDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadPhaseDataItem;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

var _location = __webpack_require__(126);

var _location2 = _interopRequireDefault(_location);

var _performance = __webpack_require__(50);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOURCES_TYPES = {
  xmlhttprequest: {
    count: 'countXhr',
    unsupported: 'unsprtXhr',
    duration: 'timeXhr',
    total: 'sizeXhr',
    longest: 'longXhr',
    http2: 'h2Xhr'
  },
  script: {
    count: 'countJs',
    unsupported: 'unsprtJs',
    duration: 'timeJs',
    total: 'sizeJs',
    cached: 'cachedJs',
    http2: 'h2Js'
  },
  link: { // css
    count: 'countCss',
    unsupported: 'unsprtCss',
    duration: 'timeCss',
    total: 'sizeCss',
    cached: 'cachedCss',
    http2: 'h2Css'
  },
  img: {
    count: 'countImg',
    unsupported: 'unsprtImg',
    duration: 'timeImg',
    total: 'sizeImg',
    cached: 'cachedImages',
    http2: 'h2Images'
  }
};

var CUSTOM_VALIDATORS = {
  link: function link(resource) {
    return (/(.\.css$|.\.css?.)/g.test(resource.name)
    );
  }
};

var durationOf = function durationOf(item) {
  return item.responseEnd - item.startTime;
};

function filterResourcesByType(resources, type) {
  var validator = CUSTOM_VALIDATORS[type];
  return resources.filter(function (r) {
    return type === r.initiatorType && (validator ? validator(r) : true);
  });
}

function calculateTotalSizeOfResource(resources) {
  return resources.reduce(function (totalSize, resource) {
    return totalSize + resource.transferSize;
  }, 0);
}

function calculateResourceLoadLongestDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var longest = resources.reduce(function (acc, cur) {
    return durationOf(cur) >= durationOf(acc) ? cur : acc;
  });
  return durationOf(longest);
}

function calculateResourceLoadDuration(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var loadStartStop = {
    startTime: Infinity,
    responseEnd: 0
  };
  resources.forEach(function (r) {
    if (loadStartStop.startTime > r.startTime) {
      loadStartStop.startTime = r.startTime;
    }
    if (loadStartStop.responseEnd < r.responseEnd) {
      loadStartStop.responseEnd = r.responseEnd;
    }
  });
  return loadStartStop.responseEnd - loadStartStop.startTime;
}

function calculatePercentageOfUnsupportedResources(resources) {
  var totalCount = resources.length;
  if (totalCount === 0) {
    return 0;
  }
  var unsupportedCount = resources.filter(isResourceUnsupported).length;
  return Math.round(unsupportedCount / totalCount * 100);
}

function calculateCachedResourcesPercentage(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var cached = resources.filter(function (r) {
    return r.transferSize === 0;
  });
  return Math.round(cached.length / resources.length * 100);
}

function calculatePercentageOfHttp2(resources) {
  if (resources.length === 0) {
    return 0;
  }
  var supported = false;
  var res = Math.round(resources.filter(function (r) {
    supported = supported || 'nextHopProtocol' in r;
    return r.nextHopProtocol === 'h2';
  }).length / resources.length * 100);
  return supported ? res : NaN;
}

function isResourceRelevant(resource) {
  return !resource.name.match(/http(s)?:\/\/frog.wix.com\//);
}

function isResourceUnsupported(resource) {
  return isCORS(resource.name) && resource.transferSize === 0 && resource.requestStart === 0;
}

function isCORS(resourceName) {
  var host = _location2.default.getHost();
  return host && resourceName.indexOf(host) === -1;
}

function normalizeValues(analysis) {
  return Object.keys(analysis).reduce(function (result, key) {
    var n = parseInt(analysis[key]);
    if (!isNaN(n) && typeof n === 'number') {
      result[key] = n;
    }
    return result;
  }, {});
}

function countAllResourcesByType(resources) {
  var supportedResources = resources.filter(function (r) {
    return !isResourceUnsupported(r);
  });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    var allSameTypeResources = filterResourcesByType(resources, currentType);
    var supportedSameTypeResources = filterResourcesByType(supportedResources, currentType);
    var type = RESOURCES_TYPES[currentType];
    result[type.count] = supportedSameTypeResources.length;
    result[type.duration] = calculateResourceLoadDuration(supportedSameTypeResources);
    result[type.total] = calculateTotalSizeOfResource(supportedSameTypeResources);
    result[type.unsupported] = calculatePercentageOfUnsupportedResources(allSameTypeResources);
    result[type.http2] = calculatePercentageOfHttp2(allSameTypeResources);
    if (type.longest) {
      result[type.longest] = calculateResourceLoadLongestDuration(supportedSameTypeResources);
    }
    if (type.cached) {
      result[type.cached] = calculateCachedResourcesPercentage(supportedSameTypeResources);
    }
    return result;
  }, {});
}

function extractResourceMetrics(resource) {
  return {
    url: resource.name,
    downloadDuration: resource.responseEnd - resource.startTime,
    bytesTransferred: resource.transferSize,
    isHTTP2: resource.nextHopProtocol === 'h2'
  };
}

function getResourcesBreakdown(resources) {
  var resourcesPartition = resources.reduce(function (result, r) {
    if (isResourceUnsupported(r)) {
      result.unsupported.push(r);
    } else {
      result.supported.push(r);
    }
    return result;
  }, { supported: [], unsupported: [] });
  return Object.keys(RESOURCES_TYPES).reduce(function (result, currentType) {
    result[currentType] = {};
    result[currentType].supported = filterResourcesByType(resourcesPartition.supported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    result[currentType].unsupported = filterResourcesByType(resourcesPartition.unsupported, currentType).map(function (r) {
      return extractResourceMetrics(r);
    });
    return result;
  }, {});
}

var ResourceDataItem = function (_BiBaseDataItem) {
  _inherits(ResourceDataItem, _BiBaseDataItem);

  function ResourceDataItem(sessionId) {
    _classCallCheck(this, ResourceDataItem);

    return _possibleConstructorReturn(this, (ResourceDataItem.__proto__ || Object.getPrototypeOf(ResourceDataItem)).call(this, 18, sessionId));
  }

  _createClass(ResourceDataItem, [{
    key: 'performNetworkAnalysis',
    value: function performNetworkAnalysis(resources) {
      if (resources.length === 0) {
        return null;
      }
      var t0 = _performance2.default.now();
      var resourcesToHandle = resources.filter(isResourceRelevant);
      var analysis = countAllResourcesByType(resourcesToHandle);
      analysis.overhead = _performance2.default.now() - t0;
      var result = normalizeValues(analysis);
      if (console.debug && _location2.default.isFedopsDev()) {
        var resourcesBreakdown = getResourcesBreakdown(resourcesToHandle);
        console.debug('[fedops network analysis] [bytes analysis]\n' + JSON.stringify(result, null, 4));
        console.debug('[fedops network analysis] [resources breakdown]\n', resourcesBreakdown);
      }
      return result;
    }
  }]);

  return ResourceDataItem;
}(_biBaseItem2.default);

exports.default = ResourceDataItem;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadFinishDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadFinishDataItem, _BiBaseDataItem);

  function BiLoadFinishDataItem(sessionId) {
    _classCallCheck(this, BiLoadFinishDataItem);

    return _possibleConstructorReturn(this, (BiLoadFinishDataItem.__proto__ || Object.getPrototypeOf(BiLoadFinishDataItem)).call(this, 11, sessionId));
  }

  return BiLoadFinishDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadFinishDataItem;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_START_EVID = undefined;

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_START_EVID = exports.INTERACTION_START_EVID = 15;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionStartDataItem, _BiBaseDataItem);

  function BiInteractionStartDataItem(sessionId) {
    _classCallCheck(this, BiInteractionStartDataItem);

    return _possibleConstructorReturn(this, (BiInteractionStartDataItem.__proto__ || Object.getPrototypeOf(BiInteractionStartDataItem)).call(this, INTERACTION_START_EVID, sessionId));
  }

  return BiInteractionStartDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionStartDataItem;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERACTION_END_EVID = undefined;

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INTERACTION_END_EVID = exports.INTERACTION_END_EVID = 16;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */

var BiInteractionEndDataItem = function (_BiBaseDataItem) {
  _inherits(BiInteractionEndDataItem, _BiBaseDataItem);

  function BiInteractionEndDataItem(sessionId) {
    _classCallCheck(this, BiInteractionEndDataItem);

    return _possibleConstructorReturn(this, (BiInteractionEndDataItem.__proto__ || Object.getPrototypeOf(BiInteractionEndDataItem)).call(this, INTERACTION_END_EVID, sessionId));
  }

  return BiInteractionEndDataItem;
}(_biBaseItem2.default);

exports.default = BiInteractionEndDataItem;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseLogger = __webpack_require__(122);

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _biLoadStartItem = __webpack_require__(283);

var _biLoadStartItem2 = _interopRequireDefault(_biLoadStartItem);

var _time = __webpack_require__(124);

var _time2 = _interopRequireDefault(_time);

var _appData = __webpack_require__(125);

var _appData2 = _interopRequireDefault(_appData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Logs application load phases.
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
var WidgetLoggerInstance = function (_BaseLogger) {
  _inherits(WidgetLoggerInstance, _BaseLogger);

  function WidgetLoggerInstance(appName, appVersion, reporter, _ref) {
    var sessionId = _ref.sessionId,
        disableAutoLoadFinish = _ref.disableAutoLoadFinish;

    _classCallCheck(this, WidgetLoggerInstance);

    var _this = _possibleConstructorReturn(this, (WidgetLoggerInstance.__proto__ || Object.getPrototypeOf(WidgetLoggerInstance)).call(this, appName, appVersion, reporter, { sessionId: sessionId, disableAutoLoadFinish: disableAutoLoadFinish }));

    _appData2.default.init(_this.appName);
    return _this;
  }

  /**
   * Manual report for widget load start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14)
   * Call this method at the earliest point possible when your widget starts loading
   */


  _createClass(WidgetLoggerInstance, [{
    key: 'appLoadStarted',
    value: function appLoadStarted() {

      _time2.default.loadStarted(this.appName);

      var dataSource = this.dataSource.clone().addItem(new _biLoadStartItem2.default(this.sessionId));

      return this._report(dataSource);
    }
  }, {
    key: 'isDisableAutoLoadFinish',
    value: function isDisableAutoLoadFinish() {
      return this._isDisableAutoLoadFinish();
    }
  }]);

  return WidgetLoggerInstance;
}(_baseLogger2.default);

exports.default = WidgetLoggerInstance;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biBaseItem = __webpack_require__(23);

var _biBaseItem2 = _interopRequireDefault(_biBaseItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents the "load started" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/14
 *
 * It should be used to monitor the initial application load.
 */
var BiLoadStartDataItem = function (_BiBaseDataItem) {
  _inherits(BiLoadStartDataItem, _BiBaseDataItem);

  function BiLoadStartDataItem(sessionId) {
    _classCallCheck(this, BiLoadStartDataItem);

    return _possibleConstructorReturn(this, (BiLoadStartDataItem.__proto__ || Object.getPrototypeOf(BiLoadStartDataItem)).call(this, 14, sessionId));
  }

  return BiLoadStartDataItem;
}(_biBaseItem2.default);

exports.default = BiLoadStartDataItem;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint-disable camelcase*/

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var ErrorHandler = function () {
  function ErrorHandler(_ref) {
    var swallowExceptions = _ref.swallowExceptions;

    _classCallCheck(this, ErrorHandler);

    this.swallowExceptions = swallowExceptions;
    this.listeners = {};

    //*************************************************************************
    // We are wrapping the browser's native methods with try/catch for several
    // reasons:
    //
    // 1. It provides us with a more elaborate stack trace.
    //    Currently we ignore the stack trace due to BI limitations, but it can
    //    be very useful for future support.
    //
    // 2. Makes it easier to classify the error types.
    //
    // 3. Some browsers don't support a global error handler.
    //*************************************************************************

    this.instrumentAjax();
    this.instrumentSetTimeout();
    this.instrumentSetInterval();
    this.instrumentAddEventListener();
    this.instrumentFetch();
    this.instrumentPromise();

    //Sometimes catches one of the instruments above? Need to verify...
    this.instrumentGloballyUnhandledError();
  }

  _createClass(ErrorHandler, [{
    key: 'subscribeListener',
    value: function subscribeListener(appName, cb) {
      this.listeners[appName] = cb;
    }
  }, {
    key: 'removeListener',
    value: function removeListener(appName) {
      delete this.listeners[appName];
    }
  }, {
    key: 'instrumentAjax',
    value: function instrumentAjax() {
      var self = this;

      if ('XMLHttpRequest' in _window) {
        var xhrproto = XMLHttpRequest.prototype;

        this._wrap(xhrproto, 'open', function (orig) {
          return function (method, url) {
            this.__fedops_xhr = {
              method: method,
              url: url,
              status_code: null
            };

            return orig.apply(this, arguments);
          };
        }, 'xhr');

        this._wrap(xhrproto, 'send', function (orig) {
          return function () {
            var xhr = this;

            function saveStatusCode() {
              if (xhr.readyState === 1 || xhr.readyState === 4) {
                try {
                  xhr.__fedops_xhr.status_code = xhr.status;
                } catch (e) {}

                if (self._isErrorStatusCode(xhr.__fedops_xhr.status_code)) {
                  self._reportError(xhr.__fedops_xhr, 'xhr', xhr.__fedops_xhr.status_code);
                }
              }
            }

            self._wrap(this, 'onload', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onerror', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            self._wrap(this, 'onprogress', function (orig) {
              return function () {
                orig && orig.apply(this, arguments);
              };
            }, 'xhr');

            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
              self._wrap(xhr, 'onreadystatechange', function (orig) {
                return function () {
                  saveStatusCode();
                  return orig.apply(this, arguments);
                };
              });
            } else {
              xhr.onreadystatechange = saveStatusCode;
            }

            return orig.apply(this, arguments);
          };
        }, 'xhr');
      }
    }
  }, {
    key: 'instrumentSetTimeout',
    value: function instrumentSetTimeout() {
      var self = this;

      this._wrap(_window, 'setTimeout', function (globalSetTimeout) {
        return function (fn) {
          for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }

          return globalSetTimeout.call.apply(globalSetTimeout, [this, self._wrapCallback(fn, 'setTimeout')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentSetInterval',
    value: function instrumentSetInterval() {
      var self = this;

      this._wrap(_window, 'setInterval', function (globalSetInterval) {
        return function (fn) {
          for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            rest[_key2 - 1] = arguments[_key2];
          }

          return globalSetInterval.call.apply(globalSetInterval, [this, self._wrapCallback(fn, 'setInterval')].concat(rest));
        };
      });
    }
  }, {
    key: 'instrumentAddEventListener',
    value: function instrumentAddEventListener() {
      var self = this;

      function instrumentEventTarget(name) {
        var origTarget = _window[name] && _window[name].prototype;

        if (origTarget && Object.prototype.hasOwnProperty.call(origTarget, 'addEventListener')) {
          self._wrap(origTarget, 'addEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              var wrapped = self._wrapCallback(fn, 'addEventListener');

              if (fn) {
                fn.__fedopsWrapper__ = wrapped;
              }

              return orig.call(this, eventName, wrapped, capture, secure);
            };
          });

          self._wrap(origTarget, 'removeEventListener', function (orig) {
            return function (eventName, fn, capture, secure) {
              fn = fn && (fn.__fedopsWrapper__ || fn);
              return orig.call(this, eventName, fn, capture, secure);
            };
          });
        }
      }

      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
      eventTargets.forEach(function (name) {
        return instrumentEventTarget(name);
      });
    }
  }, {
    key: 'instrumentRequestAnimationFrame',
    value: function instrumentRequestAnimationFrame() {}
  }, {
    key: 'instrumentFetch',
    value: function instrumentFetch() {
      var self = this;

      this._wrap(_window, 'fetch', function (globalFetch) {
        return function (url, fetchOptions) {
          return globalFetch.apply(this, arguments).then(function (response) {
            var statusCode = response.status;

            if (self._isErrorStatusCode(statusCode)) {
              var requestInfo = {
                url: url,
                method: fetchOptions ? fetchOptions.method : 'GET',
                status_code: statusCode
              };

              self._reportError(requestInfo, 'fetch', statusCode);
            }

            return response;
          });
        };
      });
    }
  }, {
    key: 'instrumentPromise',
    value: function instrumentPromise() {
      var self = this;

      _window.addEventListener('unhandledrejection', function (err) {
        self._reportError(err, 'promise');
      });
    }
  }, {
    key: 'instrumentGloballyUnhandledError',
    value: function instrumentGloballyUnhandledError() {
      var _this = this;

      _window.addEventListener('error', function (err) {
        _this._reportError(err, 'windowOnError');
      });
    }
  }, {
    key: 'instrumentHistory',
    value: function instrumentHistory() {}
  }, {
    key: '_wrap',
    value: function _wrap(obj, fnName, replaced, errorType) {
      var self = this;
      var orig = obj[fnName];
      var r = replaced(orig);

      var wrapped = function wrapped() {
        try {
          return r.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };

      obj[fnName] = wrapped;
    }
  }, {
    key: '_wrapCallback',
    value: function _wrapCallback(fn, errorType) {
      var self = this;

      return function () {
        try {
          return fn.apply(this, arguments);
        } catch (err) {
          self._reportError(err, errorType);

          if (!self.swallowExceptions) {
            throw err;
          }
        }
      };
    }
  }, {
    key: '_reportError',
    value: function _reportError(err, errorType, errorInfo) {
      var self = this;

      var actualError = err && (err.error || err);

      if (!actualError.__fedopsHandledError__) {
        var appNames = Object.keys(this.listeners);

        appNames.forEach(function (appName) {
          self.listeners[appName](actualError, errorType, errorInfo);
        });

        actualError.__fedopsHandledError__ = true;
      }
    }
  }, {
    key: '_isErrorStatusCode',
    value: function _isErrorStatusCode(statusCode) {
      return statusCode >= 400 || statusCode === 0;
    }
  }]);

  return ErrorHandler;
}();

/*eslint-enable camelcase*/


exports.default = ErrorHandler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_BASE_URL = exports.BI_BASE_URL = 'https://frog.wix.com/fed';
var SESSION_ID_STORAGE_KEY = exports.SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
var DEFAULT_APP_VERSION = exports.DEFAULT_APP_VERSION = '0.0.0';

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(288)(module)))

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Strip = undefined;

var _getIterator2 = __webpack_require__(46);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Strip = exports.Strip = function () {
  function Strip(config) {
    (0, _classCallCheck3.default)(this, Strip);

    this.ratio = 0;
    this.groups = [];
    this.width = 0;
    this.height = 0;
    this.isFullWidth = true;

    this.idx = config.idx;
    this.styleParams = config.styleParams;
    this.container = config.container;
  }

  (0, _createClass3.default)(Strip, [{
    key: "addGroup",
    value: function addGroup(group) {
      if (this.hasGroups) {
        this.lastGroup.isLastGroup = false;
      }
      this.groups.push(group);
      this.lastGroup.isLastGroup = true;
      this.lastGroup.stripWidth = this.height * this.ratio;
    }
  }, {
    key: "markAsIncomplete",
    value: function markAsIncomplete() {
      //prevent from the last group to be streched
      this.isFullWidth = false;
      this.lastGroup.isLastGroup = false;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.width = width;
      if (this.hasGroups) {
        this.lastGroup.stripWidth = width;
      }
    }
  }, {
    key: "resizeToHeight",
    value: function resizeToHeight(height) {
      this.height = height;
      var left = 0;
      var remainder = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.groups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          group.setLeft(left);
          // group.left = (left);
          group.width += remainder; //add the remainder from the last group round
          group.resizeToHeight(height);
          remainder = group.width;
          group.round();
          remainder -= group.width;
          left += group.width;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "isFull",
    value: function isFull(newGroup, isLastImage) {

      if (!this.hasGroups) {
        return false;
      }

      if (this.styleParams.groupsPerStrip > 0) {
        return this.groups.length >= this.styleParams.groupsPerStrip;
      }

      var galleryWidth = this.container.galleryWidth;
      var _styleParams = this.styleParams,
          oneRow = _styleParams.oneRow,
          gallerySize = _styleParams.gallerySize;


      var isStripSmallEnough = void 0;
      if (oneRow) {
        isStripSmallEnough = false; //onerow layout is one long strip
      } else {
        var withNewGroup = galleryWidth / (this.ratio + newGroup.ratio) - gallerySize; //start a new strip BEFORE adding the current group
        var withoutNewGroup = galleryWidth / this.ratio - gallerySize; //start a new strip AFTER adding the current group
        if (isNaN(withNewGroup) || isNaN(withoutNewGroup)) {
          isStripSmallEnough = false;
        } else if (withoutNewGroup < 0) {
          //the strip is already too small
          isStripSmallEnough = true;
        } else if (withNewGroup < 0) {
          //adding the new group makes is small enough
          // check if adding the new group makes the strip TOO small
          //so - without the new group, the strip is larger than the required size - but adding the new group might make it too small
          isStripSmallEnough = Math.abs(withoutNewGroup) < Math.abs(withNewGroup);
        } else {
          isStripSmallEnough = false;
        }

        if (isStripSmallEnough && isLastImage) {
          //if it is the last image - prefer adding it to the last strip rather putting it on a new strip
          isStripSmallEnough = Number(Math.abs(withoutNewGroup)) < Math.abs(withNewGroup);
        }
      }

      return isStripSmallEnough;
    }
  }, {
    key: "hasGroups",
    get: function get() {
      return this.groups.length > 0;
    }
  }, {
    key: "lastGroup",
    get: function get() {
      return this.groups[this.groups.length - 1];
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height,
        ratio: this.ratio,
        isFullWidth: this.isFullWidth
      };
    }
  }]);
  return Strip;
}();

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Column = exports.Column = function () {
  function Column(idx, width, cubeRatio) {
    (0, _classCallCheck3.default)(this, Column);

    this.idx = idx;
    this.groups = [];
    this.height = 0;
    this.width = width;
    this.cubeRatio = cubeRatio;
  }

  (0, _createClass3.default)(Column, [{
    key: "addGroup",
    value: function addGroup(group) {
      this.addGroups([group]);
    }
  }, {
    key: "addGroups",
    value: function addGroups(groups) {
      this.groups = this.groups.concat(groups);
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height
      };
    }
  }]);
  return Column;
}();

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLayout;

var _layouter = __webpack_require__(132);

var _layouter2 = _interopRequireDefault(_layouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLayout() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_layouter2.default, [null].concat(args)))().createLayout();
}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjMiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAyMyAzOSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgICAgZmlsdGVyOiB1cmwoI2ZpbHRlcik7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIiIHg9IjEzMyIgeT0iMjI1IiB3aWR0aD0iMjMiIGhlaWdodD0iMzkiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxmZU9mZnNldCByZXN1bHQ9Im9mZnNldCIgZHg9Ii0wLjg2NiIgZHk9IjAuNSIgaW49IlNvdXJjZUFscGhhIi8+CiAgICAgIDxmZUdhdXNzaWFuQmx1ciByZXN1bHQ9ImJsdXIiIHN0ZERldmlhdGlvbj0iMSIvPgogICAgICA8ZmVGbG9vZCByZXN1bHQ9ImZsb29kIiBmbG9vZC1jb2xvcj0iIzE2MTYxNiIgZmxvb2Qtb3BhY2l0eT0iMC4yNSIvPgogICAgICA8ZmVDb21wb3NpdGUgcmVzdWx0PSJjb21wb3NpdGUiIG9wZXJhdG9yPSJpbiIgaW4yPSJibHVyIi8+CiAgICAgIDxmZUJsZW5kIHJlc3VsdD0iYmxlbmQiIGluPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgIDxmZUZsb29kIHJlc3VsdD0iZmxvb2QtMiIgZmxvb2QtY29sb3I9IiNmZmYiLz4KICAgICAgPGZlQ29tcG9zaXRlIHJlc3VsdD0iY29tcG9zaXRlLTIiIG9wZXJhdG9yPSJpbiIgaW4yPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgIDxmZUJsZW5kIHJlc3VsdD0iYmxlbmQtMiIgaW4yPSJibGVuZCIvPgogICAgPC9maWx0ZXI+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJfMjUwX21pZGRsZV9yaWdodF9jb3B5XzMiIGRhdGEtbmFtZT0iMjUwIG1pZGRsZSByaWdodCAgY29weSAzIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNTQuOTk0LDI1OS41MjJMMTUzLjQ3NywyNjFsLTE4LjQ3MS0xOCwxOC40NzMtMTgsMS41MTksMS40OEwxMzguMDQ0LDI0M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzMgLTIyNSkiLz4KPC9zdmc+Cg=="

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjMiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAyMyAzOSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgICBmaWxsLXJ1bGU6IGV2ZW5vZGQ7CiAgICAgICAgZmlsdGVyOiB1cmwoI2ZpbHRlcik7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIiIHg9Ijg1NSIgeT0iMjMwIiB3aWR0aD0iMjMiIGhlaWdodD0iMzkiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxmZU9mZnNldCByZXN1bHQ9Im9mZnNldCIgZHg9Ii0wLjg2NiIgZHk9IjAuNSIgaW49IlNvdXJjZUFscGhhIi8+CiAgICAgIDxmZUdhdXNzaWFuQmx1ciByZXN1bHQ9ImJsdXIiIHN0ZERldmlhdGlvbj0iMSIvPgogICAgICA8ZmVGbG9vZCByZXN1bHQ9ImZsb29kIiBmbG9vZC1jb2xvcj0iIzE2MTYxNiIgZmxvb2Qtb3BhY2l0eT0iMC4yNSIvPgogICAgICA8ZmVDb21wb3NpdGUgcmVzdWx0PSJjb21wb3NpdGUiIG9wZXJhdG9yPSJpbiIgaW4yPSJibHVyIi8+CiAgICAgIDxmZUJsZW5kIHJlc3VsdD0iYmxlbmQiIGluPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgIDxmZUZsb29kIHJlc3VsdD0iZmxvb2QtMiIgZmxvb2QtY29sb3I9IiNmZmYiLz4KICAgICAgPGZlQ29tcG9zaXRlIHJlc3VsdD0iY29tcG9zaXRlLTIiIG9wZXJhdG9yPSJpbiIgaW4yPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgIDxmZUJsZW5kIHJlc3VsdD0iYmxlbmQtMiIgaW4yPSJibGVuZCIvPgogICAgPC9maWx0ZXI+CiAgPC9kZWZzPgogIDxwYXRoIGlkPSJfMjUwX21pZGRsZV9yaWdodF9jb3B5XzIiIGRhdGEtbmFtZT0iMjUwIG1pZGRsZSByaWdodCAgY29weSAyIiBjbGFzcz0iY2xzLTEiIGQ9Ik04NTcuMDA1LDIzMS40NzlMODU4LjUsMjMwbDE4LjEyNCwxOC0xOC4xMjcsMTgtMS40OS0xLjQ4TDg3My42MzgsMjQ4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg1NSAtMjMwKSIvPgo8L3N2Zz4K"

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _renderUtils = __webpack_require__(70);

var _gallerySettings = __webpack_require__(295);

var _gallerySettings2 = _interopRequireDefault(_gallerySettings);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var watermarkDataKey = 'watermarkData';

var WatermarkApi = function () {
  function WatermarkApi(dataKey) {
    (0, _classCallCheck3.default)(this, WatermarkApi);

    this.dataKey = dataKey;
    this.defaultWatermarkData = {
      position: 9,
      size: 40,
      opacity: 40,
      imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
      imageRatio: 1.42517815
    };
    this.origOpacity = 40;

    this.emptyWatermarkData = {
      position: 1,
      size: 1,
      opacity: 1,
      imageUrl: '8bb438_39a78b46d4fe47069da63da9348b4ee5~mv2.png',
      imageRatio: 1
    };

    this.cachedWatermark = {
      default: this.defaultWatermarkData
    };

    this.disableWatermark = this.disableWatermark.bind(this);
    this.enableWatermark = this.enableWatermark.bind(this);

    try {
      this.protocol = window.location.protocol;
      this.galleryId = window.galleryId;
      this.instance = window.instance;
    } catch (e) {
      this.protocol = 'http:';
      this.galleryId = '';
      this.instance = '';
    }
  }

  (0, _createClass3.default)(WatermarkApi, [{
    key: 'applyWatermarkOnMediaDialogResult',
    value: function applyWatermarkOnMediaDialogResult(mediaResult, galleryId, instance) {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        if (mediaResult && mediaResult.length) {
          var watermarSave = null;
          _this.getWatermarkData(galleryId).then(function (watermarkData) {
            var imageUrl = watermarkData.imageUrl,
                position = watermarkData.position,
                size = watermarkData.size,
                opacity = watermarkData.opacity;

            watermarSave = watermarkData;
            var payload = {
              wm: 'media/' + imageUrl,
              wmop: opacity,
              wmpos: position,
              wmscl: size,
              files: mediaResult.map(function (item) {
                return { file_name: item.fileName };
              })
            };
            return _axios2.default.post(_this.protocol + '//progallery.wix.com/editor/api/v1/watermark/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', payload, {
              withCredentials: true,
              xsrfCookieName: null
            });
          }).then(function () {
            resolve(watermarSave);
          });
        } else {
          reject();
        }
      });
    }
  }, {
    key: 'getCompId',
    value: function getCompId() {
      return new _promise2.default(function (resolve) {
        var compId = null;
        if (typeof window !== 'undefined' && window.isFullscreen) {
          compId = _renderUtils.renderUtils.getWorkerWindow()['pro-gallery-fullscreen-comp-id'];
        } else {
          compId = _WixSdkWrapper2.default.Utils.getOrigCompId() || _WixSdkWrapper2.default.Utils.getCompId() || 'default';
        }
        resolve(compId);
      });
    }
  }, {
    key: 'getDataKey',
    value: function getDataKey() {
      var _this2 = this;

      return new _promise2.default(function (resolve) {
        _this2.getCompId().then(function (compId) {
          var dataKey = _this2.dataKey + '-' + compId;
          resolve(dataKey);
        });
      });
    }
  }, {
    key: 'saveWatermark',
    value: function saveWatermark(_ref, galleryId, instance) {
      var position = _ref.position,
          opacity = _ref.opacity,
          size = _ref.size,
          imageUrl = _ref.imageUrl,
          imageRatio = _ref.imageRatio;

      var _this3 = this;

      //save watermark to store api
      return _gallerySettings2.default.set('watermark', { position: position, opacity: opacity, size: size, imageUrl: imageUrl, imageRatio: imageRatio }).then(function () {
        return _this3._updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance);
      });
    }
  }, {
    key: 'getCachedWatermark',
    value: function getCachedWatermark(compId) {
      return this.cachedWatermark[compId] || this.defaultWatermarkData;
    }
  }, {
    key: 'disableWatermark',
    value: function disableWatermark(galleryId, instance) {
      var _this4 = this;

      if (_renderUtils.renderUtils.isDev()) {
        console.log('Disabling watermark');
      }
      this.getCompId().then(function (compId) {
        var _getCachedWatermark = _this4.getCachedWatermark(compId),
            position = _getCachedWatermark.position,
            size = _getCachedWatermark.size,
            opacity = _getCachedWatermark.opacity,
            imageUrl = _getCachedWatermark.imageUrl,
            imageRatio = _getCachedWatermark.imageRatio;

        _this4.origOpacity = opacity; //save original opacity of the watermark
        opacity = 0;
        return _this4.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
      });
    }
  }, {
    key: 'enableWatermark',
    value: function enableWatermark(galleryId, instance) {
      var _this5 = this;

      if (_renderUtils.renderUtils.isDev()) {
        console.log('Enabling watermark');
      }
      this.getCompId().then(function (compId) {
        var _getCachedWatermark2 = _this5.getCachedWatermark(compId),
            position = _getCachedWatermark2.position,
            size = _getCachedWatermark2.size,
            imageUrl = _getCachedWatermark2.imageUrl,
            imageRatio = _getCachedWatermark2.imageRatio;

        var opacity = _this5.origOpacity; //retrieve original opacity of the watermark
        return _this5.saveWatermark({ position: position, size: size, opacity: opacity, imageUrl: imageUrl, imageRatio: imageRatio }, galleryId, instance);
      });
    }
  }, {
    key: '_updateMediaWatermark',
    value: function _updateMediaWatermark(imageUrl, opacity, position, size, galleryId, instance) {
      var _this6 = this;

      return new _promise2.default(function (resolve) {
        var payload = {
          wm: 'media/' + imageUrl,
          wmop: opacity,
          wmpos: position,
          wmscl: size
        };
        return _axios2.default.post(_this6.protocol + '//progallery.wix.com/editor/api/v1/watermark/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', payload, {
          withCredentials: true,
          xsrfCookieName: null
        }).then(function () {
          resolve();
        });
      });
    }
  }, {
    key: 'getWatermarkDataFromGallerySettingsSync',
    value: function getWatermarkDataFromGallerySettingsSync(prerenderedGallery) {
      var watermarkData = null;
      if (prerenderedGallery && prerenderedGallery.gallerySettings) {
        var objGallerySettings = null;
        if (typeof prerenderedGallery.gallerySettings === 'string') {
          try {
            objGallerySettings = JSON.parse(_renderUtils.renderUtils.stripSlashes(prerenderedGallery.gallerySettings));
          } catch (error) {}
        } else if ((0, _typeof3.default)(prerenderedGallery.gallerySettings) === 'object') {
          objGallerySettings = prerenderedGallery.gallerySettings;
        }

        if (objGallerySettings) {
          watermarkData = objGallerySettings.watermark;
          if (watermarkData) {
            if (typeof watermarkData === 'string') {
              try {
                watermarkData = JSON.parse(watermarkData);
              } catch (error) {
                console.error('watermarkApi - watermark from gallery settings (' + watermarkData + ') is invalid', error);
              }
            }
          }
        }
      }

      return watermarkData;
    }
  }, {
    key: 'getWatermarkDataFromServerAsync',
    value: function getWatermarkDataFromServerAsync(galleryId) {
      var _this7 = this;

      galleryId = galleryId || this.galleryId;
      var instance = this.instance;
      return new _promise2.default(function (resolve, reject) {
        if (instance && galleryId) {
          _axios2.default.get(_this7.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/' + galleryId + '?instance=' + instance + '&isStore=true', {
            withCredentials: true,
            xsrfCookieName: null
          }).then(function (response) {
            var data = response.data;

            if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' && data.settings && data.settings.watermark) {
              resolve(data.settings.watermark);
            } else {
              reject('watermarkApi - getWatermarkDataFromServerAsync - returned data from server is corrupt');
            }
          }).catch(function () {
            reject('watermarkApi - getWatermarkDataFromServerAsync - request error');
          });
        } else {
          reject('watermarkApi - getWatermarkDataFromServerAsync - no galleryId (' + galleryId + ') or instance (' + instance + ')');
        }
      });
    }
  }, {
    key: 'getWatermarkData',
    value: function getWatermarkData(galleryId) {
      var _this8 = this;

      return new _promise2.default(function (resolve, reject) {
        _this8.getCompId().then(function (compId) {
          if (_this8.cachedWatermark[compId] && !_renderUtils.renderUtils.isEditor()) {
            // if (renderUtils.isDev()) console.log('Getting cached watermark');
            resolve(_this8.cachedWatermark[compId]);
          } else {
            var prerenderedItems = void 0;
            try {
              prerenderedItems = window.prerenderedGallery || window.prerenderedItem;
            } catch (e) {
              prerenderedItems = [];
            }
            _this8.cachedWatermark[compId] = _this8.getWatermarkDataFromGallerySettingsSync(prerenderedItems);
            // this.cachedWatermark = this.defaultWatermarkData; //set the default watermark until the Promise will resolve
            _renderUtils.renderUtils.isDev() && console.log('Getting public watermark');
            if (_this8.cachedWatermark[compId]) {
              resolve(_this8.cachedWatermark[compId]);
            } else {
              // fall back to data.public
              _this8.getWatermarkDataFromServerAsync(galleryId).then(function (watermarkData) {
                _this8.cachedWatermark[compId] = watermarkData;
                resolve(_this8.cachedWatermark[compId]);
              }).catch(function (e) {
                _renderUtils.renderUtils.isDev() && console.log('Getting watermark from server failed - ', e);
                _this8.cachedWatermark[compId] = new _promise2.default(function () {
                  _this8.getDataKey().then(function (dataKey) {
                    if (_WixSdkWrapper2.default && _WixSdkWrapper2.default.Data && _WixSdkWrapper2.default.Data.Public) {
                      _WixSdkWrapper2.default.Data.Public.get(dataKey, { scope: _WixSdkWrapper2.default.Data.SCOPE.APP }, function (data) {
                        if (_renderUtils.renderUtils.isDev()) {
                          console.log('Got watermark from Data.Public', data);
                        }
                        var parsedData = JSON.parse(data[dataKey]);
                        _this8.cachedWatermark[compId] = parsedData;
                        resolve(parsedData);
                      }, function (e) {
                        if (_renderUtils.renderUtils.isDev()) {
                          console.log('cannot fetch watermark from Data.Public', e);
                        }

                        _this8.cachedWatermark[compId] = _this8.defaultWatermarkData;
                        resolve(_this8.cachedWatermark[compId]);
                      });
                    } else {
                      if (_renderUtils.renderUtils.isDev()) {
                        console.log('Cannot get watermark from Data.Public (wix not found)');
                      }
                      reject('Wix not found');
                    }
                  });
                });
              });
            }
          }
        });
      });
    }
  }]);
  return WatermarkApi;
}();

exports.default = new WatermarkApi(watermarkDataKey);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(296);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _baseUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GallerySettings = function () {
  function GallerySettings() {
    var _this = this;

    (0, _classCallCheck3.default)(this, GallerySettings);

    try {
      this.protocol = window.location.protocol;
      this.galleryId = window.galleryId;
      this.instance = window.instance;
    } catch (e) {
      this.protocol = 'http:';
      this.galleryId = '';
      this.instance = '';
    }
    this.baseUrl = this.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';
    this.getGallerySettingsApi = function () {
      return '' + _this.baseUrl + _this.galleryId + '?instance=' + _this.instance + '&isStore=' + _baseUtils.baseUtils.isStoreGallery();
    };
  }

  (0, _createClass3.default)(GallerySettings, [{
    key: 'get',
    value: function get(key) {
      return _axios2.default.get(this.getGallerySettingsApi(), { withCredentials: true, xsrfCookieName: null }).then(function (_ref) {
        var data = _ref.data;

        return key ? data.settings[key] : data.settings;
      });
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      var _this2 = this;

      return this.get().then(function (data) {
        data = data || {};
        var settings = (0, _assign2.default)(data, (0, _defineProperty3.default)({}, key, value));
        return _axios2.default.put(_this2.getGallerySettingsApi(), { settings: settings }, { withCredentials: true, xsrfCookieName: null }).then(function () {
          return _baseUtils.baseUtils.setExternalId();
        });
      });
    }
  }]);
  return GallerySettings;
}();

var gallerySettings = new GallerySettings();
exports.default = gallerySettings;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(89);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.imageClientSDK=t():e.imageClientSDK=t()}(this,function(){return function(e){var t={};function a(i){if(t[i])return t[i].exports;var r=t[i]={i:i,l:!1,exports:{}};return e[i].call(r.exports,r,r.exports,a),r.l=!0,r.exports}return a.m=e,a.c=t,a.d=function(e,t,i){a.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},a.t=function(e,t){if(1&t&&(e=a(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(a.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)a.d(i,r,function(t){return e[t]}.bind(null,r));return i},a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,"a",t),t},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.p="",a(a.s=15)}([function(e,t,a){"use strict";var i={JPG:"jpg",JPEG:"jpeg",PNG:"png",WEBP:"webp",WIX_ICO_MP:"wix_ico_mp",WIX_MP:"wix_mp",GIF:"gif",SVG:"svg",UNRECOGNIZED:"unrecognized"},r=[i.JPG,i.JPEG,i.PNG,i.GIF,i.WEBP];e.exports={alignTypes:{CENTER:"center",TOP:"top",TOP_LEFT:"top_left",TOP_RIGHT:"top_right",BOTTOM:"bottom",BOTTOM_LEFT:"bottom_left",BOTTOM_RIGHT:"bottom_right",LEFT:"left",RIGHT:"right"},alignTypesMap:{center:"c",top:"t",top_left:"tl",top_right:"tr",bottom:"b",bottom_left:"bl",bottom_right:"br",left:"l",right:"r"},transformTypes:{FIT:"fit",FILL:"fill",FILL_FOCAL:"fill_focal",CROP:"crop",LEGACY_CROP:"legacy_crop",LEGACY_FILL:"legacy_fill"},fittingTypes:{SCALE_TO_FILL:"fill",SCALE_TO_FIT:"fit",STRETCH:"stretch",ORIGINAL_SIZE:"original_size",TILE:"tile",TILE_HORIZONTAL:"tile_horizontal",TILE_VERTICAL:"tile_vertical",FIT_AND_TILE:"fit_and_tile",LEGACY_STRIP_TILE:"legacy_strip_tile",LEGACY_STRIP_TILE_HORIZONTAL:"legacy_strip_tile_horizontal",LEGACY_STRIP_TILE_VERTICAL:"legacy_strip_tile_vertical",LEGACY_STRIP_SCALE_TO_FILL:"legacy_strip_fill",LEGACY_STRIP_SCALE_TO_FIT:"legacy_strip_fit",LEGACY_STRIP_FIT_AND_TILE:"legacy_strip_fit_and_tile",LEGACY_STRIP_ORIGINAL_SIZE:"legacy_strip_original_size",LEGACY_ORIGINAL_SIZE:"actual_size",LEGACY_FIT_WIDTH:"fitWidth",LEGACY_FIT_HEIGHT:"fitHeight",LEGACY_FULL:"full",LEGACY_BG_FIT_AND_TILE:"legacy_tile",LEGACY_BG_FIT_AND_TILE_HORIZONTAL:"legacy_tile_horizontal",LEGACY_BG_FIT_AND_TILE_VERTICAL:"legacy_tile_vertical",LEGACY_BG_NORMAL:"legacy_normal"},htmlTag:{BG:"bg",IMG:"img",SVG:"svg"},upscaleMethods:{AUTO:"auto",CLASSIC:"classic",SUPER:"super"},upscaleMethodsValues:{classic:1,super:2},defaultUSM:{radius:.66,amount:1,threshold:.01},emptyData:{uri:"",css:{img:{},container:{}},attr:{img:{},container:{}}},imageQuality:{HIGH:"HIGH",MEDIUM:"MEDIUM",LOW:"LOW",TINY:"TINY"},imageScaleDefaults:{HIGH:{size:196e4,quality:90,maxUpscale:1},MEDIUM:{size:36e4,quality:85,maxUpscale:1},LOW:{size:16e4,quality:80,maxUpscale:1.2},TINY:{size:0,quality:80,maxUpscale:1.4}},fileType:i,supportedExtensions:r,webp:{LOSSLESS:"lossless",LOSSY:"lossy",ALPHA:"alpha",ANIMATION:"animation"},SAFE_TRANSFORMED_AREA:25e6,SUPER_UPSCALE_MODELS:[1.5,2,4],MAX_DEVICE_PIXEL_RATIO:2,API_VERSION:"v1"}},function(e,t,a){"use strict";var i=a(2),r=a(0),n=a(4);function s(e){var t=new window.Image;t.onload=function(){var a=n.getFeature("isWEBP");a[e]=t.width>0&&t.height>0,n.setFeature("isWEBP",a)},t.src="data:image/webp;base64,"+{lossy:"UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",lossless:"UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",alpha:"UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",animation:"UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"}[e]}function o(e){var t=[r.fileType.PNG,r.fileType.JPEG,r.fileType.JPG,r.fileType.WIX_ICO_MP,r.fileType.WIX_MP];return i.includes(t,u(e))}function l(e){return i.includes(["webp"],u(e))}function c(e){return/(^https?)|(^data)|(^\/\/)/.test(e)}function u(e){return(/[.]([^.]+)$/.exec(e)&&/[.]([^.]+)$/.exec(e)[1]||"").toLowerCase()}function p(e,t,a,i,n){return n===r.transformTypes.FILL?function(e,t,a,i){return Math.max(a/e,i/t)}(e,t,a,i):n===r.transformTypes.FIT?function(e,t,a,i){return Math.min(a/e,i/t)}(e,t,a,i):1}function h(e,t){var a=T(e,t);return{optimizedScaleFactor:r.imageScaleDefaults[a].maxUpscale,upscaleMethodValue:r.upscaleMethodsValues.classic,forceUSM:!1}}function f(e,t){var a=T(e,t);return{optimizedScaleFactor:r.imageScaleDefaults[a].maxUpscale,upscaleMethodValue:r.upscaleMethodsValues.classic,forceUSM:!1}}function g(e,t,a){return{optimizedScaleFactor:i.last(r.SUPER_UPSCALE_MODELS),upscaleMethodValue:r.upscaleMethodsValues.super,forceUSM:!(r.SUPER_UPSCALE_MODELS.includes(a)||a>i.last(r.SUPER_UPSCALE_MODELS))}}function T(e,t){var a=e*t;return a>r.imageScaleDefaults[r.imageQuality.HIGH].size?r.imageQuality.HIGH:a>r.imageScaleDefaults[r.imageQuality.MEDIUM].size?r.imageQuality.MEDIUM:a>r.imageScaleDefaults[r.imageQuality.LOW].size?r.imageQuality.LOW:r.imageQuality.TINY}function A(e,t){var a=Math.pow(10,t||0);return(e*a/a).toFixed(parseInt(t,10))}e.exports={populateGlobalFeatureSupport:function(){"undefined"!=typeof window&&(s(r.webp.LOSSY),s(r.webp.LOSSLESS),s(r.webp.ALPHA),s(r.webp.ANIMATION),n.setFeature("isObjectFitBrowser",function(e){return e in window.document.documentElement.style}("objectFit")))},isWEBPBrowserSupport:function(e){var t=n.getFeature("isWEBP"),a=e===r.fileType.JPG&&t[r.webp.LOSSY],i=e===r.fileType.PNG&&t[r.webp.LOSSLESS],s=e===r.fileType.PNG&&t[r.webp.ALPHA];return a||i&&s},isObjectFitBrowserSupport:function(){return n.getFeature("isObjectFitBrowser")},isImageTransformApplicable:function(e){return o(e)&&!c(e)},isValidRequest:function(e,t,a){return a&&t&&!function(e){return!e||!e.trim()||"none"===e.toLowerCase()}(t.id)&&i.includes(r.fittingTypes,e)},isImageTypeSupported:o,isExternalUrl:c,isWEBP:l,getFileType:function(e){return function(e){return i.includes(["jpg","jpeg"],u(e))}(e)?r.fileType.JPG:function(e){return i.includes(["png"],u(e))}(e)?r.fileType.PNG:l(e)?r.fileType.WEBP:r.fileType.UNRECOGNIZED},getFileExtension:u,getFileName:function(e,t){var a=/\.([^.]*)$/;if("string"==typeof t&&t.length){var n=t,s=t.match(a);return s&&i.includes(r.supportedExtensions,s[1])&&(n=t.replace(a,"")),encodeURIComponent(n)}var o=e.match(/\/(.*?)$/);return(o?o[1]:e).replace(a,"")},getAlignedRect:function(e,t,a){var i=void 0,n=void 0;switch(a){case r.alignTypes.CENTER:i=Math.max(0,(e.width-t.width)/2),n=Math.max(0,(e.height-t.height)/2);break;case r.alignTypes.TOP:i=Math.max(0,(e.width-t.width)/2),n=0;break;case r.alignTypes.TOP_LEFT:i=0,n=0;break;case r.alignTypes.TOP_RIGHT:i=Math.max(0,e.width-t.width),n=0;break;case r.alignTypes.BOTTOM:i=Math.max(0,(e.width-t.width)/2),n=Math.max(0,e.height-t.height);break;case r.alignTypes.BOTTOM_LEFT:i=0,n=Math.max(0,e.height-t.height);break;case r.alignTypes.BOTTOM_RIGHT:i=Math.max(0,e.width-t.width),n=Math.max(0,e.height-t.height);break;case r.alignTypes.LEFT:i=0,n=Math.max(0,(e.height-t.height)/2);break;case r.alignTypes.RIGHT:i=Math.max(0,e.width-t.width),n=Math.max(0,(e.height-t.height)/2)}return{x:e.x?e.x+i:i,y:e.y?e.y+n:n,width:Math.min(e.width,t.width),height:Math.min(e.height,t.height)}},getOverlappingRect:function(e,t){var a=Math.max(0,Math.min(e.width,t.x+t.width)-Math.max(0,t.x)),i=Math.max(0,Math.min(e.height,t.y+t.height)-Math.max(0,t.y));return a&&i&&(e.width!==a||e.height!==i)?{x:Math.max(0,t.x),y:Math.max(0,t.y),width:a,height:i}:null},getScaleFactor:p,getTransformData:function(e,t,a,i,n){var s=function(e){return Math.min(e.pixelAspectRatio||1,r.MAX_DEVICE_PIXEL_RATIO)}(a),o=function(e,t,a,i,n){var s=void 0,o=void 0,l=void 0;if(s=p(e,t,a,i,n),n===r.transformTypes.FILL?(o=a,l=i):n===r.transformTypes.FIT&&(o=e*s,l=t*s),o*l>r.SAFE_TRANSFORMED_AREA){var c=Math.sqrt(r.SAFE_TRANSFORMED_AREA/(o*l));s=p(e,t,o*=c,l*=c,n)}return{scaleFactor:s,width:o,height:l}}(e,t,a.width*s,a.height*s,i),l=o.scaleFactor;return function(e,t,a,i,n,s,o){var l=function(e,t,a,i){return{classic:h,auto:f,super:g}[i](e,t,a)}(e,t,s,n),c=l.optimizedScaleFactor,u=l.upscaleMethodValue,p=l.forceUSM;if(s<=c)return{width:a,height:i,scaleFactor:s,upscaleMethodValue:u,forceUSM:p,cssUpscaleNeeded:!1};var T=void 0,A=void 0;switch(o){case r.transformTypes.FILL:T=a*(c/s),A=i*(c/s);break;case r.transformTypes.FIT:T=e*c,A=t*c}return{width:T,height:A,scaleFactor:c,upscaleMethodValue:u,forceUSM:p,cssUpscaleNeeded:!0}}(e,t,o.width,o.height,n,l,i)},getAlignment:function(e){return r.alignTypesMap[e.alignment]||r.alignTypesMap[r.alignTypes.CENTER]},getPreferredImageQuality:function(e,t){return r.imageScaleDefaults[T(e,t)].quality},getDimension:function(e,t,a,i,r){var n=p(e,t,a,i,r);return{width:Math.round(e*n),height:Math.round(t*n)}},getFocalPoint:function(e){var t=null;return"number"==typeof e.x&&"number"==typeof e.y&&(t={x:A(Math.max(0,Math.min(100,e.x))/100,2),y:A(Math.max(0,Math.min(100,e.y))/100,2)}),t},getUpscaleString:function(e){return e&&e.upscaleMethod&&"string"==typeof e.upscaleMethod&&r.upscaleMethods[e.upscaleMethod.toUpperCase()]||r.upscaleMethods.AUTO},roundToFixed:A}},function(e,t,a){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};e.exports={assign:function(){for(var e=arguments[0]||{},t=Array.prototype.slice.call(arguments,1,arguments.length),a=0;a<t.length;a++){var i=t[a];for(var r in i)i.hasOwnProperty(r)&&(e[r]=i[r])}return e},includes:function(e,t){return e.indexOf?e.indexOf(t)>-1:!(!e||"object"!==(void 0===e?"undefined":i(e)))&&Object.keys(e).some(function(a){return e[a]===t})},last:function(e){return e[e.length-1]},template:function(e){return function(t){var a=e;for(var i in t)t.hasOwnProperty(i)&&(a=a.replace(new RegExp("\\${"+i+"}","g"),t[i]));return a}}}},function(e,t,a){"use strict";var i=a(1),r=a(5),n=a(6);e.exports=function(e,t,a,s){var o=i.getFileType(t.id),l={fileName:i.getFileName(t.id,t.name),fileExtension:i.getFileExtension(t.id),fileType:o,isWEBPSupport:i.isWEBPBrowserSupport(o),fittingType:e,src:{id:t.id,width:t.width,height:t.height,isCropped:!1},focalPoint:{x:t.focalPoint&&t.focalPoint.x,y:t.focalPoint&&t.focalPoint.y},quality:0,upscaleMethod:i.getUpscaleString(s),progressive:!0,unsharpMask:{},watermark:"",parts:[]};return i.isImageTransformApplicable(t.id)&&(r.setTransformParts(l,t,a),n.setTransformOptions(l,s)),l}},function(e,t,a){"use strict";var i={isWEBP:{lossless:!1,lossy:!1,alpha:!1,animation:!1},isObjectFitBrowser:!1};e.exports={getFeature:function(e){return i[e]},setFeature:function(e,t){i[e]=t}}},function(e,t,a){"use strict";var i=a(2),r=a(0),n=a(1);function s(e,t){var a=n.getTransformData(e.src.width,e.src.height,t,r.transformTypes.FIT,e.upscaleMethod);return{transformType:r.transformTypes.FILL,width:Math.round(a.width),height:Math.round(a.height),alignment:r.alignTypesMap.center,upscale:a.scaleFactor>1,forceUSM:a.forceUSM,scaleFactor:a.scaleFactor,cssUpscaleNeeded:a.cssUpscaleNeeded,upscaleMethodValue:a.upscaleMethodValue}}function o(e){return{transformType:r.transformTypes.CROP,x:Math.round(e.x),y:Math.round(e.y),width:Math.round(e.width),height:Math.round(e.height),upscale:!1,forceUSM:!1,scaleFactor:1,cssUpscaleNeeded:!1}}e.exports={setTransformParts:function(e,t,a){var l=void 0;switch(t.crop&&(l=n.getOverlappingRect(t,t.crop))&&(e.src.width=l.width,e.src.height=l.height,e.src.cropped=!0,e.parts.push(o(l))),e.fittingType){case r.fittingTypes.SCALE_TO_FIT:case r.fittingTypes.LEGACY_FIT_WIDTH:case r.fittingTypes.LEGACY_FIT_HEIGHT:case r.fittingTypes.LEGACY_FULL:case r.fittingTypes.FIT_AND_TILE:case r.fittingTypes.LEGACY_BG_FIT_AND_TILE:case r.fittingTypes.LEGACY_BG_FIT_AND_TILE_HORIZONTAL:case r.fittingTypes.LEGACY_BG_FIT_AND_TILE_VERTICAL:case r.fittingTypes.LEGACY_BG_NORMAL:e.parts.push(s(e,a));break;case r.fittingTypes.SCALE_TO_FILL:e.parts.push(function(e,t){var a=n.getTransformData(e.src.width,e.src.height,t,r.transformTypes.FILL,e.upscaleMethod),i=n.getFocalPoint(e.focalPoint);return{transformType:i?r.transformTypes.FILL_FOCAL:r.transformTypes.FILL,width:Math.round(a.width),height:Math.round(a.height),alignment:n.getAlignment(t),focalPointX:i&&i.x,focalPointY:i&&i.y,upscale:a.scaleFactor>1,forceUSM:a.forceUSM,scaleFactor:a.scaleFactor,cssUpscaleNeeded:a.cssUpscaleNeeded,upscaleMethodValue:a.upscaleMethodValue}}(e,a));break;case r.fittingTypes.STRETCH:e.parts.push(function(e,t){var a=n.getScaleFactor(e.src.width,e.src.height,t.width,t.height,r.transformTypes.FILL),o=i.assign({},t);return o.width=e.src.width*a,o.height=e.src.height*a,s(e,o)}(e,a));break;case r.fittingTypes.TILE_HORIZONTAL:case r.fittingTypes.TILE_VERTICAL:case r.fittingTypes.TILE:case r.fittingTypes.LEGACY_ORIGINAL_SIZE:case r.fittingTypes.ORIGINAL_SIZE:l=n.getAlignedRect(e.src,a,a.alignment),e.src.isCropped?(i.assign(e.parts[0],l),e.src.width=l.width,e.src.height=l.height):e.parts.push(o(l));break;case r.fittingTypes.LEGACY_STRIP_TILE_HORIZONTAL:case r.fittingTypes.LEGACY_STRIP_TILE_VERTICAL:case r.fittingTypes.LEGACY_STRIP_TILE:case r.fittingTypes.LEGACY_STRIP_ORIGINAL_SIZE:e.parts.push(function(e){return{transformType:r.transformTypes.LEGACY_CROP,width:Math.round(e.width),height:Math.round(e.height),alignment:n.getAlignment(e),upscale:!1,forceUSM:!1,scaleFactor:1,cssUpscaleNeeded:!1}}(a));break;case r.fittingTypes.LEGACY_STRIP_SCALE_TO_FIT:case r.fittingTypes.LEGACY_STRIP_FIT_AND_TILE:e.parts.push(function(e){return{transformType:r.transformTypes.FIT,width:Math.round(e.width),height:Math.round(e.height),upscale:!1,forceUSM:!0,scaleFactor:1,cssUpscaleNeeded:!1}}(a));break;case r.fittingTypes.LEGACY_STRIP_SCALE_TO_FILL:e.parts.push(function(e){return{transformType:r.transformTypes.LEGACY_FILL,width:Math.round(e.width),height:Math.round(e.height),alignment:n.getAlignment(e),upscale:!1,forceUSM:!0,scaleFactor:1,cssUpscaleNeeded:!1}}(a))}}}},function(e,t,a){"use strict";var i=a(2),r=a(0),n=a(1);e.exports={setTransformOptions:function(e,t){t=t||{},e.quality=function(e,t){var a=i.last(e.parts),r=n.getPreferredImageQuality(a.width,a.height),s=t.quality&&t.quality>=5&&t.quality<=90?t.quality:r;return parseInt(s,10)}(e,t),e.unsharpMask=function(e,t){var a=void 0;return!function(e){var t=void 0!==(e=e||{}).radius&&e.radius>=.1&&e.radius<=500,a=void 0!==e.amount&&e.amount>=0&&e.amount<=10,i=void 0!==e.threshold&&e.threshold>=0&&e.threshold<=255;return t&&a&&i}(t.unsharpMask)?function(e){return void 0!==(e=e||{}).radius&&0===e.radius&&void 0!==e.amount&&0===e.amount&&void 0!==e.threshold&&0===e.threshold}(t.unsharpMask)||function(e){var t=i.last(e.parts);return!(t.scaleFactor>=1)||t.forceUSM}(e)&&(a=r.defaultUSM):a={radius:t.unsharpMask.radius,amount:t.unsharpMask.amount,threshold:t.unsharpMask.threshold},a&&(a.radius=n.roundToFixed(a.radius,2),a.amount=n.roundToFixed(a.amount,2),a.threshold=n.roundToFixed(a.threshold,2)),a}(e,t),e.progressive=function(e){return!1!==e.progressive}(t),e.watermark=function(e){return e.watermark}(t)}}},function(e,t,a){"use strict";var i=a(0),r=a(1),n=a(8),s=a(3);e.exports=function(e,t,a,o,l){var c=i.emptyData.uri;return r.isImageTransformApplicable(t.id)?(l=l||s(e,t,a,o,l),c=n.getImageURI(l)):c=t.id,c}},function(e,t,a){"use strict";var i=a(2),r=a(0),n=i.template("fit/w_${width},h_${height}"),s=i.template("fill/w_${width},h_${height},al_${alignment}"),o=i.template("fill/w_${width},h_${height},fp_${focalPointX}_${focalPointY}"),l=i.template("crop/x_${x},y_${y},w_${width},h_${height}"),c=i.template("crop/w_${width},h_${height},al_${alignment}"),u=i.template("fill/w_${width},h_${height},al_${alignment}"),p=i.template(",lg_${upscaleMethodValue}"),h=i.template(",q_${quality}"),f=i.template(",usm_${radius}_${amount}_${threshold}"),g=i.template(",bl"),T=i.template(",wm_${watermark}");e.exports={getImageURI:function(e){var t=[];e.parts.forEach(function(e){switch(e.transformType){case r.transformTypes.CROP:t.push(l(e));break;case r.transformTypes.LEGACY_CROP:t.push(c(e));break;case r.transformTypes.LEGACY_FILL:var a=u(e);e.upscale&&(a+=p(e)),t.push(a);break;case r.transformTypes.FIT:var i=n(e);e.upscale&&(i+=p(e)),t.push(i);break;case r.transformTypes.FILL:var h=s(e);e.upscale&&(h+=p(e)),t.push(h);break;case r.transformTypes.FILL_FOCAL:var f=o(e);e.upscale&&(f+=p(e)),t.push(f)}});var a=t.join("/");return(e.fileType===r.fileType.PNG&&e.isWEBPSupport||e.fileType===r.fileType.JPG)&&(a+=h(e)),e.unsharpMask&&(a+=f(e.unsharpMask)),e.progressive||(a+=g(e)),e.watermark&&(a+=T(e)),e.src.id+"/"+r.API_VERSION+"/"+a+"/"+e.fileName+"."+(e.isWEBPSupport?"webp":e.fileExtension)}}},,,,,,,function(e,t,a){"use strict";var i=a(16),r=a(0);i.populateGlobalFeatureSupport();var n="https://static.wixstatic.com/",s="https://static.wixstatic.com/media/",o=/^media\//i;function l(e){return o.test(e)?""+n+e:""+s+e}e.exports={getScaleToFitImageURL:function(e,t,a,n,s,o){return l(i.getData(r.fittingTypes.SCALE_TO_FIT,{id:e,width:t,height:a,name:o&&o.name},{width:n,height:s,htmlTag:i.htmlTag.IMG,alignment:i.alignTypes.CENTER,pixelAspectRatio:window.devicePixelRatio},o).uri)},getScaleToFillImageURL:function(e,t,a,n,s,o){return l(i.getData(r.fittingTypes.SCALE_TO_FILL,{id:e,width:t,height:a,name:o&&o.name,focalPoint:{x:o&&o.focalPoint&&o.focalPoint.x,y:o&&o.focalPoint&&o.focalPoint.y}},{width:n,height:s,htmlTag:i.htmlTag.IMG,alignment:i.alignTypes.CENTER,pixelAspectRatio:window.devicePixelRatio},o).uri)},getCropImageURL:function(e,t,a,n,s,o,c,u,p,h){return l(i.getData(r.fittingTypes.SCALE_TO_FILL,{id:e,width:t,height:a,name:h&&h.name,crop:{x:n,y:s,width:o,height:c}},{width:u,height:p,htmlTag:i.htmlTag.IMG,alignment:i.alignTypes.CENTER,pixelAspectRatio:window.devicePixelRatio},h).uri)}}},function(e,t,a){"use strict";var i=a(0),r=a(1),n=a(7);e.exports={populateGlobalFeatureSupport:r.populateGlobalFeatureSupport,getData:function(e,t,a,s){var o=i.emptyData.uri;return r.isValidRequest(e,t,a)&&(o=n(e,t,a,s)),{uri:o}},fittingTypes:i.fittingTypes,alignTypes:i.alignTypes,htmlTag:i.htmlTag,upscaleMethods:i.upscaleMethods}}])});
//# sourceMappingURL=imageClientSDK.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _versionManager = __webpack_require__(52);

var _versionManager2 = _interopRequireDefault(_versionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minDate = -8640000000000000;

module.exports = {
  fullscreen: [{
    version: _versionManager2.default.Versions.min,
    dateFrom: minDate
  }, {
    version: 'V2',
    dateFrom: Date.parse('2017-09-25T12:00:00.000Z'),
    description: 'Editor_Settings_Upgrade_Panel_Upgrade_Expand_Mode',
    affectsProGallery: true,
    affectsArtStore: false
  }],
  spacing: [{
    version: _versionManager2.default.Versions.min,
    dateFrom: minDate
  }, {
    version: 2,
    dateFrom: Date.parse('2017-08-29T11:27:29.000Z'),
    ignoreUserManuaUpdate: true
  }],
  layouts: [{
    version: _versionManager2.default.Versions.min,
    dateFrom: minDate
  }, {
    version: 2,
    dateFrom: Date.parse('2018-05-24T18:00:00.000Z')
  }]
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (url) {
	if (typeof url !== 'string') {
		throw new TypeError('Expected a string, got ' + typeof url);
	}

	url = url.trim();

	if (/^\.*\/|^(?!localhost)\w+:/.test(url)) {
		return url;
	}

	return url.replace(/^(?!(?:\w+:)?\/\/)/, 'http://');
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryContainer = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(76);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(45);

var _redux = __webpack_require__(37);

var _galleryActions = __webpack_require__(47);

var actions = _interopRequireWildcard(_galleryActions);

var _galleryView = __webpack_require__(115);

var _galleryView2 = _interopRequireDefault(_galleryView);

var _slideshowView = __webpack_require__(131);

var _slideshowView2 = _interopRequireDefault(_slideshowView);

var _layoutHelper = __webpack_require__(301);

var _itemsHelper = __webpack_require__(302);

var _dimensionsHelper = __webpack_require__(138);

var _proGalleryLayouter = __webpack_require__(39);

var _galleryItem = __webpack_require__(51);

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _galleryGroup = __webpack_require__(82);

var _galleryGroup2 = _interopRequireDefault(_galleryGroup);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _spacing = __webpack_require__(83);

var _layouts = __webpack_require__(136);

var _itemActions = __webpack_require__(22);

var _biLogger = __webpack_require__(29);

var _WixSdkWrapper = __webpack_require__(13);

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _consts = __webpack_require__(49);

var _consts2 = _interopRequireDefault(_consts);

var _axios = __webpack_require__(30);

var _axios2 = _interopRequireDefault(_axios);

var _prependHttpExtra = __webpack_require__(137);

var _prependHttpExtra2 = _interopRequireDefault(_prependHttpExtra);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryContainer = exports.GalleryContainer = function (_React$Component) {
  (0, _inherits3.default)(GalleryContainer, _React$Component);

  function GalleryContainer(props) {
    (0, _classCallCheck3.default)(this, GalleryContainer);

    //
    var _this = (0, _possibleConstructorReturn3.default)(this, (GalleryContainer.__proto__ || (0, _getPrototypeOf2.default)(GalleryContainer)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(GalleryContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.stateFromProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.stateFromProps(nextProps);
    }
  }, {
    key: 'stateFromProps',
    value: function stateFromProps(_ref) {
      var items = _ref.items,
          styles = _ref.styles,
          container = _ref.container,
          watermarkData = _ref.watermarkData;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      console.count('PROGALLERY [COUNT] - stateFromProps');
      console.time('PROGALLERY [TIMING] - stateFromProps');

      var _items = void 0,
          _styles = void 0,
          _container = void 0;

      var isNew = {
        items: !!items && (!this.state.items || items !== this.props.items),
        styles: !!styles && (!this.state.styles || styles !== this.props.styles),
        container: !!container && (!this.state.container || container !== this.props.container),
        watermark: !!watermarkData && watermarkData !== this.props.watermarkData
      };
      isNew.any = (0, _keys2.default)(isNew).reduce(function (is, key) {
        return is || isNew[key];
      }, false);

      items = items || this.items;

      console.log('PROGALLERY [RENDERS] - stateFromProps', { isNew: isNew }, { items: items, styles: styles, container: container, watermarkData: watermarkData });

      var newState = {};

      if (isNew.items) {
        _items = items.map(function (item) {
          return _itemsHelper.ItemsHelper.convertDtoToLayoutItem(item);
        });
        this.items = _items;
        newState.items = _items.map(function (item) {
          return item.id;
        });
      } else {
        _items = this.state.items;
      }

      if (isNew.styles || isNew.container) {
        styles = styles || this.state.styles;
        container = container || this.state.container;

        _styles = (0, _layoutHelper.addLayoutStyles)(styles, container);
        _container = (0, _assign2.default)({}, container, (0, _dimensionsHelper.getGalleryDimensions)(styles, container), {
          scrollBase: this.getScrollBase(),
          getScrollingElement: this.getScrollingElement(_styles)
        });
        newState.styles = _styles;
        newState.container = _container;
      } else {
        _styles = this.state.styles;
        _container = this.state.container;
      }

      if (!this.galleryStructure || isNew.any) {
        var layoutParams = {
          items: _items,
          container: _container,
          styleParams: _styles,
          gotScrollEvent: true,
          showAllItems: true
        };

        var layout = (0, _proGalleryLayouter.createLayout)(layoutParams);

        this.galleryStructure = _itemsHelper.ItemsHelper.convertToGalleryItems(layout, {
          watermark: watermarkData,
          sharpParams: _styles.sharpParams
        });
      }

      if (isNew.any) {
        console.time('PROGALLERY [TIMING] - stateFromProps - newState setting');
        console.log('PROGALLERY [RENDERS] - newState', { newState: newState }, this.items, this.galleryStructure);
        this.setState(newState, function () {
          callback();
          console.timeEnd('PROGALLERY [TIMING] - stateFromProps - newState setting');
          console.timeEnd('PROGALLERY [TIMING] - stateFromProps');
        });
      } else {
        callback();
      }
    }
  }, {
    key: 'getScrollBase',
    value: function getScrollBase() {
      var scrollBase = this.props.container.scrollBase;

      var _document$getElementB = document.getElementById('pro-gallery-' + this.props.domId).getBoundingClientRect(),
          y = _document$getElementB.y;

      scrollBase += y;
      return scrollBase;
    }
  }, {
    key: 'getScrollingElement',
    value: function getScrollingElement(styles) {
      var _this2 = this;

      var horizontal = styles.oneRow ? function () {
        return document.querySelector('#pro-gallery-' + _this2.props.domId + ' #gallery-horizontal-scroll');
      } : function () {};
      var vertical = this.props.getScrollingElement ? typeof this.props.getScrollingElement === 'function' ? this.props.getScrollingElement : function () {
        return _this2.props.getScrollingElement;
      } : function () {
        return window;
      };
      return { vertical: vertical, horizontal: horizontal };
    }
  }, {
    key: 'getMoreItemsIfNeeded',
    value: function getMoreItemsIfNeeded(groupIdx) {
      var _this3 = this;

      if (this.props.getMoreItems && !this.gettingMoreItems && this.props.totalItemsCount > this.state.items.length && groupIdx === this.galleryStructure.groups.length - 1) {
        //this is the last group
        this.gettingMoreItems = true;
        console.error('PROGALLERY [ITEMS] Getting more items', this.state.items.length, this.props.totalItemsCount);
        this.props.getMoreItems(this.state.items.length, function (newItems) {
          _this3.stateFromProps({
            items: _this3.items.concat(newItems.map(function (item) {
              return _itemsHelper.ItemsHelper.convertDtoToLayoutItem(item);
            }) || [])
          }, function () {
            console.error('PROGALLERY [ITEMS] Got more items', _this3.state.items.length, _this3.props.totalItemsCount);
            _this3.gettingMoreItems = false;
          });
        });
      }
      return false;
    }
  }, {
    key: 'canRender',
    value: function canRender() {
      var can = this.state.container && this.state.styles && this.state.items;

      !can && console.log('PROGALLERY [CAN_RENDER] GalleryContainer', this.domId, can, this.state.container, this.state.styles, this.state.items);

      return can;
    }
  }, {
    key: 'render',
    value: function render() {

      if (!this.canRender()) {
        return null;
      }

      console.time('PROGALLERY [COUNTS] - GalleryContainer (render)');

      var styles = this.state.styles;

      var ViewComponent = styles.oneRow ? _slideshowView2.default : _galleryView2.default;
      console.log('PROGALLERY [RENDER] - GalleryContainer', this.state.container.scrollBase, { state: this.state, items: this.items });

      return _react2.default.createElement(
        'div',
        null,
        'NEWWWW',
        _react2.default.createElement(ViewComponent, (0, _extends3.default)({
          totalItemsCount: this.props.totalItemsCount //the items passed in the props might not be all the items
          , items: this.items,
          galleryStructure: this.galleryStructure,
          styleParams: styles,
          container: this.state.container,
          thumbnailSize: _dimensionsHelper.thumbnailSize,
          watermark: this.props.watermarkData,
          settings: this.props.settings,
          gotScrollEvent: true,
          scroll: _lodash2.default.merge({
            y: 0,
            scrollTop: 0,
            scale: 1
          }, {
            isInfinite: true
          }),
          convertToGalleryItems: _itemsHelper.ItemsHelper.convertToGalleryItems,
          convertDtoToLayoutItem: _itemsHelper.ItemsHelper.convertDtoToLayoutItem,
          domId: this.props.domId,
          actions: _lodash2.default.merge(this.props.actions, {
            getMoreItemsIfNeeded: this.getMoreItemsIfNeeded.bind(this),
            toggleInfiniteScroll: this.toggleInfiniteScroll,
            toggleFullscreen: this.toggleFullscreen,
            setWixHeight: this.setWixHeight,
            scrollToItem: this.scrollToItem
          }),
          debug: {
            lastHeight: this.lastHeight,
            newHeight: this.newHeight,
            resizeCount: this.resizeCount,
            orientationCount: this.orientationCount,
            maxGalleryWidth: this.props.maxGalleryWidth
          },
          store: this.props.store
        }, this.props.gallery))
      );
    }
  }]);
  return GalleryContainer;
}(_react2.default.Component);

function mapStateToProps(state) {
  return state.gallery;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actions, dispatch)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GalleryContainer);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLayoutStyles = undefined;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _spacing = __webpack_require__(83);

var _dimensionsHelper = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyLayout = {
  galleryType: undefined,
  groupSize: undefined,
  showArrows: undefined,
  cubeImages: undefined,
  cubeType: undefined,
  cubeRatio: undefined,
  isVertical: undefined,
  gallerySize: undefined,
  collageAmount: undefined,
  collageDensity: undefined,
  groupTypes: undefined,
  oneRow: undefined,
  borderRadius: undefined,
  boxShadow: undefined,
  imageMargin: undefined,
  galleryMargin: undefined,
  floatingImages: undefined,
  chooseBestGroup: undefined,
  smartCrop: undefined,
  hasThumbnails: undefined,
  enableScroll: undefined,
  isGrid: undefined,
  isSlider: undefined,
  isColumns: undefined,
  isSlideshow: undefined,
  cropOnlyFill: undefined,
  fixedColumns: undefined,
  enableInfiniteScroll: undefined
};

function getStyleBySeed(seed) {
  if (!seed > 0) {
    seed = 999999;
  }
  seed = Math.floor(seed);

  var strToSeed = function strToSeed(str) {
    str = String(str);
    var total = 0;
    for (var s = 0; s < str.length; s++) {
      total += str.charCodeAt(s);
    }
    return total;
  };

  var mergeSeeds = function mergeSeeds(s1, s2) {
    return Math.floor((s1 / s2 - Math.floor(s1 / s2)) * 10000000);
  };

  var numFromSeed = function numFromSeed(min, max, strSeed) {
    var seed2 = strToSeed(strSeed);
    var range = max - min + 1;
    return mergeSeeds(seed, seed2) % range + min;
  };

  var boolFromSeed = function boolFromSeed(strSeed) {
    return !!numFromSeed(0, 1, strSeed);
  };

  var style = {
    cubeImages: boolFromSeed('cubeImages'),
    cubeRatio: numFromSeed(1, 25, 'cubeRatio') / 5,
    isVertical: boolFromSeed('isVertical'),
    gallerySize: numFromSeed(300, 800, 'gallerySize'),
    collageAmount: numFromSeed(5, 10, 'collageAmount') / 10,
    collageDensity: (_spacing.spacingVersionManager.isNewSpacing() ? numFromSeed(1, 100, 'collageDensity') : numFromSeed(5, 10, 'collageDensity')) / 100,
    groupTypes: ['1'].concat(_lodash2.default.filter('2h,2v,3t,3b,3l,3r,3h,3v'.split(','), function (type, i) {
      return boolFromSeed('groupTypes' + i);
    })),
    oneRow: boolFromSeed('oneRow'),
    borderRadius: 0,
    boxShadow: 0,
    imageMargin: numFromSeed(0, _spacing.spacingVersionManager.isNewSpacing() ? numFromSeed(300, 800, 'gallerySize') / 5 : 5, 'imageMargin'),
    galleryMargin: _spacing.spacingVersionManager.isNewSpacing() ? 0 : numFromSeed(0, 5, 'imageMargin'),
    floatingImages: 0,
    chooseBestGroup: boolFromSeed('chooseBestGroup'),
    smartCrop: boolFromSeed('smartCrop'),
    showArrows: false,
    cubeType: 'fill',
    hasThumbnails: false,
    enableScroll: true,
    isGrid: false,
    isSlideshow: false,
    isSlider: false,
    isColumns: false,
    cropOnlyFill: false,
    fixedColumns: 0,
    enableInfiniteScroll: 1
  };

  //force adjustments
  if (style.oneRow) {
    style.isVertical = false;
  }
  style.galleryType = style.isVertical ? 'Columns' : 'Strips';
  style.groupSize = parseInt(_lodash2.default.last(style.groupTypes));
  style.groupTypes = style.groupTypes.join(',');
  style.minItemSize = style.gallerySize / style.groupSize / 2;

  return style;
}

function getStyleByGalleryType(styles, container) {
  //legacy layouts
  var galleryType = styles.galleryType,
      gallerySize = styles.gallerySize;


  var galleryTypes = {
    collage_ver: function collage_ver() {
      return {
        cubeImages: false,
        isVertical: true,
        galleryType: 'Columns',
        groupSize: 3,
        groupTypes: '1,2h,2v,3t,3b,3l,3r',
        gallerySize: Math.round(gallerySize * 5 + 500),
        fixedColumns: 0
      };
    },
    collage_hor: function collage_hor() {
      return {
        cubeImages: false,
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 3,
        groupTypes: '1,2h,2v,3t,3b,3l,3r',
        gallerySize: Math.round(gallerySize * 5 + 500),
        fixedColumns: 0
      };
    },
    grid: function grid() {
      return {
        cubeImages: true,
        isVertical: true,
        galleryType: 'Columns',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: Math.round(gallerySize * 8.5 + 150),
        fixedColumns: 0,
        isGrid: true
      };
    },
    masonry_ver: function masonry_ver() {
      return {
        cubeImages: false,
        isVertical: true,
        galleryType: 'Columns',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: Math.round(gallerySize * 8 + 200),
        fixedColumns: 0
      };
    },
    masonry_hor: function masonry_hor() {
      return {
        cubeImages: false,
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: Math.round(gallerySize * 5 + 200),
        fixedColumns: 0
      };
    },
    one_col: function one_col() {
      return {
        cubeImages: false,
        isVertical: true,
        galleryType: 'Columns',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: (0, _dimensionsHelper.getGalleryWidth)(styles, container), //'full_width';
        fixedColumns: 1
      };
    },
    one_row: function one_row() {
      return {
        cubeImages: false,
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: (0, _dimensionsHelper.getGalleryHeight)(styles, container),
        fixedColumns: 0
      };
    },
    slideshow: function slideshow() {
      return {
        showArrows: true,
        cubeImages: true,
        cubeRatio: (0, _dimensionsHelper.getGalleryRatio)(styles, container),
        isVertical: true,
        gallerySize: (0, _dimensionsHelper.getGalleryWidth)(styles, container),
        galleryType: 'Columns',
        groupSize: 1,
        groupTypes: '1',
        fixedColumns: 1
      };
    }
  };

  var styleState = void 0;

  switch (galleryType) {
    case '-1':
      //empty
      styleState = {
        gallerySize: gallerySize
      };
      break;
    case '0':
      //vertical collage
      styleState = galleryTypes.collage_ver();
      break;
    default:
    case '1':
      //horizontal collage
      styleState = galleryTypes.collage_hor();
      break;
    case '2':
      //grid
      styleState = galleryTypes.grid();
      break;
    case '3':
      //vertical masonry
      styleState = galleryTypes.masonry_ver();
      break;
    case '4':
      //horizontal masonry
      styleState = galleryTypes.masonry_hor();
      break;
    case '5':
      //one column
      styleState = galleryTypes.one_col();
      break;
    case '6':
      //one row
      styleState = galleryTypes.one_row();
      break;
    case '7':
      //slideshow
      styleState = galleryTypes.slideshow();
      break;
  }

  return styleState;
}

function getStyleByLayout(styles, container) {
  //new layouts
  var galleryLayout = styles.galleryLayout,
      gallerySize = styles.gallerySize,
      magicLayoutSeed = styles.magicLayoutSeed;


  var layouts = {
    collage: function collage() {
      return {
        showArrows: false,
        cubeImages: false,
        groupSize: 3,
        groupTypes: '1,2h,2v,3t,3b,3l,3r',
        gallerySize: Math.round(gallerySize * 5 + 500),
        fixedColumns: 0,
        hasThumbnails: false,
        enableScroll: true,
        isGrid: false,
        isSlider: false,
        isMasonry: false,
        isColumns: false,
        isSlideshow: false,
        cropOnlyFill: false
      };
    },
    masonry: function masonry() {
      return {
        showArrows: false,
        cubeImages: false,
        groupSize: 1,
        groupTypes: '1',
        gallerySize: gallerySize,
        fixedColumns: 0,
        hasThumbnails: false,
        enableScroll: true,
        isGrid: false,
        isSlider: false,
        isMasonry: true,
        isColumns: false,
        isSlideshow: false,
        cropOnlyFill: false,
        oneRow: false
      };
    },
    grid: function grid() {
      return {
        showArrows: false,
        cubeImages: true,
        smartCrop: false,
        imageResize: false,
        isVertical: true,
        galleryType: 'Columns',
        groupSize: 1,
        groupTypes: '1',
        fixedColumns: undefined,
        gallerySize: Math.round(gallerySize * 8.5 + 150),
        hasThumbnails: false,
        enableScroll: true,
        cropOnlyFill: false,
        isSlider: false,
        isColumns: false,
        isGrid: true,
        isMasonry: false,
        isSlideshow: false,
        minItemSize: 50
      };
    },
    thumbnails: function thumbnails() {
      return {
        showArrows: true,
        cubeImages: true,
        smartCrop: false,
        cubeType: 'fill',
        cubeRatio: function cubeRatio() {
          var dims = (0, _dimensionsHelper.getGalleryDimensions)(styles, container);
          return dims.galleryWidth / dims.galleryHeight;
        },
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 1,
        gallerySize: (0, _dimensionsHelper.getGalleryWidth)(styles, container),
        groupTypes: '1',
        oneRow: true,
        hasThumbnails: true,
        enableScroll: false,
        isGrid: false,
        isSlider: false,
        isMasonry: false,
        isColumns: false,
        isSlideshow: false,
        cropOnlyFill: false,
        floatingImages: 0,
        galleryMargin: 0,
        imageMargin: 0
      };
    },
    slider: function slider() {
      return {
        showArrows: true,
        cubeImages: true,
        smartCrop: false,
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: (0, _dimensionsHelper.getGalleryHeight)(styles, container),
        oneRow: true,
        hasThumbnails: false,
        enableScroll: true,
        isGrid: false,
        isSlider: true,
        isColumns: false,
        isMasonry: false,
        isSlideshow: false,
        cropOnlyFill: true
      };
    },
    slideshow: function slideshow() {
      return {
        showArrows: true,
        cubeImages: true,
        smartCrop: false,
        cubeRatio: function cubeRatio() {
          var dims = (0, _dimensionsHelper.getGalleryDimensions)(styles, container);
          return dims.galleryWidth / dims.galleryHeight;
        },
        cubeType: 'fill',
        isVertical: false,
        gallerySize: 550,
        galleryType: 'Strips',
        groupSize: 1,
        groupTypes: '1',
        fixedColumns: 1,
        oneRow: true,
        hasThumbnails: false,
        enableScroll: false,
        isGrid: false,
        isColumns: false,
        isMasonry: false,
        isSlider: false,
        isSlideshow: true,
        cropOnlyFill: false,
        floatingImages: 0,
        galleryMargin: 0,
        imageMargin: 0
      };
    },
    panorama: function panorama() {
      return {
        showArrows: false,
        cubeImages: false,
        isVertical: true,
        galleryType: 'Columns',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: (0, _dimensionsHelper.getGalleryWidth)(styles, container),
        oneRow: false,
        fixedColumns: 1,
        hasThumbnails: false,
        enableScroll: true,
        isGrid: false,
        isColumns: false,
        isMasonry: false,
        isSlider: false,
        isSlideshow: false,
        cropOnlyFill: false
      };
    },
    column: function column() {
      return {
        showArrows: true,
        cubeImages: true,
        smartCrop: false,
        cubeType: 'fill',
        cubeRatio: 0.35,
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 1,
        groupTypes: '1',
        gallerySize: (0, _dimensionsHelper.getGalleryHeight)(styles, container),
        fixedColumns: 0,
        hasThumbnails: false,
        oneRow: true,
        enableScroll: true,
        isGrid: false,
        isColumns: true,
        isMasonry: false,
        isSlider: false,
        isSlideshow: false,
        cropOnlyFill: false
      };
    },
    fullsize: function fullsize() {
      return {
        showArrows: true,
        cubeImages: true,
        smartCrop: false,
        cubeType: 'fill',
        cubeRatio: function cubeRatio() {
          var dims = (0, _dimensionsHelper.getGalleryDimensions)(styles, container);
          return dims.galleryWidth / dims.galleryHeight;
        },
        isVertical: false,
        galleryType: 'Strips',
        groupSize: 1,
        gallerySize: (0, _dimensionsHelper.getGalleryWidth)(styles, container),
        groupTypes: '1',
        oneRow: true,
        hasThumbnails: false,
        enableScroll: false,
        isGrid: false,
        isSlider: false,
        isColumns: false,
        isMasonry: false,
        isSlideshow: false,
        cropOnlyFill: false,
        floatingImages: 0,
        galleryMargin: 0,
        imageMargin: 0
      };
    },
    empty: function empty() {
      return {
        gallerySize: Math.round(gallerySize * 9 + 100)
      };
    },
    magic: function magic() {
      return getStyleBySeed(magicLayoutSeed);
    }
  };

  var galleyLayoutList = ['empty', // -1
  'collage', // 0
  'masonry', // 1
  'grid', // 2
  'thumbnails', // 3
  'slider', // 4
  'slideshow', // 5
  'panorama', // 6
  'column', // 7
  'magic', // 8
  'fullsize' // 9
  ];

  var layoutName = galleyLayoutList[galleryLayout + 1]; //the empty layout is -1, collage is 0 etc.
  if (_lodash2.default.isUndefined(layoutName)) {
    if (_utils2.default.isStoreGallery()) {
      galleryLayout = 2;
      layoutName = 'grid';
    } else {
      galleryLayout = 0;
      layoutName = 'collage';
    }
  }

  var specialMobileStoreConfig = {};
  if (_utils2.default.isStoreGallery() && _utils2.default.isMobile()) {
    galleryLayout = 2;
    layoutName = 'grid';
    specialMobileStoreConfig.forceMobileCustomButton = true;
  }

  if (_utils2.default.isVerbose()) {
    console.log('chosen layout is', layoutName);
  }

  return _lodash2.default.merge(layouts[layoutName](), specialMobileStoreConfig, {
    galleryLayout: galleryLayout
  });
}

function addLayoutStyles(styles, container) {

  var galleryLayoutV1 = styles.galleryType;
  var galleryLayoutV2 = styles.galleryLayout;

  if (!_lodash2.default.isUndefined(galleryLayoutV1) && _lodash2.default.isUndefined(galleryLayoutV2)) {
    //legacy layouts - only if galleyrType parameter is specifically defined (i.e. layout had changed)

    styles = (0, _assign2.default)(styles, getStyleByGalleryType(styles, container)); //legacy layouts
    styles.layoutsVersion = 1;
    var selectedLayoutVars = ['galleryType', 'galleryThumbnailsAlignment', 'magicLayoutSeed', 'imageResize', 'isVertical', 'scrollDirection', 'enableInfiniteScroll'];
    styles.selectedLayout = selectedLayoutVars.map(function (key) {
      return String(styles[key]);
    }).join('|');
  } else {
    //new layouts
    if (_utils2.default.isVerbose()) {
      console.log('Using galleryLayout for defaults', styles);
    }
    styles = (0, _assign2.default)(emptyLayout, styles, getStyleByLayout(styles, container)); //legacy layouts
    var _selectedLayoutVars = ['galleryLayout', 'galleryThumbnailsAlignment', 'magicLayoutSeed', 'imageResize', 'isVertical', 'scrollDirection', 'enableInfiniteScroll'];
    styles.selectedLayout = _selectedLayoutVars.map(function (key) {
      return String(styles[key]);
    }).join('|');
    styles.layoutsVersion = 2;
    styles.selectedLayoutV2 = galleryLayoutV2;
    if (_utils2.default.isVerbose()) {
      console.log('new selected layout', styles.selectedLayout);
    }
  }

  return styles;
}

exports.addLayoutStyles = addLayoutStyles;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemsHelper = undefined;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _galleryItem = __webpack_require__(51);

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _galleryGroup = __webpack_require__(82);

var _galleryGroup2 = _interopRequireDefault(_galleryGroup);

var _utils = __webpack_require__(3);

var _utils2 = _interopRequireDefault(_utils);

var _lodash = __webpack_require__(7);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemsHelper = exports.ItemsHelper = function () {
  function ItemsHelper() {
    (0, _classCallCheck3.default)(this, ItemsHelper);
  }

  (0, _createClass3.default)(ItemsHelper, null, [{
    key: 'convertDtoToLayoutItem',
    value: function convertDtoToLayoutItem(dto) {
      var isLayoutItem = !!(dto.id && dto.width > 0 && dto.height > 0);
      if (isLayoutItem) {
        return dto;
      } else {
        var dtoMetadata = dto.metadata || dto.metaData;
        var metadata = _lodash2.default.isObject(dtoMetadata) ? dtoMetadata : _utils2.default.parseStringObject(dtoMetadata) || {};
        return (0, _extends3.default)({
          id: dto.itemId || dto.photoId,
          width: metadata.width,
          height: metadata.height
        }, dto);
      }
    }
  }, {
    key: 'convertToGalleryItems',
    value: function convertToGalleryItems(galleryStructure) {
      var itemConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pointer = 0;
      galleryStructure.galleryItems = [];
      for (var c = 0; c < galleryStructure.columns.length; c++) {
        var column = galleryStructure.columns[c];
        column.galleryGroups = [];
        var groups = column.groups || column;
        for (var g = 0; g < groups.length; g++) {
          var group = groups[g];
          var groupItems = [];
          for (var i = 0; i < group.items.length; i++) {
            var item = group.items[i];
            groupItems[i] = new _galleryItem2.default((0, _assign2.default)({
              scheme: item,
              dto: item.dto
            }, itemConfig));
            galleryStructure.galleryItems[item.idx] = groupItems[i];
            pointer++;
          }
          column.galleryGroups[g] = new _galleryGroup2.default({
            scheme: group,
            dto: group.dto,
            items: groupItems
          });
        }
      }

      console.log({ galleryStructure: galleryStructure });

      return galleryStructure;
    }
  }]);
  return ItemsHelper;
}();

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _galleryTypes = __webpack_require__(68);

var types = _interopRequireWildcard(_galleryTypes);

var _videoPlayModes = __webpack_require__(304);

var _videoPlayModes2 = _interopRequireDefault(_videoPlayModes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function (_ref) {
  var videoQueue = _ref.videoQueue,
      utils = _ref.utils;
  return function (store) {

    var playVideo = function playVideo(i) {
      store.dispatch({ type: types.SET_VIDEO_PLAY_INDEX, payload: i });
    };

    var playCurrentVideo = function playCurrentVideo() {
      playVideo(videoQueue.current());
    };

    var playNextVideo = function playNextVideo() {
      playVideo(videoQueue.next());
    };

    var stopPlaying = function stopPlaying() {
      playVideo(-1);
    };

    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;

        var _store$getState = store.getState(),
            videoPlayMode = _store$getState.gallery.videoPlayMode;

        // This doesn't affect autoplay


        switch (type) {
          case types.VIDEO_ADDED:
            videoQueue.addItem(payload);
            break;
          case types.VIDEO_REMOVED:
            videoQueue.removeItem(payload);
            break;
        }

        next(action);

        // Auto-play handling
        var isAutoPlay = videoPlayMode === _videoPlayModes2.default.autoPlay;
        var indexToPlay = null;
        if (utils.isEditor() && payload !== -1) {
          stopPlaying();
        } else if (isAutoPlay) {
          switch (type) {
            case types.NAVIGATION_IN:
            case types.VIDEO_ENDED:
              playNextVideo();
              break;
            case types.EDITOR_MODE_CHANGED:
            case types.GALLERY_WINDOW_LAYOUT_CHANGED:
              indexToPlay = videoQueue.isCurrentVideoVisible() ? playCurrentVideo() : playNextVideo();
              break;
            case types.VIDEO_ADDED:
              playCurrentVideo();
              break;
            default:
              break;
          }
        }
      };
    };
  };
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  hover: 0,
  autoPlay: 1,
  click: 2
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoQueue = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoQueue = exports.VideoQueue = function () {
  function VideoQueue() {
    (0, _classCallCheck3.default)(this, VideoQueue);

    this.que = [];
    this.dummyVideo = { idx: -1, isVisible: function isVisible() {
        return false;
      } };
    this.video = this.dummyVideo;
  }

  (0, _createClass3.default)(VideoQueue, [{
    key: "current",
    value: function current() {
      return this.video.idx;
    }
  }, {
    key: "isCurrentVideoVisible",
    value: function isCurrentVideoVisible() {
      return this.video.isVisible();
    }
  }, {
    key: "next",
    value: function next() {
      if (this.que.length === 0) {
        return null;
      }
      var i = this.que.indexOf(this.video);
      var nextVideo = this.nextVisibleVideo(i + 1);

      this.video = nextVideo;
      return this.video.idx;
    }
  }, {
    key: "nextVisibleVideo",
    value: function nextVisibleVideo(j) {
      var len = this.que.length;
      var queIndex = void 0;
      for (var i = 0; i < len; i++) {
        queIndex = (i + j) % len;
        if (this.que[queIndex].isVisible()) {
          break;
        }
      }
      return this.que[queIndex].isVisible() ? this.que[queIndex] : this.dummyVideo;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.que.length === 0;
    }
  }, {
    key: "addItem",
    value: function addItem(item) {
      if (this.isEmpty()) {
        this.video = item;
      }
      this.que.push(item);
    }
  }, {
    key: "removeItem",
    value: function removeItem(id) {
      this.que = this.que.filter(function (element) {
        return element.idx !== id;
      });
      if (this.isEmpty()) {
        this.video = this.dummyVideo;
      }
    }
  }]);
  return VideoQueue;
}();

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultImages = [{
  metadata: {
    height: 1000,
    lastModified: 1445860855,
    name: '8b72558253b2502b401bb46e5599f22a',
    size: 1100727,
    width: 1920,
    sourceName: 'private'
  },
  orderIndex: 0,
  photoId: '8b72558253b2502b401bb46e5599f22a',
  url: '8bb438_1b73a6b067b24175bd087e86613bd00c.jpg'
}, {
  metadata: {
    height: 5600,
    lastModified: 1445857830,
    name: '2d3b675ea857dc41158bad3b28300824',
    size: 8128464,
    width: 3737
  },
  orderIndex: 1,
  photoId: '2d3b675ea857dc41158bad3b28300824',
  url: '8bb438_78ff5e32500d48cdaa22a3f446d68216.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857821,
    name: '860df034014674abd7a2e73abe0b851b',
    size: 5655675,
    width: 5600
  },
  orderIndex: 2,
  photoId: '860df034014674abd7a2e73abe0b851b',
  url: '8bb438_ff062a651e174cf5926fe5c088be1099.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857814,
    name: 'a898a24fe0d2c60a348eac9e38cae265',
    size: 11697590,
    width: 5600
  },
  orderIndex: 3,
  photoId: 'a898a24fe0d2c60a348eac9e38cae265',
  url: '8bb438_5ec836c505f445dfab711a56e67fc502.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857800,
    name: '5dd5a6e757c702b2856a3a2f4bb00154',
    size: 6528300,
    width: 5600
  },
  orderIndex: 4,
  photoId: '5dd5a6e757c702b2856a3a2f4bb00154',
  url: '8bb438_2798f080526a4d3f8cb89d93e305a0b8.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857785,
    name: 'e8b32772f67865aedb3b12115eaf19a4',
    size: 4931341,
    width: 5600
  },
  orderIndex: 5,
  photoId: 'e8b32772f67865aedb3b12115eaf19a4',
  url: '8bb438_9a335dcb8c884086b8ffdf1ea44ca7e9.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857778,
    name: '90e376fcd4b801bed0f22cb5bd7d0045',
    size: 11051393,
    width: 5600
  },
  orderIndex: 6,
  photoId: '90e376fcd4b801bed0f22cb5bd7d0045',
  url: '8bb438_6e9b65f5c9e343c6bc3344b2def0df11.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857763,
    name: '0db65a80624a2e0b8c71e553b6f4b3f6',
    size: 9294683,
    width: 5600
  },
  orderIndex: 7,
  photoId: '0db65a80624a2e0b8c71e553b6f4b3f6',
  url: '8bb438_f4f7fa31c5364557af0da7c4fd543cc9.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857751,
    name: '1f02dcba84a9b73b40d25e59280a9580',
    size: 9048422,
    width: 5600
  },
  orderIndex: 8,
  photoId: '1f02dcba84a9b73b40d25e59280a9580',
  url: '8bb438_0e26eb36903c40558d3e9a3dc088b791.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857742,
    name: '70cf2b13f9bde8f8c33768260f25050a',
    size: 6486671,
    width: 5600
  },
  orderIndex: 9,
  photoId: '70cf2b13f9bde8f8c33768260f25050a',
  url: '8bb438_1d81fe98c5cc433a9651fc24e7ce2617.jpg'
}, {
  metadata: {
    height: 3737,
    lastModified: 1445857734,
    name: '8e0bf32b6fade59dcfd7757ead8a0478',
    size: 9556027,
    width: 5600
  },
  orderIndex: 10,
  photoId: '8e0bf32b6fade59dcfd7757ead8a0478',
  url: '8bb438_2ecb6a1a9d5b4e148bd83a1ea3920860.jpg'
}];

var defaultVideos = [{
  itemId: 'd19570fa-e97f-4b3d-b8ad-4e24b3a9a3ec',
  url: '0d72ac_31569a98fd8d436f98ae9c827c216443',
  orderIndex: 1.447790730099E8,
  metadata: {
    name: '342278662.mp4',
    size: 8941842,
    lastModified: 1431352380000,
    width: 1920,
    height: 1080,
    type: 'video',
    posters: [{
      url: '0d72ac_31569a98fd8d436f98ae9c827c216443f000.jpg',
      height: 1080,
      width: 1920
    }, {
      url: '0d72ac_31569a98fd8d436f98ae9c827c216443f001.jpg',
      height: 1080,
      width: 1920
    }, {
      url: '0d72ac_31569a98fd8d436f98ae9c827c216443f002.jpg',
      height: 1080,
      width: 1920
    }, { url: '0d72ac_31569a98fd8d436f98ae9c827c216443f003.jpg', height: 1080, width: 1920 }],
    duration: 14914,
    qualities: [{
      formats: ['mp4', 'webm'],
      height: 480,
      quality: '480p',
      width: 854
    }, { formats: ['mp4', 'webm'], height: 720, quality: '720p', width: 1280 }, {
      formats: ['mp4', 'webm'],
      height: 1080,
      quality: '1080p',
      width: 1920
    }]
  }
}, {
  itemId: '5f51db65-4104-447b-b675-94657671a73f',
  url: '0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dc',
  orderIndex: 1.447790760099E8,
  metadata: {
    name: '343014810.mp4',
    size: 23225503,
    lastModified: 1435064726000,
    width: 1920,
    height: 1080,
    type: 'video',
    posters: [{
      url: '0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf000.jpg',
      height: 1080,
      width: 1920
    }, {
      url: '0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf001.jpg',
      height: 1080,
      width: 1920
    }, {
      url: '0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf002.jpg',
      height: 1080,
      width: 1920
    }, { url: '0d72ac_3e5c5b13a90749a6a02c845e8d1fa4dcf003.jpg', height: 1080, width: 1920 }],
    duration: 44878,
    qualities: [{
      formats: ['mp4', 'webm'],
      height: 480,
      quality: '480p',
      width: 854
    }, { formats: ['mp4', 'webm'], height: 720, quality: '720p', width: 1280 }, {
      formats: ['mp4', 'webm'],
      height: 1080,
      quality: '1080p',
      width: 1920
    }]
  }
}, {
  itemId: '98c5601c-3486-452b-933c-49cb451d676f',
  url: '0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0db',
  orderIndex: 1.447790830099E8,
  metadata: {
    name: 'Loop_NightRide1 (1).mp4',
    size: 50631228,
    lastModified: 1441172756000,
    width: 1920,
    height: 1080,
    type: 'video',
    posters: [{
      url: '0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf000.jpg',
      height: 1080,
      width: 1920
    }, {
      url: '0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf001.jpg',
      height: 1080,
      width: 1920
    }, {
      url: '0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf002.jpg',
      height: 1080,
      width: 1920
    }, { url: '0d72ac_8cebf3ded81a496cb5a1dde4d3ebf0dbf003.jpg', height: 1080, width: 1920 }],
    duration: 24290,
    qualities: [{
      formats: ['mp4', 'webm'],
      height: 480,
      quality: '480p',
      width: 854
    }, { formats: ['mp4', 'webm'], height: 720, quality: '720p', width: 1280 }, {
      formats: ['mp4', 'webm'],
      height: 1080,
      quality: '1080p',
      width: 1920
    }]
  }
}];

exports.defaultImages = defaultImages;
exports.defaultVideos = defaultVideos;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// main.bundle.min.js